if ((typeof Shopify) === 'undefined') { window.Shopify = {}; }
  // Get from cart.js returns the cart in JSON
  if ((typeof Shopify.getCart) === 'undefined') {
  Shopify.getCart = function(callback, cart) {
    if(!cart){
    return jQuery.getJSON('/cart.js', function (cart, textStatus, xhr) {
        if ((typeof callback) === 'function') {
        callback(cart,textStatus, xhr);
      }
      else {
        Shopify.onCartUpdate(cart);
          }
      });
    }else{
      if ((typeof callback) === 'function') {
      callback(cart);
    }else if(typeof Shopify.onCartUpdate ==='function') {
      Shopify.onCartUpdate(cart);
        }
    }
  };
}

(function() {
    function n(t, e, i, n) {
        return new a(t,e,i,n)
    }
    function a(t, e, i, n) {
        this.options = n || {},
        this.options.adapters = this.options.adapters || {},
        this.obj = t,
        this.keypath = e,
        this.callback = i,
        this.objectPath = [],
        this.parse(),
        o(this.target = this.realize()) && this.set(!0, this.key, this.target, this.callback)
    }
    function o(t) {
        return "object" == typeof t && null !== t
    }
    function s(t) {
        throw new Error("[sightglass] " + t)
    }
    n.adapters = {},
    a.tokenize = function(t, e, i) {
        var n, a, o = [], s = {
            i: i,
            path: ""
        };
        for (n = 0; n < t.length; n++)
            a = t.charAt(n),
            ~e.indexOf(a) ? (o.push(s),
            s = {
                i: a,
                path: ""
            }) : s.path += a;
        return o.push(s),
        o
    }
    ,
    a.prototype.parse = function() {
        var t, e, i = this.interfaces();
        i.length || s("Must define at least one adapter interface."),
        e = ~i.indexOf(this.keypath[0]) ? (t = this.keypath[0],
        this.keypath.substr(1)) : (void 0 === (t = this.options.root || n.root) && s("Must define a default root adapter."),
        this.keypath),
        this.tokens = a.tokenize(e, i, t),
        this.key = this.tokens.pop()
    }
    ,
    a.prototype.realize = function() {
        var i, n = this.obj, a = !1;
        return this.tokens.forEach(function(t, e) {
            o(n) ? (void 0 !== this.objectPath[e] ? n !== (i = this.objectPath[e]) && (this.set(!1, t, i, this.update.bind(this)),
            this.set(!0, t, n, this.update.bind(this)),
            this.objectPath[e] = n) : (this.set(!0, t, n, this.update.bind(this)),
            this.objectPath[e] = n),
            n = this.get(t, n)) : (!1 === a && (a = e),
            (i = this.objectPath[e]) && this.set(!1, t, i, this.update.bind(this)))
        }, this),
        !1 !== a && this.objectPath.splice(a),
        n
    }
    ,
    a.prototype.update = function() {
        var t, e;
        (t = this.realize()) !== this.target && (o(this.target) && this.set(!1, this.key, this.target, this.callback),
        o(t) && this.set(!0, this.key, t, this.callback),
        e = this.value(),
        this.target = t,
        this.value() !== e && this.callback())
    }
    ,
    a.prototype.value = function() {
        if (o(this.target))
            return this.get(this.key, this.target)
    }
    ,
    a.prototype.setValue = function(t) {
        o(this.target) && this.adapter(this.key).set(this.target, this.key.path, t)
    }
    ,
    a.prototype.get = function(t, e) {
        return this.adapter(t).get(e, t.path)
    }
    ,
    a.prototype.set = function(t, e, i, n) {
        var a = t ? "observe" : "unobserve";
        this.adapter(e)[a](i, e.path, n)
    }
    ,
    a.prototype.interfaces = function() {
        var e = Object.keys(this.options.adapters);
        return Object.keys(n.adapters).forEach(function(t) {
            ~e.indexOf(t) || e.push(t)
        }),
        e
    }
    ,
    a.prototype.adapter = function(t) {
        return this.options.adapters[t.i] || n.adapters[t.i]
    }
    ,
    a.prototype.unobserve = function() {
        var i;
        this.tokens.forEach(function(t, e) {
            (i = this.objectPath[e]) && this.set(!1, t, i, this.update.bind(this))
        }, this),
        o(this.target) && this.set(!1, this.key, this.target, this.callback)
    }
    ,
    "undefined" != typeof module && module.exports ? module.exports = n : "function" == typeof define && define.amd ? define([], function() {
        return this.sightglass = n
    }) : this.sightglass = n
}
).call(this),
function() {
    function g(t, e) {
        return function() {
            return t.apply(e, arguments)
        }
    }
    function t(t, e) {
        for (var i in e)
            s.call(e, i) && (t[i] = e[i]);
        function n() {
            this.constructor = t
        }
        return n.prototype = e.prototype,
        t.prototype = new n,
        t.__super__ = e.prototype,
        t
    }
    var S, n, a, e, i, o, m = [].slice, s = {}.hasOwnProperty, d = [].indexOf || function(t) {
        for (var e = 0, i = this.length; e < i; e++)
            if (e in this && this[e] === t)
                return e;
        return -1
    }
    ;
    function r() {}
    function l() {}
    function c(t, e, i) {
        var n, a, o, s, r, l, c, u, d, h, f, p, m;
        for (this.els = t,
        this.models = e,
        null == i && (i = {}),
        this.update = g(this.update, this),
        this.publish = g(this.publish, this),
        this.sync = g(this.sync, this),
        this.unbind = g(this.unbind, this),
        this.bind = g(this.bind, this),
        this.select = g(this.select, this),
        this.traverse = g(this.traverse, this),
        this.build = g(this.build, this),
        this.buildBinding = g(this.buildBinding, this),
        this.bindingRegExp = g(this.bindingRegExp, this),
        this.options = g(this.options, this),
        this.els.jquery || this.els instanceof Array || (this.els = [this.els]),
        r = 0,
        c = (d = S.extensions).length; r < c; r++) {
            if (this[a = d[r]] = {},
            i[a])
                for (n in h = i[a])
                    o = h[n],
                    this[a][n] = o;
            for (n in f = S.public[a])
                o = f[n],
                null == (s = this[a])[n] && (s[n] = o)
        }
        for (l = 0,
        u = (p = S.options).length; l < u; l++)
            this[a = p[l]] = null != (m = i[a]) ? m : S.public[a];
        this.build()
    }
    function u(t, e, i, n, a) {
        this.view = t,
        this.el = e,
        this.type = i,
        this.keypath = n,
        this.options = null != a ? a : {},
        this.getValue = g(this.getValue, this),
        this.update = g(this.update, this),
        this.unbind = g(this.unbind, this),
        this.bind = g(this.bind, this),
        this.publish = g(this.publish, this),
        this.sync = g(this.sync, this),
        this.set = g(this.set, this),
        this.eventHandler = g(this.eventHandler, this),
        this.formattedValue = g(this.formattedValue, this),
        this.parseTarget = g(this.parseTarget, this),
        this.observe = g(this.observe, this),
        this.setBinder = g(this.setBinder, this),
        this.formatters = this.options.formatters || [],
        this.dependencies = [],
        this.formatterObservers = {},
        this.model = void 0,
        this.setBinder()
    }
    function h(t, e, i) {
        var n, a, o, s, r, l, c;
        for (this.view = t,
        this.el = e,
        this.type = i,
        this.unbind = g(this.unbind, this),
        this.bind = g(this.bind, this),
        this.locals = g(this.locals, this),
        this.component = this.view.components[this.type],
        this.static = {},
        this.observers = {},
        this.upstreamObservers = {},
        a = t.bindingRegExp(),
        s = 0,
        r = (l = this.el.attributes || []).length; s < r; s++)
            n = l[s],
            a.test(n.name) || (o = this.camelCase(n.name),
            0 <= d.call(null != (c = this.component.static) ? c : [], o) ? this.static[o] = n.value : this.observers[o] = n.value)
    }
    function f(t, e, i, n, a) {
        this.view = t,
        this.el = e,
        this.type = i,
        this.keypath = n,
        this.options = null != a ? a : {},
        this.sync = g(this.sync, this),
        this.formatters = this.options.formatters || [],
        this.dependencies = [],
        this.formatterObservers = {}
    }
    S = {
        options: ["prefix", "templateDelimiters", "rootInterface", "preloadData", "handler"],
        extensions: ["binders", "formatters", "components", "adapters"],
        public: {
            binders: {},
            components: {},
            formatters: {},
            adapters: {},
            prefix: "rv",
            templateDelimiters: ["{", "}"],
            rootInterface: ".",
            preloadData: !0,
            handler: function(t, e, i) {
                return this.call(t, e, i.view.models)
            },
            configure: function(t) {
                var e, i, n, a;
                for (n in null == t && (t = {}),
                t)
                    if (a = t[n],
                    "binders" === n || "components" === n || "formatters" === n || "adapters" === n)
                        for (i in a)
                            e = a[i],
                            S[n][i] = e;
                    else
                        S.public[n] = a
            },
            bind: function(t, e, i) {
                var n;
                return null == e && (e = {}),
                null == i && (i = {}),
                (n = new S.View(t,e,i)).bind(),
                n
            },
            init: function(t, e, i) {
                var n, a;
                return null == i && (i = {}),
                null == e && (e = document.createElement("div")),
                t = S.public.components[t],
                e.innerHTML = t.template.call(this, e),
                n = t.initialize.call(this, e, i),
                (a = new S.View(e,n)).bind(),
                a
            }
        }
    },
    window.jQuery || window.$ ? (e = "on"in jQuery.prototype ? ["on", "off"] : ["bind", "unbind"],
    n = e[0],
    a = e[1],
    S.Util = {
        bindEvent: function(t, e, i) {
            return jQuery(t)[n](e, i)
        },
        unbindEvent: function(t, e, i) {
            return jQuery(t)[a](e, i)
        },
        getInputValue: function(t) {
            var e;
            return "checkbox" === (e = jQuery(t)).attr("type") ? e.is(":checked") : e.val()
        }
    }) : S.Util = {
        bindEvent: "addEventListener"in window ? function(t, e, i) {
            return t.addEventListener(e, i, !1)
        }
        : function(t, e, i) {
            return t.attachEvent("on" + e, i)
        }
        ,
        unbindEvent: "removeEventListener"in window ? function(t, e, i) {
            return t.removeEventListener(e, i, !1)
        }
        : function(t, e, i) {
            return t.detachEvent("on" + e, i)
        }
        ,
        getInputValue: function(t) {
            var e, i, n, a;
            if ("checkbox" === t.type)
                return t.checked;
            if ("select-multiple" !== t.type)
                return t.value;
            for (a = [],
            i = 0,
            n = t.length; i < n; i++)
                (e = t[i]).selected && a.push(e.value);
            return a
        }
    },
    S.TypeParser = (r.types = {
        primitive: 0,
        keypath: 1
    },
    r.parse = function(t) {
        return /^'.*'$|^".*"$/.test(t) ? {
            type: this.types.primitive,
            value: t.slice(1, -1)
        } : "true" === t ? {
            type: this.types.primitive,
            value: !0
        } : "false" === t ? {
            type: this.types.primitive,
            value: !1
        } : "null" === t ? {
            type: this.types.primitive,
            value: null
        } : "undefined" === t ? {
            type: this.types.primitive,
            value: void 0
        } : !1 === isNaN(Number(t)) ? {
            type: this.types.primitive,
            value: Number(t)
        } : {
            type: this.types.keypath,
            value: t
        }
    }
    ,
    r),
    S.TextTemplateParser = (l.types = {
        text: 0,
        binding: 1
    },
    l.parse = function(t, e) {
        var i, n, a, o, s, r, l;
        for (r = [],
        o = t.length,
        n = i = 0; n < o; ) {
            if ((i = t.indexOf(e[0], n)) < 0) {
                r.push({
                    type: this.types.text,
                    value: t.slice(n)
                });
                break
            }
            if (0 < i && n < i && r.push({
                type: this.types.text,
                value: t.slice(n, i)
            }),
            n = i + e[0].length,
            (i = t.indexOf(e[1], n)) < 0) {
                s = t.slice(n - e[1].length),
                (null != (a = r[r.length - 1]) ? a.type : void 0) === this.types.text ? a.value += s : r.push({
                    type: this.types.text,
                    value: s
                });
                break
            }
            l = t.slice(n, i).trim(),
            r.push({
                type: this.types.binding,
                value: l
            }),
            n = i + e[1].length
        }
        return r
    }
    ,
    l),
    S.View = (c.prototype.options = function() {
        var t, e, i, n, a;
        for (e = {},
        i = 0,
        n = (a = S.extensions.concat(S.options)).length; i < n; i++)
            e[t = a[i]] = this[t];
        return e
    }
    ,
    c.prototype.bindingRegExp = function() {
        return new RegExp("^" + this.prefix + "-")
    }
    ,
    c.prototype.buildBinding = function(t, e, i, a) {
        var n, o, s, r, l, c, u;
        return l = {},
        u = function() {
            var t, e, i, n;
            for (n = [],
            t = 0,
            e = (i = a.split("|")).length; t < e; t++)
                c = i[t],
                n.push(c.trim());
            return n
        }(),
        r = (n = function() {
            var t, e, i, n;
            for (n = [],
            t = 0,
            e = (i = u.shift().split("<")).length; t < e; t++)
                o = i[t],
                n.push(o.trim());
            return n
        }()).shift(),
        l.formatters = u,
        (s = n.shift()) && (l.dependencies = s.split(/\s+/)),
        this.bindings.push(new S[t](this,e,i,r,l))
    }
    ,
    c.prototype.build = function() {
        var t, m, e, i, n, g;
        for (this.bindings = [],
        m = function(a) {
            var t, e, i, o, n, s, r, l, c, u, d, h, f, p;
            if (3 === a.nodeType) {
                if (n = S.TextTemplateParser,
                (i = g.templateDelimiters) && (l = n.parse(a.data, i)).length && (1 !== l.length || l[0].type !== n.types.text)) {
                    for (c = 0,
                    d = l.length; c < d; c++)
                        r = l[c],
                        s = document.createTextNode(r.value),
                        a.parentNode.insertBefore(s, a),
                        1 === r.type && g.buildBinding("TextBinding", s, null, r.value);
                    a.parentNode.removeChild(a)
                }
            } else
                1 === a.nodeType && (t = g.traverse(a));
            if (!t) {
                for (p = [],
                u = 0,
                h = (f = function() {
                    var t, e, i, n;
                    for (n = [],
                    t = 0,
                    e = (i = a.childNodes).length; t < e; t++)
                        o = i[t],
                        n.push(o);
                    return n
                }()).length; u < h; u++)
                    e = f[u],
                    p.push(m(e));
                return p
            }
        }
        ,
        e = 0,
        i = (n = (g = this).els).length; e < i; e++)
            t = n[e],
            m(t);
        this.bindings.sort(function(t, e) {
            var i, n;
            return ((null != (i = e.binder) ? i.priority : void 0) || 0) - ((null != (n = t.binder) ? n.priority : void 0) || 0)
        })
    }
    ,
    c.prototype.traverse = function(t) {
        var e, i, n, a, o, s, r, l, c, u, d, h, f, p, m;
        for (a = this.bindingRegExp(),
        o = "SCRIPT" === t.nodeName || "STYLE" === t.nodeName,
        c = 0,
        d = (f = t.attributes).length; c < d; c++)
            if (e = f[c],
            a.test(e.name)) {
                if (r = e.name.replace(a, ""),
                !(n = this.binders[r]))
                    for (s in p = this.binders)
                        l = p[s],
                        "*" !== s && -1 !== s.indexOf("*") && new RegExp("^" + s.replace(/\*/g, ".+") + "$").test(r) && (n = l);
                n || (n = this.binders["*"]),
                n.block && (o = !0,
                i = [e])
            }
        for (u = 0,
        h = (m = i || t.attributes).length; u < h; u++)
            e = m[u],
            a.test(e.name) && (r = e.name.replace(a, ""),
            this.buildBinding("Binding", t, r, e.value));
        return o || (r = t.nodeName.toLowerCase(),
        this.components[r] && !t._bound && (this.bindings.push(new S.ComponentBinding(this,t,r)),
        o = !0)),
        o
    }
    ,
    c.prototype.select = function(t) {
        var e, i, n, a, o;
        for (o = [],
        i = 0,
        n = (a = this.bindings).length; i < n; i++)
            t(e = a[i]) && o.push(e);
        return o
    }
    ,
    c.prototype.bind = function() {
        var t, e, i, n, a;
        for (a = [],
        e = 0,
        i = (n = this.bindings).length; e < i; e++)
            t = n[e],
            a.push(t.bind());
        return a
    }
    ,
    c.prototype.unbind = function() {
        var t, e, i, n, a;
        for (a = [],
        e = 0,
        i = (n = this.bindings).length; e < i; e++)
            t = n[e],
            a.push(t.unbind());
        return a
    }
    ,
    c.prototype.sync = function() {
        var t, e, i, n, a;
        for (a = [],
        e = 0,
        i = (n = this.bindings).length; e < i; e++)
            t = n[e],
            a.push("function" == typeof t.sync ? t.sync() : void 0);
        return a
    }
    ,
    c.prototype.publish = function() {
        var t, e, i, n, a;
        for (a = [],
        e = 0,
        i = (n = this.select(function(t) {
            var e;
            return null != (e = t.binder) ? e.publishes : void 0
        })).length; e < i; e++)
            t = n[e],
            a.push(t.publish());
        return a
    }
    ,
    c.prototype.update = function(t) {
        var e, i, n, a, o, s, r;
        for (i in null == t && (t = {}),
        t)
            n = t[i],
            this.models[i] = n;
        for (r = [],
        a = 0,
        o = (s = this.bindings).length; a < o; a++)
            e = s[a],
            r.push("function" == typeof e.update ? e.update(t) : void 0);
        return r
    }
    ,
    c),
    S.Binding = (u.prototype.setBinder = function() {
        var t, e, i;
        if (!(this.binder = this.view.binders[this.type]))
            for (t in i = this.view.binders)
                e = i[t],
                "*" !== t && -1 !== t.indexOf("*") && new RegExp("^" + t.replace(/\*/g, ".+") + "$").test(this.type) && (this.binder = e,
                this.args = new RegExp("^" + t.replace(/\*/g, "(.+)") + "$").exec(this.type),
                this.args.shift());
        if (this.binder || (this.binder = this.view.binders["*"]),
        this.binder instanceof Function)
            return this.binder = {
                routine: this.binder
            }
    }
    ,
    u.prototype.observe = function(t, e, i) {
        return S.sightglass(t, e, i, {
            root: this.view.rootInterface,
            adapters: this.view.adapters
        })
    }
    ,
    u.prototype.parseTarget = function() {
        var t;
        return 0 === (t = S.TypeParser.parse(this.keypath)).type ? this.value = t.value : (this.observer = this.observe(this.view.models, this.keypath, this.sync),
        this.model = this.observer.target)
    }
    ,
    u.prototype.formattedValue = function(t) {
        var e, n, a, i, o, s, r, l, c, u, d, h, f, p;
        for (i = u = 0,
        h = (p = this.formatters).length; u < h; i = ++u) {
            for (o = p[i],
            s = (a = o.match(/[^\s']+|'([^']|'[^\s])*'|"([^"]|"[^\s])*"/g)).shift(),
            o = this.view.formatters[s],
            l = [],
            e = d = 0,
            f = (a = function() {
                var t, e, i;
                for (i = [],
                t = 0,
                e = a.length; t < e; t++)
                    n = a[t],
                    i.push(S.TypeParser.parse(n));
                return i
            }()).length; d < f; e = ++d)
                n = a[e],
                l.push(0 === n.type ? n.value : ((c = this.formatterObservers)[i] || (c[i] = {}),
                (r = this.formatterObservers[i][e]) || (r = this.observe(this.view.models, n.value, this.sync),
                this.formatterObservers[i][e] = r),
                r.value()));
            (null != o ? o.read : void 0)instanceof Function ? t = o.read.apply(o, [t].concat(m.call(l))) : o instanceof Function && (t = o.apply(null, [t].concat(m.call(l))))
        }
        return t
    }
    ,
    u.prototype.eventHandler = function(e) {
        var i, n;
        return n = (i = this).view.handler,
        function(t) {
            return n.call(e, this, t, i)
        }
    }
    ,
    u.prototype.set = function(t) {
        var e;
        return t = t instanceof Function && !this.binder.function ? this.formattedValue(t.call(this.model)) : this.formattedValue(t),
        null != (e = this.binder.routine) ? e.call(this, this.el, t) : void 0
    }
    ,
    u.prototype.sync = function() {
        var r, l;
        return this.set(function() {
            var t, e, i, n, a, o, s;
            if (this.observer) {
                if (this.model !== this.observer.target) {
                    for (t = 0,
                    i = (a = this.dependencies).length; t < i; t++)
                        (l = a[t]).unobserve();
                    if (this.dependencies = [],
                    null != (this.model = this.observer.target) && (null != (o = this.options.dependencies) ? o.length : void 0))
                        for (e = 0,
                        n = (s = this.options.dependencies).length; e < n; e++)
                            r = s[e],
                            l = this.observe(this.model, r, this.sync),
                            this.dependencies.push(l)
                }
                return this.observer.value()
            }
            return this.value
        }
        .call(this))
    }
    ,
    u.prototype.publish = function() {
        var t, e, i, n, a, o, s, r;
        if (this.observer) {
            for (i = this.getValue(this.el),
            n = 0,
            a = (o = this.formatters.slice(0).reverse()).length; n < a; n++)
                e = (t = o[n].split(/\s+/)).shift(),
                (null != (s = this.view.formatters[e]) ? s.publish : void 0) && (i = (r = this.view.formatters[e]).publish.apply(r, [i].concat(m.call(t))));
            return this.observer.setValue(i)
        }
    }
    ,
    u.prototype.bind = function() {
        var t, e, i, n, a, o, s;
        if (this.parseTarget(),
        null != (a = this.binder.bind) && a.call(this, this.el),
        null != this.model && (null != (o = this.options.dependencies) ? o.length : void 0))
            for (i = 0,
            n = (s = this.options.dependencies).length; i < n; i++)
                t = s[i],
                e = this.observe(this.model, t, this.sync),
                this.dependencies.push(e);
        if (this.view.preloadData)
            return this.sync()
    }
    ,
    u.prototype.unbind = function() {
        var t, e, i, n, a, o, s, r, l;
        for (null != (o = this.binder.unbind) && o.call(this, this.el),
        null != (s = this.observer) && s.unobserve(),
        n = 0,
        a = (r = this.dependencies).length; n < a; n++)
            r[n].unobserve();
        for (i in this.dependencies = [],
        l = this.formatterObservers)
            for (t in e = l[i])
                e[t].unobserve();
        return this.formatterObservers = {}
    }
    ,
    u.prototype.update = function(t) {
        var e, i;
        return null == t && (t = {}),
        this.model = null != (e = this.observer) ? e.target : void 0,
        null != (i = this.binder.update) ? i.call(this, t) : void 0
    }
    ,
    u.prototype.getValue = function(t) {
        return this.binder && null != this.binder.getValue ? this.binder.getValue.call(this, t) : S.Util.getInputValue(t)
    }
    ,
    u),
    S.ComponentBinding = (i = S.Binding,
    t(h, i),
    h.prototype.sync = function() {}
    ,
    h.prototype.update = function() {}
    ,
    h.prototype.publish = function() {}
    ,
    h.prototype.locals = function() {
        var t, e, i, n, a, o;
        for (t in i = {},
        a = this.static)
            n = a[t],
            i[t] = n;
        for (t in o = this.observers)
            e = o[t],
            i[t] = e.value();
        return i
    }
    ,
    h.prototype.camelCase = function(t) {
        return t.replace(/-([a-z])/g, function(t) {
            return t[1].toUpperCase()
        })
    }
    ,
    h.prototype.bind = function() {
        var t, e, i, n, a, o, s, r, l, c, u, d, h, f, p, m, g, y, v, b, A;
        if (!this.bound) {
            for (e in f = this.observers)
                i = f[e],
                this.observers[e] = this.observe(this.view.models, i, function(e) {
                    return function(t) {
                        return function() {
                            return e.componentView.models[t] = e.observers[t].value()
                        }
                    }
                }(this).call(this, e));
            this.bound = !0
        }
        if (null != this.componentView)
            return this.componentView.bind();
        for (this.el.innerHTML = this.component.template.call(this),
        s = this.component.initialize.call(this, this.el, this.locals()),
        this.el._bound = !0,
        o = {},
        c = 0,
        d = (p = S.extensions).length; c < d; c++) {
            if (o[a = p[c]] = {},
            this.component[a])
                for (t in m = this.component[a])
                    r = m[t],
                    o[a][t] = r;
            for (t in g = this.view[a])
                r = g[t],
                null == (l = o[a])[t] && (l[t] = r)
        }
        for (u = 0,
        h = (y = S.options).length; u < h; u++)
            o[a = y[u]] = null != (v = this.component[a]) ? v : this.view[a];
        for (e in this.componentView = new S.View(this.el,s,o),
        this.componentView.bind(),
        A = [],
        b = this.observers)
            n = b[e],
            A.push(this.upstreamObservers[e] = this.observe(this.componentView.models, e, function(i) {
                return function(t, e) {
                    return function() {
                        return e.setValue(i.componentView.models[t])
                    }
                }
            }(this).call(this, e, n)));
        return A
    }
    ,
    h.prototype.unbind = function() {
        var t, e, i, n;
        for (t in e = this.upstreamObservers)
            e[t].unobserve();
        for (t in i = this.observers)
            i[t].unobserve();
        return null != (n = this.componentView) ? n.unbind.call(this) : void 0
    }
    ,
    h),
    S.TextBinding = (o = S.Binding,
    t(f, o),
    f.prototype.binder = {
        routine: function(t, e) {
            return t.data = null != e ? e : ""
        }
    },
    f.prototype.sync = function() {
        return f.__super__.sync.apply(this, arguments)
    }
    ,
    f),
    S.public.binders.text = function(t, e) {
        return null != t.textContent ? t.textContent = null != e ? e : "" : t.innerText = null != e ? e : ""
    }
    ,
    S.public.binders.html = function(t, e) {
        return t.innerHTML = null != e ? e : ""
    }
    ,
    S.public.binders.show = function(t, e) {
        return t.style.display = e ? "" : "none"
    }
    ,
    S.public.binders.hide = function(t, e) {
        return t.style.display = e ? "none" : ""
    }
    ,
    S.public.binders.enabled = function(t, e) {
        return t.disabled = !e
    }
    ,
    S.public.binders.disabled = function(t, e) {
        return t.disabled = !!e
    }
    ,
    S.public.binders.checked = {
        publishes: !0,
        priority: 2e3,
        bind: function(t) {
            return S.Util.bindEvent(t, "change", this.publish)
        },
        unbind: function(t) {
            return S.Util.unbindEvent(t, "change", this.publish)
        },
        routine: function(t, e) {
            var i;
            return "radio" === t.type ? t.checked = (null != (i = t.value) ? i.toString() : void 0) === (null != e ? e.toString() : void 0) : t.checked = !!e
        }
    },
    S.public.binders.unchecked = {
        publishes: !0,
        priority: 2e3,
        bind: function(t) {
            return S.Util.bindEvent(t, "change", this.publish)
        },
        unbind: function(t) {
            return S.Util.unbindEvent(t, "change", this.publish)
        },
        routine: function(t, e) {
            var i;
            return "radio" === t.type ? t.checked = (null != (i = t.value) ? i.toString() : void 0) !== (null != e ? e.toString() : void 0) : t.checked = !e
        }
    },
    S.public.binders.value = {
        publishes: !0,
        priority: 3e3,
        bind: function(t) {
            if ("INPUT" !== t.tagName || "radio" !== t.type)
                return this.event = "SELECT" === t.tagName ? "change" : "input",
                S.Util.bindEvent(t, this.event, this.publish)
        },
        unbind: function(t) {
            if ("INPUT" !== t.tagName || "radio" !== t.type)
                return S.Util.unbindEvent(t, this.event, this.publish)
        },
        routine: function(t, e) {
            var i, n, a, o, s, r, l;
            if ("INPUT" === t.tagName && "radio" === t.type)
                return t.setAttribute("value", e);
            if (null != window.jQuery) {
                if (t = jQuery(t),
                (null != e ? e.toString() : void 0) !== (null != (o = t.val()) ? o.toString() : void 0))
                    return t.val(null != e ? e : "")
            } else if ("select-multiple" === t.type) {
                if (null != e) {
                    for (l = [],
                    n = 0,
                    a = t.length; n < a; n++)
                        i = t[n],
                        l.push(i.selected = (s = i.value,
                        0 <= d.call(e, s)));
                    return l
                }
            } else if ((null != e ? e.toString() : void 0) !== (null != (r = t.value) ? r.toString() : void 0))
                return t.value = null != e ? e : ""
        }
    },
    S.public.binders.if = {
        block: !0,
        priority: 4e3,
        bind: function(t) {
            var e, i;
            if (null == this.marker)
                return e = [this.view.prefix, this.type].join("-").replace("--", "-"),
                i = t.getAttribute(e),
                this.marker = document.createComment(" rivets: " + this.type + " " + i + " "),
                this.bound = !1,
                t.removeAttribute(e),
                t.parentNode.insertBefore(this.marker, t),
                t.parentNode.removeChild(t)
        },
        unbind: function() {
            var t;
            return null != (t = this.nested) ? t.unbind() : void 0
        },
        routine: function(t, e) {
            var i, n, a, o;
            if (!!e == !this.bound) {
                if (e) {
                    for (i in a = {},
                    o = this.view.models)
                        n = o[i],
                        a[i] = n;
                    return (this.nested || (this.nested = new S.View(t,a,this.view.options()))).bind(),
                    this.marker.parentNode.insertBefore(t, this.marker.nextSibling),
                    this.bound = !0
                }
                return t.parentNode.removeChild(t),
                this.nested.unbind(),
                this.bound = !1
            }
        },
        update: function(t) {
            var e;
            return null != (e = this.nested) ? e.update(t) : void 0
        }
    },
    S.public.binders.unless = {
        block: !0,
        priority: 4e3,
        bind: function(t) {
            return S.public.binders.if.bind.call(this, t)
        },
        unbind: function() {
            return S.public.binders.if.unbind.call(this)
        },
        routine: function(t, e) {
            return S.public.binders.if.routine.call(this, t, !e)
        },
        update: function(t) {
            return S.public.binders.if.update.call(this, t)
        }
    },
    S.public.binders["on-*"] = {
        function: !0,
        priority: 1e3,
        unbind: function(t) {
            if (this.handler)
                return S.Util.unbindEvent(t, this.args[0], this.handler)
        },
        routine: function(t, e) {
            return this.handler && S.Util.unbindEvent(t, this.args[0], this.handler),
            S.Util.bindEvent(t, this.args[0], this.handler = this.eventHandler(e))
        }
    },
    S.public.binders["each-*"] = {
        block: !0,
        priority: 4e3,
        bind: function(t) {
            var e, i, n, a;
            if (null == this.marker)
                e = [this.view.prefix, this.type].join("-").replace("--", "-"),
                this.marker = document.createComment(" rivets: " + this.type + " "),
                this.iterated = [],
                t.removeAttribute(e),
                t.parentNode.insertBefore(this.marker, t),
                t.parentNode.removeChild(t);
            else
                for (i = 0,
                n = (a = this.iterated).length; i < n; i++)
                    a[i].bind()
        },
        unbind: function(t) {
            var e, i, n, a, o;
            if (null != this.iterated) {
                for (o = [],
                i = 0,
                n = (a = this.iterated).length; i < n; i++)
                    e = a[i],
                    o.push(e.unbind());
                return o
            }
        },
        routine: function(t, e) {
            var i, n, a, o, s, r, l, c, u, d, h, f, p, m, g, y, v, b, A, w;
            if (r = this.args[0],
            e = e || [],
            this.iterated.length > e.length)
                for (h = 0,
                m = (v = Array(this.iterated.length - e.length)).length; h < m; h++)
                    v[h],
                    (d = this.iterated.pop()).unbind(),
                    this.marker.parentNode.removeChild(d.els[0]);
            for (a = f = 0,
            g = e.length; f < g; a = ++f)
                if (s = e[a],
                (n = {
                    index: a
                })[r] = s,
                null == this.iterated[a]) {
                    for (o in b = this.view.models)
                        s = b[o],
                        null == n[o] && (n[o] = s);
                    c = this.iterated.length ? this.iterated[this.iterated.length - 1].els[0] : this.marker,
                    (l = this.view.options()).preloadData = !0,
                    u = t.cloneNode(!0),
                    (d = new S.View(u,n,l)).bind(),
                    this.iterated.push(d),
                    this.marker.parentNode.insertBefore(u, c.nextSibling)
                } else
                    this.iterated[a].models[r] !== s && this.iterated[a].update(n);
            if ("OPTION" === t.nodeName) {
                for (w = [],
                p = 0,
                y = (A = this.view.bindings).length; p < y; p++)
                    (i = A[p]).el === this.marker.parentNode && "value" === i.type ? w.push(i.sync()) : w.push(void 0);
                return w
            }
        },
        update: function(t) {
            var e, i, n, a, o, s, r, l;
            for (i in e = {},
            t)
                n = t[i],
                i !== this.args[0] && (e[i] = n);
            for (l = [],
            o = 0,
            s = (r = this.iterated).length; o < s; o++)
                a = r[o],
                l.push(a.update(e));
            return l
        }
    },
    S.public.binders["class-*"] = function(t, e) {
        var i;
        if (!e == (-1 !== (i = " " + t.className + " ").indexOf(" " + this.args[0] + " ")))
            return t.className = e ? t.className + " " + this.args[0] : i.replace(" " + this.args[0] + " ", " ").trim()
    }
    ,
    S.public.binders["*"] = function(t, e) {
        return null != e ? t.setAttribute(this.type, e) : t.removeAttribute(this.type)
    }
    ,
    S.public.adapters["."] = {
        id: "_rv",
        counter: 0,
        weakmap: {},
        weakReference: function(t) {
            var e, i, n;
            return t.hasOwnProperty(this.id) || (e = this.counter++,
            Object.defineProperty(t, this.id, {
                value: e
            })),
            (i = this.weakmap)[n = t[this.id]] || (i[n] = {
                callbacks: {}
            })
        },
        cleanupWeakReference: function(t, e) {
            if (!(Object.keys(t.callbacks).length || t.pointers && Object.keys(t.pointers).length))
                return delete this.weakmap[e]
        },
        stubFunction: function(c, t) {
            var u, d, h;
            return d = c[t],
            u = this.weakReference(c),
            h = this.weakmap,
            c[t] = function() {
                var t, e, i, n, a, o, s, r, l;
                for (e in i = d.apply(c, arguments),
                o = u.pointers)
                    for (t = o[e],
                    n = 0,
                    a = (l = null != (s = null != (r = h[e]) ? r.callbacks[t] : void 0) ? s : []).length; n < a; n++)
                        (0,
                        l[n])();
                return i
            }
        },
        observeMutations: function(t, e, i) {
            var n, a, o, s, r, l;
            if (Array.isArray(t)) {
                if (null == (o = this.weakReference(t)).pointers)
                    for (o.pointers = {},
                    r = 0,
                    l = (a = ["push", "pop", "shift", "unshift", "sort", "reverse", "splice"]).length; r < l; r++)
                        n = a[r],
                        this.stubFunction(t, n);
                if (null == (s = o.pointers)[e] && (s[e] = []),
                d.call(o.pointers[e], i) < 0)
                    return o.pointers[e].push(i)
            }
        },
        unobserveMutations: function(t, e, i) {
            var n, a, o;
            if (Array.isArray(t) && null != t[this.id] && (a = this.weakmap[t[this.id]]) && (o = a.pointers[e]))
                return 0 <= (n = o.indexOf(i)) && o.splice(n, 1),
                o.length || delete a.pointers[e],
                this.cleanupWeakReference(a, t[this.id])
        },
        observe: function(o, s, r) {
            var l, t, c, u;
            return null == (l = this.weakReference(o).callbacks)[s] && (l[s] = [],
            (null != (t = Object.getOwnPropertyDescriptor(o, s)) ? t.get : void 0) || (null != t ? t.set : void 0) || (c = o[s],
            Object.defineProperty(o, s, {
                enumerable: !0,
                get: function() {
                    return c
                },
                set: (u = this,
                function(t) {
                    var e, i, n, a;
                    if (t !== c && (u.unobserveMutations(c, o[u.id], s),
                    c = t,
                    e = u.weakmap[o[u.id]])) {
                        if ((l = e.callbacks)[s])
                            for (i = 0,
                            n = (a = l[s].slice()).length; i < n; i++)
                                r = a[i],
                                0 <= d.call(l[s], r) && r();
                        return u.observeMutations(t, o[u.id], s)
                    }
                }
                )
            }))),
            d.call(l[s], r) < 0 && l[s].push(r),
            this.observeMutations(o[s], o[this.id], s)
        },
        unobserve: function(t, e, i) {
            var n, a, o;
            if ((o = this.weakmap[t[this.id]]) && (n = o.callbacks[e]))
                return 0 <= (a = n.indexOf(i)) && (n.splice(a, 1),
                n.length || delete o.callbacks[e]),
                this.unobserveMutations(t[e], t[this.id], e),
                this.cleanupWeakReference(o, t[this.id])
        },
        get: function(t, e) {
            return t[e]
        },
        set: function(t, e, i) {
            return t[e] = i
        }
    },
    S.factory = function(t) {
        return S.sightglass = t,
        (S.public._ = S).public
    }
    ,
    "object" == typeof ("undefined" != typeof module && null !== module ? module.exports : void 0) ? module.exports = S.factory(require("sightglass")) : "function" == typeof define && define.amd ? define(["sightglass"], function(t) {
        return this.rivets = S.factory(t)
    }) : this.rivets = S.factory(sightglass)
}
.call(this),
function() {
    function e(t, e) {
        return function() {
            return t.apply(e, arguments)
        }
    }
    var i, t, s, r, a, o;
    function n() {
        this.update = e(this.update, this)
    }
    function l(t) {
        this.propertyArray = e(this.propertyArray, this),
        this.update = e(this.update, this),
        this.update(t)
    }
    n.prototype.update = function(a) {
        var o, t, e;
        for (t in a)
            e = a[t],
            "items" !== t && (this[t] = e);
        return this.items = function() {
            var t, e, i, n;
            for (n = [],
            t = 0,
            e = (i = a.items).length; t < e; t++)
                o = i[t],
                n.push(new r(o));
            return n
        }()
    }
    ,
    t = n,
    l.prototype.update = function(t) {
        var e, i;
        for (e in t)
            i = t[e],
            "properties" !== e && (this[e] = i);
        return this.properties = s.Utils.extend({}, t.properties)
    }
    ,
    l.prototype.propertyArray = function() {
        var t, e, i, n;
        for (t in n = [],
        i = this.properties)
            e = i[t],
            n.push({
                name: t,
                value: e
            });
        return n
    }
    ,
    r = l,
    s = {
        settings: {
            debug: !1,
            dataAPI: !0,
            requestBodyClass: null,
            rivetsModels: {},
            currency: null,
            moneyFormat: null,
            moneyWithCurrencyFormat: null,
            weightUnit: "g",
            weightPrecision: 0
        },
        cart: new t,
        init: function(t, e) {
            return null == e && (e = {}),
            s.configure(e),
            s.Utils.log("Initialising CartJS."),
            s.cart.update(t),
            s.settings.dataAPI && (s.Utils.log('"dataAPI" setting is true, initialising Data API.'),
            s.Data.init()),
            s.settings.requestBodyClass && (s.Utils.log('"requestBodyClass" set, adding event listeners.'),
            jQuery(document).on("cart.requestStarted", function() {
                return jQuery("body").addClass(s.settings.requestBodyClass)
            }),
            jQuery(document).on("cart.requestComplete", function() {
                return jQuery("body").removeClass(s.settings.requestBodyClass)
            })),
            s.Rivets.init(),
            jQuery(document).trigger("cart.ready", [s.cart])
        },
        configure: function(t) {
            return null == t && (t = {}),
            s.Utils.extend(s.settings, t)
        }
    },
    null == window.console && (window.console = {},
    window.console.log = function() {}
    ),
    s.Utils = {
        log: function() {
            return s.Utils.console(console.log, arguments)
        },
        error: function() {
            return s.Utils.console(console.error, arguments)
        },
        console: function(t, e) {
            if (s.settings.debug && "undefined" != typeof console && null !== console)
                return (e = Array.prototype.slice.call(e)).unshift("[CartJS]:"),
                t.apply(console, e)
        },
        wrapKeys: function(t, e, i) {
            var n, a, o;
            for (n in null == e && (e = "properties"),
            o = {},
            t)
                a = t[n],
                o[e + "[" + n + "]"] = null != i ? i : a;
            return o
        },
        unwrapKeys: function(t, e, i) {
            var n, a, o;
            for (n in null == e && (e = "properties"),
            a = {},
            t)
                o = t[n],
                a[n.replace(e + "[", "").replace("]", "")] = null != i ? i : o;
            return a
        },
        extend: function(t, e) {
            var i, n;
            for (i in e)
                n = e[i],
                t[i] = n;
            return t
        },
        clone: function(t) {
            var e, i;
            if (null == t || "object" != typeof t)
                return t;
            for (e in i = new t.constructor,
            t)
                i[e] = clone(t[e]);
            return i
        },
        isArray: Array.isArray || function(t) {
            return "[object Array]" === {}.toString.call(t)
        }
        ,
        ensureArray: function(t) {
            return s.Utils.isArray(t) ? t : null != t ? [t] : []
        },
        formatMoney: function(t, e, i, n) {
            var a, o;
            return null == n && (n = ""),
            n || (n = s.settings.currency),
            null != window.Currency && n !== s.settings.currency && (t = Currency.convert(t, s.settings.currency, n),
            null != (null != (a = window.Currency) ? a.moneyFormats : void 0) && n in window.Currency.moneyFormats && (e = window.Currency.moneyFormats[n][i])),
            null != (null != (o = window.Shopify) ? o.formatMoney : void 0) ? Shopify.formatMoney(t, e) : t
        },
        getSizedImageUrl: function(t, e) {
            var i, n;
            return null != (null != (i = window.Shopify) && null != (n = i.Image) ? n.getSizedImageUrl : void 0) ? t ? Shopify.Image.getSizedImageUrl(t, e) : Shopify.Image.getSizedImageUrl("https://cdn.shopify.com/s/images/admin/no-image-.gif", e).replace("-_", "-") : t || "https://cdn.shopify.com/s/images/admin/no-image-large.gif"
        }
    },
    a = !(o = []),
    s.Queue = {
        add: function(t, e, i) {
            var n;
            if (null == i && (i = {}),
            n = {
                url: t,
                data: e,
                type: i.type || "POST",
                dataType: i.dataType || "json",
                success: s.Utils.ensureArray(i.success),
                error: s.Utils.ensureArray(i.error),
                complete: s.Utils.ensureArray(i.complete)
            },
            i.updateCart && n.success.push(s.cart.update),
            o.push(n),
            !a)
                return jQuery(document).trigger("cart.requestStarted", [s.cart]),
                s.Queue.process()
        },
        process: function() {
          Shopify.getCart(function(cart){
            var t;
            return o.length ? (a = !0,
            (t = o.shift()).complete = s.Queue.process,
            jQuery.ajax(t)) : (a = !1,
            void jQuery(document).trigger("cart.requestComplete", [s.cart]))
          });
        }
    },
    s.Core = {
        getCart: function(t) {
            return null == t && (t = {}),
            t.type = "GET",
            t.updateCart = !0,
            s.Queue.add("/cart.js", {}, t)
        },
        addItem: function(t, e, i, n) {
            var a;
            return null == e && (e = 1),
            null == i && (i = {}),
            null == n && (n = {}),
            (a = s.Utils.wrapKeys(i)).id = t,
            a.quantity = e,
            s.Queue.add("/cart/add.js", a, n),
            s.Core.getCart()
        },
        updateItem: function(t, e, i, n) {
            var a;
            return null == i && (i = {}),
            null == n && (n = {}),
            (a = s.Utils.wrapKeys(i)).line = t,
            null != e && (a.quantity = e),
            n.updateCart = !0,
            s.Queue.add("/cart/change.js", a, n),
            s.Core.getCart()
        },
        removeItem: function(t, e) {
            return null == e && (e = {}),
            s.Core.updateItem(t, 0, {}, e),
            s.Core.getCart()
        },
        updateItemById: function(t, e, i, n) {
            var a;
            return null == i && (i = {}),
            null == n && (n = {}),
            (a = s.Utils.wrapKeys(i)).id = t,
            null != e && (a.quantity = e),
            n.updateCart = !0,
            s.Queue.add("/cart/change.js", a, n),
            s.Core.getCart()
        },
        updateItemQuantitiesById: function(t, e) {
            return null == t && (t = {}),
            null == e && (e = {}),
            e.updateCart = !0,
            s.Queue.add("/cart/update.js", {
                updates: t
            }, e),
            s.Core.getCart()
        },
        removeItemById: function(t, e) {
            var i;
            return null == e && (e = {}),
            i = {
                id: t,
                quantity: 0
            },
            e.updateCart = !0,
            s.Queue.add("/cart/change.js", i, e),
            s.Core.getCart()
        },
        clear: function(t) {
            return null == t && (t = {}),
            t.updateCart = !0,
            s.Queue.add("/cart/clear.js", {}, t),
            s.Core.getCart()
        },
        getAttribute: function(t, e) {
            return t in s.cart.attributes ? s.cart.attributes[t] : e
        },
        setAttribute: function(t, e, i) {
            var n;
            return null == i && (i = {}),
            (n = {})[t] = e,
            s.Core.setAttributes(n, i)
        },
        getAttributes: function() {
            return s.cart.attributes
        },
        setAttributes: function(t, e) {
            return null == t && (t = {}),
            null == e && (e = {}),
            e.updateCart = !0,
            s.Queue.add("/cart/update.js", s.Utils.wrapKeys(t, "attributes"), e)
        },
        clearAttributes: function(t) {
            return null == t && (t = {}),
            t.updateCart = !0,
            s.Queue.add("/cart/update.js", s.Utils.wrapKeys(s.Core.getAttributes(), "attributes", ""), t)
        },
        getNote: function() {
            return s.cart.note
        },
        setNote: function(t, e) {
            return null == e && (e = {}),
            e.updateCart = !0,
            s.Queue.add("/cart/update.js", {
                note: t
            }, e)
        }
    },
    i = null,
    s.Data = {
        init: function() {
            return i = jQuery(document),
            s.Data.setEventListeners("on"),
            s.Data.render(null, s.cart)
        },
        destroy: function() {
            return s.Data.setEventListeners("off")
        },
        setEventListeners: function(t) {
            return i[t]("click", "[data-cart-add]", s.Data.add),
            i[t]("click", "[data-cart-remove]", s.Data.remove),
            i[t]("click", "[data-cart-remove-id]", s.Data.removeById),
            i[t]("click", "[data-cart-update]", s.Data.update),
            i[t]("change", "[data-cart-input-update]", s.Data.inputUpdate),
            i[t]("click", "[data-cart-update-id]", s.Data.updateById),
            i[t]("click", "[data-cart-clear]", s.Data.clear),
            i[t]("change", "[data-cart-toggle]", s.Data.toggle),
            i[t]("change", "[data-cart-toggle-attribute]", s.Data.toggleAttribute),
            i[t]("submit", "[data-cart-submit]", s.Data.submit),
            i[t]("cart.requestComplete", s.Data.render)
        },
        add: function(t) {
            var e;
            return t.preventDefault(),
            e = jQuery(this),
            s.Core.addItem(e.attr("data-cart-add"), e.attr("data-cart-quantity"))
        },
        remove: function(t) {
            var e;
            return t.preventDefault(),
            e = jQuery(this),
            s.Core.removeItem(e.attr("data-cart-remove"))
        },
        removeById: function(t) {
            var e;
            return t.preventDefault(),
            e = jQuery(this),
            s.Core.removeItemById(e.attr("data-cart-remove-id"))
        },
        update: function(t) {
            var e;
            return t.preventDefault(),
            e = jQuery(this),
            s.Core.updateItem(e.attr("data-cart-update"), e.attr("data-cart-quantity"))
        },
        inputUpdate: function(t) {
            var e;
            return t.preventDefault(),
            e = jQuery(this),
            s.Core.updateItem(e.attr("data-cart-input-update"), e.val())
        },
        updateById: function(t) {
            var e;
            return t.preventDefault(),
            e = jQuery(this),
            s.Core.updateItemById(e.attr("data-cart-update-id"), e.attr("data-cart-quantity"))
        },
        clear: function(t) {
            return t.preventDefault(),
            s.Core.clear()
        },
        toggle: function(t) {
            var e, i;
            return i = (e = jQuery(this)).attr("data-cart-toggle"),
            e.is(":checked") ? s.Core.addItem(i) : s.Core.removeItemById(i)
        },
        toggleAttribute: function(t) {
            var e, i;
            return i = (e = jQuery(this)).attr("data-cart-toggle-attribute"),
            s.Core.setAttribute(i, e.is(":checked") ? "Yes" : "")
        },
        submit: function(t) {
            var e, i, n, a;
            return t.preventDefault(),
            e = jQuery(this).serializeArray(),
            a = i = void 0,
            n = {},
            jQuery.each(e, function(t, e) {
                return "id" === e.name ? i = e.value : "quantity" === e.name ? a = e.value : e.name.match(/^properties\[\w+\]$/) ? n[e.name] = e.value : void 0
            }),
            s.Core.addItem(i, a, s.Utils.unwrapKeys(n))
        },
        render: function(t, e) {
            var i;
            return i = {
                item_count: e.item_count,
                total_price: e.total_price,
                total_price_money: s.Utils.formatMoney(e.total_price, s.settings.moneyFormat, "money_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0),
                total_price_money_with_currency: s.Utils.formatMoney(e.total_price, s.settings.moneyWithCurrencyFormat, "money_with_currency_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0)
            },
            jQuery("[data-cart-render]").each(function() {
                var t;
                return (t = jQuery(this)).html(i[t.attr("data-cart-render")])
            })
        }
    },
    "rivets"in window ? (s.Rivets = {
        model: null,
        boundViews: [],
        init: function() {
            return s.Rivets.bindViews()
        },
        destroy: function() {
            return s.Rivets.unbindViews()
        },
        bindViews: function() {
            return s.Utils.log("Rivets.js is present, binding views."),
            s.Rivets.unbindViews(),
            s.Rivets.model = s.Utils.extend({
                cart: s.cart
            }, s.settings.rivetsModels),
            null != window.Currency && (s.Rivets.model.Currency = window.Currency),
            jQuery("[data-cart-view]").each(function() {
                var t;
                return t = rivets.bind(jQuery(this), s.Rivets.model),
                s.Rivets.boundViews.push(t)
            })
        },
        unbindViews: function() {
            var t, e, i;
            for (t = 0,
            e = (i = s.Rivets.boundViews).length; t < e; t++)
                i[t].unbind();
            return s.Rivets.boundViews = []
        }
    },
    rivets.formatters.eq = function(t, e) {
        return t === e
    }
    ,
    rivets.formatters.includes = function(t, e) {
        return 0 <= t.indexOf(e)
    }
    ,
    rivets.formatters.match = function(t, e, i) {
        return t.match(new RegExp(e,i))
    }
    ,
    rivets.formatters.lt = function(t, e) {
        return t < e
    }
    ,
    rivets.formatters.gt = function(t, e) {
        return e < t
    }
    ,
    rivets.formatters.not = function(t) {
        return !t
    }
    ,
    rivets.formatters.empty = function(t) {
        return !t.length
    }
    ,
    rivets.formatters.plus = function(t, e) {
        return parseInt(t) + parseInt(e)
    }
    ,
    rivets.formatters.minus = function(t, e) {
        return parseInt(t) - parseInt(e)
    }
    ,
    rivets.formatters.times = function(t, e) {
        return t * e
    }
    ,
    rivets.formatters.divided_by = function(t, e) {
        return t / e
    }
    ,
    rivets.formatters.modulo = function(t, e) {
        return t % e
    }
    ,
    rivets.formatters.prepend = function(t, e) {
        return e + t
    }
    ,
    rivets.formatters.append = function(t, e) {
        return t + e
    }
    ,
    rivets.formatters.slice = function(t, e, i) {
        return t.slice(e, i)
    }
    ,
    rivets.formatters.pluralize = function(t, e, i) {
        return null == i && (i = e + "s"),
        s.Utils.isArray(t) && (t = t.length),
        1 === t ? e : i
    }
    ,
    rivets.formatters.array_element = function(t, e) {
        return t[e]
    }
    ,
    rivets.formatters.array_first = function(t) {
        return t[0]
    }
    ,
    rivets.formatters.array_last = function(t) {
        return t[t.length - 1]
    }
    ,
    rivets.formatters.money = function(t, e) {
        return s.Utils.formatMoney(t, s.settings.moneyFormat, "money_format", e)
    }
    ,
    rivets.formatters.money_with_currency = function(t, e) {
        return s.Utils.formatMoney(t, s.settings.moneyWithCurrencyFormat, "money_with_currency_format", e)
    }
    ,
    rivets.formatters.weight = function(t) {
        switch (s.settings.weightUnit) {
        case "kg":
            return (t / 1e3).toFixed(s.settings.weightPrecision);
        case "oz":
            return (.035274 * t).toFixed(s.settings.weightPrecision);
        case "lb":
            return (.00220462 * t).toFixed(s.settings.weightPrecision);
        default:
            return t.toFixed(s.settings.weightPrecision)
        }
    }
    ,
    rivets.formatters.weight_with_unit = function(t) {
        return rivets.formatters.weight(t) + s.settings.weightUnit
    }
    ,
    rivets.formatters.product_image_size = function(t, e) {
        return s.Utils.getSizedImageUrl(t, e)
    }
    ,
    rivets.formatters.moneyWithCurrency = rivets.formatters.money_with_currency,
    rivets.formatters.weightWithUnit = rivets.formatters.weight_with_unit,
    rivets.formatters.productImageSize = rivets.formatters.product_image_size) : s.Rivets = {
        init: function() {},
        destroy: function() {}
    },
    s.factory = function(t) {
        return t.init = s.init,
        t.configure = s.configure,
        t.cart = s.cart,
        t.settings = s.settings,
        t.getCart = s.Core.getCart,
        t.addItem = s.Core.addItem,
        t.updateItem = s.Core.updateItem,
        t.updateItemById = s.Core.updateItemById,
        t.updateItemQuantitiesById = s.Core.updateItemQuantitiesById,
        t.removeItem = s.Core.removeItem,
        t.removeItemById = s.Core.removeItemById,
        t.clear = s.Core.clear,
        t.getAttribute = s.Core.getAttribute,
        t.setAttribute = s.Core.setAttribute,
        t.getAttributes = s.Core.getAttributes,
        t.setAttributes = s.Core.setAttributes,
        t.clearAttributes = s.Core.clearAttributes,
        t.getNote = s.Core.getNote,
        t.setNote = s.Core.setNote,
        t.render = s.Data.render
    }
    ,
    "object" == typeof exports ? s.factory(exports) : "function" == typeof define && define.amd ? define(["exports"], function(t) {
        return s.factory(this.CartJS = t),
        t
    }) : s.factory(this.CartJS = {})
}
.call(this),
function(t) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], t) : t(jQuery)
}(function(a) {
    "use strict";
    var o = []
      , e = []
      , n = {
        precision: 100,
        elapse: !1,
        defer: !1
    };
    e.push(/^[0-9]*$/.source),
    e.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),
    e.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),
    e = new RegExp(e.join("|"));
    var h = {
        Y: "years",
        m: "months",
        n: "daysToMonth",
        d: "daysToWeek",
        w: "weeks",
        W: "weeksToMonth",
        H: "hours",
        M: "minutes",
        S: "seconds",
        D: "totalDays",
        I: "totalHours",
        N: "totalMinutes",
        T: "totalSeconds"
    };
    function f(t, e) {
        var i = "s"
          , n = "";
        return t && (i = 1 === (t = t.replace(/(:|;|\s)/gi, "").split(/\,/)).length ? t[0] : (n = t[0],
        t[1])),
        1 < Math.abs(e) ? i : n
    }
    function s(t, e, i) {
        this.el = t,
        this.$el = a(t),
        this.interval = null,
        this.offset = {},
        this.options = a.extend({}, n),
        this.instanceNumber = o.length,
        o.push(this),
        this.$el.data("countdown-instance", this.instanceNumber),
        i && ("function" == typeof i ? (this.$el.on("update.countdown", i),
        this.$el.on("stoped.countdown", i),
        this.$el.on("finish.countdown", i)) : this.options = a.extend({}, n, i)),
        this.setFinalDate(e),
        !1 === this.options.defer && this.start()
    }
    a.extend(s.prototype, {
        start: function() {
            null !== this.interval && clearInterval(this.interval);
            var t = this;
            this.update(),
            this.interval = setInterval(function() {
                t.update.call(t)
            }, this.options.precision)
        },
        stop: function() {
            clearInterval(this.interval),
            this.interval = null,
            this.dispatchEvent("stoped")
        },
        toggle: function() {
            this.interval ? this.stop() : this.start()
        },
        pause: function() {
            this.stop()
        },
        resume: function() {
            this.start()
        },
        remove: function() {
            this.stop.call(this),
            o[this.instanceNumber] = null,
            delete this.$el.data().countdownInstance
        },
        setFinalDate: function(t) {
            this.finalDate = function(t) {
                if (t instanceof Date)
                    return t;
                if (String(t).match(e))
                    return String(t).match(/^[0-9]*$/) && (t = Number(t)),
                    String(t).match(/\-/) && (t = String(t).replace(/\-/g, "/")),
                    new Date(t);
                throw new Error("Couldn't cast `" + t + "` to a date object.")
            }(t)
        },
        update: function() {
            if (0 !== this.$el.closest("html").length) {
                var t, e = void 0 !== a._data(this.el, "events"), i = new Date;
                t = this.finalDate.getTime() - i.getTime(),
                t = Math.ceil(t / 1e3),
                t = !this.options.elapse && t < 0 ? 0 : Math.abs(t),
                this.totalSecsLeft !== t && e && (this.totalSecsLeft = t,
                this.elapsed = i >= this.finalDate,
                this.offset = {
                    seconds: this.totalSecsLeft % 60,
                    minutes: Math.floor(this.totalSecsLeft / 60) % 60,
                    hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
                    days: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                    daysToWeek: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                    daysToMonth: Math.floor(this.totalSecsLeft / 60 / 60 / 24 % 30.4368),
                    weeks: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7),
                    weeksToMonth: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7) % 4,
                    months: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 30.4368),
                    years: Math.abs(this.finalDate.getFullYear() - i.getFullYear()),
                    totalDays: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
                    totalHours: Math.floor(this.totalSecsLeft / 60 / 60),
                    totalMinutes: Math.floor(this.totalSecsLeft / 60),
                    totalSeconds: this.totalSecsLeft
                },
                this.options.elapse || 0 !== this.totalSecsLeft ? this.dispatchEvent("update") : (this.stop(),
                this.dispatchEvent("finish")))
            } else
                this.remove()
        },
        dispatchEvent: function(t) {
            var e = a.Event(t + ".countdown");
            e.finalDate = this.finalDate,
            e.elapsed = this.elapsed,
            e.offset = a.extend({}, this.offset),
            e.strftime = function(d) {
                return function(t) {
                    var e, i, n = t.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);
                    if (n)
                        for (var a = 0, o = n.length; a < o; ++a) {
                            var s = n[a].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/)
                              , r = (e = s[0],
                            void 0,
                            i = e.toString().replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1"),
                            new RegExp(i))
                              , l = s[1] || ""
                              , c = s[3] || ""
                              , u = null;
                            s = s[2],
                            h.hasOwnProperty(s) && (u = h[s],
                            u = Number(d[u])),
                            null !== u && ("!" === l && (u = f(c, u)),
                            "" === l && u < 10 && (u = "0" + u.toString()),
                            t = t.replace(r, u.toString()))
                        }
                    return t = t.replace(/%%/, "%")
                }
            }(this.offset),
            this.$el.trigger(e)
        }
    }),
    a.fn.countdown = function() {
        var n = Array.prototype.slice.call(arguments, 0);
        return this.each(function() {
            var t = a(this).data("countdown-instance");
            if (void 0 !== t) {
                var e = o[t]
                  , i = n[0];
                s.prototype.hasOwnProperty(i) ? e[i].apply(e, n.slice(1)) : null === String(i).match(/^[$A-Z_][0-9A-Z_$]*$/i) ? (e.setFinalDate.call(e, i),
                e.start()) : a.error("Method %s does not exist on jQuery.countdown".replace(/\%s/gi, i))
            } else
                new s(this,n[0],n[1])
        })
    }
}),
function(t) {
    if ("function" == typeof define && define.amd)
        define(t);
    else if ("object" == typeof exports)
        module.exports = t();
    else {
        var e = window.Cookies
          , i = window.Cookies = t();
        i.noConflict = function() {
            return window.Cookies = e,
            i
        }
    }
}(function() {
    function f() {
        for (var t = 0, e = {}; t < arguments.length; t++) {
            var i = arguments[t];
            for (var n in i)
                e[n] = i[n]
        }
        return e
    }
    return function t(d) {
        function h(t, e, i) {
            var n;
            if ("undefined" != typeof document) {
                if (1 < arguments.length) {
                    if ("number" == typeof (i = f({
                        path: "/"
                    }, h.defaults, i)).expires) {
                        var a = new Date;
                        a.setMilliseconds(a.getMilliseconds() + 864e5 * i.expires),
                        i.expires = a
                    }
                    try {
                        n = JSON.stringify(e),
                        /^[\{\[]/.test(n) && (e = n)
                    } catch (t) {}
                    return e = d.write ? d.write(e, t) : encodeURIComponent(String(e)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent),
                    t = (t = (t = encodeURIComponent(String(t))).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)).replace(/[\(\)]/g, escape),
                    document.cookie = [t, "=", e, i.expires && "; expires=" + i.expires.toUTCString(), i.path && "; path=" + i.path, i.domain && "; domain=" + i.domain, i.secure ? "; secure" : ""].join("")
                }
                t || (n = {});
                for (var o = document.cookie ? document.cookie.split("; ") : [], s = /(%[0-9A-Z]{2})+/g, r = 0; r < o.length; r++) {
                    var l = o[r].split("=")
                      , c = l.slice(1).join("=");
                    '"' === c.charAt(0) && (c = c.slice(1, -1));
                    try {
                        var u = l[0].replace(s, decodeURIComponent);
                        if (c = d.read ? d.read(c, u) : d(c, u) || c.replace(s, decodeURIComponent),
                        this.json)
                            try {
                                c = JSON.parse(c)
                            } catch (t) {}
                        if (t === u) {
                            n = c;
                            break
                        }
                        t || (n[u] = c)
                    } catch (t) {}
                }
                return n
            }
        }
        return (h.set = h).get = function(t) {
            return h(t)
        }
        ,
        h.getJSON = function() {
            return h.apply({
                json: !0
            }, [].slice.call(arguments))
        }
        ,
        h.defaults = {},
        h.remove = function(t, e) {
            h(t, "", f(e, {
                expires: -1
            }))
        }
        ,
        h.withConverter = t,
        h
    }(function() {})
}),
function(t) {
    "function" == typeof define && define.amd ? define(["jquery"], t) : t("object" == typeof exports ? require("jquery") : window.jQuery || window.Zepto)
}(function(u) {
    function t() {}
    function d(t, e) {
        m.ev.on("mfp" + t + A, e)
    }
    function h(t, e, i, n) {
        var a = document.createElement("div");
        return a.className = "mfp-" + t,
        i && (a.innerHTML = i),
        n ? e && e.appendChild(a) : (a = u(a),
        e && a.appendTo(e)),
        a
    }
    function f(t, e) {
        m.ev.triggerHandler("mfp" + t, e),
        m.st.callbacks && (t = t.charAt(0).toLowerCase() + t.slice(1),
        m.st.callbacks[t] && m.st.callbacks[t].apply(m, u.isArray(e) ? e : [e]))
    }
    function p(t) {
        return t === e && m.currTemplate.closeBtn || (m.currTemplate.closeBtn = u(m.st.closeMarkup.replace("%title%", m.st.tClose)),
        e = t),
        m.currTemplate.closeBtn
    }
    function o() {
        u.magnificPopup.instance || ((m = new t).init(),
        u.magnificPopup.instance = m)
    }
    var m, n, g, a, y, e, l = "Close", c = "BeforeClose", v = "MarkupParse", b = "Open", A = ".mfp", w = "mfp-ready", i = "mfp-removing", s = "mfp-prevent-close", r = !!window.jQuery, S = u(window);
    t.prototype = {
        constructor: t,
        init: function() {
            var t = navigator.appVersion;
            m.isIE7 = -1 !== t.indexOf("MSIE 7."),
            m.isIE8 = -1 !== t.indexOf("MSIE 8."),
            m.isLowIE = m.isIE7 || m.isIE8,
            m.isAndroid = /android/gi.test(t),
            m.isIOS = /iphone|ipad|ipod/gi.test(t),
            m.supportsTransition = function() {
                var t = document.createElement("p").style
                  , e = ["ms", "O", "Moz", "Webkit"];
                if (void 0 !== t.transition)
                    return !0;
                for (; e.length; )
                    if (e.pop() + "Transition"in t)
                        return !0;
                return !1
            }(),
            m.probablyMobile = m.isAndroid || m.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent),
            g = u(document),
            m.popupsCache = {}
        },
        open: function(t) {
            var e;
            if (!1 === t.isObj) {
                m.items = t.items.toArray(),
                m.index = 0;
                var i, n = t.items;
                for (e = 0; e < n.length; e++)
                    if ((i = n[e]).parsed && (i = i.el[0]),
                    i === t.el[0]) {
                        m.index = e;
                        break
                    }
            } else
                m.items = u.isArray(t.items) ? t.items : [t.items],
                m.index = t.index || 0;
            if (!m.isOpen) {
                m.types = [],
                y = "",
                m.ev = t.mainEl && t.mainEl.length ? t.mainEl.eq(0) : g,
                t.key ? (m.popupsCache[t.key] || (m.popupsCache[t.key] = {}),
                m.currTemplate = m.popupsCache[t.key]) : m.currTemplate = {},
                m.st = u.extend(!0, {}, u.magnificPopup.defaults, t),
                m.fixedContentPos = "auto" === m.st.fixedContentPos ? !m.probablyMobile : m.st.fixedContentPos,
                m.st.modal && (m.st.closeOnContentClick = !1,
                m.st.closeOnBgClick = !1,
                m.st.showCloseBtn = !1,
                m.st.enableEscapeKey = !1),
                m.bgOverlay || (m.bgOverlay = h("bg").on("click" + A, function() {
                    m.close()
                }),
                m.wrap = h("wrap").attr("tabindex", -1).on("click" + A, function(t) {
                    m._checkIfClose(t.target) && m.close()
                }),
                m.container = h("container", m.wrap)),
                m.contentContainer = h("content"),
                m.st.preloader && (m.preloader = h("preloader", m.container, m.st.tLoading));
                var a = u.magnificPopup.modules;
                for (e = 0; e < a.length; e++) {
                    var o = a[e];
                    o = o.charAt(0).toUpperCase() + o.slice(1),
                    m["init" + o].call(m)
                }
                f("BeforeOpen"),
                m.st.showCloseBtn && (m.st.closeBtnInside ? (d(v, function(t, e, i, n) {
                    i.close_replaceWith = p(n.type)
                }),
                y += " mfp-close-btn-in") : m.wrap.append(p())),
                m.st.alignTop && (y += " mfp-align-top"),
                m.wrap.css(m.fixedContentPos ? {
                    overflow: m.st.overflowY,
                    overflowX: "hidden",
                    overflowY: m.st.overflowY
                } : {
                    top: S.scrollTop(),
                    position: "absolute"
                }),
                !1 !== m.st.fixedBgPos && ("auto" !== m.st.fixedBgPos || m.fixedContentPos) || m.bgOverlay.css({
                    height: g.height(),
                    position: "absolute"
                }),
                m.st.enableEscapeKey && g.on("keyup" + A, function(t) {
                    27 === t.keyCode && m.close()
                }),
                S.on("resize" + A, function() {
                    m.updateSize()
                }),
                m.st.closeOnContentClick || (y += " mfp-auto-cursor"),
                y && m.wrap.addClass(y);
                var s = m.wH = S.height()
                  , r = {};
                if (m.fixedContentPos && m._hasScrollBar(s)) {
                    var l = m._getScrollbarSize();
                    l && (r.marginRight = l)
                }
                m.fixedContentPos && (m.isIE7 ? u("body, html").css("overflow", "hidden") : r.overflow = "hidden");
                var c = m.st.mainClass;
                return m.isIE7 && (c += " mfp-ie7"),
                c && m._addClassToMFP(c),
                m.updateItemHTML(),
                f("BuildControls"),
                u("html").css(r),
                m.bgOverlay.add(m.wrap).prependTo(m.st.prependTo || u(document.body)),
                m._lastFocusedEl = document.activeElement,
                setTimeout(function() {
                    m.content ? (m._addClassToMFP(w),
                    m._setFocus()) : m.bgOverlay.addClass(w),
                    g.on("focusin" + A, m._onFocusIn)
                }, 16),
                m.isOpen = !0,
                m.updateSize(s),
                f(b),
                t
            }
            m.updateItemHTML()
        },
        close: function() {
            m.isOpen && (f(c),
            m.isOpen = !1,
            m.st.removalDelay && !m.isLowIE && m.supportsTransition ? (m._addClassToMFP(i),
            setTimeout(function() {
                m._close()
            }, m.st.removalDelay)) : m._close())
        },
        _close: function() {
            f(l);
            var t = i + " " + w + " ";
            if (m.bgOverlay.detach(),
            m.wrap.detach(),
            m.container.empty(),
            m.st.mainClass && (t += m.st.mainClass + " "),
            m._removeClassFromMFP(t),
            m.fixedContentPos) {
                var e = {
                    marginRight: ""
                };
                m.isIE7 ? u("body, html").css("overflow", "") : e.overflow = "",
                u("html").css(e)
            }
            g.off("keyup.mfp focusin" + A),
            m.ev.off(A),
            m.wrap.attr("class", "mfp-wrap").removeAttr("style"),
            m.bgOverlay.attr("class", "mfp-bg"),
            m.container.attr("class", "mfp-container"),
            !m.st.showCloseBtn || m.st.closeBtnInside && !0 !== m.currTemplate[m.currItem.type] || m.currTemplate.closeBtn && m.currTemplate.closeBtn.detach(),
            m._lastFocusedEl && u(m._lastFocusedEl).focus(),
            m.currItem = null,
            m.content = null,
            m.currTemplate = null,
            m.prevHeight = 0,
            f("AfterClose")
        },
        updateSize: function(t) {
            if (m.isIOS) {
                var e = document.documentElement.clientWidth / window.innerWidth
                  , i = window.innerHeight * e;
                m.wrap.css("height", i),
                m.wH = i
            } else
                m.wH = t || S.height();
            m.fixedContentPos || m.wrap.css("height", m.wH),
            f("Resize")
        },
        updateItemHTML: function() {
            var t = m.items[m.index];
            m.contentContainer.detach(),
            m.content && m.content.detach(),
            t.parsed || (t = m.parseEl(m.index));
            var e = t.type;
            if (f("BeforeChange", [m.currItem ? m.currItem.type : "", e]),
            m.currItem = t,
            !m.currTemplate[e]) {
                var i = !!m.st[e] && m.st[e].markup;
                f("FirstMarkupParse", i),
                m.currTemplate[e] = !i || u(i)
            }
            a && a !== t.type && m.container.removeClass("mfp-" + a + "-holder");
            var n = m["get" + e.charAt(0).toUpperCase() + e.slice(1)](t, m.currTemplate[e]);
            m.appendContent(n, e),
            t.preloaded = !0,
            f("Change", t),
            a = t.type,
            m.container.prepend(m.contentContainer),
            f("AfterChange")
        },
        appendContent: function(t, e) {
            (m.content = t) ? m.st.showCloseBtn && m.st.closeBtnInside && !0 === m.currTemplate[e] ? m.content.find(".mfp-close").length || m.content.append(p()) : m.content = t : m.content = "",
            f("BeforeAppend"),
            m.container.addClass("mfp-" + e + "-holder"),
            m.contentContainer.append(m.content)
        },
        parseEl: function(t) {
            var e, i = m.items[t];
            if ((i = i.tagName ? {
                el: u(i)
            } : (e = i.type,
            {
                data: i,
                src: i.src
            })).el) {
                for (var n = m.types, a = 0; a < n.length; a++)
                    if (i.el.hasClass("mfp-" + n[a])) {
                        e = n[a];
                        break
                    }
                i.src = i.el.attr("data-mfp-src"),
                i.src || (i.src = i.el.attr("href"))
            }
            return i.type = e || m.st.type || "inline",
            i.index = t,
            i.parsed = !0,
            m.items[t] = i,
            f("ElementParse", i),
            m.items[t]
        },
        addGroup: function(e, i) {
            function t(t) {
                t.mfpEl = this,
                m._openClick(t, e, i)
            }
            i || (i = {});
            var n = "click.magnificPopup";
            i.mainEl = e,
            i.items ? (i.isObj = !0,
            e.off(n).on(n, t)) : (i.isObj = !1,
            i.delegate ? e.off(n).on(n, i.delegate, t) : (i.items = e).off(n).on(n, t))
        },
        _openClick: function(t, e, i) {
            if ((void 0 !== i.midClick ? i.midClick : u.magnificPopup.defaults.midClick) || 2 !== t.which && !t.ctrlKey && !t.metaKey) {
                var n = void 0 !== i.disableOn ? i.disableOn : u.magnificPopup.defaults.disableOn;
                if (n)
                    if (u.isFunction(n)) {
                        if (!n.call(m))
                            return !0
                    } else if (S.width() < n)
                        return !0;
                t.type && (t.preventDefault(),
                m.isOpen && t.stopPropagation()),
                i.el = u(t.mfpEl),
                i.delegate && (i.items = e.find(i.delegate)),
                m.open(i)
            }
        },
        updateStatus: function(t, e) {
            if (m.preloader) {
                n !== t && m.container.removeClass("mfp-s-" + n),
                e || "loading" !== t || (e = m.st.tLoading);
                var i = {
                    status: t,
                    text: e
                };
                f("UpdateStatus", i),
                t = i.status,
                e = i.text,
                m.preloader.html(e),
                m.preloader.find("a").on("click", function(t) {
                    t.stopImmediatePropagation()
                }),
                m.container.addClass("mfp-s-" + t),
                n = t
            }
        },
        _checkIfClose: function(t) {
            if (!u(t).hasClass(s)) {
                var e = m.st.closeOnContentClick
                  , i = m.st.closeOnBgClick;
                if (e && i)
                    return !0;
                if (!m.content || u(t).hasClass("mfp-close") || m.preloader && t === m.preloader[0])
                    return !0;
                if (t === m.content[0] || u.contains(m.content[0], t)) {
                    if (e)
                        return !0
                } else if (i && u.contains(document, t))
                    return !0;
                return !1
            }
        },
        _addClassToMFP: function(t) {
            m.bgOverlay.addClass(t),
            m.wrap.addClass(t)
        },
        _removeClassFromMFP: function(t) {
            this.bgOverlay.removeClass(t),
            m.wrap.removeClass(t)
        },
        _hasScrollBar: function(t) {
            return (m.isIE7 ? g.height() : document.body.scrollHeight) > (t || S.height())
        },
        _setFocus: function() {
            (m.st.focus ? m.content.find(m.st.focus).eq(0) : m.wrap).focus()
        },
        _onFocusIn: function(t) {
            return t.target === m.wrap[0] || u.contains(m.wrap[0], t.target) ? void 0 : (m._setFocus(),
            !1)
        },
        _parseMarkup: function(a, t, e) {
            var o;
            e.data && (t = u.extend(e.data, t)),
            f(v, [a, t, e]),
            u.each(t, function(t, e) {
                if (void 0 === e || !1 === e)
                    return !0;
                if (1 < (o = t.split("_")).length) {
                    var i = a.find(A + "-" + o[0]);
                    if (0 < i.length) {
                        var n = o[1];
                        "replaceWith" === n ? i[0] !== e[0] && i.replaceWith(e) : "img" === n ? i.is("img") ? i.attr("src", e) : i.replaceWith('<img src="' + e + '" class="' + i.attr("class") + '" />') : i.attr(o[1], e)
                    }
                } else
                    a.find(A + "-" + t).html(e)
            })
        },
        _getScrollbarSize: function() {
            if (void 0 === m.scrollbarSize) {
                var t = document.createElement("div");
                t.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",
                document.body.appendChild(t),
                m.scrollbarSize = t.offsetWidth - t.clientWidth,
                document.body.removeChild(t)
            }
            return m.scrollbarSize
        }
    },
    u.magnificPopup = {
        instance: null,
        proto: t.prototype,
        modules: [],
        open: function(t, e) {
            return o(),
            (t = t ? u.extend(!0, {}, t) : {}).isObj = !0,
            t.index = e || 0,
            this.instance.open(t)
        },
        close: function() {
            return u.magnificPopup.instance && u.magnificPopup.instance.close()
        },
        registerModule: function(t, e) {
            e.options && (u.magnificPopup.defaults[t] = e.options),
            u.extend(this.proto, e.proto),
            this.modules.push(t)
        },
        defaults: {
            disableOn: 0,
            key: null,
            midClick: !1,
            mainClass: "",
            preloader: !0,
            focus: "",
            closeOnContentClick: !1,
            closeOnBgClick: !0,
            closeBtnInside: !0,
            showCloseBtn: !0,
            enableEscapeKey: !0,
            modal: !1,
            alignTop: !1,
            removalDelay: 0,
            prependTo: null,
            fixedContentPos: "auto",
            fixedBgPos: "auto",
            overflowY: "auto",
            closeMarkup: '<button title="%title%" type="button" class="mfp-close">&times;</button>',
            tClose: "Close (Esc)",
            tLoading: "Loading..."
        }
    },
    u.fn.magnificPopup = function(t) {
        o();
        var e = u(this);
        if ("string" == typeof t)
            if ("open" === t) {
                var i, n = r ? e.data("magnificPopup") : e[0].magnificPopup, a = parseInt(arguments[1], 10) || 0;
                i = n.items ? n.items[a] : (i = e,
                n.delegate && (i = i.find(n.delegate)),
                i.eq(a)),
                m._openClick({
                    mfpEl: i
                }, e, n)
            } else
                m.isOpen && m[t].apply(m, Array.prototype.slice.call(arguments, 1));
        else
            t = u.extend(!0, {}, t),
            r ? e.data("magnificPopup", t) : e[0].magnificPopup = t,
            m.addGroup(e, t);
        return e
    }
    ;
    function C() {
        M && (k.after(M.addClass(T)).detach(),
        M = null)
    }
    var T, k, M, x = "inline";
    u.magnificPopup.registerModule(x, {
        options: {
            hiddenClass: "hide",
            markup: "",
            tNotFound: "Content not found"
        },
        proto: {
            initInline: function() {
                m.types.push(x),
                d(l + "." + x, function() {
                    C()
                })
            },
            getInline: function(t, e) {
                if (C(),
                t.src) {
                    var i = m.st.inline
                      , n = u(t.src);
                    if (n.length) {
                        var a = n[0].parentNode;
                        a && a.tagName && (k || (T = i.hiddenClass,
                        k = h(T),
                        T = "mfp-" + T),
                        M = n.after(k).detach().removeClass(T)),
                        m.updateStatus("ready")
                    } else
                        m.updateStatus("error", i.tNotFound),
                        n = u("<div>");
                    return t.inlineElement = n
                }
                return m.updateStatus("ready"),
                m._parseMarkup(e, {}, t),
                e
            }
        }
    });
    function _() {
        E && u(document.body).removeClass(E)
    }
    function P() {
        _(),
        m.req && m.req.abort()
    }
    var E, O = "ajax";
    u.magnificPopup.registerModule(O, {
        options: {
            settings: null,
            cursor: "mfp-ajax-cur",
            tError: '<a href="%url%">The content</a> could not be loaded.'
        },
        proto: {
            initAjax: function() {
                m.types.push(O),
                E = m.st.ajax.cursor,
                d(l + "." + O, P),
                d("BeforeChange." + O, P)
            },
            getAjax: function(a) {
                E && u(document.body).addClass(E),
                m.updateStatus("loading");
                var t = u.extend({
                    url: a.src,
                    success: function(t, e, i) {
                        var n = {
                            data: t,
                            xhr: i
                        };
                        f("ParseAjax", n),
                        m.appendContent(u(n.data), O),
                        a.finished = !0,
                        _(),
                        m._setFocus(),
                        setTimeout(function() {
                            m.wrap.addClass(w)
                        }, 16),
                        m.updateStatus("ready"),
                        f("AjaxContentAdded")
                    },
                    error: function() {
                        _(),
                        a.finished = a.loadError = !0,
                        m.updateStatus("error", m.st.ajax.tError.replace("%url%", a.src))
                    }
                }, m.st.ajax.settings);
                return m.req = u.ajax(t),
                ""
            }
        }
    });
    var D;
    u.magnificPopup.registerModule("image", {
        options: {
            markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
            cursor: "mfp-zoom-out-cur",
            titleSrc: "title",
            verticalFit: !0,
            tError: '<a href="%url%">The image</a> could not be loaded.'
        },
        proto: {
            initImage: function() {
                var t = m.st.image
                  , e = ".image";
                m.types.push("image"),
                d(b + e, function() {
                    "image" === m.currItem.type && t.cursor && u(document.body).addClass(t.cursor)
                }),
                d(l + e, function() {
                    t.cursor && u(document.body).removeClass(t.cursor),
                    S.off("resize" + A)
                }),
                d("Resize" + e, m.resizeImage),
                m.isLowIE && d("AfterChange", m.resizeImage)
            },
            resizeImage: function() {
                var t = m.currItem;
                if (t && t.img && m.st.image.verticalFit) {
                    var e = 0;
                    m.isLowIE && (e = parseInt(t.img.css("padding-top"), 10) + parseInt(t.img.css("padding-bottom"), 10)),
                    t.img.css("max-height", m.wH - e)
                }
            },
            _onImageHasSize: function(t) {
                t.img && (t.hasSize = !0,
                D && clearInterval(D),
                t.isCheckingImgSize = !1,
                f("ImageHasSize", t),
                t.imgHidden && (m.content && m.content.removeClass("mfp-loading"),
                t.imgHidden = !1))
            },
            findImageSize: function(e) {
                var i = 0
                  , n = e.img[0]
                  , a = function(t) {
                    D && clearInterval(D),
                    D = setInterval(function() {
                        return 0 < n.naturalWidth ? void m._onImageHasSize(e) : (200 < i && clearInterval(D),
                        void (3 === ++i ? a(10) : 40 === i ? a(50) : 100 === i && a(500)))
                    }, t)
                };
                a(1)
            },
            getImage: function(t, e) {
                var i = 0
                  , n = function() {
                    t && (t.img[0].complete ? (t.img.off(".mfploader"),
                    t === m.currItem && (m._onImageHasSize(t),
                    m.updateStatus("ready")),
                    t.hasSize = !0,
                    t.loaded = !0,
                    f("ImageLoadComplete")) : ++i < 200 ? setTimeout(n, 100) : a())
                }
                  , a = function() {
                    t && (t.img.off(".mfploader"),
                    t === m.currItem && (m._onImageHasSize(t),
                    m.updateStatus("error", o.tError.replace("%url%", t.src))),
                    t.hasSize = !0,
                    t.loaded = !0,
                    t.loadError = !0)
                }
                  , o = m.st.image
                  , s = e.find(".mfp-img");
                if (s.length) {
                    var r = document.createElement("img");
                    r.className = "mfp-img",
                    t.el && t.el.find("img").length && (r.alt = t.el.find("img").attr("alt")),
                    t.img = u(r).on("load.mfploader", n).on("error.mfploader", a),
                    r.src = t.src,
                    s.is("img") && (t.img = t.img.clone()),
                    0 < (r = t.img[0]).naturalWidth ? t.hasSize = !0 : r.width || (t.hasSize = !1)
                }
                return m._parseMarkup(e, {
                    title: function(t) {
                        if (t.data && void 0 !== t.data.title)
                            return t.data.title;
                        var e = m.st.image.titleSrc;
                        if (e) {
                            if (u.isFunction(e))
                                return e.call(m, t);
                            if (t.el)
                                return t.el.attr(e) || ""
                        }
                        return ""
                    }(t),
                    img_replaceWith: t.img
                }, t),
                m.resizeImage(),
                t.hasSize ? (D && clearInterval(D),
                t.loadError ? (e.addClass("mfp-loading"),
                m.updateStatus("error", o.tError.replace("%url%", t.src))) : (e.removeClass("mfp-loading"),
                m.updateStatus("ready"))) : (m.updateStatus("loading"),
                t.loading = !0,
                t.hasSize || (t.imgHidden = !0,
                e.addClass("mfp-loading"),
                m.findImageSize(t))),
                e
            }
        }
    });
    var I;
    u.magnificPopup.registerModule("zoom", {
        options: {
            enabled: !1,
            easing: "ease-in-out",
            duration: 300,
            opener: function(t) {
                return t.is("img") ? t : t.find("img")
            }
        },
        proto: {
            initZoom: function() {
                var t, o = m.st.zoom, e = ".zoom";
                if (o.enabled && m.supportsTransition) {
                    function i(t) {
                        var e = t.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image")
                          , i = "all " + o.duration / 1e3 + "s " + o.easing
                          , n = {
                            position: "fixed",
                            zIndex: 9999,
                            left: 0,
                            top: 0,
                            "-webkit-backface-visibility": "hidden"
                        }
                          , a = "transition";
                        return n["-webkit-" + a] = n["-moz-" + a] = n["-o-" + a] = n[a] = i,
                        e.css(n),
                        e
                    }
                    function n() {
                        m.content.css("visibility", "visible")
                    }
                    var a, s, r = o.duration;
                    d("BuildControls" + e, function() {
                        if (m._allowZoom()) {
                            if (clearTimeout(a),
                            m.content.css("visibility", "hidden"),
                            !(t = m._getItemToZoom()))
                                return void n();
                            (s = i(t)).css(m._getOffset()),
                            m.wrap.append(s),
                            a = setTimeout(function() {
                                s.css(m._getOffset(!0)),
                                a = setTimeout(function() {
                                    n(),
                                    setTimeout(function() {
                                        s.remove(),
                                        t = s = null,
                                        f("ZoomAnimationEnded")
                                    }, 16)
                                }, r)
                            }, 16)
                        }
                    }),
                    d(c + e, function() {
                        if (m._allowZoom()) {
                            if (clearTimeout(a),
                            m.st.removalDelay = r,
                            !t) {
                                if (!(t = m._getItemToZoom()))
                                    return;
                                s = i(t)
                            }
                            s.css(m._getOffset(!0)),
                            m.wrap.append(s),
                            m.content.css("visibility", "hidden"),
                            setTimeout(function() {
                                s.css(m._getOffset())
                            }, 16)
                        }
                    }),
                    d(l + e, function() {
                        m._allowZoom() && (n(),
                        s && s.remove(),
                        t = null)
                    })
                }
            },
            _allowZoom: function() {
                return "image" === m.currItem.type
            },
            _getItemToZoom: function() {
                return !!m.currItem.hasSize && m.currItem.img
            },
            _getOffset: function(t) {
                var e, i = (e = t ? m.currItem.img : m.st.zoom.opener(m.currItem.el || m.currItem)).offset(), n = parseInt(e.css("padding-top"), 10), a = parseInt(e.css("padding-bottom"), 10);
                i.top -= u(window).scrollTop() - n;
                var o = {
                    width: e.width(),
                    height: (r ? e.innerHeight() : e[0].offsetHeight) - a - n
                };
                return void 0 === I && (I = void 0 !== document.createElement("p").style.MozTransform),
                I ? o["-moz-transform"] = o.transform = "translate(" + i.left + "px," + i.top + "px)" : (o.left = i.left,
                o.top = i.top),
                o
            }
        }
    });
    function N(t) {
        if (m.currTemplate[z]) {
            var e = m.currTemplate[z].find("iframe");
            e.length && (t || (e[0].src = "//about:blank"),
            m.isIE8 && e.css("display", t ? "block" : "none"))
        }
    }
    var z = "iframe";
    u.magnificPopup.registerModule(z, {
        options: {
            markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
            srcAction: "iframe_src",
            patterns: {
                youtube: {
                    index: "youtube.com",
                    id: "v=",
                    src: "//www.youtube.com/embed/%id%?autoplay=1"
                },
                vimeo: {
                    index: "vimeo.com/",
                    id: "/",
                    src: "//player.vimeo.com/video/%id%?autoplay=1"
                },
                gmaps: {
                    index: "//maps.google.",
                    src: "%id%&output=embed"
                }
            }
        },
        proto: {
            initIframe: function() {
                m.types.push(z),
                d("BeforeChange", function(t, e, i) {
                    e !== i && (e === z ? N() : i === z && N(!0))
                }),
                d(l + "." + z, function() {
                    N()
                })
            },
            getIframe: function(t, e) {
                var i = t.src
                  , n = m.st.iframe;
                u.each(n.patterns, function() {
                    return -1 < i.indexOf(this.index) ? (this.id && (i = "string" == typeof this.id ? i.substr(i.lastIndexOf(this.id) + this.id.length, i.length) : this.id.call(this, i)),
                    i = this.src.replace("%id%", i),
                    !1) : void 0
                });
                var a = {};
                return n.srcAction && (a[n.srcAction] = i),
                m._parseMarkup(e, a, t),
                m.updateStatus("ready"),
                e
            }
        }
    });
    function B(t) {
        var e = m.items.length;
        return e - 1 < t ? t - e : t < 0 ? e + t : t
    }
    function L(t, e, i) {
        return t.replace(/%curr%/gi, e + 1).replace(/%total%/gi, i)
    }
    u.magnificPopup.registerModule("gallery", {
        options: {
            enabled: !1,
            arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
            preload: [0, 2],
            navigateByImgClick: !0,
            arrows: !0,
            tPrev: "Previous (Left arrow key)",
            tNext: "Next (Right arrow key)",
            tCounter: "%curr% of %total%"
        },
        proto: {
            initGallery: function() {
                var o = m.st.gallery
                  , t = ".mfp-gallery"
                  , a = Boolean(u.fn.mfpFastClick);
                return m.direction = !0,
                !(!o || !o.enabled) && (y += " mfp-gallery",
                d(b + t, function() {
                    o.navigateByImgClick && m.wrap.on("click" + t, ".mfp-img", function() {
                        return 1 < m.items.length ? (m.next(),
                        !1) : void 0
                    }),
                    g.on("keydown" + t, function(t) {
                        37 === t.keyCode ? m.prev() : 39 === t.keyCode && m.next()
                    })
                }),
                d("UpdateStatus" + t, function(t, e) {
                    e.text && (e.text = L(e.text, m.currItem.index, m.items.length))
                }),
                d(v + t, function(t, e, i, n) {
                    var a = m.items.length;
                    i.counter = 1 < a ? L(o.tCounter, n.index, a) : ""
                }),
                d("BuildControls" + t, function() {
                    if (1 < m.items.length && o.arrows && !m.arrowLeft) {
                        var t = o.arrowMarkup
                          , e = m.arrowLeft = u(t.replace(/%title%/gi, o.tPrev).replace(/%dir%/gi, "left")).addClass(s)
                          , i = m.arrowRight = u(t.replace(/%title%/gi, o.tNext).replace(/%dir%/gi, "right")).addClass(s)
                          , n = a ? "mfpFastClick" : "click";
                        e[n](function() {
                            m.prev()
                        }),
                        i[n](function() {
                            m.next()
                        }),
                        m.isIE7 && (h("b", e[0], !1, !0),
                        h("a", e[0], !1, !0),
                        h("b", i[0], !1, !0),
                        h("a", i[0], !1, !0)),
                        m.container.append(e.add(i))
                    }
                }),
                d("Change" + t, function() {
                    m._preloadTimeout && clearTimeout(m._preloadTimeout),
                    m._preloadTimeout = setTimeout(function() {
                        m.preloadNearbyImages(),
                        m._preloadTimeout = null
                    }, 16)
                }),
                void d(l + t, function() {
                    g.off(t),
                    m.wrap.off("click" + t),
                    m.arrowLeft && a && m.arrowLeft.add(m.arrowRight).destroyMfpFastClick(),
                    m.arrowRight = m.arrowLeft = null
                }))
            },
            next: function() {
                m.direction = !0,
                m.index = B(m.index + 1),
                m.updateItemHTML()
            },
            prev: function() {
                m.direction = !1,
                m.index = B(m.index - 1),
                m.updateItemHTML()
            },
            goTo: function(t) {
                m.direction = t >= m.index,
                m.index = t,
                m.updateItemHTML()
            },
            preloadNearbyImages: function() {
                var t, e = m.st.gallery.preload, i = Math.min(e[0], m.items.length), n = Math.min(e[1], m.items.length);
                for (t = 1; t <= (m.direction ? n : i); t++)
                    m._preloadItem(m.index + t);
                for (t = 1; t <= (m.direction ? i : n); t++)
                    m._preloadItem(m.index - t)
            },
            _preloadItem: function(t) {
                if (t = B(t),
                !m.items[t].preloaded) {
                    var e = m.items[t];
                    e.parsed || (e = m.parseEl(t)),
                    f("LazyLoad", e),
                    "image" === e.type && (e.img = u('<img class="mfp-img" />').on("load.mfploader", function() {
                        e.hasSize = !0
                    }).on("error.mfploader", function() {
                        e.hasSize = !0,
                        e.loadError = !0,
                        f("LazyLoadError", e)
                    }).attr("src", e.src)),
                    e.preloaded = !0
                }
            }
        }
    });
    var R, W, F = "retina";
    function j() {
        S.off("touchmove" + W + " touchend" + W)
    }
    u.magnificPopup.registerModule(F, {
        options: {
            replaceSrc: function(t) {
                return t.src.replace(/\.\w+$/, function(t) {
                    return "@2x" + t
                })
            },
            ratio: 1
        },
        proto: {
            initRetina: function() {
                if (1 < window.devicePixelRatio) {
                    var i = m.st.retina
                      , n = i.ratio;
                    1 < (n = isNaN(n) ? n() : n) && (d("ImageHasSize." + F, function(t, e) {
                        e.img.css({
                            "max-width": e.img[0].naturalWidth / n,
                            width: "100%"
                        })
                    }),
                    d("ElementParse." + F, function(t, e) {
                        e.src = i.replaceSrc(e, n)
                    }))
                }
            }
        }
    }),
    R = "ontouchstart"in window,
    W = ".mfpFastClick",
    u.fn.mfpFastClick = function(l) {
        return u(this).each(function() {
            var e, i, n, a, o, s, r, t = u(this);
            R && t.on("touchstart" + W, function(t) {
                o = !1,
                r = 1,
                s = t.originalEvent ? t.originalEvent.touches[0] : t.touches[0],
                n = s.clientX,
                a = s.clientY,
                S.on("touchmove" + W, function(t) {
                    s = t.originalEvent ? t.originalEvent.touches : t.touches,
                    r = s.length,
                    s = s[0],
                    (10 < Math.abs(s.clientX - n) || 10 < Math.abs(s.clientY - a)) && (o = !0,
                    j())
                }).on("touchend" + W, function(t) {
                    j(),
                    o || 1 < r || (e = !0,
                    t.preventDefault(),
                    clearTimeout(i),
                    i = setTimeout(function() {
                        e = !1
                    }, 1e3),
                    l())
                })
            }),
            t.on("click" + W, function() {
                e || l()
            })
        })
    }
    ,
    u.fn.destroyMfpFastClick = function() {
        u(this).off("touchstart" + W + " click" + W),
        R && S.off("touchmove" + W + " touchend" + W)
    }
    ,
    o()
}),
function(e, i) {
    "function" == typeof define && define.amd ? define("jquery-bridget/jquery-bridget", ["jquery"], function(t) {
        return i(e, t)
    }) : "object" == typeof module && module.exports ? module.exports = i(e, require("jquery")) : e.jQueryBridget = i(e, e.jQuery)
}(window, function(t, e) {
    "use strict";
    var i = Array.prototype.slice
      , n = t.console
      , d = void 0 === n ? function() {}
    : function(t) {
        n.error(t)
    }
    ;
    function a(c, a, u) {
        (u = u || e || t.jQuery) && (a.prototype.option || (a.prototype.option = function(t) {
            u.isPlainObject(t) && (this.options = u.extend(!0, this.options, t))
        }
        ),
        u.fn[c] = function(t) {
            return "string" == typeof t ? function(t, o, s) {
                var r, l = "$()." + c + '("' + o + '")';
                return t.each(function(t, e) {
                    var i = u.data(e, c);
                    if (i) {
                        var n = i[o];
                        if (n && "_" != o.charAt(0)) {
                            var a = n.apply(i, s);
                            r = void 0 === r ? a : r
                        } else
                            d(l + " is not a valid method")
                    } else
                        d(c + " not initialized. Cannot call methods, i.e. " + l)
                }),
                void 0 !== r ? r : t
            }(this, t, i.call(arguments, 1)) : (function(t, n) {
                t.each(function(t, e) {
                    var i = u.data(e, c);
                    i ? (i.option(n),
                    i._init()) : (i = new a(e,n),
                    u.data(e, c, i))
                })
            }(this, t),
            this)
        }
        ,
        o(u))
    }
    function o(t) {
        !t || t && t.bridget || (t.bridget = a)
    }
    return o(e || t.jQuery),
    a
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == typeof module && module.exports ? module.exports = e() : t.EvEmitter = e()
}("undefined" != typeof window ? window : this, function() {
    function t() {}
    var e = t.prototype;
    return e.on = function(t, e) {
        if (t && e) {
            var i = this._events = this._events || {}
              , n = i[t] = i[t] || [];
            return -1 == n.indexOf(e) && n.push(e),
            this
        }
    }
    ,
    e.once = function(t, e) {
        if (t && e) {
            this.on(t, e);
            var i = this._onceEvents = this._onceEvents || {};
            return (i[t] = i[t] || {})[e] = !0,
            this
        }
    }
    ,
    e.off = function(t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
            var n = i.indexOf(e);
            return -1 != n && i.splice(n, 1),
            this
        }
    }
    ,
    e.emitEvent = function(t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
            var n = 0
              , a = i[n];
            e = e || [];
            for (var o = this._onceEvents && this._onceEvents[t]; a; ) {
                var s = o && o[a];
                s && (this.off(t, a),
                delete o[a]),
                a.apply(this, e),
                a = i[n += s ? 0 : 1]
            }
            return this
        }
    }
    ,
    t
}),
function(t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define("get-size/get-size", [], function() {
        return e()
    }) : "object" == typeof module && module.exports ? module.exports = e() : t.getSize = e()
}(window, function() {
    "use strict";
    function y(t) {
        var e = parseFloat(t);
        return -1 == t.indexOf("%") && !isNaN(e) && e
    }
    var i = "undefined" == typeof console ? function() {}
    : function(t) {
        console.error(t)
    }
      , v = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"]
      , b = v.length;
    function A(t) {
        var e = getComputedStyle(t);
        return e || i("Style returned " + e + ". Are you running this code in a hidden iframe on Firefox? See http://bit.ly/getsizebug1"),
        e
    }
    var w, S = !1;
    function C(t) {
        if (function() {
            if (!S) {
                S = !0;
                var t = document.createElement("div");
                t.style.width = "200px",
                t.style.padding = "1px 2px 3px 4px",
                t.style.borderStyle = "solid",
                t.style.borderWidth = "1px 2px 3px 4px",
                t.style.boxSizing = "border-box";
                var e = document.body || document.documentElement;
                e.appendChild(t);
                var i = A(t);
                C.isBoxSizeOuter = w = 200 == y(i.width),
                e.removeChild(t)
            }
        }(),
        "string" == typeof t && (t = document.querySelector(t)),
        t && "object" == typeof t && t.nodeType) {
            var e = A(t);
            if ("none" == e.display)
                return function() {
                    for (var t = {
                        width: 0,
                        height: 0,
                        innerWidth: 0,
                        innerHeight: 0,
                        outerWidth: 0,
                        outerHeight: 0
                    }, e = 0; e < b; e++) {
                        t[v[e]] = 0
                    }
                    return t
                }();
            var i = {};
            i.width = t.offsetWidth,
            i.height = t.offsetHeight;
            for (var n = i.isBorderBox = "border-box" == e.boxSizing, a = 0; a < b; a++) {
                var o = v[a]
                  , s = e[o]
                  , r = parseFloat(s);
                i[o] = isNaN(r) ? 0 : r
            }
            var l = i.paddingLeft + i.paddingRight
              , c = i.paddingTop + i.paddingBottom
              , u = i.marginLeft + i.marginRight
              , d = i.marginTop + i.marginBottom
              , h = i.borderLeftWidth + i.borderRightWidth
              , f = i.borderTopWidth + i.borderBottomWidth
              , p = n && w
              , m = y(e.width);
            !1 !== m && (i.width = m + (p ? 0 : l + h));
            var g = y(e.height);
            return !1 !== g && (i.height = g + (p ? 0 : c + f)),
            i.innerWidth = i.width - (l + h),
            i.innerHeight = i.height - (c + f),
            i.outerWidth = i.width + u,
            i.outerHeight = i.height + d,
            i
        }
    }
    return C
}),
function(t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", e) : "object" == typeof module && module.exports ? module.exports = e() : t.matchesSelector = e()
}(window, function() {
    "use strict";
    var i = function() {
        var t = Element.prototype;
        if (t.matches)
            return "matches";
        if (t.matchesSelector)
            return "matchesSelector";
        for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
            var n = e[i] + "MatchesSelector";
            if (t[n])
                return n
        }
    }();
    return function(t, e) {
        return t[i](e)
    }
}),
function(e, i) {
    "function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function(t) {
        return i(e, t)
    }) : "object" == typeof module && module.exports ? module.exports = i(e, require("desandro-matches-selector")) : e.fizzyUIUtils = i(e, e.matchesSelector)
}(window, function(c, o) {
    var u = {
        extend: function(t, e) {
            for (var i in e)
                t[i] = e[i];
            return t
        },
        modulo: function(t, e) {
            return (t % e + e) % e
        },
        makeArray: function(t) {
            var e = [];
            if (Array.isArray(t))
                e = t;
            else if (t && "number" == typeof t.length)
                for (var i = 0; i < t.length; i++)
                    e.push(t[i]);
            else
                e.push(t);
            return e
        },
        removeFrom: function(t, e) {
            var i = t.indexOf(e);
            -1 != i && t.splice(i, 1)
        },
        getParent: function(t, e) {
            for (; t != document.body; )
                if (t = t.parentNode,
                o(t, e))
                    return t
        },
        getQueryElement: function(t) {
            return "string" == typeof t ? document.querySelector(t) : t
        },
        handleEvent: function(t) {
            var e = "on" + t.type;
            this[e] && this[e](t)
        },
        filterFindElements: function(t, n) {
            t = u.makeArray(t);
            var a = [];
            return t.forEach(function(t) {
                if (t instanceof HTMLElement)
                    if (n) {
                        o(t, n) && a.push(t);
                        for (var e = t.querySelectorAll(n), i = 0; i < e.length; i++)
                            a.push(e[i])
                    } else
                        a.push(t)
            }),
            a
        },
        debounceMethod: function(t, e, n) {
            var a = t.prototype[e]
              , o = e + "Timeout";
            t.prototype[e] = function() {
                var t = this[o];
                t && clearTimeout(t);
                var e = arguments
                  , i = this;
                this[o] = setTimeout(function() {
                    a.apply(i, e),
                    delete i[o]
                }, n || 100)
            }
        },
        docReady: function(t) {
            var e = document.readyState;
            "complete" == e || "interactive" == e ? t() : document.addEventListener("DOMContentLoaded", t)
        },
        toDashed: function(t) {
            return t.replace(/(.)([A-Z])/g, function(t, e, i) {
                return e + "-" + i
            }).toLowerCase()
        }
    }
      , d = c.console;
    return u.htmlInit = function(r, l) {
        u.docReady(function() {
            var t = u.toDashed(l)
              , a = "data-" + t
              , e = document.querySelectorAll("[" + a + "]")
              , i = document.querySelectorAll(".js-" + t)
              , n = u.makeArray(e).concat(u.makeArray(i))
              , o = a + "-options"
              , s = c.jQuery;
            n.forEach(function(e) {
                var t, i = e.getAttribute(a) || e.getAttribute(o);
                try {
                    t = i && JSON.parse(i)
                } catch (t) {
                    return void (d && d.error("Error parsing " + a + " on " + e.className + ": " + t))
                }
                var n = new r(e,t);
                s && s.data(e, l, n)
            })
        })
    }
    ,
    u
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("outlayer/item", ["ev-emitter/ev-emitter", "get-size/get-size"], e) : "object" == typeof module && module.exports ? module.exports = e(require("ev-emitter"), require("get-size")) : (t.Outlayer = {},
    t.Outlayer.Item = e(t.EvEmitter, t.getSize))
}(window, function(t, e) {
    "use strict";
    var i = document.documentElement.style
      , n = "string" == typeof i.transition ? "transition" : "WebkitTransition"
      , a = "string" == typeof i.transform ? "transform" : "WebkitTransform"
      , o = {
        WebkitTransition: "webkitTransitionEnd",
        transition: "transitionend"
    }[n]
      , s = {
        transform: a,
        transition: n,
        transitionDuration: n + "Duration",
        transitionProperty: n + "Property",
        transitionDelay: n + "Delay"
    };
    function r(t, e) {
        t && (this.element = t,
        this.layout = e,
        this.position = {
            x: 0,
            y: 0
        },
        this._create())
    }
    var l = r.prototype = Object.create(t.prototype);
    l.constructor = r,
    l._create = function() {
        this._transn = {
            ingProperties: {},
            clean: {},
            onEnd: {}
        },
        this.css({
            position: "absolute"
        })
    }
    ,
    l.handleEvent = function(t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }
    ,
    l.getSize = function() {
        this.size = e(this.element)
    }
    ,
    l.css = function(t) {
        var e = this.element.style;
        for (var i in t) {
            e[s[i] || i] = t[i]
        }
    }
    ,
    l.getPosition = function() {
        var t = getComputedStyle(this.element)
          , e = this.layout._getOption("originLeft")
          , i = this.layout._getOption("originTop")
          , n = t[e ? "left" : "right"]
          , a = t[i ? "top" : "bottom"]
          , o = this.layout.size
          , s = -1 != n.indexOf("%") ? parseFloat(n) / 100 * o.width : parseInt(n, 10)
          , r = -1 != a.indexOf("%") ? parseFloat(a) / 100 * o.height : parseInt(a, 10);
        s = isNaN(s) ? 0 : s,
        r = isNaN(r) ? 0 : r,
        s -= e ? o.paddingLeft : o.paddingRight,
        r -= i ? o.paddingTop : o.paddingBottom,
        this.position.x = s,
        this.position.y = r
    }
    ,
    l.layoutPosition = function() {
        var t = this.layout.size
          , e = {}
          , i = this.layout._getOption("originLeft")
          , n = this.layout._getOption("originTop")
          , a = i ? "paddingLeft" : "paddingRight"
          , o = i ? "left" : "right"
          , s = i ? "right" : "left"
          , r = this.position.x + t[a];
        e[o] = this.getXValue(r),
        e[s] = "";
        var l = n ? "paddingTop" : "paddingBottom"
          , c = n ? "top" : "bottom"
          , u = n ? "bottom" : "top"
          , d = this.position.y + t[l];
        e[c] = this.getYValue(d),
        e[u] = "",
        this.css(e),
        this.emitEvent("layout", [this])
    }
    ,
    l.getXValue = function(t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && !e ? t / this.layout.size.width * 100 + "%" : t + "px"
    }
    ,
    l.getYValue = function(t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && e ? t / this.layout.size.height * 100 + "%" : t + "px"
    }
    ,
    l._transitionTo = function(t, e) {
        this.getPosition();
        var i = this.position.x
          , n = this.position.y
          , a = parseInt(t, 10)
          , o = parseInt(e, 10)
          , s = a === this.position.x && o === this.position.y;
        if (this.setPosition(t, e),
        !s || this.isTransitioning) {
            var r = t - i
              , l = e - n
              , c = {};
            c.transform = this.getTranslate(r, l),
            this.transition({
                to: c,
                onTransitionEnd: {
                    transform: this.layoutPosition
                },
                isCleaning: !0
            })
        } else
            this.layoutPosition()
    }
    ,
    l.getTranslate = function(t, e) {
        return "translate3d(" + (t = this.layout._getOption("originLeft") ? t : -t) + "px, " + (e = this.layout._getOption("originTop") ? e : -e) + "px, 0)"
    }
    ,
    l.goTo = function(t, e) {
        this.setPosition(t, e),
        this.layoutPosition()
    }
    ,
    l.moveTo = l._transitionTo,
    l.setPosition = function(t, e) {
        this.position.x = parseInt(t, 10),
        this.position.y = parseInt(e, 10)
    }
    ,
    l._nonTransition = function(t) {
        for (var e in this.css(t.to),
        t.isCleaning && this._removeStyles(t.to),
        t.onTransitionEnd)
            t.onTransitionEnd[e].call(this)
    }
    ,
    l.transition = function(t) {
        if (parseFloat(this.layout.options.transitionDuration)) {
            var e = this._transn;
            for (var i in t.onTransitionEnd)
                e.onEnd[i] = t.onTransitionEnd[i];
            for (i in t.to)
                e.ingProperties[i] = !0,
                t.isCleaning && (e.clean[i] = !0);
            if (t.from) {
                this.css(t.from);
                this.element.offsetHeight;
                null
            }
            this.enableTransition(t.to),
            this.css(t.to),
            this.isTransitioning = !0
        } else
            this._nonTransition(t)
    }
    ;
    var c = "opacity," + a.replace(/([A-Z])/g, function(t) {
        return "-" + t.toLowerCase()
    });
    l.enableTransition = function() {
        if (!this.isTransitioning) {
            var t = this.layout.options.transitionDuration;
            t = "number" == typeof t ? t + "ms" : t,
            this.css({
                transitionProperty: c,
                transitionDuration: t,
                transitionDelay: this.staggerDelay || 0
            }),
            this.element.addEventListener(o, this, !1)
        }
    }
    ,
    l.onwebkitTransitionEnd = function(t) {
        this.ontransitionend(t)
    }
    ,
    l.onotransitionend = function(t) {
        this.ontransitionend(t)
    }
    ;
    var u = {
        "-webkit-transform": "transform"
    };
    l.ontransitionend = function(t) {
        if (t.target === this.element) {
            var e = this._transn
              , i = u[t.propertyName] || t.propertyName;
            if (delete e.ingProperties[i],
            function(t) {
                for (var e in t)
                    return !1;
                return !null
            }(e.ingProperties) && this.disableTransition(),
            i in e.clean && (this.element.style[t.propertyName] = "",
            delete e.clean[i]),
            i in e.onEnd)
                e.onEnd[i].call(this),
                delete e.onEnd[i];
            this.emitEvent("transitionEnd", [this])
        }
    }
    ,
    l.disableTransition = function() {
        this.removeTransitionStyles(),
        this.element.removeEventListener(o, this, !1),
        this.isTransitioning = !1
    }
    ,
    l._removeStyles = function(t) {
        var e = {};
        for (var i in t)
            e[i] = "";
        this.css(e)
    }
    ;
    var d = {
        transitionProperty: "",
        transitionDuration: "",
        transitionDelay: ""
    };
    return l.removeTransitionStyles = function() {
        this.css(d)
    }
    ,
    l.stagger = function(t) {
        t = isNaN(t) ? 0 : t,
        this.staggerDelay = t + "ms"
    }
    ,
    l.removeElem = function() {
        this.element.parentNode.removeChild(this.element),
        this.css({
            display: ""
        }),
        this.emitEvent("remove", [this])
    }
    ,
    l.remove = function() {
        n && parseFloat(this.layout.options.transitionDuration) ? (this.once("transitionEnd", function() {
            this.removeElem()
        }),
        this.hide()) : this.removeElem()
    }
    ,
    l.reveal = function() {
        delete this.isHidden,
        this.css({
            display: ""
        });
        var t = this.layout.options
          , e = {};
        e[this.getHideRevealTransitionEndProperty("visibleStyle")] = this.onRevealTransitionEnd,
        this.transition({
            from: t.hiddenStyle,
            to: t.visibleStyle,
            isCleaning: !0,
            onTransitionEnd: e
        })
    }
    ,
    l.onRevealTransitionEnd = function() {
        this.isHidden || this.emitEvent("reveal")
    }
    ,
    l.getHideRevealTransitionEndProperty = function(t) {
        var e = this.layout.options[t];
        if (e.opacity)
            return "opacity";
        for (var i in e)
            return i
    }
    ,
    l.hide = function() {
        this.isHidden = !0,
        this.css({
            display: ""
        });
        var t = this.layout.options
          , e = {};
        e[this.getHideRevealTransitionEndProperty("hiddenStyle")] = this.onHideTransitionEnd,
        this.transition({
            from: t.visibleStyle,
            to: t.hiddenStyle,
            isCleaning: !0,
            onTransitionEnd: e
        })
    }
    ,
    l.onHideTransitionEnd = function() {
        this.isHidden && (this.css({
            display: "none"
        }),
        this.emitEvent("hide"))
    }
    ,
    l.destroy = function() {
        this.css({
            position: "",
            left: "",
            right: "",
            top: "",
            bottom: "",
            transition: "",
            transform: ""
        })
    }
    ,
    r
}),
function(a, o) {
    "use strict";
    "function" == typeof define && define.amd ? define("outlayer/outlayer", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./item"], function(t, e, i, n) {
        return o(a, t, e, i, n)
    }) : "object" == typeof module && module.exports ? module.exports = o(a, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./item")) : a.Outlayer = o(a, a.EvEmitter, a.getSize, a.fizzyUIUtils, a.Outlayer.Item)
}(window, function(t, e, a, o, n) {
    "use strict";
    function i() {}
    var s = t.console
      , r = t.jQuery
      , l = 0
      , c = {};
    function u(t, e) {
        var i = o.getQueryElement(t);
        if (i) {
            this.element = i,
            r && (this.$element = r(this.element)),
            this.options = o.extend({}, this.constructor.defaults),
            this.option(e);
            var n = ++l;
            this.element.outlayerGUID = n,
            (c[n] = this)._create(),
            this._getOption("initLayout") && this.layout()
        } else
            s && s.error("Bad element for " + this.constructor.namespace + ": " + (i || t))
    }
    u.namespace = "outlayer",
    u.Item = n,
    u.defaults = {
        containerStyle: {
            position: "relative"
        },
        initLayout: !0,
        originLeft: !0,
        originTop: !0,
        resize: !0,
        resizeContainer: !0,
        transitionDuration: "0.4s",
        hiddenStyle: {
            opacity: 0,
            transform: "scale(0.001)"
        },
        visibleStyle: {
            opacity: 1,
            transform: "scale(1)"
        }
    };
    var d = u.prototype;
    function h(t) {
        function e() {
            t.apply(this, arguments)
        }
        return (e.prototype = Object.create(t.prototype)).constructor = e
    }
    o.extend(d, e.prototype),
    d.option = function(t) {
        o.extend(this.options, t)
    }
    ,
    d._getOption = function(t) {
        var e = this.constructor.compatOptions[t];
        return e && void 0 !== this.options[e] ? this.options[e] : this.options[t]
    }
    ,
    u.compatOptions = {
        initLayout: "isInitLayout",
        horizontal: "isHorizontal",
        layoutInstant: "isLayoutInstant",
        originLeft: "isOriginLeft",
        originTop: "isOriginTop",
        resize: "isResizeBound",
        resizeContainer: "isResizingContainer"
    },
    d._create = function() {
        this.reloadItems(),
        this.stamps = [],
        this.stamp(this.options.stamp),
        o.extend(this.element.style, this.options.containerStyle),
        this._getOption("resize") && this.bindResize()
    }
    ,
    d.reloadItems = function() {
        this.items = this._itemize(this.element.children)
    }
    ,
    d._itemize = function(t) {
        for (var e = this._filterFindItemElements(t), i = this.constructor.Item, n = [], a = 0; a < e.length; a++) {
            var o = new i(e[a],this);
            n.push(o)
        }
        return n
    }
    ,
    d._filterFindItemElements = function(t) {
        return o.filterFindElements(t, this.options.itemSelector)
    }
    ,
    d.getItemElements = function() {
        return this.items.map(function(t) {
            return t.element
        })
    }
    ,
    d.layout = function() {
        this._resetLayout(),
        this._manageStamps();
        var t = this._getOption("layoutInstant")
          , e = void 0 !== t ? t : !this._isLayoutInited;
        this.layoutItems(this.items, e),
        this._isLayoutInited = !0
    }
    ,
    d._init = d.layout,
    d._resetLayout = function() {
        this.getSize()
    }
    ,
    d.getSize = function() {
        this.size = a(this.element)
    }
    ,
    d._getMeasurement = function(t, e) {
        var i, n = this.options[t];
        n ? ("string" == typeof n ? i = this.element.querySelector(n) : n instanceof HTMLElement && (i = n),
        this[t] = i ? a(i)[e] : n) : this[t] = 0
    }
    ,
    d.layoutItems = function(t, e) {
        t = this._getItemsForLayout(t),
        this._layoutItems(t, e),
        this._postLayout()
    }
    ,
    d._getItemsForLayout = function(t) {
        return t.filter(function(t) {
            return !t.isIgnored
        })
    }
    ,
    d._layoutItems = function(t, i) {
        if (this._emitCompleteOnItems("layout", t),
        t && t.length) {
            var n = [];
            t.forEach(function(t) {
                var e = this._getItemLayoutPosition(t);
                e.item = t,
                e.isInstant = i || t.isLayoutInstant,
                n.push(e)
            }, this),
            this._processLayoutQueue(n)
        }
    }
    ,
    d._getItemLayoutPosition = function() {
        return {
            x: 0,
            y: 0
        }
    }
    ,
    d._processLayoutQueue = function(t) {
        this.updateStagger(),
        t.forEach(function(t, e) {
            this._positionItem(t.item, t.x, t.y, t.isInstant, e)
        }, this)
    }
    ,
    d.updateStagger = function() {
        var t = this.options.stagger;
        if (null != t)
            return this.stagger = function(t) {
                if ("number" == typeof t)
                    return t;
                var e = t.match(/(^\d*\.?\d*)(\w*)/)
                  , i = e && e[1]
                  , n = e && e[2];
                if (!i.length)
                    return 0;
                i = parseFloat(i);
                var a = f[n] || 1;
                return i * a
            }(t),
            this.stagger;
        this.stagger = 0
    }
    ,
    d._positionItem = function(t, e, i, n, a) {
        n ? t.goTo(e, i) : (t.stagger(a * this.stagger),
        t.moveTo(e, i))
    }
    ,
    d._postLayout = function() {
        this.resizeContainer()
    }
    ,
    d.resizeContainer = function() {
        if (this._getOption("resizeContainer")) {
            var t = this._getContainerSize();
            t && (this._setContainerMeasure(t.width, !0),
            this._setContainerMeasure(t.height, !1))
        }
    }
    ,
    d._getContainerSize = i,
    d._setContainerMeasure = function(t, e) {
        if (void 0 !== t) {
            var i = this.size;
            i.isBorderBox && (t += e ? i.paddingLeft + i.paddingRight + i.borderLeftWidth + i.borderRightWidth : i.paddingBottom + i.paddingTop + i.borderTopWidth + i.borderBottomWidth),
            t = Math.max(t, 0),
            this.element.style[e ? "width" : "height"] = t + "px"
        }
    }
    ,
    d._emitCompleteOnItems = function(e, t) {
        var i = this;
        function n() {
            i.dispatchEvent(e + "Complete", null, [t])
        }
        var a = t.length;
        if (t && a) {
            var o = 0;
            t.forEach(function(t) {
                t.once(e, s)
            })
        } else
            n();
        function s() {
            ++o == a && n()
        }
    }
    ,
    d.dispatchEvent = function(t, e, i) {
        var n = e ? [e].concat(i) : i;
        if (this.emitEvent(t, n),
        r)
            if (this.$element = this.$element || r(this.element),
            e) {
                var a = r.Event(e);
                a.type = t,
                this.$element.trigger(a, i)
            } else
                this.$element.trigger(t, i)
    }
    ,
    d.ignore = function(t) {
        var e = this.getItem(t);
        e && (e.isIgnored = !0)
    }
    ,
    d.unignore = function(t) {
        var e = this.getItem(t);
        e && delete e.isIgnored
    }
    ,
    d.stamp = function(t) {
        (t = this._find(t)) && (this.stamps = this.stamps.concat(t),
        t.forEach(this.ignore, this))
    }
    ,
    d.unstamp = function(t) {
        (t = this._find(t)) && t.forEach(function(t) {
            o.removeFrom(this.stamps, t),
            this.unignore(t)
        }, this)
    }
    ,
    d._find = function(t) {
        if (t)
            return "string" == typeof t && (t = this.element.querySelectorAll(t)),
            t = o.makeArray(t)
    }
    ,
    d._manageStamps = function() {
        this.stamps && this.stamps.length && (this._getBoundingRect(),
        this.stamps.forEach(this._manageStamp, this))
    }
    ,
    d._getBoundingRect = function() {
        var t = this.element.getBoundingClientRect()
          , e = this.size;
        this._boundingRect = {
            left: t.left + e.paddingLeft + e.borderLeftWidth,
            top: t.top + e.paddingTop + e.borderTopWidth,
            right: t.right - (e.paddingRight + e.borderRightWidth),
            bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth)
        }
    }
    ,
    d._manageStamp = i,
    d._getElementOffset = function(t) {
        var e = t.getBoundingClientRect()
          , i = this._boundingRect
          , n = a(t);
        return {
            left: e.left - i.left - n.marginLeft,
            top: e.top - i.top - n.marginTop,
            right: i.right - e.right - n.marginRight,
            bottom: i.bottom - e.bottom - n.marginBottom
        }
    }
    ,
    d.handleEvent = o.handleEvent,
    d.bindResize = function() {
        t.addEventListener("resize", this),
        this.isResizeBound = !0
    }
    ,
    d.unbindResize = function() {
        t.removeEventListener("resize", this),
        this.isResizeBound = !1
    }
    ,
    d.onresize = function() {
        this.resize()
    }
    ,
    o.debounceMethod(u, "onresize", 100),
    d.resize = function() {
        this.isResizeBound && this.needsResizeLayout() && this.layout()
    }
    ,
    d.needsResizeLayout = function() {
        var t = a(this.element);
        return this.size && t && t.innerWidth !== this.size.innerWidth
    }
    ,
    d.addItems = function(t) {
        var e = this._itemize(t);
        return e.length && (this.items = this.items.concat(e)),
        e
    }
    ,
    d.appended = function(t) {
        var e = this.addItems(t);
        e.length && (this.layoutItems(e, !0),
        this.reveal(e))
    }
    ,
    d.prepended = function(t) {
        var e = this._itemize(t);
        if (e.length) {
            var i = this.items.slice(0);
            this.items = e.concat(i),
            this._resetLayout(),
            this._manageStamps(),
            this.layoutItems(e, !0),
            this.reveal(e),
            this.layoutItems(i)
        }
    }
    ,
    d.reveal = function(t) {
        if (this._emitCompleteOnItems("reveal", t),
        t && t.length) {
            var i = this.updateStagger();
            t.forEach(function(t, e) {
                t.stagger(e * i),
                t.reveal()
            })
        }
    }
    ,
    d.hide = function(t) {
        if (this._emitCompleteOnItems("hide", t),
        t && t.length) {
            var i = this.updateStagger();
            t.forEach(function(t, e) {
                t.stagger(e * i),
                t.hide()
            })
        }
    }
    ,
    d.revealItemElements = function(t) {
        var e = this.getItems(t);
        this.reveal(e)
    }
    ,
    d.hideItemElements = function(t) {
        var e = this.getItems(t);
        this.hide(e)
    }
    ,
    d.getItem = function(t) {
        for (var e = 0; e < this.items.length; e++) {
            var i = this.items[e];
            if (i.element == t)
                return i
        }
    }
    ,
    d.getItems = function(t) {
        t = o.makeArray(t);
        var i = [];
        return t.forEach(function(t) {
            var e = this.getItem(t);
            e && i.push(e)
        }, this),
        i
    }
    ,
    d.remove = function(t) {
        var e = this.getItems(t);
        this._emitCompleteOnItems("remove", e),
        e && e.length && e.forEach(function(t) {
            t.remove(),
            o.removeFrom(this.items, t)
        }, this)
    }
    ,
    d.destroy = function() {
        var t = this.element.style;
        t.height = "",
        t.position = "",
        t.width = "",
        this.items.forEach(function(t) {
            t.destroy()
        }),
        this.unbindResize();
        var e = this.element.outlayerGUID;
        delete c[e],
        delete this.element.outlayerGUID,
        r && r.removeData(this.element, this.constructor.namespace)
    }
    ,
    u.data = function(t) {
        var e = (t = o.getQueryElement(t)) && t.outlayerGUID;
        return e && c[e]
    }
    ,
    u.create = function(t, e) {
        var i = h(u);
        return i.defaults = o.extend({}, u.defaults),
        o.extend(i.defaults, e),
        i.compatOptions = o.extend({}, u.compatOptions),
        i.namespace = t,
        i.data = u.data,
        i.Item = h(n),
        o.htmlInit(i, t),
        r && r.bridget && r.bridget(t, i),
        i
    }
    ;
    var f = {
        ms: 1,
        s: 1e3
    };
    return u.Item = n,
    u
}),
function(t, e) {
    "function" == typeof define && define.amd ? define(["outlayer/outlayer", "get-size/get-size"], e) : "object" == typeof module && module.exports ? module.exports = e(require("outlayer"), require("get-size")) : t.Masonry = e(t.Outlayer, t.getSize)
}(window, function(t, c) {
    var e = t.create("masonry");
    return e.compatOptions.fitWidth = "isFitWidth",
    e.prototype._resetLayout = function() {
        this.getSize(),
        this._getMeasurement("columnWidth", "outerWidth"),
        this._getMeasurement("gutter", "outerWidth"),
        this.measureColumns(),
        this.colYs = [];
        for (var t = 0; t < this.cols; t++)
            this.colYs.push(0);
        this.maxY = 0
    }
    ,
    e.prototype.measureColumns = function() {
        if (this.getContainerWidth(),
        !this.columnWidth) {
            var t = this.items[0]
              , e = t && t.element;
            this.columnWidth = e && c(e).outerWidth || this.containerWidth
        }
        var i = this.columnWidth += this.gutter
          , n = this.containerWidth + this.gutter
          , a = n / i
          , o = i - n % i;
        a = Math[o && o < 1 ? "round" : "floor"](a),
        this.cols = Math.max(a, 1)
    }
    ,
    e.prototype.getContainerWidth = function() {
        var t = this._getOption("fitWidth") ? this.element.parentNode : this.element
          , e = c(t);
        this.containerWidth = e && e.innerWidth
    }
    ,
    e.prototype._getItemLayoutPosition = function(t) {
        t.getSize();
        var e = t.size.outerWidth % this.columnWidth
          , i = Math[e && e < 1 ? "round" : "ceil"](t.size.outerWidth / this.columnWidth);
        i = Math.min(i, this.cols);
        for (var n = this._getColGroup(i), a = Math.min.apply(Math, n), o = n.indexOf(a), s = {
            x: this.columnWidth * o,
            y: a
        }, r = a + t.size.outerHeight, l = this.cols + 1 - n.length, c = 0; c < l; c++)
            this.colYs[o + c] = r;
        return s
    }
    ,
    e.prototype._getColGroup = function(t) {
        if (t < 2)
            return this.colYs;
        for (var e = [], i = this.cols + 1 - t, n = 0; n < i; n++) {
            var a = this.colYs.slice(n, n + t);
            e[n] = Math.max.apply(Math, a)
        }
        return e
    }
    ,
    e.prototype._manageStamp = function(t) {
        var e = c(t)
          , i = this._getElementOffset(t)
          , n = this._getOption("originLeft") ? i.left : i.right
          , a = n + e.outerWidth
          , o = Math.floor(n / this.columnWidth);
        o = Math.max(0, o);
        var s = Math.floor(a / this.columnWidth);
        s -= a % this.columnWidth ? 0 : 1,
        s = Math.min(this.cols - 1, s);
        for (var r = (this._getOption("originTop") ? i.top : i.bottom) + e.outerHeight, l = o; l <= s; l++)
            this.colYs[l] = Math.max(r, this.colYs[l])
    }
    ,
    e.prototype._getContainerSize = function() {
        this.maxY = Math.max.apply(Math, this.colYs);
        var t = {
            height: this.maxY
        };
        return this._getOption("fitWidth") && (t.width = this._getContainerFitWidth()),
        t
    }
    ,
    e.prototype._getContainerFitWidth = function() {
        for (var t = 0, e = this.cols; --e && 0 === this.colYs[e]; )
            t++;
        return (this.cols - t) * this.columnWidth - this.gutter
    }
    ,
    e.prototype.needsResizeLayout = function() {
        var t = this.containerWidth;
        return this.getContainerWidth(),
        t != this.containerWidth
    }
    ,
    e
}),
function(h) {
    "use strict";
    var f = null
      , p = null;
    !function() {
        var a, o, s, r, t, e = ["webkit", "moz", "o", "ms"], i = h.document.createElement("div"), n = -1;
        for (n = 0; n < e.length && !h.requestAnimationFrame; n++)
            h.requestAnimationFrame = h[e[n] + "RequestAnimationFrame"];
        function l() {}
        void 0 === i.nextElementSibling && Object.defineProperty(h.Element.prototype, "nextElementSibling", {
            get: function() {
                for (var t = this.nextSibling; t; ) {
                    if (1 === t.nodeType)
                        return t;
                    t = t.nextSibling
                }
                return null
            }
        }),
        (t = h.Element.prototype).matches = t.matches || t.machesSelector || t.mozMatchesSelector || t.msMatchesSelector || t.oMatchesSelector || t.webkitMatchesSelector || function(t) {
            return -1 < Array.prototype.indexOf.call(this.parentElement.querySelectorAll(t), this)
        }
        ,
        Object.keys || (Object.keys = (r = Object.prototype.hasOwnProperty,
        a = !{
            toString: null
        }.propertyIsEnumerable("toString"),
        s = (o = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"]).length,
        function(t) {
            var e = []
              , i = ""
              , n = -1;
            if ("object" != typeof t && ("function" != typeof t || null === t))
                throw new TypeError("Object.keys called on non-object");
            for (i in t)
                r.call(t, i) && e.push(i);
            if (a)
                for (n = 0; n < s; n++)
                    r.call(t, o[n]) && e.push(o[n]);
            return e
        }
        )),
        Array.isArray || (Array.isArray = function(t) {
            return "[object Array]" === Object.prototype.toString.call(t)
        }
        ),
        "function" != typeof Object.create && (Object.create = function(t, e) {
            if (t !== Object(t) && null !== t)
                throw TypeError("Argument must be an object, or null");
            l.prototype = t || {};
            var i = new l;
            return l.prototype = null,
            void 0 !== e && Object.defineProperties(i, e),
            null === t && (i.__proto__ = null),
            i
        }
        ),
        String.prototype.trim || (String.prototype.trim = function() {
            return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "")
        }
        ),
        Array.prototype.indexOf || (Array.prototype.indexOf = function(t) {
            var e, i, n, a;
            if (null === this)
                throw new TypeError;
            if (0 == (a = (n = Object(this)).length >>> 0))
                return -1;
            if (e = 0,
            1 < arguments.length && ((e = Number(arguments[1])) != e ? e = 0 : 0 !== e && e !== 1 / 0 && e !== -1 / 0 && (e = (0 < e || -1) * Math.floor(Math.abs(e)))),
            a <= e)
                return -1;
            for (i = 0 <= e ? e : Math.max(a - Math.abs(e), 0); i < a; i++)
                if (i in n && n[i] === t)
                    return i;
            return -1
        }
        ),
        Function.prototype.bind || (Function.prototype.bind = function(t) {
            var e, i, n, a;
            if ("function" != typeof this)
                throw new TypeError;
            return e = Array.prototype.slice.call(arguments, 1),
            n = function() {}
            ,
            a = function() {
                return i.apply(this instanceof n ? this : t, e.concat(Array.prototype.slice.call(arguments)))
            }
            ,
            (i = this).prototype && (n.prototype = this.prototype),
            a.prototype = new n,
            a
        }
        ),
        h.Element.prototype.dispatchEvent || (h.Element.prototype.dispatchEvent = function(t) {
            try {
                return this.fireEvent("on" + t.type, t)
            } catch (t) {}
        }
        )
    }(),
    (f = function(t, e, i) {
        var n = null
          , a = !1
          , o = null
          , s = null
          , r = null
          , l = []
          , c = ""
          , u = []
          , d = -1;
        if (r = i || h.document,
        (a = arguments[3]) && (a = "boolean" == typeof a),
        "string" == typeof t)
            u = r.querySelectorAll(t);
        else if (t && "object" == typeof t && p.isElement(t, r))
            u = [t];
        else {
            if (!t || "object" != typeof t || !t.length)
                throw new Error(f.messages.errorFactoryInvalidContainer());
            u = t
        }
        if (u.length < 1)
            throw new Error(f.messages.errorFactoryContainerNotFound());
        for (d = 0; (n = u[d]) && (!(0 < d) || a); d++)
            n.id ? c = n.id : (c = "MixItUp" + p.randomHex(),
            n.id = c),
            f.instances[c]instanceof f.Mixer ? (o = f.instances[c],
            (!e || e && e.debug && !1 !== e.debug.showWarnings) && console.warn(f.messages.warningFactoryPreexistingInstance())) : ((o = new f.Mixer).attach(n, r, c, e),
            f.instances[c] = o),
            s = new f.Facade(o),
            e && e.debug && e.debug.enable ? l.push(o) : l.push(s);
        return a ? new f.Collection(l) : l[0]
    }
    ).use = function(t) {
        f.Base.prototype.callActions.call(f, "beforeUse", arguments),
        "function" == typeof t && "mixitup-extension" === t.TYPE ? void 0 === f.extensions[t.NAME] && (t(f),
        f.extensions[t.NAME] = t) : t.fn && t.fn.jquery && (f.libraries.$ = t),
        f.Base.prototype.callActions.call(f, "afterUse", arguments)
    }
    ,
    f.instances = {},
    f.extensions = {},
    f.libraries = {},
    p = {
        hasClass: function(t, e) {
            return !!t.className.match(new RegExp("(\\s|^)" + e + "(\\s|$)"))
        },
        addClass: function(t, e) {
            this.hasClass(t, e) || (t.className += t.className ? " " + e : e)
        },
        removeClass: function(t, e) {
            if (this.hasClass(t, e)) {
                var i = new RegExp("(\\s|^)" + e + "(\\s|$)");
                t.className = t.className.replace(i, " ").trim()
            }
        },
        extend: function(e, t, i, n) {
            var a = []
              , o = ""
              , s = -1;
            i = i || !1,
            n = n || !1;
            try {
                if (Array.isArray(t))
                    for (s = 0; s < t.length; s++)
                        a.push(s);
                else
                    t && (a = Object.keys(t));
                for (s = 0; s < a.length; s++)
                    o = a[s],
                    !i || "object" != typeof t[o] || this.isElement(t[o]) ? e[o] = t[o] : (Array.isArray(t[o]) ? e[o] || (e[o] = []) : e[o] || (e[o] = {}),
                    this.extend(e[o], t[o], i, n))
            } catch (t) {
                if (!n)
                    throw t;
                this.handleExtendError(t, e)
            }
            return e
        },
        handleExtendError: function(t, e) {
            var i = null
              , n = ""
              , a = ""
              , o = ""
              , s = ""
              , r = ""
              , l = -1
              , c = -1;
            if (t instanceof TypeError && (i = /property "?(\w*)"?[,:] object/i.exec(t.message))) {
                for (r in n = i[1],
                e) {
                    for (c = 0; c < n.length && n.charAt(c) === r.charAt(c); )
                        c++;
                    l < c && (l = c,
                    s = r)
                }
                throw 1 < l && (o = f.messages.errorConfigInvalidPropertySuggestion({
                    probableMatch: s
                })),
                a = f.messages.errorConfigInvalidProperty({
                    erroneous: n,
                    suggestion: o
                }),
                new TypeError(a)
            }
            throw t
        },
        template: function(n) {
            for (var t = /\${([\w]*)}/g, a = {}, e = null; e = t.exec(n); )
                a[e[1]] = new RegExp("\\${" + e[1] + "}","g");
            return function(t) {
                var e = ""
                  , i = n;
                for (e in t = t || {},
                a)
                    i = i.replace(a[e], void 0 !== t[e] ? t[e] : "");
                return i
            }
        },
        on: function(t, e, i, n) {
            t && (t.addEventListener ? t.addEventListener(e, i, n) : t.attachEvent && (t["e" + e + i] = i,
            t[e + i] = function() {
                t["e" + e + i](h.event)
            }
            ,
            t.attachEvent("on" + e, t[e + i])))
        },
        off: function(t, e, i) {
            t && (t.removeEventListener ? t.removeEventListener(e, i, !1) : t.detachEvent && (t.detachEvent("on" + e, t[e + i]),
            t[e + i] = null))
        },
        getCustomEvent: function(t, e, i) {
            var n = null;
            return i = i || h.document,
            "function" == typeof h.CustomEvent ? n = new h.CustomEvent(t,{
                detail: e,
                bubbles: !0,
                cancelable: !0
            }) : "function" == typeof i.createEvent ? (n = i.createEvent("CustomEvent")).initCustomEvent(t, !0, !0, e) : ((n = i.createEventObject()).type = t,
            n.returnValue = !1,
            n.cancelBubble = !1,
            n.detail = e),
            n
        },
        getOriginalEvent: function(t) {
            return t.touches && t.touches.length ? t.touches[0] : t.changedTouches && t.changedTouches.length ? t.changedTouches[0] : t
        },
        index: function(t, e) {
            for (var i = 0; null !== (t = t.previousElementSibling); )
                e && !t.matches(e) || ++i;
            return i
        },
        camelCase: function(t) {
            return t.toLowerCase().replace(/([_-][a-z])/g, function(t) {
                return t.toUpperCase().replace(/[_-]/, "")
            })
        },
        pascalCase: function(t) {
            return (t = this.camelCase(t)).charAt(0).toUpperCase() + t.slice(1)
        },
        dashCase: function(t) {
            return t.replace(/([A-Z])/g, "-$1").replace(/^-/, "").toLowerCase()
        },
        isElement: function(t, e) {
            return e = e || h.document,
            !!(h.HTMLElement && t instanceof h.HTMLElement) || !!(e.defaultView && e.defaultView.HTMLElement && t instanceof e.defaultView.HTMLElement) || null !== t && 1 === t.nodeType && "string" == typeof t.nodeName
        },
        createElement: function(t, e) {
            var i = null
              , n = null;
            for (i = (e = e || h.document).createDocumentFragment(),
            (n = e.createElement("div")).innerHTML = t; n.firstChild; )
                i.appendChild(n.firstChild);
            return i
        },
        removeWhitespace: function(t) {
            for (var e; t && "#text" === t.nodeName; )
                t = (e = t).previousSibling,
                e.parentElement && e.parentElement.removeChild(e)
        },
        isEqualArray: function(t, e) {
            var i = t.length;
            if (i !== e.length)
                return !1;
            for (; i--; )
                if (t[i] !== e[i])
                    return !1;
            return !0
        },
        deepEquals: function(t, e) {
            var i;
            if ("object" == typeof t && t && "object" == typeof e && e) {
                if (Object.keys(t).length !== Object.keys(e).length)
                    return !1;
                for (i in t)
                    if (!e.hasOwnProperty(i) || !this.deepEquals(t[i], e[i]))
                        return !1
            } else if (t !== e)
                return !1;
            return !0
        },
        arrayShuffle: function(t) {
            for (var e = t.slice(), i = e.length, n = i, a = -1, o = []; n--; )
                a = ~~(Math.random() * i),
                o = e[n],
                e[n] = e[a],
                e[a] = o;
            return e
        },
        arrayFromList: function(e) {
            var i, n;
            try {
                return Array.prototype.slice.call(e)
            } catch (t) {
                for (i = [],
                n = 0; n < e.length; n++)
                    i.push(e[n]);
                return i
            }
        },
        debounce: function(a, o, s) {
            var r;
            return function() {
                var t, e = this, i = arguments, n = s && !r;
                t = function() {
                    r = null,
                    s || a.apply(e, i)
                }
                ,
                clearTimeout(r),
                r = setTimeout(t, o),
                n && a.apply(e, i)
            }
        },
        position: function(t) {
            for (var e = 0, i = 0, n = t; t; )
                e -= t.scrollLeft,
                i -= t.scrollTop,
                t === n && (e += t.offsetLeft,
                i += t.offsetTop,
                n = t.offsetParent),
                t = t.parentElement;
            return {
                x: e,
                y: i
            }
        },
        getHypotenuse: function(t, e) {
            var i = t.x - e.x
              , n = t.y - e.y;
            return i = i < 0 ? -1 * i : i,
            n = n < 0 ? -1 * n : n,
            Math.sqrt(Math.pow(i, 2) + Math.pow(n, 2))
        },
        getIntersectionRatio: function(t, e) {
            var i, n = t.width * t.height;
            return i = Math.max(0, Math.min(t.left + t.width, e.left + e.width) - Math.max(t.left, e.left)),
            Math.max(0, Math.min(t.top + t.height, e.top + e.height) - Math.max(t.top, e.top)) * i / n
        },
        closestParent: function(t, e, i, n) {
            var a = t.parentNode;
            if (n = n || h.document,
            i && t.matches(e))
                return t;
            for (; a && a != n.body; ) {
                if (a.matches && a.matches(e))
                    return a;
                if (!a.parentNode)
                    return null;
                a = a.parentNode
            }
            return null
        },
        children: function(t, e, i) {
            var n = []
              , a = "";
            return i = i || h.doc,
            t && (t.id || (a = "Temp" + this.randomHexKey(),
            t.id = a),
            n = i.querySelectorAll("#" + t.id + " > " + e),
            a && t.removeAttribute("id")),
            n
        },
        clean: function(t) {
            var e = []
              , i = -1;
            for (i = 0; i < t.length; i++)
                "" !== t[i] && e.push(t[i]);
            return e
        },
        defer: function(t) {
            var e = null
              , i = null
              , n = null;
            return i = new this.Deferred,
            f.features.has.promises ? i.promise = new Promise(function(t, e) {
                i.resolve = t,
                i.reject = e
            }
            ) : (n = h.jQuery || t.$) && "function" == typeof n.Deferred ? (e = n.Deferred(),
            i.promise = e.promise(),
            i.resolve = e.resolve,
            i.reject = e.reject) : h.console && console.warn(f.messages.warningNoPromiseImplementation()),
            i
        },
        all: function(t, e) {
            var i = null;
            return f.features.has.promises ? Promise.all(t) : (i = h.jQuery || e.$) && "function" == typeof i.when ? i.when.apply(i, t).done(function() {
                return arguments
            }) : (h.console && console.warn(f.messages.warningNoPromiseImplementation()),
            [])
        },
        getPrefix: function(t, e, i) {
            var n = -1
              , a = "";
            if (p.dashCase(e)in t.style)
                return "";
            for (n = 0; a = i[n]; n++)
                if (a + e in t.style)
                    return a.toLowerCase();
            return "unsupported"
        },
        randomHex: function() {
            return ("00000" + (16777216 * Math.random() << 0).toString(16)).substr(-6).toUpperCase()
        },
        getDocumentState: function(t) {
            return t = "object" == typeof t.body ? t : h.document,
            {
                scrollTop: h.pageYOffset,
                scrollLeft: h.pageXOffset,
                docHeight: t.documentElement.scrollHeight,
                docWidth: t.documentElement.scrollWidth,
                viewportHeight: t.documentElement.clientHeight,
                viewportWidth: t.documentElement.clientWidth
            }
        },
        bind: function(t, e) {
            return function() {
                return e.apply(t, arguments)
            }
        },
        isVisible: function(t) {
            var e = null;
            return !!t.offsetParent || "fixed" === (e = h.getComputedStyle(t)).position && "hidden" !== e.visibility && "0" !== e.opacity
        },
        seal: function(t) {
            "function" == typeof Object.seal && Object.seal(t)
        },
        freeze: function(t) {
            "function" == typeof Object.freeze && Object.freeze(t)
        },
        compareVersions: function(t, e) {
            var i = t.split(".")
              , n = e.split(".")
              , a = -1
              , o = -1
              , s = -1;
            for (s = 0; s < i.length; s++) {
                if (a = parseInt(i[s].replace(/[^\d.]/g, "")),
                (o = parseInt(n[s].replace(/[^\d.]/g, "") || 0)) < a)
                    return !1;
                if (a < o)
                    return !0
            }
            return !0
        },
        Deferred: function() {
            this.promise = null,
            this.resolve = null,
            this.reject = null,
            this.id = p.randomHex()
        },
        isEmptyObject: function(t) {
            var e = "";
            if ("function" == typeof Object.keys)
                return 0 === Object.keys(t).length;
            for (e in t)
                if (t.hasOwnProperty(e))
                    return !1;
            return !0
        },
        getClassname: function(t, e, i) {
            var n = "";
            return (n += t.block).length && (n += t.delineatorElement),
            n += t["element" + this.pascalCase(e)],
            i ? (n.length && (n += t.delineatorModifier),
            n += i) : n
        },
        getProperty: function(t, e) {
            var i, n = e.split("."), a = "", o = 0;
            if (!e)
                return t;
            for (i = function(t) {
                return t ? t[a] : null
            }
            ; o < n.length; )
                a = n[o],
                t = i(t),
                o++;
            return void 0 !== t ? t : null
        }
    },
    f.h = p,
    f.Base = function() {}
    ,
    f.Base.prototype = {
        constructor: f.Base,
        callActions: function(t, e) {
            var i = this.constructor.actions[t]
              , n = "";
            if (i && !p.isEmptyObject(i))
                for (n in i)
                    i[n].apply(this, e)
        },
        callFilters: function(t, e, i) {
            var n = this.constructor.filters[t]
              , a = e
              , o = "";
            if (!n || p.isEmptyObject(n))
                return a;
            for (o in i = i || [],
            n)
                (i = p.arrayFromList(i)).unshift(a),
                a = n[o].apply(this, i);
            return a
        }
    },
    f.BaseStatic = function() {
        this.actions = {},
        this.filters = {},
        this.extend = function(t) {
            p.extend(this.prototype, t)
        }
        ,
        this.registerAction = function(t, e, i) {
            (this.actions[t] = this.actions[t] || {})[e] = i
        }
        ,
        this.registerFilter = function(t, e, i) {
            (this.filters[t] = this.filters[t] || {})[e] = i
        }
    }
    ,
    f.Features = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.boxSizingPrefix = "",
        this.transformPrefix = "",
        this.transitionPrefix = "",
        this.boxSizingPrefix = "",
        this.transformProp = "",
        this.transformRule = "",
        this.transitionProp = "",
        this.perspectiveProp = "",
        this.perspectiveOriginProp = "",
        this.has = new f.Has,
        this.canary = null,
        this.BOX_SIZING_PROP = "boxSizing",
        this.TRANSITION_PROP = "transition",
        this.TRANSFORM_PROP = "transform",
        this.PERSPECTIVE_PROP = "perspective",
        this.PERSPECTIVE_ORIGIN_PROP = "perspectiveOrigin",
        this.VENDORS = ["Webkit", "moz", "O", "ms"],
        this.TWEENABLE = ["opacity", "width", "height", "marginRight", "marginBottom", "x", "y", "scale", "translateX", "translateY", "translateZ", "rotateX", "rotateY", "rotateZ"],
        this.callActions("afterConstruct")
    }
    ,
    f.BaseStatic.call(f.Features),
    f.Features.prototype = Object.create(f.Base.prototype),
    p.extend(f.Features.prototype, {
        constructor: f.Features,
        init: function() {
            var t = this;
            t.callActions("beforeInit", arguments),
            t.canary = document.createElement("div"),
            t.setPrefixes(),
            t.runTests(),
            t.callActions("beforeInit", arguments)
        },
        runTests: function() {
            var t = this;
            t.callActions("beforeRunTests", arguments),
            t.has.promises = "function" == typeof h.Promise,
            t.has.transitions = "unsupported" !== t.transitionPrefix,
            t.callActions("afterRunTests", arguments),
            p.freeze(t.has)
        },
        setPrefixes: function() {
            var t = this;
            t.callActions("beforeSetPrefixes", arguments),
            t.transitionPrefix = p.getPrefix(t.canary, "Transition", t.VENDORS),
            t.transformPrefix = p.getPrefix(t.canary, "Transform", t.VENDORS),
            t.boxSizingPrefix = p.getPrefix(t.canary, "BoxSizing", t.VENDORS),
            t.boxSizingProp = t.boxSizingPrefix ? t.boxSizingPrefix + p.pascalCase(t.BOX_SIZING_PROP) : t.BOX_SIZING_PROP,
            t.transitionProp = t.transitionPrefix ? t.transitionPrefix + p.pascalCase(t.TRANSITION_PROP) : t.TRANSITION_PROP,
            t.transformProp = t.transformPrefix ? t.transformPrefix + p.pascalCase(t.TRANSFORM_PROP) : t.TRANSFORM_PROP,
            t.transformRule = t.transformPrefix ? "-" + t.transformPrefix + "-" + t.TRANSFORM_PROP : t.TRANSFORM_PROP,
            t.perspectiveProp = t.transformPrefix ? t.transformPrefix + p.pascalCase(t.PERSPECTIVE_PROP) : t.PERSPECTIVE_PROP,
            t.perspectiveOriginProp = t.transformPrefix ? t.transformPrefix + p.pascalCase(t.PERSPECTIVE_ORIGIN_PROP) : t.PERSPECTIVE_ORIGIN_PROP,
            t.callActions("afterSetPrefixes", arguments)
        }
    }),
    f.Has = function() {
        this.transitions = !1,
        this.promises = !1,
        p.seal(this)
    }
    ,
    f.features = new f.Features,
    f.features.init(),
    f.ConfigAnimation = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.enable = !0,
        this.effects = "fade scale",
        this.effectsIn = "",
        this.effectsOut = "",
        this.duration = 600,
        this.easing = "ease",
        this.applyPerspective = !0,
        this.perspectiveDistance = "3000px",
        this.perspectiveOrigin = "50% 50%",
        this.queue = !0,
        this.queueLimit = 3,
        this.animateResizeContainer = !0,
        this.animateResizeTargets = !1,
        this.staggerSequence = null,
        this.reverseOut = !1,
        this.nudge = !0,
        this.clampHeight = !0,
        this.clampWidth = !0,
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.ConfigAnimation),
    f.ConfigAnimation.prototype = Object.create(f.Base.prototype),
    f.ConfigAnimation.prototype.constructor = f.ConfigAnimation,
    f.ConfigBehavior = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.liveSort = !1,
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.ConfigBehavior),
    f.ConfigBehavior.prototype = Object.create(f.Base.prototype),
    f.ConfigBehavior.prototype.constructor = f.ConfigBehavior,
    f.ConfigCallbacks = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.onMixStart = null,
        this.onMixBusy = null,
        this.onMixEnd = null,
        this.onMixFail = null,
        this.onMixClick = null,
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.ConfigCallbacks),
    f.ConfigCallbacks.prototype = Object.create(f.Base.prototype),
    f.ConfigCallbacks.prototype.constructor = f.ConfigCallbacks,
    f.ConfigControls = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.enable = !0,
        this.live = !1,
        this.scope = "global",
        this.toggleLogic = "or",
        this.toggleDefault = "all",
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.ConfigControls),
    f.ConfigControls.prototype = Object.create(f.Base.prototype),
    f.ConfigControls.prototype.constructor = f.ConfigControls,
    f.ConfigClassNames = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.block = "mixitup",
        this.elementContainer = "container",
        this.elementFilter = "control",
        this.elementSort = "control",
        this.elementMultimix = "control",
        this.elementToggle = "control",
        this.modifierActive = "active",
        this.modifierDisabled = "disabled",
        this.modifierFailed = "failed",
        this.delineatorElement = "-",
        this.delineatorModifier = "-",
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.ConfigClassNames),
    f.ConfigClassNames.prototype = Object.create(f.Base.prototype),
    f.ConfigClassNames.prototype.constructor = f.ConfigClassNames,
    f.ConfigData = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.uidKey = "",
        this.dirtyCheck = !1,
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.ConfigData),
    f.ConfigData.prototype = Object.create(f.Base.prototype),
    f.ConfigData.prototype.constructor = f.ConfigData,
    f.ConfigDebug = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.enable = !1,
        this.showWarnings = !0,
        this.fauxAsync = !1,
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.ConfigDebug),
    f.ConfigDebug.prototype = Object.create(f.Base.prototype),
    f.ConfigDebug.prototype.constructor = f.ConfigDebug,
    f.ConfigLayout = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.allowNestedTargets = !0,
        this.containerClassName = "",
        this.siblingBefore = null,
        this.siblingAfter = null,
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.ConfigLayout),
    f.ConfigLayout.prototype = Object.create(f.Base.prototype),
    f.ConfigLayout.prototype.constructor = f.ConfigLayout,
    f.ConfigLoad = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.filter = "all",
        this.sort = "default:asc",
        this.dataset = null,
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.ConfigLoad),
    f.ConfigLoad.prototype = Object.create(f.Base.prototype),
    f.ConfigLoad.prototype.constructor = f.ConfigLoad,
    f.ConfigSelectors = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.target = ".mix",
        this.control = "",
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.ConfigSelectors),
    f.ConfigSelectors.prototype = Object.create(f.Base.prototype),
    f.ConfigSelectors.prototype.constructor = f.ConfigSelectors,
    f.ConfigRender = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.target = null,
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.ConfigRender),
    f.ConfigRender.prototype = Object.create(f.Base.prototype),
    f.ConfigRender.prototype.constructor = f.ConfigRender,
    f.ConfigTemplates = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.ConfigTemplates),
    f.ConfigTemplates.prototype = Object.create(f.Base.prototype),
    f.ConfigTemplates.prototype.constructor = f.ConfigTemplates,
    f.Config = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.animation = new f.ConfigAnimation,
        this.behavior = new f.ConfigBehavior,
        this.callbacks = new f.ConfigCallbacks,
        this.controls = new f.ConfigControls,
        this.classNames = new f.ConfigClassNames,
        this.data = new f.ConfigData,
        this.debug = new f.ConfigDebug,
        this.layout = new f.ConfigLayout,
        this.load = new f.ConfigLoad,
        this.selectors = new f.ConfigSelectors,
        this.render = new f.ConfigRender,
        this.templates = new f.ConfigTemplates,
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.Config),
    f.Config.prototype = Object.create(f.Base.prototype),
    f.Config.prototype.constructor = f.Config,
    f.MixerDom = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.document = null,
        this.body = null,
        this.container = null,
        this.parent = null,
        this.targets = [],
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.MixerDom),
    f.MixerDom.prototype = Object.create(f.Base.prototype),
    f.MixerDom.prototype.constructor = f.MixerDom,
    f.UiClassNames = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.base = "",
        this.active = "",
        this.disabled = "",
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.UiClassNames),
    f.UiClassNames.prototype = Object.create(f.Base.prototype),
    f.UiClassNames.prototype.constructor = f.UiClassNames,
    f.CommandDataset = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.dataset = null,
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.CommandDataset),
    f.CommandDataset.prototype = Object.create(f.Base.prototype),
    f.CommandDataset.prototype.constructor = f.CommandDataset,
    f.CommandMultimix = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.filter = null,
        this.sort = null,
        this.insert = null,
        this.remove = null,
        this.changeLayout = null,
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.CommandMultimix),
    f.CommandMultimix.prototype = Object.create(f.Base.prototype),
    f.CommandMultimix.prototype.constructor = f.CommandMultimix,
    f.CommandFilter = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.selector = "",
        this.collection = null,
        this.action = "show",
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.CommandFilter),
    f.CommandFilter.prototype = Object.create(f.Base.prototype),
    f.CommandFilter.prototype.constructor = f.CommandFilter,
    f.CommandSort = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.sortString = "",
        this.attribute = "",
        this.order = "asc",
        this.collection = null,
        this.next = null,
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.CommandSort),
    f.CommandSort.prototype = Object.create(f.Base.prototype),
    f.CommandSort.prototype.constructor = f.CommandSort,
    f.CommandInsert = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.index = 0,
        this.collection = [],
        this.position = "before",
        this.sibling = null,
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.CommandInsert),
    f.CommandInsert.prototype = Object.create(f.Base.prototype),
    f.CommandInsert.prototype.constructor = f.CommandInsert,
    f.CommandRemove = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.targets = [],
        this.collection = [],
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.CommandRemove),
    f.CommandRemove.prototype = Object.create(f.Base.prototype),
    f.CommandRemove.prototype.constructor = f.CommandRemove,
    f.CommandChangeLayout = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.containerClassName = "",
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.CommandChangeLayout),
    f.CommandChangeLayout.prototype = Object.create(f.Base.prototype),
    f.CommandChangeLayout.prototype.constructor = f.CommandChangeLayout,
    f.ControlDefinition = function(t, e, i, n) {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.type = t,
        this.selector = e,
        this.live = i || !1,
        this.parent = n || "",
        this.callActions("afterConstruct"),
        p.freeze(this),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.ControlDefinition),
    f.ControlDefinition.prototype = Object.create(f.Base.prototype),
    f.ControlDefinition.prototype.constructor = f.ControlDefinition,
    f.controlDefinitions = [],
    f.controlDefinitions.push(new f.ControlDefinition("multimix","[data-filter][data-sort]")),
    f.controlDefinitions.push(new f.ControlDefinition("filter","[data-filter]")),
    f.controlDefinitions.push(new f.ControlDefinition("sort","[data-sort]")),
    f.controlDefinitions.push(new f.ControlDefinition("toggle","[data-toggle]")),
    f.Control = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.el = null,
        this.selector = "",
        this.bound = [],
        this.pending = -1,
        this.type = "",
        this.status = "inactive",
        this.filter = "",
        this.sort = "",
        this.canDisable = !1,
        this.handler = null,
        this.classNames = new f.UiClassNames,
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.Control),
    f.Control.prototype = Object.create(f.Base.prototype),
    p.extend(f.Control.prototype, {
        constructor: f.Control,
        init: function(t, e, i) {
            var n = this;
            if (this.callActions("beforeInit", arguments),
            n.el = t,
            n.type = e,
            n.selector = i,
            n.selector)
                n.status = "live";
            else
                switch (n.canDisable = "boolean" == typeof n.el.disable,
                n.type) {
                case "filter":
                    n.filter = n.el.getAttribute("data-filter");
                    break;
                case "toggle":
                    n.filter = n.el.getAttribute("data-toggle");
                    break;
                case "sort":
                    n.sort = n.el.getAttribute("data-sort");
                    break;
                case "multimix":
                    n.filter = n.el.getAttribute("data-filter"),
                    n.sort = n.el.getAttribute("data-sort")
                }
            n.bindClick(),
            f.controls.push(n),
            this.callActions("afterInit", arguments)
        },
        isBound: function(t) {
            var e;
            return this.callActions("beforeIsBound", arguments),
            e = -1 < this.bound.indexOf(t),
            this.callFilters("afterIsBound", e, arguments)
        },
        addBinding: function(t) {
            this.callActions("beforeAddBinding", arguments),
            this.isBound() || this.bound.push(t),
            this.callActions("afterAddBinding", arguments)
        },
        removeBinding: function(t) {
            var e = this
              , i = -1;
            this.callActions("beforeRemoveBinding", arguments),
            -1 < (i = e.bound.indexOf(t)) && e.bound.splice(i, 1),
            e.bound.length < 1 && (e.unbindClick(),
            i = f.controls.indexOf(e),
            f.controls.splice(i, 1),
            "active" === e.status && e.renderStatus(e.el, "inactive")),
            this.callActions("afterRemoveBinding", arguments)
        },
        bindClick: function() {
            var e = this;
            this.callActions("beforeBindClick", arguments),
            e.handler = function(t) {
                e.handleClick(t)
            }
            ,
            p.on(e.el, "click", e.handler),
            this.callActions("afterBindClick", arguments)
        },
        unbindClick: function() {
            this.callActions("beforeUnbindClick", arguments),
            p.off(this.el, "click", this.handler),
            this.handler = null,
            this.callActions("afterUnbindClick", arguments)
        },
        handleClick: function(t) {
            var e = this
              , i = null
              , n = null
              , a = !1
              , o = {}
              , s = null
              , r = []
              , l = -1;
            if (this.callActions("beforeHandleClick", arguments),
            this.pending = 0,
            n = e.bound[0],
            i = e.selector ? p.closestParent(t.target, n.config.selectors.control + e.selector, !0, n.dom.document) : e.el) {
                switch (e.type) {
                case "filter":
                    o.filter = e.filter || i.getAttribute("data-filter");
                    break;
                case "sort":
                    o.sort = e.sort || i.getAttribute("data-sort");
                    break;
                case "multimix":
                    o.filter = e.filter || i.getAttribute("data-filter"),
                    o.sort = e.sort || i.getAttribute("data-sort");
                    break;
                case "toggle":
                    o.filter = e.filter || i.getAttribute("data-toggle"),
                    a = "live" === e.status ? p.hasClass(i, e.classNames.active) : "active" === e.status
                }
                for (l = 0; l < e.bound.length; l++)
                    s = new f.CommandMultimix,
                    p.extend(s, o),
                    r.push(s);
                for (r = e.callFilters("commandsHandleClick", r, arguments),
                e.pending = e.bound.length,
                l = 0; n = e.bound[l]; l++)
                    (o = r[l]) && (n.lastClicked || (n.lastClicked = i),
                    f.events.fire("mixClick", n.dom.container, {
                        state: n.state,
                        instance: n,
                        originalEvent: t,
                        control: n.lastClicked
                    }, n.dom.document),
                    "function" == typeof n.config.callbacks.onMixClick && !1 === n.config.callbacks.onMixClick.call(n.lastClicked, n.state, t, n) || ("toggle" === e.type ? a ? n.toggleOff(o.filter) : n.toggleOn(o.filter) : n.multimix(o)));
                this.callActions("afterHandleClick", arguments)
            } else
                e.callActions("afterHandleClick", arguments)
        },
        update: function(t, e) {
            var i = this
              , n = new f.CommandMultimix;
            i.callActions("beforeUpdate", arguments),
            i.pending--,
            i.pending = Math.max(0, i.pending),
            0 < i.pending || ("live" === i.status ? i.updateLive(t, e) : (n.sort = i.sort,
            n.filter = i.filter,
            i.callFilters("actionsUpdate", n, arguments),
            i.parseStatusChange(i.el, t, n, e)),
            i.callActions("afterUpdate", arguments))
        },
        updateLive: function(t, e) {
            var i = this
              , n = null
              , a = null
              , o = null
              , s = -1;
            if (i.callActions("beforeUpdateLive", arguments),
            i.el) {
                for (n = i.el.querySelectorAll(i.selector),
                s = 0; o = n[s]; s++) {
                    switch (a = new f.CommandMultimix,
                    i.type) {
                    case "filter":
                        a.filter = o.getAttribute("data-filter");
                        break;
                    case "sort":
                        a.sort = o.getAttribute("data-sort");
                        break;
                    case "multimix":
                        a.filter = o.getAttribute("data-filter"),
                        a.sort = o.getAttribute("data-sort");
                        break;
                    case "toggle":
                        a.filter = o.getAttribute("data-toggle")
                    }
                    a = i.callFilters("actionsUpdateLive", a, arguments),
                    i.parseStatusChange(o, t, a, e)
                }
                i.callActions("afterUpdateLive", arguments)
            }
        },
        parseStatusChange: function(t, e, i, n) {
            var a = this
              , o = ""
              , s = -1;
            switch (a.callActions("beforeParseStatusChange", arguments),
            a.type) {
            case "filter":
                e.filter === i.filter ? a.renderStatus(t, "active") : a.renderStatus(t, "inactive");
                break;
            case "multimix":
                e.sort === i.sort && e.filter === i.filter ? a.renderStatus(t, "active") : a.renderStatus(t, "inactive");
                break;
            case "sort":
                e.sort.match(/:asc/g) && (o = e.sort.replace(/:asc/g, "")),
                e.sort === i.sort || o === i.sort ? a.renderStatus(t, "active") : a.renderStatus(t, "inactive");
                break;
            case "toggle":
                for (n.length < 1 && a.renderStatus(t, "inactive"),
                e.filter === i.filter && a.renderStatus(t, "active"),
                s = 0; s < n.length; s++) {
                    if (n[s] === i.filter) {
                        a.renderStatus(t, "active");
                        break
                    }
                    a.renderStatus(t, "inactive")
                }
            }
            a.callActions("afterParseStatusChange", arguments)
        },
        renderStatus: function(t, e) {
            var i = this;
            switch (i.callActions("beforeRenderStatus", arguments),
            e) {
            case "active":
                p.addClass(t, i.classNames.active),
                p.removeClass(t, i.classNames.disabled),
                i.canDisable && (i.el.disabled = !1);
                break;
            case "inactive":
                p.removeClass(t, i.classNames.active),
                p.removeClass(t, i.classNames.disabled),
                i.canDisable && (i.el.disabled = !1);
                break;
            case "disabled":
                i.canDisable && (i.el.disabled = !0),
                p.addClass(t, i.classNames.disabled),
                p.removeClass(t, i.classNames.active)
            }
            "live" !== i.status && (i.status = e),
            i.callActions("afterRenderStatus", arguments)
        }
    }),
    f.controls = [],
    f.StyleData = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.x = 0,
        this.y = 0,
        this.top = 0,
        this.right = 0,
        this.bottom = 0,
        this.left = 0,
        this.width = 0,
        this.height = 0,
        this.marginRight = 0,
        this.marginBottom = 0,
        this.opacity = 0,
        this.scale = new f.TransformData,
        this.translateX = new f.TransformData,
        this.translateY = new f.TransformData,
        this.translateZ = new f.TransformData,
        this.rotateX = new f.TransformData,
        this.rotateY = new f.TransformData,
        this.rotateZ = new f.TransformData,
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.StyleData),
    f.StyleData.prototype = Object.create(f.Base.prototype),
    f.StyleData.prototype.constructor = f.StyleData,
    f.TransformData = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.value = 0,
        this.unit = "",
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.TransformData),
    f.TransformData.prototype = Object.create(f.Base.prototype),
    f.TransformData.prototype.constructor = f.TransformData,
    f.TransformDefaults = function() {
        f.StyleData.apply(this),
        this.callActions("beforeConstruct"),
        this.scale.value = .01,
        this.scale.unit = "",
        this.translateX.value = 20,
        this.translateX.unit = "px",
        this.translateY.value = 20,
        this.translateY.unit = "px",
        this.translateZ.value = 20,
        this.translateZ.unit = "px",
        this.rotateX.value = 90,
        this.rotateX.unit = "deg",
        this.rotateY.value = 90,
        this.rotateY.unit = "deg",
        this.rotateX.value = 90,
        this.rotateX.unit = "deg",
        this.rotateZ.value = 180,
        this.rotateZ.unit = "deg",
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.TransformDefaults),
    f.TransformDefaults.prototype = Object.create(f.StyleData.prototype),
    f.TransformDefaults.prototype.constructor = f.TransformDefaults,
    f.transformDefaults = new f.TransformDefaults,
    f.EventDetail = function() {
        this.state = null,
        this.futureState = null,
        this.instance = null,
        this.originalEvent = null
    }
    ,
    f.Events = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.mixStart = null,
        this.mixBusy = null,
        this.mixEnd = null,
        this.mixFail = null,
        this.mixClick = null,
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.Events),
    f.Events.prototype = Object.create(f.Base.prototype),
    f.Events.prototype.constructor = f.Events,
    f.Events.prototype.fire = function(t, e, i, n) {
        var a, o = new f.EventDetail;
        if (this.callActions("beforeFire", arguments),
        void 0 === this[t])
            throw new Error('Event type "' + t + '" not found.');
        o.state = new f.State,
        p.extend(o.state, i.state),
        i.futureState && (o.futureState = new f.State,
        p.extend(o.futureState, i.futureState)),
        o.instance = i.instance,
        i.originalEvent && (o.originalEvent = i.originalEvent),
        a = p.getCustomEvent(t, o, n),
        this.callFilters("eventFire", a, arguments),
        e.dispatchEvent(a)
    }
    ,
    f.events = new f.Events,
    f.QueueItem = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.args = [],
        this.instruction = null,
        this.triggerElement = null,
        this.deferred = null,
        this.isToggling = !1,
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.QueueItem),
    f.QueueItem.prototype = Object.create(f.Base.prototype),
    f.QueueItem.prototype.constructor = f.QueueItem,
    f.Mixer = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.config = new f.Config,
        this.id = "",
        this.isBusy = !1,
        this.isToggling = !1,
        this.incPadding = !0,
        this.controls = [],
        this.targets = [],
        this.origOrder = [],
        this.cache = {},
        this.toggleArray = [],
        this.targetsMoved = 0,
        this.targetsImmovable = 0,
        this.targetsBound = 0,
        this.targetsDone = 0,
        this.staggerDuration = 0,
        this.effectsIn = null,
        this.effectsOut = null,
        this.transformIn = [],
        this.transformOut = [],
        this.queue = [],
        this.state = null,
        this.lastOperation = null,
        this.lastClicked = null,
        this.userCallback = null,
        this.userDeferred = null,
        this.dom = new f.MixerDom,
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.Mixer),
    f.Mixer.prototype = Object.create(f.Base.prototype),
    p.extend(f.Mixer.prototype, {
        constructor: f.Mixer,
        attach: function(t, e, i, n) {
            var a = this
              , o = null
              , s = -1;
            for (a.callActions("beforeAttach", arguments),
            a.id = i,
            n && p.extend(a.config, n, !0, !0),
            a.sanitizeConfig(),
            a.cacheDom(t, e),
            a.config.layout.containerClassName && p.addClass(a.dom.container, a.config.layout.containerClassName),
            f.features.has.transitions || (a.config.animation.enable = !1),
            void 0 === h.console && (a.config.debug.showWarnings = !1),
            a.config.data.uidKey && (a.config.controls.enable = !1),
            a.indexTargets(),
            a.state = a.getInitialState(),
            s = 0; o = a.lastOperation.toHide[s]; s++)
                o.hide();
            a.config.controls.enable && (a.initControls(),
            a.updateControls({
                filter: a.state.activeFilter,
                sort: a.state.activeSort
            }),
            a.buildToggleArray(null, a.state)),
            a.parseEffects(),
            a.callActions("afterAttach", arguments)
        },
        sanitizeConfig: function() {
            var t = this;
            t.callActions("beforeSanitizeConfig", arguments),
            t.config.controls.scope = t.config.controls.scope.toLowerCase().trim(),
            t.config.controls.toggleLogic = t.config.controls.toggleLogic.toLowerCase().trim(),
            t.config.controls.toggleDefault = t.config.controls.toggleDefault.toLowerCase().trim(),
            t.config.animation.effects = t.config.animation.effects.trim(),
            t.callActions("afterSanitizeConfig", arguments)
        },
        getInitialState: function() {
            var t = this
              , e = new f.State
              , i = new f.Operation;
            if (t.callActions("beforeGetInitialState", arguments),
            e.activeContainerClassName = t.config.layout.containerClassName,
            t.config.load.dataset) {
                if (!t.config.data.uidKey || "string" != typeof t.config.data.uidKey)
                    throw new TypeError(f.messages.errorConfigDataUidKeyNotSet());
                i.startDataset = i.newDataset = e.activeDataset = t.config.load.dataset.slice(),
                i.startContainerClassName = i.newContainerClassName = e.activeContainerClassName,
                i.show = t.targets.slice(),
                e = t.callFilters("stateGetInitialState", e, arguments)
            } else
                e.activeFilter = t.parseFilterArgs([t.config.load.filter]).command,
                e.activeSort = t.parseSortArgs([t.config.load.sort]).command,
                e.totalTargets = t.targets.length,
                (e = t.callFilters("stateGetInitialState", e, arguments)).activeSort.collection || e.activeSort.attribute || "random" === e.activeSort.order || "desc" === e.activeSort.order ? (i.newSort = e.activeSort,
                t.sortOperation(i),
                t.printSort(!1, i),
                t.targets = i.newOrder) : i.startOrder = i.newOrder = t.targets,
                i.startFilter = i.newFilter = e.activeFilter,
                i.startSort = i.newSort = e.activeSort,
                i.startContainerClassName = i.newContainerClassName = e.activeContainerClassName,
                "all" === i.newFilter.selector ? i.newFilter.selector = t.config.selectors.target : "none" === i.newFilter.selector && (i.newFilter.selector = "");
            return i = t.callFilters("operationGetInitialState", i, [e]),
            (t.lastOperation = i).newFilter && t.filterOperation(i),
            t.buildState(i)
        },
        cacheDom: function(t, e) {
            var i = this;
            i.callActions("beforeCacheDom", arguments),
            i.dom.document = e,
            i.dom.body = i.dom.document.querySelector("body"),
            i.dom.container = t,
            i.dom.parent = t,
            i.callActions("afterCacheDom", arguments)
        },
        indexTargets: function() {
            var t, e = this, i = null, n = null, a = -1;
            if (e.callActions("beforeIndexTargets", arguments),
            e.dom.targets = e.config.layout.allowNestedTargets ? e.dom.container.querySelectorAll(e.config.selectors.target) : p.children(e.dom.container, e.config.selectors.target, e.dom.document),
            e.dom.targets = p.arrayFromList(e.dom.targets),
            e.targets = [],
            (t = e.config.load.dataset) && t.length !== e.dom.targets.length)
                throw new Error(f.messages.errorDatasetPrerenderedMismatch());
            if (e.dom.targets.length) {
                for (a = 0; n = e.dom.targets[a]; a++)
                    (i = new f.Target).init(n, e, t ? t[a] : void 0),
                    i.isInDom = !0,
                    e.targets.push(i);
                e.dom.parent = e.dom.targets[0].parentElement === e.dom.container ? e.dom.container : e.dom.targets[0].parentElement
            }
            e.origOrder = e.targets,
            e.callActions("afterIndexTargets", arguments)
        },
        initControls: function() {
            var t = this
              , e = ""
              , i = null
              , n = null
              , a = null
              , o = null
              , s = null
              , r = -1
              , l = -1;
            switch (t.callActions("beforeInitControls", arguments),
            t.config.controls.scope) {
            case "local":
                a = t.dom.container;
                break;
            case "global":
                a = t.dom.document;
                break;
            default:
                throw new Error(f.messages.errorConfigInvalidControlsScope())
            }
            for (r = 0; e = f.controlDefinitions[r]; r++)
                if (t.config.controls.live || e.live) {
                    if (e.parent) {
                        if (!(o = t.dom[e.parent]) || o.length < 0)
                            continue;
                        "number" != typeof o.length && (o = [o])
                    } else
                        o = [a];
                    for (l = 0; n = o[l]; l++)
                        s = t.getControl(n, e.type, e.selector),
                        t.controls.push(s)
                } else
                    for (i = a.querySelectorAll(t.config.selectors.control + e.selector),
                    l = 0; n = i[l]; l++)
                        (s = t.getControl(n, e.type, "")) && t.controls.push(s);
            t.callActions("afterInitControls", arguments)
        },
        getControl: function(t, e, i) {
            var n = this
              , a = null
              , o = -1;
            if (n.callActions("beforeGetControl", arguments),
            !i)
                for (o = 0; a = f.controls[o]; o++) {
                    if (a.el === t && a.isBound(n))
                        return n.callFilters("controlGetControl", null, arguments);
                    if (a.el === t && a.type === e && a.selector === i)
                        return a.addBinding(n),
                        n.callFilters("controlGetControl", a, arguments)
                }
            return (a = new f.Control).init(t, e, i),
            a.classNames.base = p.getClassname(n.config.classNames, e),
            a.classNames.active = p.getClassname(n.config.classNames, e, n.config.classNames.modifierActive),
            a.classNames.disabled = p.getClassname(n.config.classNames, e, n.config.classNames.modifierDisabled),
            a.addBinding(n),
            n.callFilters("controlGetControl", a, arguments)
        },
        getToggleSelector: function() {
            var t = this
              , e = "or" === t.config.controls.toggleLogic ? ", " : ""
              , i = "";
            return t.callActions("beforeGetToggleSelector", arguments),
            t.toggleArray = p.clean(t.toggleArray),
            "" === (i = t.toggleArray.join(e)) && (i = t.config.controls.toggleDefault),
            t.callFilters("selectorGetToggleSelector", i, arguments)
        },
        buildToggleArray: function(t, e) {
            var i = this
              , n = "";
            if (i.callActions("beforeBuildToggleArray", arguments),
            t && t.filter)
                n = t.filter.selector.replace(/\s/g, "");
            else {
                if (!e)
                    return;
                n = e.activeFilter.selector.replace(/\s/g, "")
            }
            n !== i.config.selectors.target && "all" !== n || (n = ""),
            "or" === i.config.controls.toggleLogic ? i.toggleArray = n.split(",") : i.toggleArray = i.splitCompoundSelector(n),
            i.toggleArray = p.clean(i.toggleArray),
            i.callActions("afterBuildToggleArray", arguments)
        },
        splitCompoundSelector: function(t) {
            var e = t.split(/([\.\[])/g)
              , i = []
              , n = ""
              , a = -1;
            for ("" === e[0] && e.shift(),
            a = 0; a < e.length; a++)
                a % 2 == 0 && (n = ""),
                n += e[a],
                a % 2 != 0 && i.push(n);
            return i
        },
        updateControls: function(t) {
            var e = this
              , i = null
              , n = new f.CommandMultimix
              , a = -1;
            for (e.callActions("beforeUpdateControls", arguments),
            t.filter ? n.filter = t.filter.selector : n.filter = e.state.activeFilter.selector,
            t.sort ? n.sort = e.buildSortString(t.sort) : n.sort = e.buildSortString(e.state.activeSort),
            n.filter === e.config.selectors.target && (n.filter = "all"),
            "" === n.filter && (n.filter = "none"),
            p.freeze(n),
            a = 0; i = e.controls[a]; a++)
                i.update(n, e.toggleArray);
            e.callActions("afterUpdateControls", arguments)
        },
        buildSortString: function(t) {
            var e = "";
            return e += t.sortString,
            t.next && (e += " " + this.buildSortString(t.next)),
            e
        },
        insertTargets: function(t, e) {
            var i, n = this, a = -1, o = null, s = null, r = null, l = -1;
            if (n.callActions("beforeInsertTargets", arguments),
            void 0 === t.index && (t.index = 0),
            i = n.getNextSibling(t.index, t.sibling, t.position),
            o = n.dom.document.createDocumentFragment(),
            a = i ? p.index(i, n.config.selectors.target) : n.targets.length,
            t.collection) {
                for (l = 0; r = t.collection[l]; l++) {
                    if (-1 < n.dom.targets.indexOf(r))
                        throw new Error(f.messages.errorInsertPreexistingElement());
                    r.style.display = "none",
                    o.appendChild(r),
                    o.appendChild(n.dom.document.createTextNode(" ")),
                    p.isElement(r, n.dom.document) && r.matches(n.config.selectors.target) && ((s = new f.Target).init(r, n),
                    s.isInDom = !0,
                    n.targets.splice(a, 0, s),
                    a++)
                }
                n.dom.parent.insertBefore(o, i)
            }
            e.startOrder = n.origOrder = n.targets,
            n.callActions("afterInsertTargets", arguments)
        },
        getNextSibling: function(t, e, i) {
            var n = this
              , a = null;
            return t = Math.max(t, 0),
            e && "before" === i ? a = e : e && "after" === i ? a = e.nextElementSibling || null : 0 < n.targets.length && void 0 !== t ? a = t < n.targets.length || !n.targets.length ? n.targets[t].dom.el : n.targets[n.targets.length - 1].dom.el.nextElementSibling : 0 === n.targets.length && 0 < n.dom.parent.children.length && (n.config.layout.siblingAfter ? a = n.config.layout.siblingAfter : n.config.layout.siblingBefore ? a = n.config.layout.siblingBefore.nextElementSibling : n.dom.parent.children[0]),
            n.callFilters("elementGetNextSibling", a, arguments)
        },
        filterOperation: function(t) {
            var e, i = !1, n = -1, a = null, o = -1;
            for (this.callActions("beforeFilterOperation", arguments),
            e = t.newFilter.action,
            o = 0; a = t.newOrder[o]; o++)
                i = t.newFilter.collection ? -1 < t.newFilter.collection.indexOf(a.dom.el) : "" !== t.newFilter.selector && a.dom.el.matches(t.newFilter.selector),
                this.evaluateHideShow(i, a, e, t);
            if (t.toRemove.length)
                for (o = 0; a = t.show[o]; o++)
                    -1 < t.toRemove.indexOf(a) && (t.show.splice(o, 1),
                    -1 < (n = t.toShow.indexOf(a)) && t.toShow.splice(n, 1),
                    t.toHide.push(a),
                    t.hide.push(a),
                    o--);
            t.matching = t.show.slice(),
            0 === t.show.length && "" !== t.newFilter.selector && 0 !== this.targets.length && (t.hasFailed = !0),
            this.callActions("afterFilterOperation", arguments)
        },
        evaluateHideShow: function(t, e, i, n) {
            this.callActions("beforeEvaluateHideShow", arguments),
            !0 === t && "show" === i || !1 === t && "hide" === i ? (n.show.push(e),
            e.isShown || n.toShow.push(e)) : (n.hide.push(e),
            e.isShown && n.toHide.push(e)),
            this.callActions("afterEvaluateHideShow", arguments)
        },
        sortOperation: function(i) {
            var n = this;
            n.callActions("beforeSortOperation", arguments),
            i.startOrder = n.targets,
            i.newSort.collection ? i.newOrder = i.newSort.collection : "random" === i.newSort.order ? i.newOrder = p.arrayShuffle(i.startOrder) : "" === i.newSort.attribute ? (i.newOrder = n.origOrder.slice(),
            "desc" === i.newSort.order && i.newOrder.reverse()) : (i.newOrder = i.startOrder.slice(),
            i.newOrder.sort(function(t, e) {
                return n.compare(t, e, i.newSort)
            })),
            p.isEqualArray(i.newOrder, i.startOrder) && (i.willSort = !1),
            n.callActions("afterSortOperation", arguments)
        },
        compare: function(t, e, i) {
            var n = i.order
              , a = this.getAttributeValue(t, i.attribute)
              , o = this.getAttributeValue(e, i.attribute);
            return isNaN(1 * a) || isNaN(1 * o) ? (a = a.toLowerCase(),
            o = o.toLowerCase()) : (a *= 1,
            o *= 1),
            a < o ? "asc" === n ? -1 : 1 : o < a ? "asc" === n ? 1 : -1 : a === o && i.next ? this.compare(t, e, i.next) : 0
        },
        getAttributeValue: function(t, e) {
            var i;
            return null === (i = t.dom.el.getAttribute("data-" + e)) && this.config.debug.showWarnings && console.warn(f.messages.warningInconsistentSortingAttributes({
                attribute: "data-" + e
            })),
            this.callFilters("valueGetAttributeValue", i || 0, arguments)
        },
        printSort: function(t, e) {
            var i, n = this, a = t ? e.newOrder : e.startOrder, o = t ? e.startOrder : e.newOrder, s = a.length ? a[a.length - 1].dom.el.nextElementSibling : null, r = h.document.createDocumentFragment(), l = null, c = null, u = -1;
            for (n.callActions("beforePrintSort", arguments),
            u = 0; l = a[u]; u++)
                "absolute" !== (c = l.dom.el).style.position && (p.removeWhitespace(c.previousSibling),
                c.parentElement.removeChild(c));
            for ((i = s ? s.previousSibling : n.dom.parent.lastChild) && "#text" === i.nodeName && p.removeWhitespace(i),
            u = 0; l = o[u]; u++)
                c = l.dom.el,
                p.isElement(r.lastChild) && r.appendChild(h.document.createTextNode(" ")),
                r.appendChild(c);
            n.dom.parent.firstChild && n.dom.parent.firstChild !== s && r.insertBefore(h.document.createTextNode(" "), r.childNodes[0]),
            s ? (r.appendChild(h.document.createTextNode(" ")),
            n.dom.parent.insertBefore(r, s)) : n.dom.parent.appendChild(r),
            n.callActions("afterPrintSort", arguments)
        },
        parseSortString: function(t, e) {
            var i = t.split(" ")
              , n = e
              , a = []
              , o = -1;
            for (o = 0; o < i.length; o++) {
                switch (a = i[o].split(":"),
                n.sortString = i[o],
                n.attribute = p.dashCase(a[0]),
                n.order = a[1] || "asc",
                n.attribute) {
                case "default":
                    n.attribute = "";
                    break;
                case "random":
                    n.attribute = "",
                    n.order = "random"
                }
                if (!n.attribute || "random" === n.order)
                    break;
                o < i.length - 1 && (n.next = new f.CommandSort,
                p.freeze(n),
                n = n.next)
            }
            return this.callFilters("commandsParseSort", e, arguments)
        },
        parseEffects: function() {
            var t = this
              , e = ""
              , i = t.config.animation.effectsIn || t.config.animation.effects
              , n = t.config.animation.effectsOut || t.config.animation.effects;
            for (e in t.callActions("beforeParseEffects", arguments),
            t.effectsIn = new f.StyleData,
            t.effectsOut = new f.StyleData,
            t.transformIn = [],
            t.transformOut = [],
            t.effectsIn.opacity = t.effectsOut.opacity = 1,
            t.parseEffect("fade", i, t.effectsIn, t.transformIn),
            t.parseEffect("fade", n, t.effectsOut, t.transformOut, !0),
            f.transformDefaults)
                f.transformDefaults[e]instanceof f.TransformData && (t.parseEffect(e, i, t.effectsIn, t.transformIn),
                t.parseEffect(e, n, t.effectsOut, t.transformOut, !0));
            t.parseEffect("stagger", i, t.effectsIn, t.transformIn),
            t.parseEffect("stagger", n, t.effectsOut, t.transformOut, !0),
            t.callActions("afterParseEffects", arguments)
        },
        parseEffect: function(t, e, i, n, a) {
            var o, s = this, r = "", l = "", c = ["%", "px", "em", "rem", "vh", "vw", "deg"], u = "", d = -1;
            if (s.callActions("beforeParseEffect", arguments),
            "string" != typeof e)
                throw new TypeError(f.messages.errorConfigInvalidAnimationEffects());
            if (e.indexOf(t) < 0)
                "stagger" === t && (s.staggerDuration = 0);
            else {
                switch (-1 < (o = e.indexOf(t + "(")) && (r = e.substring(o),
                l = /\(([^)]+)\)/.exec(r)[1]),
                t) {
                case "fade":
                    i.opacity = l ? parseFloat(l) : 0;
                    break;
                case "stagger":
                    s.staggerDuration = l ? parseFloat(l) : 100;
                    break;
                default:
                    if (a && s.config.animation.reverseOut && "scale" !== t ? i[t].value = -1 * (l ? parseFloat(l) : f.transformDefaults[t].value) : i[t].value = l ? parseFloat(l) : f.transformDefaults[t].value,
                    l) {
                        for (d = 0; u = c[d]; d++)
                            if (-1 < l.indexOf(u)) {
                                i[t].unit = u;
                                break
                            }
                    } else
                        i[t].unit = f.transformDefaults[t].unit;
                    n.push(t + "(" + i[t].value + i[t].unit + ")")
                }
                s.callActions("afterParseEffect", arguments)
            }
        },
        buildState: function(t) {
            var e = this
              , i = new f.State
              , n = null
              , a = -1;
            for (e.callActions("beforeBuildState", arguments),
            a = 0; n = e.targets[a]; a++)
                (!t.toRemove.length || t.toRemove.indexOf(n) < 0) && i.targets.push(n.dom.el);
            for (a = 0; n = t.matching[a]; a++)
                i.matching.push(n.dom.el);
            for (a = 0; n = t.show[a]; a++)
                i.show.push(n.dom.el);
            for (a = 0; n = t.hide[a]; a++)
                (!t.toRemove.length || t.toRemove.indexOf(n) < 0) && i.hide.push(n.dom.el);
            return i.id = e.id,
            i.container = e.dom.container,
            i.activeFilter = t.newFilter,
            i.activeSort = t.newSort,
            i.activeDataset = t.newDataset,
            i.activeContainerClassName = t.newContainerClassName,
            i.hasFailed = t.hasFailed,
            i.totalTargets = e.targets.length,
            i.totalShow = t.show.length,
            i.totalHide = t.hide.length,
            i.totalMatching = t.matching.length,
            i.triggerElement = t.triggerElement,
            e.callFilters("stateBuildState", i, arguments)
        },
        goMix: function(t, e) {
            var i, n = this;
            return n.callActions("beforeGoMix", arguments),
            n.config.animation.duration && n.config.animation.effects && p.isVisible(n.dom.container) || (t = !1),
            e.toShow.length || e.toHide.length || e.willSort || e.willChangeLayout || (t = !1),
            e.startState.show.length || e.show.length || (t = !1),
            f.events.fire("mixStart", n.dom.container, {
                state: e.startState,
                futureState: e.newState,
                instance: n
            }, n.dom.document),
            "function" == typeof n.config.callbacks.onMixStart && n.config.callbacks.onMixStart.call(n.dom.container, e.startState, e.newState, n),
            p.removeClass(n.dom.container, p.getClassname(n.config.classNames, "container", n.config.classNames.modifierFailed)),
            i = n.userDeferred ? n.userDeferred : n.userDeferred = p.defer(f.libraries),
            n.isBusy = !0,
            t && f.features.has.transitions ? (h.pageYOffset !== e.docState.scrollTop && h.scrollTo(e.docState.scrollLeft, e.docState.scrollTop),
            n.config.animation.applyPerspective && (n.dom.parent.style[f.features.perspectiveProp] = n.config.animation.perspectiveDistance,
            n.dom.parent.style[f.features.perspectiveOriginProp] = n.config.animation.perspectiveOrigin),
            n.config.animation.animateResizeContainer && e.startHeight !== e.newHeight && e.viewportDeltaY !== e.startHeight - e.newHeight && (n.dom.parent.style.height = e.startHeight + "px"),
            n.config.animation.animateResizeContainer && e.startWidth !== e.newWidth && e.viewportDeltaX !== e.startWidth - e.newWidth && (n.dom.parent.style.width = e.startWidth + "px"),
            e.startHeight === e.newHeight && (n.dom.parent.style.height = e.startHeight + "px"),
            e.startWidth === e.newWidth && (n.dom.parent.style.width = e.startWidth + "px"),
            e.startHeight === e.newHeight && e.startWidth === e.newWidth && (n.dom.parent.style.overflow = "hidden"),
            requestAnimationFrame(function() {
                n.moveTargets(e)
            })) : n.config.debug.fauxAsync ? setTimeout(function() {
                n.cleanUp(e)
            }, n.config.animation.duration) : n.cleanUp(e),
            n.callFilters("promiseGoMix", i.promise, arguments)
        },
        getStartMixData: function(t) {
            var e = this
              , i = h.getComputedStyle(e.dom.parent)
              , n = e.dom.parent.getBoundingClientRect()
              , a = null
              , o = {}
              , s = -1
              , r = i[f.features.boxSizingProp];
            for (e.incPadding = "border-box" === r,
            e.callActions("beforeGetStartMixData", arguments),
            s = 0; a = t.show[s]; s++)
                o = a.getPosData(),
                t.showPosData[s] = {
                    startPosData: o
                };
            for (s = 0; a = t.toHide[s]; s++)
                o = a.getPosData(),
                t.toHidePosData[s] = {
                    startPosData: o
                };
            t.startX = n.left,
            t.startY = n.top,
            t.startHeight = e.incPadding ? n.height : n.height - parseFloat(i.paddingTop) - parseFloat(i.paddingBottom) - parseFloat(i.borderTop) - parseFloat(i.borderBottom),
            t.startWidth = e.incPadding ? n.width : n.width - parseFloat(i.paddingLeft) - parseFloat(i.paddingRight) - parseFloat(i.borderLeft) - parseFloat(i.borderRight),
            e.callActions("afterGetStartMixData", arguments)
        },
        setInter: function(t) {
            var e = this
              , i = null
              , n = -1;
            for (e.callActions("beforeSetInter", arguments),
            e.config.animation.clampHeight && (e.dom.parent.style.height = t.startHeight + "px",
            e.dom.parent.style.overflow = "hidden"),
            e.config.animation.clampWidth && (e.dom.parent.style.width = t.startWidth + "px",
            e.dom.parent.style.overflow = "hidden"),
            n = 0; i = t.toShow[n]; n++)
                i.show();
            t.willChangeLayout && (p.removeClass(e.dom.container, t.startContainerClassName),
            p.addClass(e.dom.container, t.newContainerClassName)),
            e.callActions("afterSetInter", arguments)
        },
        getInterMixData: function(t) {
            var e = null
              , i = -1;
            for (this.callActions("beforeGetInterMixData", arguments),
            i = 0; e = t.show[i]; i++)
                t.showPosData[i].interPosData = e.getPosData();
            for (i = 0; e = t.toHide[i]; i++)
                t.toHidePosData[i].interPosData = e.getPosData();
            this.callActions("afterGetInterMixData", arguments)
        },
        setFinal: function(t) {
            var e = null
              , i = -1;
            for (this.callActions("beforeSetFinal", arguments),
            t.willSort && this.printSort(!1, t),
            i = 0; e = t.toHide[i]; i++)
                e.hide();
            this.callActions("afterSetFinal", arguments)
        },
        getFinalMixData: function(t) {
            var e, i = this, n = null, a = null, o = -1;
            for (i.callActions("beforeGetFinalMixData", arguments),
            o = 0; a = t.show[o]; o++)
                t.showPosData[o].finalPosData = a.getPosData();
            for (o = 0; a = t.toHide[o]; o++)
                t.toHidePosData[o].finalPosData = a.getPosData();
            for ((i.config.animation.clampHeight || i.config.animation.clampWidth) && (i.dom.parent.style.height = i.dom.parent.style.width = i.dom.parent.style.overflow = ""),
            i.incPadding || (n = h.getComputedStyle(i.dom.parent)),
            e = i.dom.parent.getBoundingClientRect(),
            t.newX = e.left,
            t.newY = e.top,
            t.newHeight = i.incPadding ? e.height : e.height - parseFloat(n.paddingTop) - parseFloat(n.paddingBottom) - parseFloat(n.borderTop) - parseFloat(n.borderBottom),
            t.newWidth = i.incPadding ? e.width : e.width - parseFloat(n.paddingLeft) - parseFloat(n.paddingRight) - parseFloat(n.borderLeft) - parseFloat(n.borderRight),
            t.viewportDeltaX = t.docState.viewportWidth - this.dom.document.documentElement.clientWidth,
            t.viewportDeltaY = t.docState.viewportHeight - this.dom.document.documentElement.clientHeight,
            t.willSort && i.printSort(!0, t),
            o = 0; a = t.toShow[o]; o++)
                a.hide();
            for (o = 0; a = t.toHide[o]; o++)
                a.show();
            t.willChangeLayout && (p.removeClass(i.dom.container, t.newContainerClassName),
            p.addClass(i.dom.container, i.config.layout.containerClassName)),
            i.callActions("afterGetFinalMixData", arguments)
        },
        getTweenData: function(t) {
            var e = this
              , i = null
              , n = null
              , a = Object.getOwnPropertyNames(e.effectsIn)
              , o = ""
              , s = null
              , r = -1
              , l = -1
              , c = -1
              , u = -1;
            for (e.callActions("beforeGetTweenData", arguments),
            c = 0; i = t.show[c]; c++)
                for ((n = t.showPosData[c]).posIn = new f.StyleData,
                n.posOut = new f.StyleData,
                n.tweenData = new f.StyleData,
                i.isShown ? (n.posIn.x = n.startPosData.x - n.interPosData.x,
                n.posIn.y = n.startPosData.y - n.interPosData.y) : n.posIn.x = n.posIn.y = 0,
                n.posOut.x = n.finalPosData.x - n.interPosData.x,
                n.posOut.y = n.finalPosData.y - n.interPosData.y,
                n.posIn.opacity = i.isShown ? 1 : e.effectsIn.opacity,
                n.posOut.opacity = 1,
                n.tweenData.opacity = n.posOut.opacity - n.posIn.opacity,
                i.isShown || e.config.animation.nudge || (n.posIn.x = n.posOut.x,
                n.posIn.y = n.posOut.y),
                n.tweenData.x = n.posOut.x - n.posIn.x,
                n.tweenData.y = n.posOut.y - n.posIn.y,
                e.config.animation.animateResizeTargets && (n.posIn.width = n.startPosData.width,
                n.posIn.height = n.startPosData.height,
                r = (n.startPosData.width || n.finalPosData.width) - n.interPosData.width,
                n.posIn.marginRight = n.startPosData.marginRight - r,
                l = (n.startPosData.height || n.finalPosData.height) - n.interPosData.height,
                n.posIn.marginBottom = n.startPosData.marginBottom - l,
                n.posOut.width = n.finalPosData.width,
                n.posOut.height = n.finalPosData.height,
                r = (n.finalPosData.width || n.startPosData.width) - n.interPosData.width,
                n.posOut.marginRight = n.finalPosData.marginRight - r,
                l = (n.finalPosData.height || n.startPosData.height) - n.interPosData.height,
                n.posOut.marginBottom = n.finalPosData.marginBottom - l,
                n.tweenData.width = n.posOut.width - n.posIn.width,
                n.tweenData.height = n.posOut.height - n.posIn.height,
                n.tweenData.marginRight = n.posOut.marginRight - n.posIn.marginRight,
                n.tweenData.marginBottom = n.posOut.marginBottom - n.posIn.marginBottom),
                u = 0; o = a[u]; u++)
                    (s = e.effectsIn[o])instanceof f.TransformData && s.value && (n.posIn[o].value = s.value,
                    n.posOut[o].value = 0,
                    n.tweenData[o].value = n.posOut[o].value - n.posIn[o].value,
                    n.posIn[o].unit = n.posOut[o].unit = n.tweenData[o].unit = s.unit);
            for (c = 0; i = t.toHide[c]; c++)
                for ((n = t.toHidePosData[c]).posIn = new f.StyleData,
                n.posOut = new f.StyleData,
                n.tweenData = new f.StyleData,
                n.posIn.x = i.isShown ? n.startPosData.x - n.interPosData.x : 0,
                n.posIn.y = i.isShown ? n.startPosData.y - n.interPosData.y : 0,
                n.posOut.x = e.config.animation.nudge ? 0 : n.posIn.x,
                n.posOut.y = e.config.animation.nudge ? 0 : n.posIn.y,
                n.tweenData.x = n.posOut.x - n.posIn.x,
                n.tweenData.y = n.posOut.y - n.posIn.y,
                e.config.animation.animateResizeTargets && (n.posIn.width = n.startPosData.width,
                n.posIn.height = n.startPosData.height,
                r = n.startPosData.width - n.interPosData.width,
                n.posIn.marginRight = n.startPosData.marginRight - r,
                l = n.startPosData.height - n.interPosData.height,
                n.posIn.marginBottom = n.startPosData.marginBottom - l),
                n.posIn.opacity = 1,
                n.posOut.opacity = e.effectsOut.opacity,
                n.tweenData.opacity = n.posOut.opacity - n.posIn.opacity,
                u = 0; o = a[u]; u++)
                    (s = e.effectsOut[o])instanceof f.TransformData && s.value && (n.posIn[o].value = 0,
                    n.posOut[o].value = s.value,
                    n.tweenData[o].value = n.posOut[o].value - n.posIn[o].value,
                    n.posIn[o].unit = n.posOut[o].unit = n.tweenData[o].unit = s.unit);
            e.callActions("afterGetTweenData", arguments)
        },
        moveTargets: function(t) {
            var e = this
              , i = null
              , n = null
              , a = null
              , o = ""
              , s = !1
              , r = -1
              , l = -1
              , c = e.checkProgress.bind(e);
            for (e.callActions("beforeMoveTargets", arguments),
            l = 0; i = t.show[l]; l++)
                n = new f.IMoveData,
                a = t.showPosData[l],
                o = i.isShown ? "none" : "show",
                (s = e.willTransition(o, t.hasEffect, a.posIn, a.posOut)) && r++,
                i.show(),
                n.posIn = a.posIn,
                n.posOut = a.posOut,
                n.statusChange = o,
                n.staggerIndex = r,
                n.operation = t,
                n.callback = s ? c : null,
                i.move(n);
            for (l = 0; i = t.toHide[l]; l++)
                a = t.toHidePosData[l],
                n = new f.IMoveData,
                o = "hide",
                s = e.willTransition(o, a.posIn, a.posOut),
                n.posIn = a.posIn,
                n.posOut = a.posOut,
                n.statusChange = o,
                n.staggerIndex = l,
                n.operation = t,
                n.callback = s ? c : null,
                i.move(n);
            e.config.animation.animateResizeContainer && (e.dom.parent.style[f.features.transitionProp] = "height " + e.config.animation.duration + "ms ease, width " + e.config.animation.duration + "ms ease ",
            requestAnimationFrame(function() {
                t.startHeight !== t.newHeight && t.viewportDeltaY !== t.startHeight - t.newHeight && (e.dom.parent.style.height = t.newHeight + "px"),
                t.startWidth !== t.newWidth && t.viewportDeltaX !== t.startWidth - t.newWidth && (e.dom.parent.style.width = t.newWidth + "px")
            })),
            t.willChangeLayout && (p.removeClass(e.dom.container, e.config.layout.ContainerClassName),
            p.addClass(e.dom.container, t.newContainerClassName)),
            e.callActions("afterMoveTargets", arguments)
        },
        hasEffect: function() {
            var t = ["scale", "translateX", "translateY", "translateZ", "rotateX", "rotateY", "rotateZ"]
              , e = ""
              , i = null
              , n = !1
              , a = -1;
            if (1 !== this.effectsIn.opacity)
                return this.callFilters("resultHasEffect", !0, arguments);
            for (a = 0; e = t[a]; a++)
                if (0 !== ("undefined" !== (i = this.effectsIn[e]).value ? i.value : i)) {
                    n = !0;
                    break
                }
            return this.callFilters("resultHasEffect", n, arguments)
        },
        willTransition: function(t, e, i, n) {
            var a;
            return a = !(!p.isVisible(this.dom.container) || !("none" !== t && e || i.x !== n.x || i.y !== n.y) && (!this.config.animation.animateResizeTargets || i.width === n.width && i.height === n.height && i.marginRight === n.marginRight && i.marginTop === n.marginTop)),
            this.callFilters("resultWillTransition", a, arguments)
        },
        checkProgress: function(t) {
            this.targetsDone++,
            this.targetsBound === this.targetsDone && this.cleanUp(t)
        },
        cleanUp: function(t) {
            var e = this
              , i = null
              , n = null
              , a = null
              , o = null
              , s = -1;
            for (e.callActions("beforeCleanUp", arguments),
            e.targetsMoved = e.targetsImmovable = e.targetsBound = e.targetsDone = 0,
            s = 0; i = t.show[s]; s++)
                i.cleanUp(),
                i.show();
            for (s = 0; i = t.toHide[s]; s++)
                i.cleanUp(),
                i.hide();
            if (t.willSort && e.printSort(!1, t),
            e.dom.parent.style[f.features.transitionProp] = e.dom.parent.style.height = e.dom.parent.style.width = e.dom.parent.style.overflow = e.dom.parent.style[f.features.perspectiveProp] = e.dom.parent.style[f.features.perspectiveOriginProp] = "",
            t.willChangeLayout && (p.removeClass(e.dom.container, t.startContainerClassName),
            p.addClass(e.dom.container, t.newContainerClassName)),
            t.toRemove.length) {
                for (s = 0; i = e.targets[s]; s++)
                    -1 < t.toRemove.indexOf(i) && ((n = i.dom.el.previousSibling) && "#text" === n.nodeName && (a = i.dom.el.nextSibling) && "#text" === a.nodeName && p.removeWhitespace(n),
                    t.willSort || e.dom.parent.removeChild(i.dom.el),
                    e.targets.splice(s, 1),
                    i.isInDom = !1,
                    s--);
                e.origOrder = e.targets
            }
            t.willSort && (e.targets = t.newOrder),
            e.state = t.newState,
            e.lastOperation = t,
            e.dom.targets = e.state.targets,
            f.events.fire("mixEnd", e.dom.container, {
                state: e.state,
                instance: e
            }, e.dom.document),
            "function" == typeof e.config.callbacks.onMixEnd && e.config.callbacks.onMixEnd.call(e.dom.container, e.state, e),
            t.hasFailed && (f.events.fire("mixFail", e.dom.container, {
                state: e.state,
                instance: e
            }, e.dom.document),
            "function" == typeof e.config.callbacks.onMixFail && e.config.callbacks.onMixFail.call(e.dom.container, e.state, e),
            p.addClass(e.dom.container, p.getClassname(e.config.classNames, "container", e.config.classNames.modifierFailed))),
            "function" == typeof e.userCallback && e.userCallback.call(e.dom.container, e.state, e),
            "function" == typeof e.userDeferred.resolve && e.userDeferred.resolve(e.state),
            e.userCallback = null,
            e.userDeferred = null,
            e.lastClicked = null,
            e.isToggling = !1,
            e.isBusy = !1,
            e.queue.length && (e.callActions("beforeReadQueueCleanUp", arguments),
            o = e.queue.shift(),
            e.userDeferred = o.deferred,
            e.isToggling = o.isToggling,
            e.lastClicked = o.triggerElement,
            o.instruction.command instanceof f.CommandMultimix ? e.multimix.apply(e, o.args) : e.dataset.apply(e, o.args)),
            e.callActions("afterCleanUp", arguments)
        },
        parseMultimixArgs: function(t) {
            var e = this
              , i = new f.UserInstruction
              , n = null
              , a = -1;
            for (i.animate = e.config.animation.enable,
            i.command = new f.CommandMultimix,
            a = 0; a < t.length; a++)
                null !== (n = t[a]) && ("object" == typeof n ? p.extend(i.command, n) : "boolean" == typeof n ? i.animate = n : "function" == typeof n && (i.callback = n));
            return !i.command.insert || i.command.insert instanceof f.CommandInsert || (i.command.insert = e.parseInsertArgs([i.command.insert]).command),
            !i.command.remove || i.command.remove instanceof f.CommandRemove || (i.command.remove = e.parseRemoveArgs([i.command.remove]).command),
            !i.command.filter || i.command.filter instanceof f.CommandFilter || (i.command.filter = e.parseFilterArgs([i.command.filter]).command),
            !i.command.sort || i.command.sort instanceof f.CommandSort || (i.command.sort = e.parseSortArgs([i.command.sort]).command),
            !i.command.changeLayout || i.command.changeLayout instanceof f.CommandChangeLayout || (i.command.changeLayout = e.parseChangeLayoutArgs([i.command.changeLayout]).command),
            i = e.callFilters("instructionParseMultimixArgs", i, arguments),
            p.freeze(i),
            i
        },
        parseFilterArgs: function(t) {
            var e = new f.UserInstruction
              , i = null
              , n = -1;
            for (e.animate = this.config.animation.enable,
            e.command = new f.CommandFilter,
            n = 0; n < t.length; n++)
                "string" == typeof (i = t[n]) ? e.command.selector = i : null === i ? e.command.collection = [] : "object" == typeof i && p.isElement(i, this.dom.document) ? e.command.collection = [i] : "object" == typeof i && void 0 !== i.length ? e.command.collection = p.arrayFromList(i) : "object" == typeof i ? p.extend(e.command, i) : "boolean" == typeof i ? e.animate = i : "function" == typeof i && (e.callback = i);
            if (e.command.selector && e.command.collection)
                throw new Error(f.messages.errorFilterInvalidArguments());
            return e = this.callFilters("instructionParseFilterArgs", e, arguments),
            p.freeze(e),
            e
        },
        parseSortArgs: function(t) {
            var e = new f.UserInstruction
              , i = null
              , n = ""
              , a = -1;
            for (e.animate = this.config.animation.enable,
            e.command = new f.CommandSort,
            a = 0; a < t.length; a++)
                if (null !== (i = t[a]))
                    switch (typeof i) {
                    case "string":
                        n = i;
                        break;
                    case "object":
                        i.length && (e.command.collection = p.arrayFromList(i));
                        break;
                    case "boolean":
                        e.animate = i;
                        break;
                    case "function":
                        e.callback = i
                    }
            return n && (e.command = this.parseSortString(n, e.command)),
            e = this.callFilters("instructionParseSortArgs", e, arguments),
            p.freeze(e),
            e
        },
        parseInsertArgs: function(t) {
            var e = new f.UserInstruction
              , i = null
              , n = -1;
            for (e.animate = this.config.animation.enable,
            e.command = new f.CommandInsert,
            n = 0; n < t.length; n++)
                null !== (i = t[n]) && ("number" == typeof i ? e.command.index = i : "string" == typeof i && -1 < ["before", "after"].indexOf(i) ? e.command.position = i : "string" == typeof i ? e.command.collection = p.arrayFromList(p.createElement(i).childNodes) : "object" == typeof i && p.isElement(i, this.dom.document) ? e.command.collection.length ? e.command.sibling = i : e.command.collection = [i] : "object" == typeof i && i.length ? e.command.collection.length ? e.command.sibling = i[0] : e.command.collection = i : "object" == typeof i && i.childNodes && i.childNodes.length ? e.command.collection.length ? e.command.sibling = i.childNodes[0] : e.command.collection = p.arrayFromList(i.childNodes) : "object" == typeof i ? p.extend(e.command, i) : "boolean" == typeof i ? e.animate = i : "function" == typeof i && (e.callback = i));
            if (e.command.index && e.command.sibling)
                throw new Error(f.messages.errorInsertInvalidArguments());
            return !e.command.collection.length && this.config.debug.showWarnings && console.warn(f.messages.warningInsertNoElements()),
            e = this.callFilters("instructionParseInsertArgs", e, arguments),
            p.freeze(e),
            e
        },
        parseRemoveArgs: function(t) {
            var e = this
              , i = new f.UserInstruction
              , n = null
              , a = null
              , o = -1;
            for (i.animate = e.config.animation.enable,
            i.command = new f.CommandRemove,
            o = 0; o < t.length; o++)
                if (null !== (a = t[o]))
                    switch (typeof a) {
                    case "number":
                        e.targets[a] && (i.command.targets[0] = e.targets[a]);
                        break;
                    case "string":
                        i.command.collection = p.arrayFromList(e.dom.parent.querySelectorAll(a));
                        break;
                    case "object":
                        a && a.length ? i.command.collection = a : p.isElement(a, e.dom.document) ? i.command.collection = [a] : p.extend(i.command, a);
                        break;
                    case "boolean":
                        i.animate = a;
                        break;
                    case "function":
                        i.callback = a
                    }
            if (i.command.collection.length)
                for (o = 0; n = e.targets[o]; o++)
                    -1 < i.command.collection.indexOf(n.dom.el) && i.command.targets.push(n);
            return !i.command.targets.length && e.config.debug.showWarnings && console.warn(f.messages.warningRemoveNoElements()),
            p.freeze(i),
            i
        },
        parseDatasetArgs: function(t) {
            var e = new f.UserInstruction
              , i = null
              , n = -1;
            for (e.animate = this.config.animation.enable,
            e.command = new f.CommandDataset,
            n = 0; n < t.length; n++)
                if (null !== (i = t[n]))
                    switch (typeof i) {
                    case "object":
                        Array.isArray(i) || "number" == typeof i.length ? e.command.dataset = i : p.extend(e.command, i);
                        break;
                    case "boolean":
                        e.animate = i;
                        break;
                    case "function":
                        e.callback = i
                    }
            return p.freeze(e),
            e
        },
        parseChangeLayoutArgs: function(t) {
            var e = new f.UserInstruction
              , i = null
              , n = -1;
            for (e.animate = this.config.animation.enable,
            e.command = new f.CommandChangeLayout,
            n = 0; n < t.length; n++)
                if (null !== (i = t[n]))
                    switch (typeof i) {
                    case "string":
                        e.command.containerClassName = i;
                        break;
                    case "object":
                        p.extend(e.command, i);
                        break;
                    case "boolean":
                        e.animate = i;
                        break;
                    case "function":
                        e.callback = i
                    }
            return p.freeze(e),
            e
        },
        queueMix: function(t) {
            var e = this
              , i = null
              , n = "";
            return e.callActions("beforeQueueMix", arguments),
            i = p.defer(f.libraries),
            e.config.animation.queue && e.queue.length < e.config.animation.queueLimit ? (t.deferred = i,
            e.queue.push(t),
            e.config.controls.enable && (e.isToggling ? (e.buildToggleArray(t.instruction.command),
            n = e.getToggleSelector(),
            e.updateControls({
                filter: {
                    selector: n
                }
            })) : e.updateControls(t.instruction.command))) : (e.config.debug.showWarnings && console.warn(f.messages.warningMultimixInstanceQueueFull()),
            i.resolve(e.state),
            f.events.fire("mixBusy", e.dom.container, {
                state: e.state,
                instance: e
            }, e.dom.document),
            "function" == typeof e.config.callbacks.onMixBusy && e.config.callbacks.onMixBusy.call(e.dom.container, e.state, e)),
            e.callFilters("promiseQueueMix", i.promise, arguments)
        },
        getDataOperation: function(t) {
            var e = this
              , i = new f.Operation
              , n = [];
            if (i = e.callFilters("operationUnmappedGetDataOperation", i, arguments),
            e.dom.targets.length && !(n = e.state.activeDataset || []).length)
                throw new Error(f.messages.errorDatasetNotSet());
            return i.id = p.randomHex(),
            i.startState = e.state,
            i.startDataset = n,
            i.newDataset = t.slice(),
            e.diffDatasets(i),
            i.startOrder = e.targets,
            i.newOrder = i.show,
            e.config.animation.enable && (e.getStartMixData(i),
            e.setInter(i),
            i.docState = p.getDocumentState(e.dom.document),
            e.getInterMixData(i),
            e.setFinal(i),
            e.getFinalMixData(i),
            e.parseEffects(),
            i.hasEffect = e.hasEffect(),
            e.getTweenData(i)),
            e.targets = i.show.slice(),
            i.newState = e.buildState(i),
            Array.prototype.push.apply(e.targets, i.toRemove),
            e.callFilters("operationMappedGetDataOperation", i, arguments)
        },
        diffDatasets: function(t) {
            var e = this
              , i = []
              , n = []
              , a = []
              , o = null
              , s = null
              , r = null
              , l = null
              , c = null
              , u = {}
              , d = ""
              , h = -1;
            for (e.callActions("beforeDiffDatasets", arguments),
            h = 0; o = t.newDataset[h]; h++) {
                if (void 0 === (d = o[e.config.data.uidKey]) || d.toString().length < 1)
                    throw new TypeError(f.messages.errorDatasetInvalidUidKey({
                        uidKey: e.config.data.uidKey
                    }));
                if (u[d])
                    throw new Error(f.messages.errorDatasetDuplicateUid({
                        uid: d
                    }));
                u[d] = !0,
                (s = e.cache[d])instanceof f.Target ? (e.config.data.dirtyCheck && !p.deepEquals(o, s.data) && (r = s.render(o),
                s.data = o,
                r !== s.dom.el && (s.isInDom && (s.unbindEvents(),
                e.dom.parent.replaceChild(r, s.dom.el)),
                s.isShown || (r.style.display = "none"),
                s.dom.el = r,
                s.isInDom && s.bindEvents())),
                r = s.dom.el) : ((s = new f.Target).init(null, e, o),
                s.hide()),
                s.isInDom ? (c = s.dom.el.nextElementSibling,
                n.push(d),
                l && (l.lastElementChild && l.appendChild(e.dom.document.createTextNode(" ")),
                e.insertDatasetFrag(l, s.dom.el, a),
                l = null)) : (l || (l = e.dom.document.createDocumentFragment()),
                l.lastElementChild && l.appendChild(e.dom.document.createTextNode(" ")),
                l.appendChild(s.dom.el),
                s.isInDom = !0,
                s.unbindEvents(),
                s.bindEvents(),
                s.hide(),
                t.toShow.push(s),
                a.push(s)),
                t.show.push(s)
            }
            for (l && ((c = c || e.config.layout.siblingAfter) && l.appendChild(e.dom.document.createTextNode(" ")),
            e.insertDatasetFrag(l, c, a)),
            h = 0; o = t.startDataset[h]; h++)
                d = o[e.config.data.uidKey],
                s = e.cache[d],
                t.show.indexOf(s) < 0 ? (t.hide.push(s),
                t.toHide.push(s),
                t.toRemove.push(s)) : i.push(d);
            p.isEqualArray(i, n) || (t.willSort = !0),
            e.callActions("afterDiffDatasets", arguments)
        },
        insertDatasetFrag: function(t, e, i) {
            var n = e ? Array.from(this.dom.parent.children).indexOf(e) : this.targets.length;
            for (this.dom.parent.insertBefore(t, e); i.length; )
                this.targets.splice(n, 0, i.shift()),
                n++
        },
        willSort: function(t, e) {
            var i;
            return i = !!(this.config.behavior.liveSort || "random" === t.order || t.attribute !== e.attribute || t.order !== e.order || t.collection !== e.collection || null === t.next && e.next || t.next && null === e.next) || !(!t.next || !e.next) && this.willSort(t.next, e.next),
            this.callFilters("resultWillSort", i, arguments)
        },
        show: function() {
            return this.filter("all")
        },
        hide: function() {
            return this.filter("none")
        },
        isMixing: function() {
            return this.isBusy
        },
        filter: function() {
            var t = this.parseFilterArgs(arguments);
            return this.multimix({
                filter: t.command
            }, t.animate, t.callback)
        },
        toggleOn: function() {
            var t, e = this, i = e.parseFilterArgs(arguments), n = i.command.selector;
            return e.isToggling = !0,
            e.toggleArray.indexOf(n) < 0 && e.toggleArray.push(n),
            t = e.getToggleSelector(),
            e.multimix({
                filter: t
            }, i.animate, i.callback)
        },
        toggleOff: function() {
            var t, e = this, i = e.parseFilterArgs(arguments), n = i.command.selector;
            return e.isToggling = !0,
            e.toggleArray.splice(e.toggleArray.indexOf(n), 1),
            t = e.getToggleSelector(),
            e.multimix({
                filter: t
            }, i.animate, i.callback)
        },
        sort: function() {
            var t = this.parseSortArgs(arguments);
            return this.multimix({
                sort: t.command
            }, t.animate, t.callback)
        },
        changeLayout: function() {
            var t = this.parseChangeLayoutArgs(arguments);
            return this.multimix({
                changeLayout: t.command
            }, t.animate, t.callback)
        },
        dataset: function() {
            var t = this
              , e = t.parseDatasetArgs(arguments)
              , i = null
              , n = null
              , a = !1;
            return t.callActions("beforeDataset", arguments),
            t.isBusy ? ((n = new f.QueueItem).args = arguments,
            n.instruction = e,
            t.queueMix(n)) : (e.callback && (t.userCallback = e.callback),
            a = e.animate ^ t.config.animation.enable ? e.animate : t.config.animation.enable,
            i = t.getDataOperation(e.command.dataset),
            t.goMix(a, i))
        },
        multimix: function() {
            var t = this
              , e = null
              , i = !1
              , n = null
              , a = t.parseMultimixArgs(arguments);
            return t.callActions("beforeMultimix", arguments),
            t.isBusy ? ((n = new f.QueueItem).args = arguments,
            n.instruction = a,
            n.triggerElement = t.lastClicked,
            n.isToggling = t.isToggling,
            t.queueMix(n)) : (e = t.getOperation(a.command),
            t.config.controls.enable && (a.command.filter && !t.isToggling && (t.toggleArray.length = 0,
            t.buildToggleArray(e.command)),
            t.queue.length < 1 && t.updateControls(e.command)),
            a.callback && (t.userCallback = a.callback),
            i = a.animate ^ t.config.animation.enable ? a.animate : t.config.animation.enable,
            t.callFilters("operationMultimix", e, arguments),
            t.goMix(i, e))
        },
        getOperation: function(t) {
            var e = this
              , i = t.sort
              , n = t.filter
              , a = t.changeLayout
              , o = t.remove
              , s = t.insert
              , r = new f.Operation;
            return (r = e.callFilters("operationUnmappedGetOperation", r, arguments)).id = p.randomHex(),
            r.command = t,
            r.startState = e.state,
            r.triggerElement = e.lastClicked,
            e.isBusy ? (e.config.debug.showWarnings && console.warn(f.messages.warningGetOperationInstanceBusy()),
            null) : (s && e.insertTargets(s, r),
            o && (r.toRemove = o.targets),
            r.startSort = r.newSort = r.startState.activeSort,
            r.startOrder = r.newOrder = e.targets,
            i && (r.startSort = r.startState.activeSort,
            r.newSort = i,
            r.willSort = e.willSort(i, r.startState.activeSort),
            r.willSort && e.sortOperation(r)),
            r.startFilter = r.startState.activeFilter,
            r.newFilter = n || p.extend(new f.CommandFilter, r.startFilter),
            "all" === r.newFilter.selector ? r.newFilter.selector = e.config.selectors.target : "none" === r.newFilter.selector && (r.newFilter.selector = ""),
            e.filterOperation(r),
            r.startContainerClassName = r.startState.activeContainerClassName,
            a ? (r.newContainerClassName = a.containerClassName,
            r.newContainerClassName !== r.startContainerClassName && (r.willChangeLayout = !0)) : r.newContainerClassName = r.startContainerClassName,
            e.config.animation.enable && (e.getStartMixData(r),
            e.setInter(r),
            r.docState = p.getDocumentState(e.dom.document),
            e.getInterMixData(r),
            e.setFinal(r),
            e.getFinalMixData(r),
            e.parseEffects(),
            r.hasEffect = e.hasEffect(),
            e.getTweenData(r)),
            r.willSort && (e.targets = r.newOrder),
            r.newState = e.buildState(r),
            e.callFilters("operationMappedGetOperation", r, arguments))
        },
        tween: function(t, e) {
            var i = null
              , n = null
              , a = -1
              , o = -1;
            for (e = Math.min(e, 1),
            e = Math.max(e, 0),
            o = 0; i = t.show[o]; o++)
                n = t.showPosData[o],
                i.applyTween(n, e);
            for (o = 0; i = t.hide[o]; o++)
                i.isShown && i.hide(),
                -1 < (a = t.toHide.indexOf(i)) && (n = t.toHidePosData[a],
                i.isShown || i.show(),
                i.applyTween(n, e))
        },
        insert: function() {
            var t = this.parseInsertArgs(arguments);
            return this.multimix({
                insert: t.command
            }, t.animate, t.callback)
        },
        insertBefore: function() {
            var t = this.parseInsertArgs(arguments);
            return this.insert(t.command.collection, "before", t.command.sibling, t.animate, t.callback)
        },
        insertAfter: function() {
            var t = this.parseInsertArgs(arguments);
            return this.insert(t.command.collection, "after", t.command.sibling, t.animate, t.callback)
        },
        prepend: function() {
            var t = this.parseInsertArgs(arguments);
            return this.insert(0, t.command.collection, t.animate, t.callback)
        },
        append: function() {
            var t = this.parseInsertArgs(arguments);
            return this.insert(this.state.totalTargets, t.command.collection, t.animate, t.callback)
        },
        remove: function() {
            var t = this.parseRemoveArgs(arguments);
            return this.multimix({
                remove: t.command
            }, t.animate, t.callback)
        },
        getConfig: function(t) {
            var e;
            return e = t ? p.getProperty(this.config, t) : this.config,
            this.callFilters("valueGetConfig", e, arguments)
        },
        configure: function(t) {
            this.callActions("beforeConfigure", arguments),
            p.extend(this.config, t, !0, !0),
            this.callActions("afterConfigure", arguments)
        },
        getState: function() {
            var t;
            return t = new f.State,
            p.extend(t, this.state),
            p.freeze(t),
            this.callFilters("stateGetState", t, arguments)
        },
        forceRefresh: function() {
            this.indexTargets()
        },
        forceRender: function() {
            var t = this
              , e = null
              , i = null
              , n = "";
            for (n in t.cache)
                (i = (e = t.cache[n]).render(e.data)) !== e.dom.el && (e.isInDom && (e.unbindEvents(),
                t.dom.parent.replaceChild(i, e.dom.el)),
                e.isShown || (i.style.display = "none"),
                e.dom.el = i,
                e.isInDom && e.bindEvents());
            t.state = t.buildState(t.lastOperation)
        },
        destroy: function(t) {
            var e = this
              , i = null
              , n = null
              , a = 0;
            for (e.callActions("beforeDestroy", arguments),
            a = 0; i = e.controls[a]; a++)
                i.removeBinding(e);
            for (a = 0; n = e.targets[a]; a++)
                t && n.show(),
                n.unbindEvents();
            e.dom.container.id.match(/^MixItUp/) && e.dom.container.removeAttribute("id"),
            delete f.instances[e.id],
            e.callActions("afterDestroy", arguments)
        }
    }),
    f.IMoveData = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.posIn = null,
        this.posOut = null,
        this.operation = null,
        this.callback = null,
        this.statusChange = "",
        this.duration = -1,
        this.staggerIndex = -1,
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.IMoveData),
    f.IMoveData.prototype = Object.create(f.Base.prototype),
    f.IMoveData.prototype.constructor = f.IMoveData,
    f.TargetDom = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.el = null,
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.TargetDom),
    f.TargetDom.prototype = Object.create(f.Base.prototype),
    f.TargetDom.prototype.constructor = f.TargetDom,
    f.Target = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.id = "",
        this.sortString = "",
        this.mixer = null,
        this.callback = null,
        this.isShown = !1,
        this.isBound = !1,
        this.isExcluded = !1,
        this.isInDom = !1,
        this.handler = null,
        this.operation = null,
        this.data = null,
        this.dom = new f.TargetDom,
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.Target),
    f.Target.prototype = Object.create(f.Base.prototype),
    p.extend(f.Target.prototype, {
        constructor: f.Target,
        init: function(t, e, i) {
            var n = this
              , a = "";
            if (n.callActions("beforeInit", arguments),
            n.mixer = e,
            t || (t = n.render(i)),
            n.cacheDom(t),
            n.bindEvents(),
            "none" !== n.dom.el.style.display && (n.isShown = !0),
            i && e.config.data.uidKey) {
                if (void 0 === (a = i[e.config.data.uidKey]) || a.toString().length < 1)
                    throw new TypeError(f.messages.errorDatasetInvalidUidKey({
                        uidKey: e.config.data.uidKey
                    }));
                n.id = a,
                n.data = i,
                e.cache[a] = n
            }
            n.callActions("afterInit", arguments)
        },
        render: function(t) {
            var e, i = null, n = null, a = null;
            if (this.callActions("beforeRender", arguments),
            "function" != typeof (i = this.callFilters("renderRender", this.mixer.config.render.target, arguments)))
                throw new TypeError(f.messages.errorDatasetRendererNotSet());
            return (e = i(t)) && "object" == typeof e && p.isElement(e) ? n = e : "string" == typeof e && ((a = document.createElement("div")).innerHTML = e,
            n = a.firstElementChild),
            this.callFilters("elRender", n, arguments)
        },
        cacheDom: function(t) {
            this.callActions("beforeCacheDom", arguments),
            this.dom.el = t,
            this.callActions("afterCacheDom", arguments)
        },
        getSortString: function(t) {
            var e = this.dom.el.getAttribute("data-" + t) || "";
            this.callActions("beforeGetSortString", arguments),
            e = isNaN(1 * e) ? e.toLowerCase() : 1 * e,
            this.sortString = e,
            this.callActions("afterGetSortString", arguments)
        },
        show: function() {
            var t = this;
            t.callActions("beforeShow", arguments),
            t.isShown || (t.dom.el.style.display = "",
            t.isShown = !0),
            t.callActions("afterShow", arguments)
        },
        hide: function() {
            var t = this;
            t.callActions("beforeHide", arguments),
            t.isShown && (t.dom.el.style.display = "none",
            t.isShown = !1),
            t.callActions("afterHide", arguments)
        },
        move: function(t) {
            var e = this;
            e.callActions("beforeMove", arguments),
            e.isExcluded || e.mixer.targetsMoved++,
            e.applyStylesIn(t),
            requestAnimationFrame(function() {
                e.applyStylesOut(t)
            }),
            e.callActions("afterMove", arguments)
        },
        applyTween: function(t, e) {
            var i = this
              , n = ""
              , a = null
              , o = t.posIn
              , s = []
              , r = new f.StyleData
              , l = -1;
            for (i.callActions("beforeApplyTween", arguments),
            r.x = o.x,
            r.y = o.y,
            0 === e ? i.hide() : i.isShown || i.show(),
            l = 0; n = f.features.TWEENABLE[l]; l++)
                if (a = t.tweenData[n],
                "x" === n) {
                    if (!a)
                        continue;
                    r.x = o.x + a * e
                } else if ("y" === n) {
                    if (!a)
                        continue;
                    r.y = o.y + a * e
                } else if (a instanceof f.TransformData) {
                    if (!a.value)
                        continue;
                    r[n].value = o[n].value + a.value * e,
                    r[n].unit = a.unit,
                    s.push(n + "(" + r[n].value + a.unit + ")")
                } else {
                    if (!a)
                        continue;
                    r[n] = o[n] + a * e,
                    i.dom.el.style[n] = r[n]
                }
            (r.x || r.y) && s.unshift("translate(" + r.x + "px, " + r.y + "px)"),
            s.length && (i.dom.el.style[f.features.transformProp] = s.join(" ")),
            i.callActions("afterApplyTween", arguments)
        },
        applyStylesIn: function(t) {
            var e = this
              , i = t.posIn
              , n = 1 !== e.mixer.effectsIn.opacity
              , a = [];
            e.callActions("beforeApplyStylesIn", arguments),
            a.push("translate(" + i.x + "px, " + i.y + "px)"),
            e.mixer.config.animation.animateResizeTargets && ("show" !== t.statusChange && (e.dom.el.style.width = i.width + "px",
            e.dom.el.style.height = i.height + "px"),
            e.dom.el.style.marginRight = i.marginRight + "px",
            e.dom.el.style.marginBottom = i.marginBottom + "px"),
            n && (e.dom.el.style.opacity = i.opacity),
            "show" === t.statusChange && (a = a.concat(e.mixer.transformIn)),
            e.dom.el.style[f.features.transformProp] = a.join(" "),
            e.callActions("afterApplyStylesIn", arguments)
        },
        applyStylesOut: function(t) {
            var e = this
              , i = []
              , n = []
              , a = e.mixer.config.animation.animateResizeTargets
              , o = void 0 !== e.mixer.effectsIn.opacity;
            if (e.callActions("beforeApplyStylesOut", arguments),
            i.push(e.writeTransitionRule(f.features.transformRule, t.staggerIndex)),
            "none" !== t.statusChange && i.push(e.writeTransitionRule("opacity", t.staggerIndex, t.duration)),
            a && (i.push(e.writeTransitionRule("width", t.staggerIndex, t.duration)),
            i.push(e.writeTransitionRule("height", t.staggerIndex, t.duration)),
            i.push(e.writeTransitionRule("margin", t.staggerIndex, t.duration))),
            !t.callback)
                return e.mixer.targetsImmovable++,
                void (e.mixer.targetsMoved === e.mixer.targetsImmovable && e.mixer.cleanUp(t.operation));
            switch (e.operation = t.operation,
            e.callback = t.callback,
            e.isExcluded || e.mixer.targetsBound++,
            e.isBound = !0,
            e.applyTransition(i),
            a && 0 < t.posOut.width && 0 < t.posOut.height && (e.dom.el.style.width = t.posOut.width + "px",
            e.dom.el.style.height = t.posOut.height + "px",
            e.dom.el.style.marginRight = t.posOut.marginRight + "px",
            e.dom.el.style.marginBottom = t.posOut.marginBottom + "px"),
            e.mixer.config.animation.nudge || "hide" !== t.statusChange || n.push("translate(" + t.posOut.x + "px, " + t.posOut.y + "px)"),
            t.statusChange) {
            case "hide":
                o && (e.dom.el.style.opacity = e.mixer.effectsOut.opacity),
                n = n.concat(e.mixer.transformOut);
                break;
            case "show":
                o && (e.dom.el.style.opacity = 1)
            }
            (e.mixer.config.animation.nudge || !e.mixer.config.animation.nudge && "hide" !== t.statusChange) && n.push("translate(" + t.posOut.x + "px, " + t.posOut.y + "px)"),
            e.dom.el.style[f.features.transformProp] = n.join(" "),
            e.callActions("afterApplyStylesOut", arguments)
        },
        writeTransitionRule: function(t, e, i) {
            var n, a = this.getDelay(e);
            return n = t + " " + (0 < i ? i : this.mixer.config.animation.duration) + "ms " + a + "ms " + ("opacity" === t ? "linear" : this.mixer.config.animation.easing),
            this.callFilters("ruleWriteTransitionRule", n, arguments)
        },
        getDelay: function(t) {
            var e, i = this;
            return "function" == typeof i.mixer.config.animation.staggerSequence && (t = i.mixer.config.animation.staggerSequence.call(i, t, i.state)),
            e = i.mixer.staggerDuration ? t * i.mixer.staggerDuration : 0,
            i.callFilters("delayGetDelay", e, arguments)
        },
        applyTransition: function(t) {
            var e = t.join(", ");
            this.callActions("beforeApplyTransition", arguments),
            this.dom.el.style[f.features.transitionProp] = e,
            this.callActions("afterApplyTransition", arguments)
        },
        handleTransitionEnd: function(t) {
            var e = this
              , i = t.propertyName
              , n = e.mixer.config.animation.animateResizeTargets;
            e.callActions("beforeHandleTransitionEnd", arguments),
            e.isBound && t.target.matches(e.mixer.config.selectors.target) && (-1 < i.indexOf("transform") || -1 < i.indexOf("opacity") || n && -1 < i.indexOf("height") || n && -1 < i.indexOf("width") || n && -1 < i.indexOf("margin")) && (e.callback.call(e, e.operation),
            e.isBound = !1,
            e.callback = null,
            e.operation = null),
            e.callActions("afterHandleTransitionEnd", arguments)
        },
        eventBus: function(t) {
            switch (this.callActions("beforeEventBus", arguments),
            t.type) {
            case "webkitTransitionEnd":
            case "transitionend":
                this.handleTransitionEnd(t)
            }
            this.callActions("afterEventBus", arguments)
        },
        unbindEvents: function() {
            var t = this;
            t.callActions("beforeUnbindEvents", arguments),
            p.off(t.dom.el, "webkitTransitionEnd", t.handler),
            p.off(t.dom.el, "transitionend", t.handler),
            t.callActions("afterUnbindEvents", arguments)
        },
        bindEvents: function() {
            var t, e = this;
            e.callActions("beforeBindEvents", arguments),
            t = "webkit" === f.features.transitionPrefix ? "webkitTransitionEnd" : "transitionend",
            e.handler = function(t) {
                return e.eventBus(t)
            }
            ,
            p.on(e.dom.el, t, e.handler),
            e.callActions("afterBindEvents", arguments)
        },
        getPosData: function(t) {
            var e = this
              , i = {}
              , n = null
              , a = new f.StyleData;
            return e.callActions("beforeGetPosData", arguments),
            a.x = e.dom.el.offsetLeft,
            a.y = e.dom.el.offsetTop,
            (e.mixer.config.animation.animateResizeTargets || t) && (n = e.dom.el.getBoundingClientRect(),
            a.top = n.top,
            a.right = n.right,
            a.bottom = n.bottom,
            a.left = n.left,
            a.width = n.width,
            a.height = n.height),
            e.mixer.config.animation.animateResizeTargets && (i = h.getComputedStyle(e.dom.el),
            a.marginBottom = parseFloat(i.marginBottom),
            a.marginRight = parseFloat(i.marginRight)),
            e.callFilters("posDataGetPosData", a, arguments)
        },
        cleanUp: function() {
            var t = this;
            t.callActions("beforeCleanUp", arguments),
            t.dom.el.style[f.features.transformProp] = "",
            t.dom.el.style[f.features.transitionProp] = "",
            t.dom.el.style.opacity = "",
            t.mixer.config.animation.animateResizeTargets && (t.dom.el.style.width = "",
            t.dom.el.style.height = "",
            t.dom.el.style.marginRight = "",
            t.dom.el.style.marginBottom = ""),
            t.callActions("afterCleanUp", arguments)
        }
    }),
    f.Collection = function(t) {
        var e = null
          , i = -1;
        for (this.callActions("beforeConstruct"),
        i = 0; e = t[i]; i++)
            this[i] = e;
        this.length = t.length,
        this.callActions("afterConstruct"),
        p.freeze(this)
    }
    ,
    f.BaseStatic.call(f.Collection),
    f.Collection.prototype = Object.create(f.Base.prototype),
    p.extend(f.Collection.prototype, {
        constructor: f.Collection,
        mixitup: function(t) {
            var e = null
              , i = Array.prototype.slice.call(arguments)
              , n = []
              , a = -1;
            for (this.callActions("beforeMixitup"),
            i.shift(),
            a = 0; e = this[a]; a++)
                n.push(e[t].apply(e, i));
            return this.callFilters("promiseMixitup", p.all(n, f.libraries), arguments)
        }
    }),
    f.Operation = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.id = "",
        this.args = [],
        this.command = null,
        this.showPosData = [],
        this.toHidePosData = [],
        this.startState = null,
        this.newState = null,
        this.docState = null,
        this.willSort = !1,
        this.willChangeLayout = !1,
        this.hasEffect = !1,
        this.hasFailed = !1,
        this.triggerElement = null,
        this.show = [],
        this.hide = [],
        this.matching = [],
        this.toShow = [],
        this.toHide = [],
        this.toMove = [],
        this.toRemove = [],
        this.startOrder = [],
        this.newOrder = [],
        this.startSort = null,
        this.newSort = null,
        this.startFilter = null,
        this.newFilter = null,
        this.startDataset = null,
        this.newDataset = null,
        this.viewportDeltaX = 0,
        this.viewportDeltaY = 0,
        this.startX = 0,
        this.startY = 0,
        this.startHeight = 0,
        this.startWidth = 0,
        this.newX = 0,
        this.newY = 0,
        this.newHeight = 0,
        this.newWidth = 0,
        this.startContainerClassName = "",
        this.startDisplay = "",
        this.newContainerClassName = "",
        this.newDisplay = "",
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.Operation),
    f.Operation.prototype = Object.create(f.Base.prototype),
    f.Operation.prototype.constructor = f.Operation,
    f.State = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.id = "",
        this.activeFilter = null,
        this.activeSort = null,
        this.activeContainerClassName = "",
        this.container = null,
        this.targets = [],
        this.hide = [],
        this.show = [],
        this.matching = [],
        this.totalTargets = -1,
        this.totalShow = -1,
        this.totalHide = -1,
        this.totalMatching = -1,
        this.hasFailed = !1,
        this.triggerElement = null,
        this.activeDataset = null,
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.State),
    f.State.prototype = Object.create(f.Base.prototype),
    f.State.prototype.constructor = f.State,
    f.UserInstruction = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.command = {},
        this.animate = !1,
        this.callback = null,
        this.callActions("afterConstruct"),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.UserInstruction),
    f.UserInstruction.prototype = Object.create(f.Base.prototype),
    f.UserInstruction.prototype.constructor = f.UserInstruction,
    f.Messages = function() {
        f.Base.call(this),
        this.callActions("beforeConstruct"),
        this.ERROR_FACTORY_INVALID_CONTAINER = "[MixItUp] An invalid selector or element reference was passed to the mixitup factory function",
        this.ERROR_FACTORY_CONTAINER_NOT_FOUND = "[MixItUp] The provided selector yielded no container element",
        this.ERROR_CONFIG_INVALID_ANIMATION_EFFECTS = "[MixItUp] Invalid value for `animation.effects`",
        this.ERROR_CONFIG_INVALID_CONTROLS_SCOPE = "[MixItUp] Invalid value for `controls.scope`",
        this.ERROR_CONFIG_INVALID_PROPERTY = '[MixitUp] Invalid configuration object property "${erroneous}"${suggestion}',
        this.ERROR_CONFIG_INVALID_PROPERTY_SUGGESTION = '. Did you mean "${probableMatch}"?',
        this.ERROR_CONFIG_DATA_UID_KEY_NOT_SET = "[MixItUp] To use the dataset API, a UID key must be specified using `data.uidKey`",
        this.ERROR_DATASET_INVALID_UID_KEY = '[MixItUp] The specified UID key "${uidKey}" is not present on one or more dataset items',
        this.ERROR_DATASET_DUPLICATE_UID = '[MixItUp] The UID "${uid}" was found on two or more dataset items. UIDs must be unique.',
        this.ERROR_INSERT_INVALID_ARGUMENTS = "[MixItUp] Please provider either an index or a sibling and position to insert, not both",
        this.ERROR_INSERT_PREEXISTING_ELEMENT = "[MixItUp] An element to be inserted already exists in the container",
        this.ERROR_FILTER_INVALID_ARGUMENTS = "[MixItUp] Please provide either a selector or collection `.filter()`, not both",
        this.ERROR_DATASET_NOT_SET = "[MixItUp] To use the dataset API with pre-rendered targets, a starting dataset must be set using `load.dataset`",
        this.ERROR_DATASET_PRERENDERED_MISMATCH = "[MixItUp] `load.dataset` does not match pre-rendered targets",
        this.ERROR_DATASET_RENDERER_NOT_SET = "[MixItUp] To insert an element via the dataset API, a target renderer function must be provided to `render.target`",
        this.WARNING_FACTORY_PREEXISTING_INSTANCE = "[MixItUp] WARNING: This element already has an active MixItUp instance. The provided configuration object will be ignored. If you wish to perform additional methods on this instance, please create a reference.",
        this.WARNING_INSERT_NO_ELEMENTS = "[MixItUp] WARNING: No valid elements were passed to `.insert()`",
        this.WARNING_REMOVE_NO_ELEMENTS = "[MixItUp] WARNING: No valid elements were passed to `.remove()`",
        this.WARNING_MULTIMIX_INSTANCE_QUEUE_FULL = "[MixItUp] WARNING: An operation was requested but the MixItUp instance was busy. The operation was rejected because the queue is full or queuing is disabled.",
        this.WARNING_GET_OPERATION_INSTANCE_BUSY = "[MixItUp] WARNING: Operations can be be created while the MixItUp instance is busy.",
        this.WARNING_NO_PROMISE_IMPLEMENTATION = "[MixItUp] WARNING: No Promise implementations could be found. If you wish to use promises with MixItUp please install an ES6 Promise polyfill.",
        this.WARNING_INCONSISTENT_SORTING_ATTRIBUTES = '[MixItUp] WARNING: The requested sorting data attribute "${attribute}" was not present on one or more target elements which may product unexpected sort output',
        this.callActions("afterConstruct"),
        this.compileTemplates(),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.Messages),
    f.Messages.prototype = Object.create(f.Base.prototype),
    f.Messages.prototype.constructor = f.Messages,
    f.Messages.prototype.compileTemplates = function() {
        var t = ""
          , e = "";
        for (t in this)
            "string" == typeof (e = this[t]) && (this[p.camelCase(t)] = p.template(e))
    }
    ,
    f.messages = new f.Messages,
    f.Facade = function(t) {
        f.Base.call(this),
        this.callActions("beforeConstruct", arguments),
        this.configure = t.configure.bind(t),
        this.show = t.show.bind(t),
        this.hide = t.hide.bind(t),
        this.filter = t.filter.bind(t),
        this.toggleOn = t.toggleOn.bind(t),
        this.toggleOff = t.toggleOff.bind(t),
        this.sort = t.sort.bind(t),
        this.changeLayout = t.changeLayout.bind(t),
        this.multimix = t.multimix.bind(t),
        this.dataset = t.dataset.bind(t),
        this.tween = t.tween.bind(t),
        this.insert = t.insert.bind(t),
        this.insertBefore = t.insertBefore.bind(t),
        this.insertAfter = t.insertAfter.bind(t),
        this.prepend = t.prepend.bind(t),
        this.append = t.append.bind(t),
        this.remove = t.remove.bind(t),
        this.destroy = t.destroy.bind(t),
        this.forceRefresh = t.forceRefresh.bind(t),
        this.forceRender = t.forceRender.bind(t),
        this.isMixing = t.isMixing.bind(t),
        this.getOperation = t.getOperation.bind(t),
        this.getConfig = t.getConfig.bind(t),
        this.getState = t.getState.bind(t),
        this.callActions("afterConstruct", arguments),
        p.freeze(this),
        p.seal(this)
    }
    ,
    f.BaseStatic.call(f.Facade),
    f.Facade.prototype = Object.create(f.Base.prototype),
    f.Facade.prototype.constructor = f.Facade,
    "object" == typeof exports && "object" == typeof module ? module.exports = f : "function" == typeof define && define.amd ? define(function() {
        return f
    }) : void 0 !== h.mixitup && "function" == typeof h.mixitup || (h.mixitup = f),
    f.BaseStatic.call(f.constructor),
    f.NAME = "mixitup",
    f.CORE_VERSION = "3.2.1"
}(window),
function(t) {
    "use strict";
    var e = function(m) {
        var g = m.h;
        if (!m.CORE_VERSION || !g.compareVersions(e.REQUIRE_CORE_VERSION, m.CORE_VERSION))
            throw new Error("[MixItUp Pagination] MixItUp Pagination " + e.EXTENSION_VERSION + " requires at least MixItUp " + e.REQUIRE_CORE_VERSION);
        m.ConfigClassNames.registerAction("afterConstruct", "pagination", function() {
            this.elementPager = "control",
            this.elementPageList = "page-list",
            this.elementPageStats = "page-stats",
            this.modifierFirst = "first",
            this.modifierLast = "last",
            this.modifierPrev = "prev",
            this.modifierNext = "next",
            this.modifierTruncationMarker = "truncation-marker"
        }),
        m.ConfigLoad.registerAction("afterConstruct", "pagination", function() {
            this.page = 1
        }),
        m.ConfigPagination = function() {
            this.generatePageList = !0,
            this.generatePageStats = !0,
            this.maintainActivePage = !0,
            this.loop = !1,
            this.hidePageListIfSinglePage = !1,
            this.hidePageStatsIfSinglePage = !1,
            this.limit = -1,
            this.maxPagers = 5,
            g.seal(this)
        }
        ,
        m.ConfigRender.registerAction("afterConstruct", "pagination", function() {
            this.pager = null,
            this.pageStats = null
        }),
        m.ConfigSelectors.registerAction("afterConstruct", "pagination", function() {
            this.pageList = ".mixitup-page-list",
            this.pageStats = ".mixitup-page-stats"
        }),
        m.ConfigTemplates.registerAction("afterConstruct", "pagination", function() {
            this.pager = '<button type="button" class="${classNames}" data-page="${pageNumber}">${pageNumber}</button>',
            this.pagerPrev = '<button type="button" class="${classNames}" data-page="prev">&laquo;</button>',
            this.pagerNext = '<button type="button" class="${classNames}" data-page="next">&raquo;</button>',
            this.pagerTruncationMarker = '<span class="${classNames}">&hellip;</span>',
            this.pageStats = "${startPageAt} to ${endPageAt} of ${totalTargets}",
            this.pageStatsSingle = "${startPageAt} of ${totalTargets}",
            this.pageStatsFail = "None found"
        }),
        m.Config.registerAction("beforeConstruct", "pagination", function() {
            this.pagination = new m.ConfigPagination
        }),
        m.ModelPager = function() {
            this.pageNumber = -1,
            this.classNames = "",
            this.classList = [],
            this.isDisabled = !1,
            this.isPrev = !1,
            this.isNext = !1,
            this.isPageLink = !1,
            this.isTruncationMarker = !1,
            g.seal(this)
        }
        ,
        m.ModelPageStats = function() {
            this.startPageAt = -1,
            this.endPageAt = -1,
            this.totalTargets = -1,
            g.seal(this)
        }
        ,
        m.UiClassNames.registerAction("afterConstruct", "pagination", function() {
            this.first = "",
            this.last = "",
            this.prev = "",
            this.next = "",
            this.first = "",
            this.last = "",
            this.truncated = "",
            this.truncationMarker = ""
        }),
        m.controlDefinitions.push(new m.ControlDefinition("pager","[data-page]",!0,"pageListEls")),
        m.Control.registerFilter("commandsHandleClick", "pagination", function(t, e) {
            var i = this
              , n = {}
              , a = ""
              , o = null
              , s = null
              , r = -1;
            if (!i.selector || "[data-page]" !== i.selector)
                return t;
            for (s = g.closestParent(e.target, i.selector, !0, i.bound[0].dom.document),
            r = 0; o = i.bound[r]; r++)
                n = t[r],
                !o.config.pagination || o.config.pagination.limit < 0 || o.config.pagination.limit === 1 / 0 ? t[r] = null : !s || g.hasClass(s, o.classNamesPager.active) || g.hasClass(s, o.classNamesPager.disabled) ? t[r] = null : (a = s.getAttribute("data-page"),
                n.paginate = "prev" === a ? "prev" : "next" === a ? "next" : parseInt(a),
                o.lastClicked && (o.lastClicked = s));
            return t
        }),
        m.CommandMultimix.registerAction("afterConstruct", "pagination", function() {
            this.paginate = null
        }),
        m.CommandPaginate = function() {
            this.page = -1,
            this.limit = -1,
            this.action = "",
            this.anchor = null,
            g.seal(this)
        }
        ,
        m.Operation.registerAction("afterConstruct", "pagination", function() {
            this.startPagination = null,
            this.newPagination = null,
            this.startTotalPages = -1,
            this.newTotalPages = -1
        }),
        m.State.registerAction("afterConstruct", "pagination", function() {
            this.activePagination = null,
            this.totalPages = -1
        }),
        m.MixerDom.registerAction("afterConstruct", "pagination", function() {
            this.pageListEls = [],
            this.pageStatsEls = []
        }),
        m.Mixer.registerAction("afterConstruct", "pagination", function() {
            this.classNamesPager = new m.UiClassNames,
            this.classNamesPageList = new m.UiClassNames,
            this.classNamesPageStats = new m.UiClassNames
        }),
        m.Mixer.registerAction("afterAttach", "pagination", function() {
            var t = this
              , e = null
              , i = -1;
            if (!(t.config.pagination.limit < 0)) {
                if (t.classNamesPager.base = g.getClassname(t.config.classNames, "pager"),
                t.classNamesPager.active = g.getClassname(t.config.classNames, "pager", t.config.classNames.modifierActive),
                t.classNamesPager.disabled = g.getClassname(t.config.classNames, "pager", t.config.classNames.modifierDisabled),
                t.classNamesPager.first = g.getClassname(t.config.classNames, "pager", t.config.classNames.modifierFirst),
                t.classNamesPager.last = g.getClassname(t.config.classNames, "pager", t.config.classNames.modifierLast),
                t.classNamesPager.prev = g.getClassname(t.config.classNames, "pager", t.config.classNames.modifierPrev),
                t.classNamesPager.next = g.getClassname(t.config.classNames, "pager", t.config.classNames.modifierNext),
                t.classNamesPager.truncationMarker = g.getClassname(t.config.classNames, "pager", t.config.classNames.modifierTruncationMarker),
                t.classNamesPageList.base = g.getClassname(t.config.classNames, "page-list"),
                t.classNamesPageList.disabled = g.getClassname(t.config.classNames, "page-list", t.config.classNames.modifierDisabled),
                t.classNamesPageStats.base = g.getClassname(t.config.classNames, "page-stats"),
                t.classNamesPageStats.disabled = g.getClassname(t.config.classNames, "page-stats", t.config.classNames.modifierDisabled),
                t.config.pagination.generatePageList && 0 < t.dom.pageListEls.length)
                    for (i = 0; e = t.dom.pageListEls[i]; i++)
                        t.renderPageListEl(e, t.lastOperation);
                if (t.config.pagination.generatePageStats && 0 < t.dom.pageStatsEls.length)
                    for (i = 0; e = t.dom.pageStatsEls[i]; i++)
                        t.renderPageStatsEl(e, t.lastOperation)
            }
        }),
        m.Mixer.registerFilter("operationGetInitialState", "pagination", function(t, e) {
            return this.config.pagination.limit < 0 || (t.newPagination = e.activePagination),
            t
        }),
        m.Mixer.registerFilter("stateGetInitialState", "pagination", function(t) {
            return this.config.pagination.limit < 0 || (t.activePagination = new m.CommandPaginate,
            t.activePagination.page = this.config.load.page,
            t.activePagination.limit = this.config.pagination.limit),
            t
        }),
        m.Mixer.registerAction("afterGetFinalMixData", "pagination", function() {
            this.config.pagination.limit < 0 || "number" == typeof this.config.pagination.maxPagers && (this.config.pagination.maxPagers = Math.max(5, this.config.pagination.maxPagers))
        }),
        m.Mixer.registerAction("afterCacheDom", "pagination", function() {
            var t = this
              , e = null;
            if (!(t.config.pagination.limit < 0) && t.config.pagination.generatePageList) {
                switch (t.config.controls.scope) {
                case "local":
                    e = t.dom.container;
                    break;
                case "global":
                    e = t.dom.document;
                    break;
                default:
                    throw new Error(m.messages.ERROR_CONFIG_INVALID_CONTROLS_SCOPE)
                }
                t.dom.pageListEls = e.querySelectorAll(t.config.selectors.pageList),
                t.dom.pageStatsEls = e.querySelectorAll(t.config.selectors.pageStats)
            }
        }),
        m.Mixer.registerFilter("stateBuildState", "pagination", function(t, e) {
            return this.config.pagination.limit < 0 || (t.activePagination = e.newPagination,
            t.totalPages = e.newTotalPages),
            t
        }),
        m.Mixer.registerFilter("instructionParseMultimixArgs", "pagination", function(t) {
            return this.config.pagination.limit < 0 || !t.command.paginate || t.command.paginate instanceof m.CommandPaginate || (t.command.paginate = this.parsePaginateArgs([t.command.paginate]).command),
            t
        }),
        m.Mixer.registerAction("afterFilterOperation", "pagination", function(t) {
            var e = -1
              , i = -1
              , n = []
              , a = []
              , o = null
              , s = -1
              , r = -1;
            if (!(this.config.pagination.limit < 0)) {
                if (t.newTotalPages = t.newPagination.limit ? Math.max(Math.ceil(t.matching.length / t.newPagination.limit), 1) : 1,
                this.config.pagination.maintainActivePage && (t.newPagination.page = t.newPagination.page > t.newTotalPages ? t.newTotalPages : t.newPagination.page),
                this.config.pagination.limit = t.newPagination.limit,
                t.newPagination.anchor) {
                    for (r = 0; (o = t.matching[r]) && o.dom.el !== t.newPagination.anchor; r++)
                        ;
                    i = (e = r) + t.newPagination.limit - 1
                } else
                    e = t.newPagination.limit * (t.newPagination.page - 1),
                    i = t.newPagination.limit * t.newPagination.page - 1,
                    isNaN(e) && (e = 0);
                if (!(t.newPagination.limit < 0)) {
                    for (r = 0; o = t.show[r]; r++)
                        e <= r && r <= i ? n.push(o) : a.push(o);
                    for (t.show = n,
                    r = 0; o = t.toHide[r]; r++)
                        o.isShown || (t.toHide.splice(r, 1),
                        o.isShown = !1,
                        r--);
                    for (r = 0; o = a[r]; r++)
                        t.hide.push(o),
                        -1 < (s = t.toShow.indexOf(o)) && t.toShow.splice(s, 1),
                        o.isShown && t.toHide.push(o)
                }
            }
        }),
        m.Mixer.registerFilter("operationUnmappedGetOperation", "pagination", function(t, e) {
            var i = this;
            return i.config.pagination.limit < 0 || (t.startState = i.state,
            t.startPagination = i.state.activePagination,
            t.startTotalPages = i.state.totalPages,
            t.newPagination = new m.CommandPaginate,
            t.newPagination.limit = t.startPagination.limit,
            t.newPagination.page = t.startPagination.page,
            e.paginate ? i.parsePaginateCommand(e.paginate, t) : (e.filter || e.sort) && (g.extend(t.newPagination, t.startPagination),
            i.config.pagination.maintainActivePage ? t.newPagination.page = i.state.activePagination.page : t.newPagination.page = 1)),
            t
        }),
        m.Mixer.registerFilter("operationMappedGetOperation", "pagination", function(t, e, i) {
            var n = this
              , a = null
              , o = -1;
            if (n.config.pagination.limit < 0)
                return t;
            if (i)
                return t;
            if (n.config.pagination.generatePageList && 0 < n.dom.pageListEls.length)
                for (o = 0; a = n.dom.pageListEls[o]; o++)
                    n.renderPageListEl(a, t);
            if (n.config.pagination.generatePageStats && 0 < n.dom.pageStatsEls.length)
                for (o = 0; a = n.dom.pageStatsEls[o]; o++)
                    n.renderPageStatsEl(a, t);
            return t
        }),
        m.Mixer.extend({
            parsePaginateCommand: function(t, e) {
                if (-1 < t.page) {
                    if (0 === t.page)
                        throw new Error(m.messages.ERROR_PAGINATE_INDEX_RANGE);
                    e.newPagination.page = Math.max(1, Math.min(1 / 0, t.page))
                } else
                    "next" === t.action ? e.newPagination.page = this.getNextPage() : "prev" === t.action ? e.newPagination.page = this.getPrevPage() : t.anchor && (e.newPagination.anchor = t.anchor);
                -1 < t.limit && (e.newPagination.limit = t.limit),
                e.newPagination.limit !== e.startPagination.limit && (e.newTotalPages = e.newPagination.limit ? Math.max(Math.ceil(e.startState.matching.length / e.newPagination.limit), 1) : 1),
                (e.newPagination.limit <= 0 || e.newPagination.limit === 1 / 0) && (e.newPagination.page = 1)
            },
            getNextPage: function() {
                var t = -1;
                return (t = this.state.activePagination.page + 1) > this.state.totalPages && (t = this.config.pagination.loop ? 1 : this.state.activePagination.page),
                t
            },
            getPrevPage: function() {
                var t = -1;
                return (t = this.state.activePagination.page - 1) < 1 && (t = this.config.pagination.loop ? this.state.totalPages : this.state.activePagination.page),
                t
            },
            renderPageListEl: function(t, e) {
                var i, n, a, o = this, s = "", r = [], l = null, c = null, u = [], d = !1, h = !1, f = null, p = -1;
                if (e.newPagination.limit < 0 || e.newPagination.limit === 1 / 0 || e.newTotalPages < 2 && o.config.pagination.hidePageListIfSinglePage)
                    return t.innerHTML = "",
                    void g.addClass(t, o.classNamesPageList.disabled);
                for (i = e.newPagination.page - 1,
                c = "function" == typeof (c = o.config.render.pager) ? c : null,
                o.config.pagination.maxPagers < 1 / 0 && e.newTotalPages > o.config.pagination.maxPagers && (u = o.getAllowedIndices(e)),
                (l = new m.ModelPager).isPrev = !0,
                l.classList.push(o.classNamesPager.base, o.classNamesPager.prev),
                1 !== e.newPagination.page || o.config.pagination.loop || (l.classList.push(o.classNamesPager.disabled),
                l.isDisabled = !0),
                l.classNames = l.classList.join(" "),
                s = c ? c(l) : g.template(o.config.templates.pagerPrev)(l),
                r.push(s),
                p = 0; p < e.newTotalPages; p++)
                    (s = o.renderPager(p, e, u)) || p < i && d || i < p && h ? s && r.push(s) : ((l = new m.ModelPager).isTruncationMarker = !0,
                    l.classList.push(o.classNamesPager.base, o.classNamesPager.truncationMarker),
                    l.classNames = l.classList.join(" "),
                    s = c ? c(l) : g.template(o.config.templates.pagerTruncationMarker)(l),
                    r.push(s),
                    p < i && (d = !0),
                    i < p && (h = !0));
                for ((l = new m.ModelPager).isNext = !0,
                l.classList.push(o.classNamesPager.base, o.classNamesPager.next),
                e.newPagination.page !== e.newTotalPages || o.config.pagination.loop || l.classList.push(o.classNamesPager.disabled),
                l.classNames = l.classList.join(" "),
                s = c ? c(l) : g.template(o.config.templates.pagerNext)(l),
                r.push(s),
                a = r.join(" "),
                t.innerHTML = a,
                n = t.querySelectorAll("." + o.classNamesPager.disabled),
                p = 0; f = n[p]; p++)
                    "boolean" == typeof f.disabled && (f.disabled = !0);
                d || h ? g.addClass(t, o.classNamesPageList.truncated) : g.removeClass(t, o.classNamesPageList.truncated),
                1 < e.newTotalPages ? g.removeClass(t, o.classNamesPageList.disabled) : g.addClass(t, o.classNamesPageList.disabled)
            },
            getAllowedIndices: function(t) {
                var e, i, n = t.newPagination.page - 1, a = t.newTotalPages - 1, o = [], s = -1, r = -1, l = -1;
                for (o.push(0),
                s = this.config.pagination.maxPagers - 2,
                r = 0,
                (e = n - Math.ceil((s - 1) / 2)) < 1 && (r = 1 - e),
                a - 1 < (i = n + Math.floor((s - 1) / 2)) && (r = a - 1 - i),
                l = e + r; s; )
                    o.push(l),
                    l++,
                    s--;
                return o.push(a),
                o
            },
            renderPager: function(t, e, i) {
                var n = this
                  , a = null
                  , o = e.newPagination.page - 1
                  , s = new m.ModelPager;
                return n.config.pagination.maxPagers < 1 / 0 && i.length && i.indexOf(t) < 0 ? "" : (a = "function" == typeof (a = n.config.render.pager) ? a : null,
                s.isPageLink = !0,
                s.classList.push(n.classNamesPager.base),
                0 === t && s.classList.push(n.classNamesPager.first),
                t === e.newTotalPages - 1 && s.classList.push(n.classNamesPager.last),
                t === o && s.classList.push(n.classNamesPager.active),
                s.classNames = s.classList.join(" "),
                s.pageNumber = t + 1,
                a ? a(s) : g.template(n.config.templates.pager)(s))
            },
            renderPageStatsEl: function(t, e) {
                var i = this
                  , n = new m.ModelPageStats
                  , a = null
                  , o = ""
                  , s = "";
                return e.newPagination.limit < 0 || e.newPagination.limit === 1 / 0 || e.newTotalPages < 2 && i.config.pagination.hidePageStatsIfSinglePage ? (t.innerHTML = "",
                void g.addClass(t, i.classNamesPageStats.disabled)) : (a = "function" == typeof (a = i.config.render.pageStats) ? a : null,
                n.totalTargets = e.matching.length,
                s = n.totalTargets ? 1 === e.newPagination.limit ? i.config.templates.pageStatsSingle : i.config.templates.pageStats : i.config.templates.pageStatsFail,
                n.totalTargets && 0 < e.newPagination.limit ? (n.startPageAt = (e.newPagination.page - 1) * e.newPagination.limit + 1,
                n.endPageAt = Math.min(n.startPageAt + e.newPagination.limit - 1, n.totalTargets)) : n.startPageAt = n.endPageAt = 0,
                o = a ? a(n) : g.template(s)(n),
                t.innerHTML = o,
                void (n.totalTargets ? g.removeClass(t, i.classNamesPageStats.disabled) : g.addClass(t, i.classNamesPageStats.disabled)))
            },
            parsePaginateArgs: function(t) {
                var e = new m.UserInstruction
                  , i = null
                  , n = -1;
                for (e.animate = this.config.animation.enable,
                e.command = new m.CommandPaginate,
                n = 0; n < t.length; n++)
                    null !== (i = t[n]) && ("object" == typeof i && g.isElement(i, this.dom.document) ? e.command.anchor = i : i instanceof m.CommandPaginate || "object" == typeof i ? g.extend(e.command, i) : "number" == typeof i ? e.command.page = i : "string" != typeof i || isNaN(parseInt(i)) ? "string" == typeof i ? e.command.action = i : "boolean" == typeof i ? e.animate = i : "function" == typeof i && (e.callback = i) : e.command.page = parseInt(i));
                return g.freeze(e),
                e
            },
            paginate: function() {
                var t = this.parsePaginateArgs(arguments);
                return this.multimix({
                    paginate: t.command
                }, t.animate, t.callback)
            },
            nextPage: function() {
                var t = this.parsePaginateArgs(arguments);
                return this.multimix({
                    paginate: {
                        action: "next"
                    }
                }, t.animate, t.callback)
            },
            prevPage: function() {
                var t = this.parsePaginateArgs(arguments);
                return this.multimix({
                    paginate: {
                        action: "prev"
                    }
                }, t.animate, t.callback)
            }
        }),
        m.Facade.registerAction("afterConstruct", "pagination", function(t) {
            this.paginate = t.paginate.bind(t),
            this.nextPage = t.nextPage.bind(t),
            this.prevPage = t.prevPage.bind(t)
        })
    };
    if (e.TYPE = "mixitup-extension",
    e.NAME = "mixitup-pagination",
    e.EXTENSION_VERSION = "3.2.0",
    e.REQUIRE_CORE_VERSION = "^3.1.8",
    "object" == typeof exports && "object" == typeof module)
        module.exports = e;
    else if ("function" == typeof define && define.amd)
        define(function() {
            return e
        });
    else {
        if (!t.mixitup || "function" != typeof t.mixitup)
            throw new Error("[MixItUp Pagination] MixItUp core not found");
        e(t.mixitup)
    }
}(window),
function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.moment = e()
}(this, function() {
    "use strict";
    var t;
    function h() {
        return t.apply(null, arguments)
    }
    function s(t) {
        return t instanceof Array || "[object Array]" === Object.prototype.toString.call(t)
    }
    function r(t) {
        return null != t && "[object Object]" === Object.prototype.toString.call(t)
    }
    function l(t) {
        return "number" == typeof value || "[object Number]" === Object.prototype.toString.call(t)
    }
    function a(t) {
        return t instanceof Date || "[object Date]" === Object.prototype.toString.call(t)
    }
    function n(t, e) {
        var i, n = [];
        for (i = 0; i < t.length; ++i)
            n.push(e(t[i], i));
        return n
    }
    function f(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e)
    }
    function c(t, e) {
        for (var i in e)
            f(e, i) && (t[i] = e[i]);
        return f(e, "toString") && (t.toString = e.toString),
        f(e, "valueOf") && (t.valueOf = e.valueOf),
        t
    }
    function u(t, e, i, n) {
        return Se(t, e, i, n, !0).utc()
    }
    function p(t) {
        return null == t._pf && (t._pf = {
            empty: !1,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: !1,
            invalidMonth: null,
            invalidFormat: !1,
            userInvalidated: !1,
            iso: !1,
            parsedDateParts: [],
            meridiem: null
        }),
        t._pf
    }
    var o = Array.prototype.some ? Array.prototype.some : function(t) {
        for (var e = Object(this), i = e.length >>> 0, n = 0; n < i; n++)
            if (n in e && t.call(this, e[n], n, e))
                return !0;
        return !1
    }
    ;
    function d(t) {
        if (null == t._isValid) {
            var e = p(t)
              , i = o.call(e.parsedDateParts, function(t) {
                return null != t
            })
              , n = !isNaN(t._d.getTime()) && e.overflow < 0 && !e.empty && !e.invalidMonth && !e.invalidWeekday && !e.nullInput && !e.invalidFormat && !e.userInvalidated && (!e.meridiem || e.meridiem && i);
            if (t._strict && (n = n && 0 === e.charsLeftOver && 0 === e.unusedTokens.length && void 0 === e.bigHour),
            null != Object.isFrozen && Object.isFrozen(t))
                return n;
            t._isValid = n
        }
        return t._isValid
    }
    function m(t) {
        var e = u(NaN);
        return null != t ? c(p(e), t) : p(e).userInvalidated = !0,
        e
    }
    function g(t) {
        return void 0 === t
    }
    var y = h.momentProperties = [];
    function v(t, e) {
        var i, n, a;
        if (g(e._isAMomentObject) || (t._isAMomentObject = e._isAMomentObject),
        g(e._i) || (t._i = e._i),
        g(e._f) || (t._f = e._f),
        g(e._l) || (t._l = e._l),
        g(e._strict) || (t._strict = e._strict),
        g(e._tzm) || (t._tzm = e._tzm),
        g(e._isUTC) || (t._isUTC = e._isUTC),
        g(e._offset) || (t._offset = e._offset),
        g(e._pf) || (t._pf = p(e)),
        g(e._locale) || (t._locale = e._locale),
        0 < y.length)
            for (i in y)
                g(a = e[n = y[i]]) || (t[n] = a);
        return t
    }
    var e = !1;
    function b(t) {
        v(this, t),
        this._d = new Date(null != t._d ? t._d.getTime() : NaN),
        !1 === e && (e = !0,
        h.updateOffset(this),
        e = !1)
    }
    function A(t) {
        return t instanceof b || null != t && null != t._isAMomentObject
    }
    function w(t) {
        return t < 0 ? Math.ceil(t) || 0 : Math.floor(t)
    }
    function S(t) {
        var e = +t
          , i = 0;
        return 0 != e && isFinite(e) && (i = w(e)),
        i
    }
    function C(t, e, i) {
        var n, a = Math.min(t.length, e.length), o = Math.abs(t.length - e.length), s = 0;
        for (n = 0; n < a; n++)
            (i && t[n] !== e[n] || !i && S(t[n]) !== S(e[n])) && s++;
        return s + o
    }
    function T(t) {
        !1 === h.suppressDeprecationWarnings && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + t)
    }
    function i(a, o) {
        var s = !0;
        return c(function() {
            if (null != h.deprecationHandler && h.deprecationHandler(null, a),
            s) {
                for (var t, e = [], i = 0; i < arguments.length; i++) {
                    if (t = "",
                    "object" == typeof arguments[i]) {
                        for (var n in t += "\n[" + i + "] ",
                        arguments[0])
                            t += n + ": " + arguments[0][n] + ", ";
                        t = t.slice(0, -2)
                    } else
                        t = arguments[i];
                    e.push(t)
                }
                T(a + "\nArguments: " + Array.prototype.slice.call(e).join("") + "\n" + (new Error).stack),
                s = !1
            }
            return o.apply(this, arguments)
        }, o)
    }
    var k = {};
    function M(t, e) {
        null != h.deprecationHandler && h.deprecationHandler(t, e),
        k[t] || (T(e),
        k[t] = !0)
    }
    function x(t) {
        return t instanceof Function || "[object Function]" === Object.prototype.toString.call(t)
    }
    function _(t, e) {
        var i, n = c({}, t);
        for (i in e)
            f(e, i) && (r(t[i]) && r(e[i]) ? (n[i] = {},
            c(n[i], t[i]),
            c(n[i], e[i])) : null != e[i] ? n[i] = e[i] : delete n[i]);
        for (i in t)
            f(t, i) && !f(e, i) && r(t[i]) && (n[i] = c({}, n[i]));
        return n
    }
    function P(t) {
        null != t && this.set(t)
    }
    h.suppressDeprecationWarnings = !1,
    h.deprecationHandler = null;
    var E = Object.keys ? Object.keys : function(t) {
        var e, i = [];
        for (e in t)
            f(t, e) && i.push(e);
        return i
    }
    ;
    var O = {};
    function D(t, e) {
        var i = t.toLowerCase();
        O[i] = O[i + "s"] = O[e] = t
    }
    function I(t) {
        return "string" == typeof t ? O[t] || O[t.toLowerCase()] : void 0
    }
    function N(t) {
        var e, i, n = {};
        for (i in t)
            f(t, i) && (e = I(i)) && (n[e] = t[i]);
        return n
    }
    var z = {};
    function B(t, e) {
        z[t] = e
    }
    function L(e, i) {
        return function(t) {
            return null != t ? (W(this, e, t),
            h.updateOffset(this, i),
            this) : R(this, e)
        }
    }
    function R(t, e) {
        return t.isValid() ? t._d["get" + (t._isUTC ? "UTC" : "") + e]() : NaN
    }
    function W(t, e, i) {
        t.isValid() && t._d["set" + (t._isUTC ? "UTC" : "") + e](i)
    }
    function F(t, e, i) {
        var n = "" + Math.abs(t)
          , a = e - n.length;
        return (0 <= t ? i ? "+" : "" : "-") + Math.pow(10, Math.max(0, a)).toString().substr(1) + n
    }
    var j = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g
      , H = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g
      , U = {}
      , $ = {};
    function Y(t, e, i, n) {
        var a = n;
        "string" == typeof n && (a = function() {
            return this[n]()
        }
        ),
        t && ($[t] = a),
        e && ($[e[0]] = function() {
            return F(a.apply(this, arguments), e[1], e[2])
        }
        ),
        i && ($[i] = function() {
            return this.localeData().ordinal(a.apply(this, arguments), t)
        }
        )
    }
    function q(t, e) {
        return t.isValid() ? (e = G(e, t.localeData()),
        U[e] = U[e] || function(n) {
            var t, a, e, o = n.match(j);
            for (t = 0,
            a = o.length; t < a; t++)
                $[o[t]] ? o[t] = $[o[t]] : o[t] = (e = o[t]).match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
            return function(t) {
                var e, i = "";
                for (e = 0; e < a; e++)
                    i += o[e]instanceof Function ? o[e].call(t, n) : o[e];
                return i
            }
        }(e),
        U[e](t)) : t.localeData().invalidDate()
    }
    function G(t, e) {
        var i = 5;
        function n(t) {
            return e.longDateFormat(t) || t
        }
        for (H.lastIndex = 0; 0 <= i && H.test(t); )
            t = t.replace(H, n),
            H.lastIndex = 0,
            i -= 1;
        return t
    }
    var V = /\d/
      , X = /\d\d/
      , K = /\d{3}/
      , Q = /\d{4}/
      , Z = /[+-]?\d{6}/
      , J = /\d\d?/
      , tt = /\d\d\d\d?/
      , et = /\d\d\d\d\d\d?/
      , it = /\d{1,3}/
      , nt = /\d{1,4}/
      , at = /[+-]?\d{1,6}/
      , ot = /\d+/
      , st = /[+-]?\d+/
      , rt = /Z|[+-]\d\d:?\d\d/gi
      , lt = /Z|[+-]\d\d(?::?\d\d)?/gi
      , ct = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i
      , ut = {};
    function dt(t, i, n) {
        ut[t] = x(i) ? i : function(t, e) {
            return t && n ? n : i
        }
    }
    function ht(t, e) {
        return f(ut, t) ? ut[t](e._strict, e._locale) : new RegExp(function(t) {
            return ft(t.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(t, e, i, n, a) {
                return e || i || n || a
            }))
        }(t))
    }
    function ft(t) {
        return t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")
    }
    var pt = {};
    function mt(t, i) {
        var e, n = i;
        for ("string" == typeof t && (t = [t]),
        l(i) && (n = function(t, e) {
            e[i] = S(t)
        }
        ),
        e = 0; e < t.length; e++)
            pt[t[e]] = n
    }
    function gt(t, a) {
        mt(t, function(t, e, i, n) {
            i._w = i._w || {},
            a(t, i._w, i, n)
        })
    }
    var yt = 0
      , vt = 1
      , bt = 2
      , At = 3
      , wt = 4
      , St = 5
      , Ct = 6
      , Tt = 7
      , kt = 8
      , Mt = Array.prototype.indexOf ? Array.prototype.indexOf : function(t) {
        var e;
        for (e = 0; e < this.length; ++e)
            if (this[e] === t)
                return e;
        return -1
    }
    ;
    function xt(t, e) {
        return new Date(Date.UTC(t, e + 1, 0)).getUTCDate()
    }
    Y("M", ["MM", 2], "Mo", function() {
        return this.month() + 1
    }),
    Y("MMM", 0, 0, function(t) {
        return this.localeData().monthsShort(this, t)
    }),
    Y("MMMM", 0, 0, function(t) {
        return this.localeData().months(this, t)
    }),
    D("month", "M"),
    B("month", 8),
    dt("M", J),
    dt("MM", J, X),
    dt("MMM", function(t, e) {
        return e.monthsShortRegex(t)
    }),
    dt("MMMM", function(t, e) {
        return e.monthsRegex(t)
    }),
    mt(["M", "MM"], function(t, e) {
        e[vt] = S(t) - 1
    }),
    mt(["MMM", "MMMM"], function(t, e, i, n) {
        var a = i._locale.monthsParse(t, n, i._strict);
        null != a ? e[vt] = a : p(i).invalidMonth = t
    });
    var _t = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/
      , Pt = "January_February_March_April_May_June_July_August_September_October_November_December".split("_");
    var Et = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_");
    function Ot(t, e) {
        var i;
        if (!t.isValid())
            return t;
        if ("string" == typeof e)
            if (/^\d+$/.test(e))
                e = S(e);
            else if (!l(e = t.localeData().monthsParse(e)))
                return t;
        return i = Math.min(t.date(), xt(t.year(), e)),
        t._d["set" + (t._isUTC ? "UTC" : "") + "Month"](e, i),
        t
    }
    function Dt(t) {
        return null != t ? (Ot(this, t),
        h.updateOffset(this, !0),
        this) : R(this, "Month")
    }
    var It = ct;
    var Nt = ct;
    function zt() {
        function t(t, e) {
            return e.length - t.length
        }
        var e, i, n = [], a = [], o = [];
        for (e = 0; e < 12; e++)
            i = u([2e3, e]),
            n.push(this.monthsShort(i, "")),
            a.push(this.months(i, "")),
            o.push(this.months(i, "")),
            o.push(this.monthsShort(i, ""));
        for (n.sort(t),
        a.sort(t),
        o.sort(t),
        e = 0; e < 12; e++)
            n[e] = ft(n[e]),
            a[e] = ft(a[e]);
        for (e = 0; e < 24; e++)
            o[e] = ft(o[e]);
        this._monthsRegex = new RegExp("^(" + o.join("|") + ")","i"),
        this._monthsShortRegex = this._monthsRegex,
        this._monthsStrictRegex = new RegExp("^(" + a.join("|") + ")","i"),
        this._monthsShortStrictRegex = new RegExp("^(" + n.join("|") + ")","i")
    }
    function Bt(t) {
        return Lt(t) ? 366 : 365
    }
    function Lt(t) {
        return t % 4 == 0 && t % 100 != 0 || t % 400 == 0
    }
    Y("Y", 0, 0, function() {
        var t = this.year();
        return t <= 9999 ? "" + t : "+" + t
    }),
    Y(0, ["YY", 2], 0, function() {
        return this.year() % 100
    }),
    Y(0, ["YYYY", 4], 0, "year"),
    Y(0, ["YYYYY", 5], 0, "year"),
    Y(0, ["YYYYYY", 6, !0], 0, "year"),
    D("year", "y"),
    B("year", 1),
    dt("Y", st),
    dt("YY", J, X),
    dt("YYYY", nt, Q),
    dt("YYYYY", at, Z),
    dt("YYYYYY", at, Z),
    mt(["YYYYY", "YYYYYY"], yt),
    mt("YYYY", function(t, e) {
        e[yt] = 2 === t.length ? h.parseTwoDigitYear(t) : S(t)
    }),
    mt("YY", function(t, e) {
        e[yt] = h.parseTwoDigitYear(t)
    }),
    mt("Y", function(t, e) {
        e[yt] = parseInt(t, 10)
    }),
    h.parseTwoDigitYear = function(t) {
        return S(t) + (68 < S(t) ? 1900 : 2e3)
    }
    ;
    var Rt = L("FullYear", !0);
    function Wt(t) {
        var e = new Date(Date.UTC.apply(null, arguments));
        return t < 100 && 0 <= t && isFinite(e.getUTCFullYear()) && e.setUTCFullYear(t),
        e
    }
    function Ft(t, e, i) {
        var n = 7 + e - i;
        return n - (7 + Wt(t, 0, n).getUTCDay() - e) % 7 - 1
    }
    function jt(t, e, i, n, a) {
        var o, s, r = 1 + 7 * (e - 1) + (7 + i - n) % 7 + Ft(t, n, a);
        return s = r <= 0 ? Bt(o = t - 1) + r : r > Bt(t) ? (o = t + 1,
        r - Bt(t)) : (o = t,
        r),
        {
            year: o,
            dayOfYear: s
        }
    }
    function Ht(t, e, i) {
        var n, a, o = Ft(t.year(), e, i), s = Math.floor((t.dayOfYear() - o - 1) / 7) + 1;
        return s < 1 ? n = s + Ut(a = t.year() - 1, e, i) : s > Ut(t.year(), e, i) ? (n = s - Ut(t.year(), e, i),
        a = t.year() + 1) : (a = t.year(),
        n = s),
        {
            week: n,
            year: a
        }
    }
    function Ut(t, e, i) {
        var n = Ft(t, e, i)
          , a = Ft(t + 1, e, i);
        return (Bt(t) - n + a) / 7
    }
    Y("w", ["ww", 2], "wo", "week"),
    Y("W", ["WW", 2], "Wo", "isoWeek"),
    D("week", "w"),
    D("isoWeek", "W"),
    B("week", 5),
    B("isoWeek", 5),
    dt("w", J),
    dt("ww", J, X),
    dt("W", J),
    dt("WW", J, X),
    gt(["w", "ww", "W", "WW"], function(t, e, i, n) {
        e[n.substr(0, 1)] = S(t)
    });
    Y("d", 0, "do", "day"),
    Y("dd", 0, 0, function(t) {
        return this.localeData().weekdaysMin(this, t)
    }),
    Y("ddd", 0, 0, function(t) {
        return this.localeData().weekdaysShort(this, t)
    }),
    Y("dddd", 0, 0, function(t) {
        return this.localeData().weekdays(this, t)
    }),
    Y("e", 0, 0, "weekday"),
    Y("E", 0, 0, "isoWeekday"),
    D("day", "d"),
    D("weekday", "e"),
    D("isoWeekday", "E"),
    B("day", 11),
    B("weekday", 11),
    B("isoWeekday", 11),
    dt("d", J),
    dt("e", J),
    dt("E", J),
    dt("dd", function(t, e) {
        return e.weekdaysMinRegex(t)
    }),
    dt("ddd", function(t, e) {
        return e.weekdaysShortRegex(t)
    }),
    dt("dddd", function(t, e) {
        return e.weekdaysRegex(t)
    }),
    gt(["dd", "ddd", "dddd"], function(t, e, i, n) {
        var a = i._locale.weekdaysParse(t, n, i._strict);
        null != a ? e.d = a : p(i).invalidWeekday = t
    }),
    gt(["d", "e", "E"], function(t, e, i, n) {
        e[n] = S(t)
    });
    var $t = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_");
    var Yt = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_");
    var qt = "Su_Mo_Tu_We_Th_Fr_Sa".split("_");
    var Gt = ct;
    var Vt = ct;
    var Xt = ct;
    function Kt() {
        function t(t, e) {
            return e.length - t.length
        }
        var e, i, n, a, o, s = [], r = [], l = [], c = [];
        for (e = 0; e < 7; e++)
            i = u([2e3, 1]).day(e),
            n = this.weekdaysMin(i, ""),
            a = this.weekdaysShort(i, ""),
            o = this.weekdays(i, ""),
            s.push(n),
            r.push(a),
            l.push(o),
            c.push(n),
            c.push(a),
            c.push(o);
        for (s.sort(t),
        r.sort(t),
        l.sort(t),
        c.sort(t),
        e = 0; e < 7; e++)
            r[e] = ft(r[e]),
            l[e] = ft(l[e]),
            c[e] = ft(c[e]);
        this._weekdaysRegex = new RegExp("^(" + c.join("|") + ")","i"),
        this._weekdaysShortRegex = this._weekdaysRegex,
        this._weekdaysMinRegex = this._weekdaysRegex,
        this._weekdaysStrictRegex = new RegExp("^(" + l.join("|") + ")","i"),
        this._weekdaysShortStrictRegex = new RegExp("^(" + r.join("|") + ")","i"),
        this._weekdaysMinStrictRegex = new RegExp("^(" + s.join("|") + ")","i")
    }
    function Qt() {
        return this.hours() % 12 || 12
    }
    function Zt(t, e) {
        Y(t, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), e)
        })
    }
    function Jt(t, e) {
        return e._meridiemParse
    }
    Y("H", ["HH", 2], 0, "hour"),
    Y("h", ["hh", 2], 0, Qt),
    Y("k", ["kk", 2], 0, function() {
        return this.hours() || 24
    }),
    Y("hmm", 0, 0, function() {
        return "" + Qt.apply(this) + F(this.minutes(), 2)
    }),
    Y("hmmss", 0, 0, function() {
        return "" + Qt.apply(this) + F(this.minutes(), 2) + F(this.seconds(), 2)
    }),
    Y("Hmm", 0, 0, function() {
        return "" + this.hours() + F(this.minutes(), 2)
    }),
    Y("Hmmss", 0, 0, function() {
        return "" + this.hours() + F(this.minutes(), 2) + F(this.seconds(), 2)
    }),
    Zt("a", !0),
    Zt("A", !1),
    D("hour", "h"),
    B("hour", 13),
    dt("a", Jt),
    dt("A", Jt),
    dt("H", J),
    dt("h", J),
    dt("HH", J, X),
    dt("hh", J, X),
    dt("hmm", tt),
    dt("hmmss", et),
    dt("Hmm", tt),
    dt("Hmmss", et),
    mt(["H", "HH"], At),
    mt(["a", "A"], function(t, e, i) {
        i._isPm = i._locale.isPM(t),
        i._meridiem = t
    }),
    mt(["h", "hh"], function(t, e, i) {
        e[At] = S(t),
        p(i).bigHour = !0
    }),
    mt("hmm", function(t, e, i) {
        var n = t.length - 2;
        e[At] = S(t.substr(0, n)),
        e[wt] = S(t.substr(n)),
        p(i).bigHour = !0
    }),
    mt("hmmss", function(t, e, i) {
        var n = t.length - 4
          , a = t.length - 2;
        e[At] = S(t.substr(0, n)),
        e[wt] = S(t.substr(n, 2)),
        e[St] = S(t.substr(a)),
        p(i).bigHour = !0
    }),
    mt("Hmm", function(t, e, i) {
        var n = t.length - 2;
        e[At] = S(t.substr(0, n)),
        e[wt] = S(t.substr(n))
    }),
    mt("Hmmss", function(t, e, i) {
        var n = t.length - 4
          , a = t.length - 2;
        e[At] = S(t.substr(0, n)),
        e[wt] = S(t.substr(n, 2)),
        e[St] = S(t.substr(a))
    });
    var te, ee = L("Hours", !0), ie = {
        calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L"
        },
        longDateFormat: {
            LTS: "h:mm:ss A",
            LT: "h:mm A",
            L: "MM/DD/YYYY",
            LL: "MMMM D, YYYY",
            LLL: "MMMM D, YYYY h:mm A",
            LLLL: "dddd, MMMM D, YYYY h:mm A"
        },
        invalidDate: "Invalid date",
        ordinal: "%d",
        ordinalParse: /\d{1,2}/,
        relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        },
        months: Pt,
        monthsShort: Et,
        week: {
            dow: 0,
            doy: 6
        },
        weekdays: $t,
        weekdaysMin: qt,
        weekdaysShort: Yt,
        meridiemParse: /[ap]\.?m?\.?/i
    }, ne = {}, ae = {};
    function oe(t) {
        return t ? t.toLowerCase().replace("_", "-") : t
    }
    function se(t) {
        var e = null;
        if (!ne[t] && "undefined" != typeof module && module && module.exports)
            try {
                e = te._abbr,
                require("./locale/" + t),
                re(e)
            } catch (t) {}
        return ne[t]
    }
    function re(t, e) {
        var i;
        return t && (i = g(e) ? ce(t) : le(t, e)) && (te = i),
        te._abbr
    }
    function le(t, e) {
        if (null === e)
            return delete ne[t],
            null;
        var i = ie;
        if (e.abbr = t,
        null != ne[t])
            M("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."),
            i = ne[t]._config;
        else if (null != e.parentLocale) {
            if (null == ne[e.parentLocale])
                return ae[e.parentLocale] || (ae[e.parentLocale] = []),
                ae[e.parentLocale].push({
                    name: t,
                    config: e
                }),
                null;
            i = ne[e.parentLocale]._config
        }
        return ne[t] = new P(_(i, e)),
        ae[t] && ae[t].forEach(function(t) {
            le(t.name, t.config)
        }),
        re(t),
        ne[t]
    }
    function ce(t) {
        var e;
        if (t && t._locale && t._locale._abbr && (t = t._locale._abbr),
        !t)
            return te;
        if (!s(t)) {
            if (e = se(t))
                return e;
            t = [t]
        }
        return function(t) {
            for (var e, i, n, a, o = 0; o < t.length; ) {
                for (e = (a = oe(t[o]).split("-")).length,
                i = (i = oe(t[o + 1])) ? i.split("-") : null; 0 < e; ) {
                    if (n = se(a.slice(0, e).join("-")))
                        return n;
                    if (i && i.length >= e && C(a, i, !0) >= e - 1)
                        break;
                    e--
                }
                o++
            }
            return null
        }(t)
    }
    function ue(t) {
        var e, i = t._a;
        return i && -2 === p(t).overflow && (e = i[vt] < 0 || 11 < i[vt] ? vt : i[bt] < 1 || i[bt] > xt(i[yt], i[vt]) ? bt : i[At] < 0 || 24 < i[At] || 24 === i[At] && (0 !== i[wt] || 0 !== i[St] || 0 !== i[Ct]) ? At : i[wt] < 0 || 59 < i[wt] ? wt : i[St] < 0 || 59 < i[St] ? St : i[Ct] < 0 || 999 < i[Ct] ? Ct : -1,
        p(t)._overflowDayOfYear && (e < yt || bt < e) && (e = bt),
        p(t)._overflowWeeks && -1 === e && (e = Tt),
        p(t)._overflowWeekday && -1 === e && (e = kt),
        p(t).overflow = e),
        t
    }
    var de = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/
      , he = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/
      , fe = /Z|[+-]\d\d(?::?\d\d)?/
      , pe = [["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/], ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/], ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/], ["GGGG-[W]WW", /\d{4}-W\d\d/, !1], ["YYYY-DDD", /\d{4}-\d{3}/], ["YYYY-MM", /\d{4}-\d\d/, !1], ["YYYYYYMMDD", /[+-]\d{10}/], ["YYYYMMDD", /\d{8}/], ["GGGG[W]WWE", /\d{4}W\d{3}/], ["GGGG[W]WW", /\d{4}W\d{2}/, !1], ["YYYYDDD", /\d{7}/]]
      , me = [["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/], ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/], ["HH:mm:ss", /\d\d:\d\d:\d\d/], ["HH:mm", /\d\d:\d\d/], ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/], ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/], ["HHmmss", /\d\d\d\d\d\d/], ["HHmm", /\d\d\d\d/], ["HH", /\d\d/]]
      , ge = /^\/?Date\((\-?\d+)/i;
    function ye(t) {
        var e, i, n, a, o, s, r = t._i, l = de.exec(r) || he.exec(r);
        if (l) {
            for (p(t).iso = !0,
            e = 0,
            i = pe.length; e < i; e++)
                if (pe[e][1].exec(l[1])) {
                    a = pe[e][0],
                    n = !1 !== pe[e][2];
                    break
                }
            if (null == a)
                return void (t._isValid = !1);
            if (l[3]) {
                for (e = 0,
                i = me.length; e < i; e++)
                    if (me[e][1].exec(l[3])) {
                        o = (l[2] || " ") + me[e][0];
                        break
                    }
                if (null == o)
                    return void (t._isValid = !1)
            }
            if (!n && null != o)
                return void (t._isValid = !1);
            if (l[4]) {
                if (!fe.exec(l[4]))
                    return void (t._isValid = !1);
                s = "Z"
            }
            t._f = a + (o || "") + (s || ""),
            Ae(t)
        } else
            t._isValid = !1
    }
    function ve(t, e, i) {
        return null != t ? t : null != e ? e : i
    }
    function be(t) {
        var e, i, n, a, o = [];
        if (!t._d) {
            for (n = function(t) {
                var e = new Date(h.now());
                return t._useUTC ? [e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()] : [e.getFullYear(), e.getMonth(), e.getDate()]
            }(t),
            t._w && null == t._a[bt] && null == t._a[vt] && function(t) {
                var e, i, n, a, o, s, r, l;
                if (null != (e = t._w).GG || null != e.W || null != e.E)
                    o = 1,
                    s = 4,
                    i = ve(e.GG, t._a[yt], Ht(Ce(), 1, 4).year),
                    n = ve(e.W, 1),
                    ((a = ve(e.E, 1)) < 1 || 7 < a) && (l = !0);
                else {
                    o = t._locale._week.dow,
                    s = t._locale._week.doy;
                    var c = Ht(Ce(), o, s);
                    i = ve(e.gg, t._a[yt], c.year),
                    n = ve(e.w, c.week),
                    null != e.d ? ((a = e.d) < 0 || 6 < a) && (l = !0) : null != e.e ? (a = e.e + o,
                    (e.e < 0 || 6 < e.e) && (l = !0)) : a = o
                }
                n < 1 || n > Ut(i, o, s) ? p(t)._overflowWeeks = !0 : null != l ? p(t)._overflowWeekday = !0 : (r = jt(i, n, a, o, s),
                t._a[yt] = r.year,
                t._dayOfYear = r.dayOfYear)
            }(t),
            t._dayOfYear && (a = ve(t._a[yt], n[yt]),
            t._dayOfYear > Bt(a) && (p(t)._overflowDayOfYear = !0),
            i = Wt(a, 0, t._dayOfYear),
            t._a[vt] = i.getUTCMonth(),
            t._a[bt] = i.getUTCDate()),
            e = 0; e < 3 && null == t._a[e]; ++e)
                t._a[e] = o[e] = n[e];
            for (; e < 7; e++)
                t._a[e] = o[e] = null == t._a[e] ? 2 === e ? 1 : 0 : t._a[e];
            24 === t._a[At] && 0 === t._a[wt] && 0 === t._a[St] && 0 === t._a[Ct] && (t._nextDay = !0,
            t._a[At] = 0),
            t._d = (t._useUTC ? Wt : function(t, e, i, n, a, o, s) {
                var r = new Date(t,e,i,n,a,o,s);
                return t < 100 && 0 <= t && isFinite(r.getFullYear()) && r.setFullYear(t),
                r
            }
            ).apply(null, o),
            null != t._tzm && t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm),
            t._nextDay && (t._a[At] = 24)
        }
    }
    function Ae(t) {
        if (t._f !== h.ISO_8601) {
            t._a = [],
            p(t).empty = !0;
            var e, i, n, a, o, s, r, l, c = "" + t._i, u = c.length, d = 0;
            for (n = G(t._f, t._locale).match(j) || [],
            e = 0; e < n.length; e++)
                a = n[e],
                (i = (c.match(ht(a, t)) || [])[0]) && (0 < (o = c.substr(0, c.indexOf(i))).length && p(t).unusedInput.push(o),
                c = c.slice(c.indexOf(i) + i.length),
                d += i.length),
                $[a] ? (i ? p(t).empty = !1 : p(t).unusedTokens.push(a),
                s = a,
                l = t,
                null != (r = i) && f(pt, s) && pt[s](r, l._a, l, s)) : t._strict && !i && p(t).unusedTokens.push(a);
            p(t).charsLeftOver = u - d,
            0 < c.length && p(t).unusedInput.push(c),
            t._a[At] <= 12 && !0 === p(t).bigHour && 0 < t._a[At] && (p(t).bigHour = void 0),
            p(t).parsedDateParts = t._a.slice(0),
            p(t).meridiem = t._meridiem,
            t._a[At] = function(t, e, i) {
                var n;
                if (null == i)
                    return e;
                return null != t.meridiemHour ? t.meridiemHour(e, i) : (null != t.isPM && ((n = t.isPM(i)) && e < 12 && (e += 12),
                n || 12 !== e || (e = 0)),
                e)
            }(t._locale, t._a[At], t._meridiem),
            be(t),
            ue(t)
        } else
            ye(t)
    }
    function we(t) {
        var e = t._i
          , i = t._f;
        return t._locale = t._locale || ce(t._l),
        null === e || void 0 === i && "" === e ? m({
            nullInput: !0
        }) : ("string" == typeof e && (t._i = e = t._locale.preparse(e)),
        A(e) ? new b(ue(e)) : (a(e) ? t._d = e : s(i) ? function(t) {
            var e, i, n, a, o;
            if (0 === t._f.length)
                return p(t).invalidFormat = !0,
                t._d = new Date(NaN);
            for (a = 0; a < t._f.length; a++)
                o = 0,
                e = v({}, t),
                null != t._useUTC && (e._useUTC = t._useUTC),
                e._f = t._f[a],
                Ae(e),
                d(e) && (o += p(e).charsLeftOver,
                o += 10 * p(e).unusedTokens.length,
                p(e).score = o,
                (null == n || o < n) && (n = o,
                i = e));
            c(t, i || e)
        }(t) : i ? Ae(t) : function(t) {
            var e = t._i;
            void 0 === e ? t._d = new Date(h.now()) : a(e) ? t._d = new Date(e.valueOf()) : "string" == typeof e ? function(t) {
                var e = ge.exec(t._i);
                null === e ? (ye(t),
                !1 === t._isValid && (delete t._isValid,
                h.createFromInputFallback(t))) : t._d = new Date(+e[1])
            }(t) : s(e) ? (t._a = n(e.slice(0), function(t) {
                return parseInt(t, 10)
            }),
            be(t)) : "object" == typeof e ? function(t) {
                if (!t._d) {
                    var e = N(t._i);
                    t._a = n([e.year, e.month, e.day || e.date, e.hour, e.minute, e.second, e.millisecond], function(t) {
                        return t && parseInt(t, 10)
                    }),
                    be(t)
                }
            }(t) : l(e) ? t._d = new Date(e) : h.createFromInputFallback(t)
        }(t),
        d(t) || (t._d = null),
        t))
    }
    function Se(t, e, i, n, a) {
        var o = {};
        return !0 !== i && !1 !== i || (n = i,
        i = void 0),
        (r(t) && function(t) {
            var e;
            for (e in t)
                return !1;
            return !0
        }(t) || s(t) && 0 === t.length) && (t = void 0),
        o._isAMomentObject = !0,
        o._useUTC = o._isUTC = a,
        o._l = i,
        o._i = t,
        o._f = e,
        o._strict = n,
        function(t) {
            var e = new b(ue(we(t)));
            return e._nextDay && (e.add(1, "d"),
            e._nextDay = void 0),
            e
        }(o)
    }
    function Ce(t, e, i, n) {
        return Se(t, e, i, n, !1)
    }
    h.createFromInputFallback = i("value provided is not in a recognized ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(t) {
        t._d = new Date(t._i + (t._useUTC ? " UTC" : ""))
    }),
    h.ISO_8601 = function() {}
    ;
    var Te = i("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var t = Ce.apply(null, arguments);
        return this.isValid() && t.isValid() ? t < this ? this : t : m()
    })
      , ke = i("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var t = Ce.apply(null, arguments);
        return this.isValid() && t.isValid() ? this < t ? this : t : m()
    });
    function Me(t, e) {
        var i, n;
        if (1 === e.length && s(e[0]) && (e = e[0]),
        !e.length)
            return Ce();
        for (i = e[0],
        n = 1; n < e.length; ++n)
            e[n].isValid() && !e[n][t](i) || (i = e[n]);
        return i
    }
    function xe(t) {
        var e = N(t)
          , i = e.year || 0
          , n = e.quarter || 0
          , a = e.month || 0
          , o = e.week || 0
          , s = e.day || 0
          , r = e.hour || 0
          , l = e.minute || 0
          , c = e.second || 0
          , u = e.millisecond || 0;
        this._milliseconds = +u + 1e3 * c + 6e4 * l + 1e3 * r * 60 * 60,
        this._days = +s + 7 * o,
        this._months = +a + 3 * n + 12 * i,
        this._data = {},
        this._locale = ce(),
        this._bubble()
    }
    function _e(t) {
        return t instanceof xe
    }
    function Pe(t) {
        return t < 0 ? -1 * Math.round(-1 * t) : Math.round(t)
    }
    function Ee(t, i) {
        Y(t, 0, 0, function() {
            var t = this.utcOffset()
              , e = "+";
            return t < 0 && (t = -t,
            e = "-"),
            e + F(~~(t / 60), 2) + i + F(~~t % 60, 2)
        })
    }
    Ee("Z", ":"),
    Ee("ZZ", ""),
    dt("Z", lt),
    dt("ZZ", lt),
    mt(["Z", "ZZ"], function(t, e, i) {
        i._useUTC = !0,
        i._tzm = De(lt, t)
    });
    var Oe = /([\+\-]|\d\d)/gi;
    function De(t, e) {
        var i = (e || "").match(t);
        if (null === i)
            return null;
        var n = ((i[i.length - 1] || []) + "").match(Oe) || ["-", 0, 0]
          , a = 60 * n[1] + S(n[2]);
        return 0 === a ? 0 : "+" === n[0] ? a : -a
    }
    function Ie(t, e) {
        var i, n;
        return e._isUTC ? (i = e.clone(),
        n = (A(t) || a(t) ? t.valueOf() : Ce(t).valueOf()) - i.valueOf(),
        i._d.setTime(i._d.valueOf() + n),
        h.updateOffset(i, !1),
        i) : Ce(t).local()
    }
    function Ne(t) {
        return 15 * -Math.round(t._d.getTimezoneOffset() / 15)
    }
    function ze() {
        return !!this.isValid() && (this._isUTC && 0 === this._offset)
    }
    h.updateOffset = function() {}
    ;
    var Be = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/
      , Le = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
    function Re(t, e) {
        var i, n, a, o = t, s = null;
        return _e(t) ? o = {
            ms: t._milliseconds,
            d: t._days,
            M: t._months
        } : l(t) ? (o = {},
        e ? o[e] = t : o.milliseconds = t) : (s = Be.exec(t)) ? (i = "-" === s[1] ? -1 : 1,
        o = {
            y: 0,
            d: S(s[bt]) * i,
            h: S(s[At]) * i,
            m: S(s[wt]) * i,
            s: S(s[St]) * i,
            ms: S(Pe(1e3 * s[Ct])) * i
        }) : (s = Le.exec(t)) ? (i = "-" === s[1] ? -1 : 1,
        o = {
            y: We(s[2], i),
            M: We(s[3], i),
            w: We(s[4], i),
            d: We(s[5], i),
            h: We(s[6], i),
            m: We(s[7], i),
            s: We(s[8], i)
        }) : null == o ? o = {} : "object" == typeof o && ("from"in o || "to"in o) && (a = function(t, e) {
            var i;
            if (!t.isValid() || !e.isValid())
                return {
                    milliseconds: 0,
                    months: 0
                };
            e = Ie(e, t),
            t.isBefore(e) ? i = Fe(t, e) : ((i = Fe(e, t)).milliseconds = -i.milliseconds,
            i.months = -i.months);
            return i
        }(Ce(o.from), Ce(o.to)),
        (o = {}).ms = a.milliseconds,
        o.M = a.months),
        n = new xe(o),
        _e(t) && f(t, "_locale") && (n._locale = t._locale),
        n
    }
    function We(t, e) {
        var i = t && parseFloat(t.replace(",", "."));
        return (isNaN(i) ? 0 : i) * e
    }
    function Fe(t, e) {
        var i = {
            milliseconds: 0,
            months: 0
        };
        return i.months = e.month() - t.month() + 12 * (e.year() - t.year()),
        t.clone().add(i.months, "M").isAfter(e) && --i.months,
        i.milliseconds = +e - +t.clone().add(i.months, "M"),
        i
    }
    function je(n, a) {
        return function(t, e) {
            var i;
            return null === e || isNaN(+e) || (M(a, "moment()." + a + "(period, number) is deprecated. Please use moment()." + a + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."),
            i = t,
            t = e,
            e = i),
            He(this, Re(t = "string" == typeof t ? +t : t, e), n),
            this
        }
    }
    function He(t, e, i, n) {
        var a = e._milliseconds
          , o = Pe(e._days)
          , s = Pe(e._months);
        t.isValid() && (n = null == n || n,
        a && t._d.setTime(t._d.valueOf() + a * i),
        o && W(t, "Date", R(t, "Date") + o * i),
        s && Ot(t, R(t, "Month") + s * i),
        n && h.updateOffset(t, o || s))
    }
    Re.fn = xe.prototype;
    var Ue = je(1, "add")
      , $e = je(-1, "subtract");
    function Ye(t) {
        var e;
        return void 0 === t ? this._locale._abbr : (null != (e = ce(t)) && (this._locale = e),
        this)
    }
    h.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ",
    h.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    var qe = i("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(t) {
        return void 0 === t ? this.localeData() : this.locale(t)
    });
    function Ge() {
        return this._locale
    }
    function Ve(t, e) {
        Y(0, [t, t.length], 0, e)
    }
    function Xe(t, e, i, n, a) {
        var o;
        return null == t ? Ht(this, n, a).year : ((o = Ut(t, n, a)) < e && (e = o),
        function(t, e, i, n, a) {
            var o = jt(t, e, i, n, a)
              , s = Wt(o.year, 0, o.dayOfYear);
            return this.year(s.getUTCFullYear()),
            this.month(s.getUTCMonth()),
            this.date(s.getUTCDate()),
            this
        }
        .call(this, t, e, i, n, a))
    }
    Y(0, ["gg", 2], 0, function() {
        return this.weekYear() % 100
    }),
    Y(0, ["GG", 2], 0, function() {
        return this.isoWeekYear() % 100
    }),
    Ve("gggg", "weekYear"),
    Ve("ggggg", "weekYear"),
    Ve("GGGG", "isoWeekYear"),
    Ve("GGGGG", "isoWeekYear"),
    D("weekYear", "gg"),
    D("isoWeekYear", "GG"),
    B("weekYear", 1),
    B("isoWeekYear", 1),
    dt("G", st),
    dt("g", st),
    dt("GG", J, X),
    dt("gg", J, X),
    dt("GGGG", nt, Q),
    dt("gggg", nt, Q),
    dt("GGGGG", at, Z),
    dt("ggggg", at, Z),
    gt(["gggg", "ggggg", "GGGG", "GGGGG"], function(t, e, i, n) {
        e[n.substr(0, 2)] = S(t)
    }),
    gt(["gg", "GG"], function(t, e, i, n) {
        e[n] = h.parseTwoDigitYear(t)
    }),
    Y("Q", 0, "Qo", "quarter"),
    D("quarter", "Q"),
    B("quarter", 7),
    dt("Q", V),
    mt("Q", function(t, e) {
        e[vt] = 3 * (S(t) - 1)
    }),
    Y("D", ["DD", 2], "Do", "date"),
    D("date", "D"),
    B("date", 9),
    dt("D", J),
    dt("DD", J, X),
    dt("Do", function(t, e) {
        return t ? e._ordinalParse : e._ordinalParseLenient
    }),
    mt(["D", "DD"], bt),
    mt("Do", function(t, e) {
        e[bt] = S(t.match(J)[0])
    });
    var Ke = L("Date", !0);
    Y("DDD", ["DDDD", 3], "DDDo", "dayOfYear"),
    D("dayOfYear", "DDD"),
    B("dayOfYear", 4),
    dt("DDD", it),
    dt("DDDD", K),
    mt(["DDD", "DDDD"], function(t, e, i) {
        i._dayOfYear = S(t)
    }),
    Y("m", ["mm", 2], 0, "minute"),
    D("minute", "m"),
    B("minute", 14),
    dt("m", J),
    dt("mm", J, X),
    mt(["m", "mm"], wt);
    var Qe = L("Minutes", !1);
    Y("s", ["ss", 2], 0, "second"),
    D("second", "s"),
    B("second", 15),
    dt("s", J),
    dt("ss", J, X),
    mt(["s", "ss"], St);
    var Ze, Je = L("Seconds", !1);
    for (Y("S", 0, 0, function() {
        return ~~(this.millisecond() / 100)
    }),
    Y(0, ["SS", 2], 0, function() {
        return ~~(this.millisecond() / 10)
    }),
    Y(0, ["SSS", 3], 0, "millisecond"),
    Y(0, ["SSSS", 4], 0, function() {
        return 10 * this.millisecond()
    }),
    Y(0, ["SSSSS", 5], 0, function() {
        return 100 * this.millisecond()
    }),
    Y(0, ["SSSSSS", 6], 0, function() {
        return 1e3 * this.millisecond()
    }),
    Y(0, ["SSSSSSS", 7], 0, function() {
        return 1e4 * this.millisecond()
    }),
    Y(0, ["SSSSSSSS", 8], 0, function() {
        return 1e5 * this.millisecond()
    }),
    Y(0, ["SSSSSSSSS", 9], 0, function() {
        return 1e6 * this.millisecond()
    }),
    D("millisecond", "ms"),
    B("millisecond", 16),
    dt("S", it, V),
    dt("SS", it, X),
    dt("SSS", it, K),
    Ze = "SSSS"; Ze.length <= 9; Ze += "S")
        dt(Ze, ot);
    function ti(t, e) {
        e[Ct] = S(1e3 * ("0." + t))
    }
    for (Ze = "S"; Ze.length <= 9; Ze += "S")
        mt(Ze, ti);
    var ei = L("Milliseconds", !1);
    Y("z", 0, 0, "zoneAbbr"),
    Y("zz", 0, 0, "zoneName");
    var ii = b.prototype;
    function ni(t) {
        return t
    }
    ii.add = Ue,
    ii.calendar = function(t, e) {
        var i = t || Ce()
          , n = Ie(i, this).startOf("day")
          , a = h.calendarFormat(this, n) || "sameElse"
          , o = e && (x(e[a]) ? e[a].call(this, i) : e[a]);
        return this.format(o || this.localeData().calendar(a, this, Ce(i)))
    }
    ,
    ii.clone = function() {
        return new b(this)
    }
    ,
    ii.diff = function(t, e, i) {
        var n, a, o, s;
        return this.isValid() && (n = Ie(t, this)).isValid() ? (a = 6e4 * (n.utcOffset() - this.utcOffset()),
        "year" === (e = I(e)) || "month" === e || "quarter" === e ? (s = function(t, e) {
            var i, n, a = 12 * (e.year() - t.year()) + (e.month() - t.month()), o = t.clone().add(a, "months");
            n = e - o < 0 ? (i = t.clone().add(a - 1, "months"),
            (e - o) / (o - i)) : (i = t.clone().add(1 + a, "months"),
            (e - o) / (i - o));
            return -(a + n) || 0
        }(this, n),
        "quarter" === e ? s /= 3 : "year" === e && (s /= 12)) : (o = this - n,
        s = "second" === e ? o / 1e3 : "minute" === e ? o / 6e4 : "hour" === e ? o / 36e5 : "day" === e ? (o - a) / 864e5 : "week" === e ? (o - a) / 6048e5 : o),
        i ? s : w(s)) : NaN
    }
    ,
    ii.endOf = function(t) {
        return void 0 === (t = I(t)) || "millisecond" === t ? this : ("date" === t && (t = "day"),
        this.startOf(t).add(1, "isoWeek" === t ? "week" : t).subtract(1, "ms"))
    }
    ,
    ii.format = function(t) {
        t || (t = this.isUtc() ? h.defaultFormatUtc : h.defaultFormat);
        var e = q(this, t);
        return this.localeData().postformat(e)
    }
    ,
    ii.from = function(t, e) {
        return this.isValid() && (A(t) && t.isValid() || Ce(t).isValid()) ? Re({
            to: this,
            from: t
        }).locale(this.locale()).humanize(!e) : this.localeData().invalidDate()
    }
    ,
    ii.fromNow = function(t) {
        return this.from(Ce(), t)
    }
    ,
    ii.to = function(t, e) {
        return this.isValid() && (A(t) && t.isValid() || Ce(t).isValid()) ? Re({
            from: this,
            to: t
        }).locale(this.locale()).humanize(!e) : this.localeData().invalidDate()
    }
    ,
    ii.toNow = function(t) {
        return this.to(Ce(), t)
    }
    ,
    ii.get = function(t) {
        return x(this[t = I(t)]) ? this[t]() : this
    }
    ,
    ii.invalidAt = function() {
        return p(this).overflow
    }
    ,
    ii.isAfter = function(t, e) {
        var i = A(t) ? t : Ce(t);
        return !(!this.isValid() || !i.isValid()) && ("millisecond" === (e = I(g(e) ? "millisecond" : e)) ? this.valueOf() > i.valueOf() : i.valueOf() < this.clone().startOf(e).valueOf())
    }
    ,
    ii.isBefore = function(t, e) {
        var i = A(t) ? t : Ce(t);
        return !(!this.isValid() || !i.isValid()) && ("millisecond" === (e = I(g(e) ? "millisecond" : e)) ? this.valueOf() < i.valueOf() : this.clone().endOf(e).valueOf() < i.valueOf())
    }
    ,
    ii.isBetween = function(t, e, i, n) {
        return ("(" === (n = n || "()")[0] ? this.isAfter(t, i) : !this.isBefore(t, i)) && (")" === n[1] ? this.isBefore(e, i) : !this.isAfter(e, i))
    }
    ,
    ii.isSame = function(t, e) {
        var i, n = A(t) ? t : Ce(t);
        return !(!this.isValid() || !n.isValid()) && ("millisecond" === (e = I(e || "millisecond")) ? this.valueOf() === n.valueOf() : (i = n.valueOf(),
        this.clone().startOf(e).valueOf() <= i && i <= this.clone().endOf(e).valueOf()))
    }
    ,
    ii.isSameOrAfter = function(t, e) {
        return this.isSame(t, e) || this.isAfter(t, e)
    }
    ,
    ii.isSameOrBefore = function(t, e) {
        return this.isSame(t, e) || this.isBefore(t, e)
    }
    ,
    ii.isValid = function() {
        return d(this)
    }
    ,
    ii.lang = qe,
    ii.locale = Ye,
    ii.localeData = Ge,
    ii.max = ke,
    ii.min = Te,
    ii.parsingFlags = function() {
        return c({}, p(this))
    }
    ,
    ii.set = function(t, e) {
        if ("object" == typeof t)
            for (var i = function(t) {
                var e = [];
                for (var i in t)
                    e.push({
                        unit: i,
                        priority: z[i]
                    });
                return e.sort(function(t, e) {
                    return t.priority - e.priority
                }),
                e
            }(t = N(t)), n = 0; n < i.length; n++)
                this[i[n].unit](t[i[n].unit]);
        else if (x(this[t = I(t)]))
            return this[t](e);
        return this
    }
    ,
    ii.startOf = function(t) {
        switch (t = I(t)) {
        case "year":
            this.month(0);
        case "quarter":
        case "month":
            this.date(1);
        case "week":
        case "isoWeek":
        case "day":
        case "date":
            this.hours(0);
        case "hour":
            this.minutes(0);
        case "minute":
            this.seconds(0);
        case "second":
            this.milliseconds(0)
        }
        return "week" === t && this.weekday(0),
        "isoWeek" === t && this.isoWeekday(1),
        "quarter" === t && this.month(3 * Math.floor(this.month() / 3)),
        this
    }
    ,
    ii.subtract = $e,
    ii.toArray = function() {
        var t = this;
        return [t.year(), t.month(), t.date(), t.hour(), t.minute(), t.second(), t.millisecond()]
    }
    ,
    ii.toObject = function() {
        var t = this;
        return {
            years: t.year(),
            months: t.month(),
            date: t.date(),
            hours: t.hours(),
            minutes: t.minutes(),
            seconds: t.seconds(),
            milliseconds: t.milliseconds()
        }
    }
    ,
    ii.toDate = function() {
        return new Date(this.valueOf())
    }
    ,
    ii.toISOString = function() {
        var t = this.clone().utc();
        return 0 < t.year() && t.year() <= 9999 ? x(Date.prototype.toISOString) ? this.toDate().toISOString() : q(t, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]") : q(t, "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]")
    }
    ,
    ii.inspect = function() {
        if (!this.isValid())
            return "moment.invalid(/* " + this._i + " */)";
        var t = "moment"
          , e = "";
        this.isLocal() || (t = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone",
        e = "Z");
        var i = "[" + t + '("]'
          , n = 0 < this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY"
          , a = e + '[")]';
        return this.format(i + n + "-MM-DD[T]HH:mm:ss.SSS" + a)
    }
    ,
    ii.toJSON = function() {
        return this.isValid() ? this.toISOString() : null
    }
    ,
    ii.toString = function() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")
    }
    ,
    ii.unix = function() {
        return Math.floor(this.valueOf() / 1e3)
    }
    ,
    ii.valueOf = function() {
        return this._d.valueOf() - 6e4 * (this._offset || 0)
    }
    ,
    ii.creationData = function() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        }
    }
    ,
    ii.year = Rt,
    ii.isLeapYear = function() {
        return Lt(this.year())
    }
    ,
    ii.weekYear = function(t) {
        return Xe.call(this, t, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy)
    }
    ,
    ii.isoWeekYear = function(t) {
        return Xe.call(this, t, this.isoWeek(), this.isoWeekday(), 1, 4)
    }
    ,
    ii.quarter = ii.quarters = function(t) {
        return null == t ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (t - 1) + this.month() % 3)
    }
    ,
    ii.month = Dt,
    ii.daysInMonth = function() {
        return xt(this.year(), this.month())
    }
    ,
    ii.week = ii.weeks = function(t) {
        var e = this.localeData().week(this);
        return null == t ? e : this.add(7 * (t - e), "d")
    }
    ,
    ii.isoWeek = ii.isoWeeks = function(t) {
        var e = Ht(this, 1, 4).week;
        return null == t ? e : this.add(7 * (t - e), "d")
    }
    ,
    ii.weeksInYear = function() {
        var t = this.localeData()._week;
        return Ut(this.year(), t.dow, t.doy)
    }
    ,
    ii.isoWeeksInYear = function() {
        return Ut(this.year(), 1, 4)
    }
    ,
    ii.date = Ke,
    ii.day = ii.days = function(t) {
        if (!this.isValid())
            return null != t ? this : NaN;
        var e = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        return null != t ? (t = function(t, e) {
            return "string" != typeof t ? t : isNaN(t) ? "number" == typeof (t = e.weekdaysParse(t)) ? t : null : parseInt(t, 10)
        }(t, this.localeData()),
        this.add(t - e, "d")) : e
    }
    ,
    ii.weekday = function(t) {
        if (!this.isValid())
            return null != t ? this : NaN;
        var e = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return null == t ? e : this.add(t - e, "d")
    }
    ,
    ii.isoWeekday = function(t) {
        if (!this.isValid())
            return null != t ? this : NaN;
        if (null == t)
            return this.day() || 7;
        var e = function(t, e) {
            return "string" == typeof t ? e.weekdaysParse(t) % 7 || 7 : isNaN(t) ? null : t
        }(t, this.localeData());
        return this.day(this.day() % 7 ? e : e - 7)
    }
    ,
    ii.dayOfYear = function(t) {
        var e = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return null == t ? e : this.add(t - e, "d")
    }
    ,
    ii.hour = ii.hours = ee,
    ii.minute = ii.minutes = Qe,
    ii.second = ii.seconds = Je,
    ii.millisecond = ii.milliseconds = ei,
    ii.utcOffset = function(t, e) {
        var i, n = this._offset || 0;
        if (!this.isValid())
            return null != t ? this : NaN;
        if (null == t)
            return this._isUTC ? n : Ne(this);
        if ("string" == typeof t) {
            if (null === (t = De(lt, t)))
                return this
        } else
            Math.abs(t) < 16 && (t *= 60);
        return !this._isUTC && e && (i = Ne(this)),
        this._offset = t,
        this._isUTC = !0,
        null != i && this.add(i, "m"),
        n !== t && (!e || this._changeInProgress ? He(this, Re(t - n, "m"), 1, !1) : this._changeInProgress || (this._changeInProgress = !0,
        h.updateOffset(this, !0),
        this._changeInProgress = null)),
        this
    }
    ,
    ii.utc = function(t) {
        return this.utcOffset(0, t)
    }
    ,
    ii.local = function(t) {
        return this._isUTC && (this.utcOffset(0, t),
        this._isUTC = !1,
        t && this.subtract(Ne(this), "m")),
        this
    }
    ,
    ii.parseZone = function() {
        if (null != this._tzm)
            this.utcOffset(this._tzm);
        else if ("string" == typeof this._i) {
            var t = De(rt, this._i);
            null != t ? this.utcOffset(t) : this.utcOffset(0, !0)
        }
        return this
    }
    ,
    ii.hasAlignedHourOffset = function(t) {
        return !!this.isValid() && (t = t ? Ce(t).utcOffset() : 0,
        (this.utcOffset() - t) % 60 == 0)
    }
    ,
    ii.isDST = function() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset()
    }
    ,
    ii.isLocal = function() {
        return !!this.isValid() && !this._isUTC
    }
    ,
    ii.isUtcOffset = function() {
        return !!this.isValid() && this._isUTC
    }
    ,
    ii.isUtc = ze,
    ii.isUTC = ze,
    ii.zoneAbbr = function() {
        return this._isUTC ? "UTC" : ""
    }
    ,
    ii.zoneName = function() {
        return this._isUTC ? "Coordinated Universal Time" : ""
    }
    ,
    ii.dates = i("dates accessor is deprecated. Use date instead.", Ke),
    ii.months = i("months accessor is deprecated. Use month instead", Dt),
    ii.years = i("years accessor is deprecated. Use year instead", Rt),
    ii.zone = i("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", function(t, e) {
        return null != t ? ("string" != typeof t && (t = -t),
        this.utcOffset(t, e),
        this) : -this.utcOffset()
    }),
    ii.isDSTShifted = i("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", function() {
        if (!g(this._isDSTShifted))
            return this._isDSTShifted;
        var t = {};
        if (v(t, this),
        (t = we(t))._a) {
            var e = t._isUTC ? u(t._a) : Ce(t._a);
            this._isDSTShifted = this.isValid() && 0 < C(t._a, e.toArray())
        } else
            this._isDSTShifted = !1;
        return this._isDSTShifted
    });
    var ai = P.prototype;
    function oi(t, e, i, n) {
        var a = ce()
          , o = u().set(n, e);
        return a[i](o, t)
    }
    function si(t, e, i) {
        if (l(t) && (e = t,
        t = void 0),
        t = t || "",
        null != e)
            return oi(t, e, i, "month");
        var n, a = [];
        for (n = 0; n < 12; n++)
            a[n] = oi(t, n, i, "month");
        return a
    }
    function ri(t, e, i, n) {
        e = ("boolean" == typeof t ? l(e) && (i = e,
        e = void 0) : (e = t,
        t = !1,
        l(i = e) && (i = e,
        e = void 0)),
        e || "");
        var a, o = ce(), s = t ? o._week.dow : 0;
        if (null != i)
            return oi(e, (i + s) % 7, n, "day");
        var r = [];
        for (a = 0; a < 7; a++)
            r[a] = oi(e, (a + s) % 7, n, "day");
        return r
    }
    ai.calendar = function(t, e, i) {
        var n = this._calendar[t] || this._calendar.sameElse;
        return x(n) ? n.call(e, i) : n
    }
    ,
    ai.longDateFormat = function(t) {
        var e = this._longDateFormat[t]
          , i = this._longDateFormat[t.toUpperCase()];
        return e || !i ? e : (this._longDateFormat[t] = i.replace(/MMMM|MM|DD|dddd/g, function(t) {
            return t.slice(1)
        }),
        this._longDateFormat[t])
    }
    ,
    ai.invalidDate = function() {
        return this._invalidDate
    }
    ,
    ai.ordinal = function(t) {
        return this._ordinal.replace("%d", t)
    }
    ,
    ai.preparse = ni,
    ai.postformat = ni,
    ai.relativeTime = function(t, e, i, n) {
        var a = this._relativeTime[i];
        return x(a) ? a(t, e, i, n) : a.replace(/%d/i, t)
    }
    ,
    ai.pastFuture = function(t, e) {
        var i = this._relativeTime[0 < t ? "future" : "past"];
        return x(i) ? i(e) : i.replace(/%s/i, e)
    }
    ,
    ai.set = function(t) {
        var e, i;
        for (i in t)
            x(e = t[i]) ? this[i] = e : this["_" + i] = e;
        this._config = t,
        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + "|" + /\d{1,2}/.source)
    }
    ,
    ai.months = function(t, e) {
        return t ? s(this._months) ? this._months[t.month()] : this._months[(this._months.isFormat || _t).test(e) ? "format" : "standalone"][t.month()] : this._months
    }
    ,
    ai.monthsShort = function(t, e) {
        return t ? s(this._monthsShort) ? this._monthsShort[t.month()] : this._monthsShort[_t.test(e) ? "format" : "standalone"][t.month()] : this._monthsShort
    }
    ,
    ai.monthsParse = function(t, e, i) {
        var n, a, o;
        if (this._monthsParseExact)
            return function(t, e, i) {
                var n, a, o, s = t.toLocaleLowerCase();
                if (!this._monthsParse)
                    for (this._monthsParse = [],
                    this._longMonthsParse = [],
                    this._shortMonthsParse = [],
                    n = 0; n < 12; ++n)
                        o = u([2e3, n]),
                        this._shortMonthsParse[n] = this.monthsShort(o, "").toLocaleLowerCase(),
                        this._longMonthsParse[n] = this.months(o, "").toLocaleLowerCase();
                return i ? "MMM" === e ? -1 !== (a = Mt.call(this._shortMonthsParse, s)) ? a : null : -1 !== (a = Mt.call(this._longMonthsParse, s)) ? a : null : "MMM" === e ? -1 !== (a = Mt.call(this._shortMonthsParse, s)) ? a : -1 !== (a = Mt.call(this._longMonthsParse, s)) ? a : null : -1 !== (a = Mt.call(this._longMonthsParse, s)) ? a : -1 !== (a = Mt.call(this._shortMonthsParse, s)) ? a : null
            }
            .call(this, t, e, i);
        for (this._monthsParse || (this._monthsParse = [],
        this._longMonthsParse = [],
        this._shortMonthsParse = []),
        n = 0; n < 12; n++) {
            if (a = u([2e3, n]),
            i && !this._longMonthsParse[n] && (this._longMonthsParse[n] = new RegExp("^" + this.months(a, "").replace(".", "") + "$","i"),
            this._shortMonthsParse[n] = new RegExp("^" + this.monthsShort(a, "").replace(".", "") + "$","i")),
            i || this._monthsParse[n] || (o = "^" + this.months(a, "") + "|^" + this.monthsShort(a, ""),
            this._monthsParse[n] = new RegExp(o.replace(".", ""),"i")),
            i && "MMMM" === e && this._longMonthsParse[n].test(t))
                return n;
            if (i && "MMM" === e && this._shortMonthsParse[n].test(t))
                return n;
            if (!i && this._monthsParse[n].test(t))
                return n
        }
    }
    ,
    ai.monthsRegex = function(t) {
        return this._monthsParseExact ? (f(this, "_monthsRegex") || zt.call(this),
        t ? this._monthsStrictRegex : this._monthsRegex) : (f(this, "_monthsRegex") || (this._monthsRegex = Nt),
        this._monthsStrictRegex && t ? this._monthsStrictRegex : this._monthsRegex)
    }
    ,
    ai.monthsShortRegex = function(t) {
        return this._monthsParseExact ? (f(this, "_monthsRegex") || zt.call(this),
        t ? this._monthsShortStrictRegex : this._monthsShortRegex) : (f(this, "_monthsShortRegex") || (this._monthsShortRegex = It),
        this._monthsShortStrictRegex && t ? this._monthsShortStrictRegex : this._monthsShortRegex)
    }
    ,
    ai.week = function(t) {
        return Ht(t, this._week.dow, this._week.doy).week
    }
    ,
    ai.firstDayOfYear = function() {
        return this._week.doy
    }
    ,
    ai.firstDayOfWeek = function() {
        return this._week.dow
    }
    ,
    ai.weekdays = function(t, e) {
        return t ? s(this._weekdays) ? this._weekdays[t.day()] : this._weekdays[this._weekdays.isFormat.test(e) ? "format" : "standalone"][t.day()] : this._weekdays
    }
    ,
    ai.weekdaysMin = function(t) {
        return t ? this._weekdaysMin[t.day()] : this._weekdaysMin
    }
    ,
    ai.weekdaysShort = function(t) {
        return t ? this._weekdaysShort[t.day()] : this._weekdaysShort
    }
    ,
    ai.weekdaysParse = function(t, e, i) {
        var n, a, o;
        if (this._weekdaysParseExact)
            return function(t, e, i) {
                var n, a, o, s = t.toLocaleLowerCase();
                if (!this._weekdaysParse)
                    for (this._weekdaysParse = [],
                    this._shortWeekdaysParse = [],
                    this._minWeekdaysParse = [],
                    n = 0; n < 7; ++n)
                        o = u([2e3, 1]).day(n),
                        this._minWeekdaysParse[n] = this.weekdaysMin(o, "").toLocaleLowerCase(),
                        this._shortWeekdaysParse[n] = this.weekdaysShort(o, "").toLocaleLowerCase(),
                        this._weekdaysParse[n] = this.weekdays(o, "").toLocaleLowerCase();
                return i ? "dddd" === e ? -1 !== (a = Mt.call(this._weekdaysParse, s)) ? a : null : "ddd" === e ? -1 !== (a = Mt.call(this._shortWeekdaysParse, s)) ? a : null : -1 !== (a = Mt.call(this._minWeekdaysParse, s)) ? a : null : "dddd" === e ? -1 !== (a = Mt.call(this._weekdaysParse, s)) ? a : -1 !== (a = Mt.call(this._shortWeekdaysParse, s)) ? a : -1 !== (a = Mt.call(this._minWeekdaysParse, s)) ? a : null : "ddd" === e ? -1 !== (a = Mt.call(this._shortWeekdaysParse, s)) ? a : -1 !== (a = Mt.call(this._weekdaysParse, s)) ? a : -1 !== (a = Mt.call(this._minWeekdaysParse, s)) ? a : null : -1 !== (a = Mt.call(this._minWeekdaysParse, s)) ? a : -1 !== (a = Mt.call(this._weekdaysParse, s)) ? a : -1 !== (a = Mt.call(this._shortWeekdaysParse, s)) ? a : null
            }
            .call(this, t, e, i);
        for (this._weekdaysParse || (this._weekdaysParse = [],
        this._minWeekdaysParse = [],
        this._shortWeekdaysParse = [],
        this._fullWeekdaysParse = []),
        n = 0; n < 7; n++) {
            if (a = u([2e3, 1]).day(n),
            i && !this._fullWeekdaysParse[n] && (this._fullWeekdaysParse[n] = new RegExp("^" + this.weekdays(a, "").replace(".", ".?") + "$","i"),
            this._shortWeekdaysParse[n] = new RegExp("^" + this.weekdaysShort(a, "").replace(".", ".?") + "$","i"),
            this._minWeekdaysParse[n] = new RegExp("^" + this.weekdaysMin(a, "").replace(".", ".?") + "$","i")),
            this._weekdaysParse[n] || (o = "^" + this.weekdays(a, "") + "|^" + this.weekdaysShort(a, "") + "|^" + this.weekdaysMin(a, ""),
            this._weekdaysParse[n] = new RegExp(o.replace(".", ""),"i")),
            i && "dddd" === e && this._fullWeekdaysParse[n].test(t))
                return n;
            if (i && "ddd" === e && this._shortWeekdaysParse[n].test(t))
                return n;
            if (i && "dd" === e && this._minWeekdaysParse[n].test(t))
                return n;
            if (!i && this._weekdaysParse[n].test(t))
                return n
        }
    }
    ,
    ai.weekdaysRegex = function(t) {
        return this._weekdaysParseExact ? (f(this, "_weekdaysRegex") || Kt.call(this),
        t ? this._weekdaysStrictRegex : this._weekdaysRegex) : (f(this, "_weekdaysRegex") || (this._weekdaysRegex = Gt),
        this._weekdaysStrictRegex && t ? this._weekdaysStrictRegex : this._weekdaysRegex)
    }
    ,
    ai.weekdaysShortRegex = function(t) {
        return this._weekdaysParseExact ? (f(this, "_weekdaysRegex") || Kt.call(this),
        t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (f(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Vt),
        this._weekdaysShortStrictRegex && t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex)
    }
    ,
    ai.weekdaysMinRegex = function(t) {
        return this._weekdaysParseExact ? (f(this, "_weekdaysRegex") || Kt.call(this),
        t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (f(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Xt),
        this._weekdaysMinStrictRegex && t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex)
    }
    ,
    ai.isPM = function(t) {
        return "p" === (t + "").toLowerCase().charAt(0)
    }
    ,
    ai.meridiem = function(t, e, i) {
        return 11 < t ? i ? "pm" : "PM" : i ? "am" : "AM"
    }
    ,
    re("en", {
        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(t) {
            var e = t % 10;
            return t + (1 === S(t % 100 / 10) ? "th" : 1 == e ? "st" : 2 == e ? "nd" : 3 == e ? "rd" : "th")
        }
    }),
    h.lang = i("moment.lang is deprecated. Use moment.locale instead.", re),
    h.langData = i("moment.langData is deprecated. Use moment.localeData instead.", ce);
    var li = Math.abs;
    function ci(t, e, i, n) {
        var a = Re(e, i);
        return t._milliseconds += n * a._milliseconds,
        t._days += n * a._days,
        t._months += n * a._months,
        t._bubble()
    }
    function ui(t) {
        return t < 0 ? Math.floor(t) : Math.ceil(t)
    }
    function di(t) {
        return 4800 * t / 146097
    }
    function hi(t) {
        return 146097 * t / 4800
    }
    function fi(t) {
        return function() {
            return this.as(t)
        }
    }
    var pi = fi("ms")
      , mi = fi("s")
      , gi = fi("m")
      , yi = fi("h")
      , vi = fi("d")
      , bi = fi("w")
      , Ai = fi("M")
      , wi = fi("y");
    function Si(t) {
        return function() {
            return this._data[t]
        }
    }
    var Ci = Si("milliseconds")
      , Ti = Si("seconds")
      , ki = Si("minutes")
      , Mi = Si("hours")
      , xi = Si("days")
      , _i = Si("months")
      , Pi = Si("years");
    var Ei = Math.round
      , Oi = {
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        M: 11
    };
    var Di = Math.abs;
    function Ii() {
        var t, e, i = Di(this._milliseconds) / 1e3, n = Di(this._days), a = Di(this._months);
        e = w((t = w(i / 60)) / 60),
        i %= 60,
        t %= 60;
        var o = w(a / 12)
          , s = a %= 12
          , r = n
          , l = e
          , c = t
          , u = i
          , d = this.asSeconds();
        return d ? (d < 0 ? "-" : "") + "P" + (o ? o + "Y" : "") + (s ? s + "M" : "") + (r ? r + "D" : "") + (l || c || u ? "T" : "") + (l ? l + "H" : "") + (c ? c + "M" : "") + (u ? u + "S" : "") : "P0D"
    }
    var Ni = xe.prototype;
    return Ni.abs = function() {
        var t = this._data;
        return this._milliseconds = li(this._milliseconds),
        this._days = li(this._days),
        this._months = li(this._months),
        t.milliseconds = li(t.milliseconds),
        t.seconds = li(t.seconds),
        t.minutes = li(t.minutes),
        t.hours = li(t.hours),
        t.months = li(t.months),
        t.years = li(t.years),
        this
    }
    ,
    Ni.add = function(t, e) {
        return ci(this, t, e, 1)
    }
    ,
    Ni.subtract = function(t, e) {
        return ci(this, t, e, -1)
    }
    ,
    Ni.as = function(t) {
        var e, i, n = this._milliseconds;
        if ("month" === (t = I(t)) || "year" === t)
            return e = this._days + n / 864e5,
            i = this._months + di(e),
            "month" === t ? i : i / 12;
        switch (e = this._days + Math.round(hi(this._months)),
        t) {
        case "week":
            return e / 7 + n / 6048e5;
        case "day":
            return e + n / 864e5;
        case "hour":
            return 24 * e + n / 36e5;
        case "minute":
            return 1440 * e + n / 6e4;
        case "second":
            return 86400 * e + n / 1e3;
        case "millisecond":
            return Math.floor(864e5 * e) + n;
        default:
            throw new Error("Unknown unit " + t)
        }
    }
    ,
    Ni.asMilliseconds = pi,
    Ni.asSeconds = mi,
    Ni.asMinutes = gi,
    Ni.asHours = yi,
    Ni.asDays = vi,
    Ni.asWeeks = bi,
    Ni.asMonths = Ai,
    Ni.asYears = wi,
    Ni.valueOf = function() {
        return this._milliseconds + 864e5 * this._days + this._months % 12 * 2592e6 + 31536e6 * S(this._months / 12)
    }
    ,
    Ni._bubble = function() {
        var t, e, i, n, a, o = this._milliseconds, s = this._days, r = this._months, l = this._data;
        return 0 <= o && 0 <= s && 0 <= r || o <= 0 && s <= 0 && r <= 0 || (o += 864e5 * ui(hi(r) + s),
        r = s = 0),
        l.milliseconds = o % 1e3,
        t = w(o / 1e3),
        l.seconds = t % 60,
        e = w(t / 60),
        l.minutes = e % 60,
        i = w(e / 60),
        l.hours = i % 24,
        r += a = w(di(s += w(i / 24))),
        s -= ui(hi(a)),
        n = w(r / 12),
        r %= 12,
        l.days = s,
        l.months = r,
        l.years = n,
        this
    }
    ,
    Ni.get = function(t) {
        return this[(t = I(t)) + "s"]()
    }
    ,
    Ni.milliseconds = Ci,
    Ni.seconds = Ti,
    Ni.minutes = ki,
    Ni.hours = Mi,
    Ni.days = xi,
    Ni.weeks = function() {
        return w(this.days() / 7)
    }
    ,
    Ni.months = _i,
    Ni.years = Pi,
    Ni.humanize = function(t) {
        var e = this.localeData()
          , i = function(t, e, i) {
            var n = Re(t).abs()
              , a = Ei(n.as("s"))
              , o = Ei(n.as("m"))
              , s = Ei(n.as("h"))
              , r = Ei(n.as("d"))
              , l = Ei(n.as("M"))
              , c = Ei(n.as("y"))
              , u = a < Oi.s && ["s", a] || o <= 1 && ["m"] || o < Oi.m && ["mm", o] || s <= 1 && ["h"] || s < Oi.h && ["hh", s] || r <= 1 && ["d"] || r < Oi.d && ["dd", r] || l <= 1 && ["M"] || l < Oi.M && ["MM", l] || c <= 1 && ["y"] || ["yy", c];
            return u[2] = e,
            u[3] = 0 < +t,
            u[4] = i,
            function(t, e, i, n, a) {
                return a.relativeTime(e || 1, !!i, t, n)
            }
            .apply(null, u)
        }(this, !t, e);
        return t && (i = e.pastFuture(+this, i)),
        e.postformat(i)
    }
    ,
    Ni.toISOString = Ii,
    Ni.toString = Ii,
    Ni.toJSON = Ii,
    Ni.locale = Ye,
    Ni.localeData = Ge,
    Ni.toIsoString = i("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", Ii),
    Ni.lang = qe,
    Y("X", 0, 0, "unix"),
    Y("x", 0, 0, "valueOf"),
    dt("x", st),
    dt("X", /[+-]?\d+(\.\d{1,3})?/),
    mt("X", function(t, e, i) {
        i._d = new Date(1e3 * parseFloat(t, 10))
    }),
    mt("x", function(t, e, i) {
        i._d = new Date(S(t))
    }),
    h.version = "2.16.0",
    t = Ce,
    h.fn = ii,
    h.min = function() {
        return Me("isBefore", [].slice.call(arguments, 0))
    }
    ,
    h.max = function() {
        return Me("isAfter", [].slice.call(arguments, 0))
    }
    ,
    h.now = function() {
        return Date.now ? Date.now() : +new Date
    }
    ,
    h.utc = u,
    h.unix = function(t) {
        return Ce(1e3 * t)
    }
    ,
    h.months = function(t, e) {
        return si(t, e, "months")
    }
    ,
    h.isDate = a,
    h.locale = re,
    h.invalid = m,
    h.duration = Re,
    h.isMoment = A,
    h.weekdays = function(t, e, i) {
        return ri(t, e, i, "weekdays")
    }
    ,
    h.parseZone = function() {
        return Ce.apply(null, arguments).parseZone()
    }
    ,
    h.localeData = ce,
    h.isDuration = _e,
    h.monthsShort = function(t, e) {
        return si(t, e, "monthsShort")
    }
    ,
    h.weekdaysMin = function(t, e, i) {
        return ri(t, e, i, "weekdaysMin")
    }
    ,
    h.defineLocale = le,
    h.updateLocale = function(t, e) {
        if (null != e) {
            var i, n = ie;
            null != ne[t] && (n = ne[t]._config),
            (i = new P(e = _(n, e))).parentLocale = ne[t],
            ne[t] = i,
            re(t)
        } else
            null != ne[t] && (null != ne[t].parentLocale ? ne[t] = ne[t].parentLocale : null != ne[t] && delete ne[t]);
        return ne[t]
    }
    ,
    h.locales = function() {
        return E(ne)
    }
    ,
    h.weekdaysShort = function(t, e, i) {
        return ri(t, e, i, "weekdaysShort")
    }
    ,
    h.normalizeUnits = I,
    h.relativeTimeRounding = function(t) {
        return void 0 === t ? Ei : "function" == typeof t && (Ei = t,
        !0)
    }
    ,
    h.relativeTimeThreshold = function(t, e) {
        return void 0 !== Oi[t] && (void 0 === e ? Oi[t] : (Oi[t] = e,
        !0))
    }
    ,
    h.calendarFormat = function(t, e) {
        var i = t.diff(e, "days", !0);
        return i < -6 ? "sameElse" : i < -1 ? "lastWeek" : i < 0 ? "lastDay" : i < 1 ? "sameDay" : i < 2 ? "nextDay" : i < 7 ? "nextWeek" : "sameElse"
    }
    ,
    h.prototype = ii,
    h
}),
function(t) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], t) : "undefined" != typeof exports ? module.exports = t(require("jquery")) : t(jQuery)
}(function(c) {
    "use strict";
    var a, o = window.Slick || {};
    a = 0,
    (o = function(t, e) {
        var i, n = this;
        n.defaults = {
            accessibility: !0,
            adaptiveHeight: !1,
            appendArrows: c(t),
            appendDots: c(t),
            arrows: !0,
            asNavFor: null,
            prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
            nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
            autoplay: !1,
            autoplaySpeed: 3e3,
            centerMode: !1,
            centerPadding: "50px",
            cssEase: "ease",
            customPaging: function(t, e) {
                return c('<button type="button" data-role="none" role="button" tabindex="0" />').text(e + 1)
            },
            dots: !1,
            dotsClass: "slick-dots",
            draggable: !0,
            easing: "linear",
            edgeFriction: .35,
            fade: !1,
            focusOnSelect: !1,
            infinite: !0,
            initialSlide: 0,
            lazyLoad: "ondemand",
            mobileFirst: !1,
            pauseOnHover: !0,
            pauseOnFocus: !0,
            pauseOnDotsHover: !1,
            respondTo: "window",
            responsive: null,
            rows: 1,
            rtl: !1,
            slide: "",
            slidesPerRow: 1,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500,
            swipe: !0,
            swipeToSlide: !1,
            touchMove: !0,
            touchThreshold: 5,
            useCSS: !0,
            useTransform: !0,
            variableWidth: !1,
            vertical: !1,
            verticalSwiping: !1,
            waitForAnimate: !0,
            zIndex: 1e3
        },
        n.initials = {
            animating: !1,
            dragging: !1,
            autoPlayTimer: null,
            currentDirection: 0,
            currentLeft: null,
            currentSlide: 0,
            direction: 1,
            $dots: null,
            listWidth: null,
            listHeight: null,
            loadIndex: 0,
            $nextArrow: null,
            $prevArrow: null,
            slideCount: null,
            slideWidth: null,
            $slideTrack: null,
            $slides: null,
            sliding: !1,
            slideOffset: 0,
            swipeLeft: null,
            $list: null,
            touchObject: {},
            transformsEnabled: !1,
            unslicked: !1
        },
        c.extend(n, n.initials),
        n.activeBreakpoint = null,
        n.animType = null,
        n.animProp = null,
        n.breakpoints = [],
        n.breakpointSettings = [],
        n.cssTransitions = !1,
        n.focussed = !1,
        n.interrupted = !1,
        n.hidden = "hidden",
        n.paused = !0,
        n.positionProp = null,
        n.respondTo = null,
        n.rowCount = 1,
        n.shouldClick = !0,
        n.$slider = c(t),
        n.$slidesCache = null,
        n.transformType = null,
        n.transitionType = null,
        n.visibilityChange = "visibilitychange",
        n.windowWidth = 0,
        n.windowTimer = null,
        i = c(t).data("slick") || {},
        n.options = c.extend({}, n.defaults, e, i),
        n.currentSlide = n.options.initialSlide,
        n.originalSettings = n.options,
        void 0 !== document.mozHidden ? (n.hidden = "mozHidden",
        n.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (n.hidden = "webkitHidden",
        n.visibilityChange = "webkitvisibilitychange"),
        n.autoPlay = c.proxy(n.autoPlay, n),
        n.autoPlayClear = c.proxy(n.autoPlayClear, n),
        n.autoPlayIterator = c.proxy(n.autoPlayIterator, n),
        n.changeSlide = c.proxy(n.changeSlide, n),
        n.clickHandler = c.proxy(n.clickHandler, n),
        n.selectHandler = c.proxy(n.selectHandler, n),
        n.setPosition = c.proxy(n.setPosition, n),
        n.swipeHandler = c.proxy(n.swipeHandler, n),
        n.dragHandler = c.proxy(n.dragHandler, n),
        n.keyHandler = c.proxy(n.keyHandler, n),
        n.instanceUid = a++,
        n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/,
        n.registerBreakpoints(),
        n.init(!0)
    }
    ).prototype.activateADA = function() {
        this.$slideTrack.find(".slick-active").attr({
            "aria-hidden": "false"
        }).find("a, input, button, select").attr({
            tabindex: "0"
        })
    }
    ,
    o.prototype.addSlide = o.prototype.slickAdd = function(t, e, i) {
        var n = this;
        if ("boolean" == typeof e)
            i = e,
            e = null;
        else if (e < 0 || e >= n.slideCount)
            return !1;
        n.unload(),
        "number" == typeof e ? 0 === e && 0 === n.$slides.length ? c(t).appendTo(n.$slideTrack) : i ? c(t).insertBefore(n.$slides.eq(e)) : c(t).insertAfter(n.$slides.eq(e)) : !0 === i ? c(t).prependTo(n.$slideTrack) : c(t).appendTo(n.$slideTrack),
        n.$slides = n.$slideTrack.children(this.options.slide),
        n.$slideTrack.children(this.options.slide).detach(),
        n.$slideTrack.append(n.$slides),
        n.$slides.each(function(t, e) {
            c(e).attr("data-slick-index", t)
        }),
        n.$slidesCache = n.$slides,
        n.reinit()
    }
    ,
    o.prototype.animateHeight = function() {
        var t = this;
        if (1 === t.options.slidesToShow && !0 === t.options.adaptiveHeight && !1 === t.options.vertical) {
            var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
            t.$list.animate({
                height: e
            }, t.options.speed)
        }
    }
    ,
    o.prototype.animateSlide = function(t, e) {
        var i = {}
          , n = this;
        n.animateHeight(),
        !0 === n.options.rtl && !1 === n.options.vertical && (t = -t),
        !1 === n.transformsEnabled ? !1 === n.options.vertical ? n.$slideTrack.animate({
            left: t
        }, n.options.speed, n.options.easing, e) : n.$slideTrack.animate({
            top: t
        }, n.options.speed, n.options.easing, e) : !1 === n.cssTransitions ? (!0 === n.options.rtl && (n.currentLeft = -n.currentLeft),
        c({
            animStart: n.currentLeft
        }).animate({
            animStart: t
        }, {
            duration: n.options.speed,
            easing: n.options.easing,
            step: function(t) {
                t = Math.ceil(t),
                !1 === n.options.vertical ? i[n.animType] = "translate(" + t + "px, 0px)" : i[n.animType] = "translate(0px," + t + "px)",
                n.$slideTrack.css(i)
            },
            complete: function() {
                e && e.call()
            }
        })) : (n.applyTransition(),
        t = Math.ceil(t),
        !1 === n.options.vertical ? i[n.animType] = "translate3d(" + t + "px, 0px, 0px)" : i[n.animType] = "translate3d(0px," + t + "px, 0px)",
        n.$slideTrack.css(i),
        e && setTimeout(function() {
            n.disableTransition(),
            e.call()
        }, n.options.speed))
    }
    ,
    o.prototype.getNavTarget = function() {
        var t = this.options.asNavFor;
        return t && null !== t && (t = c(t).not(this.$slider)),
        t
    }
    ,
    o.prototype.asNavFor = function(e) {
        var t = this.getNavTarget();
        null !== t && "object" == typeof t && t.each(function() {
            var t = c(this).slick("getSlick");
            t.unslicked || t.slideHandler(e, !0)
        })
    }
    ,
    o.prototype.applyTransition = function(t) {
        var e = this
          , i = {};
        !1 === e.options.fade ? i[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : i[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase,
        !1 === e.options.fade ? e.$slideTrack.css(i) : e.$slides.eq(t).css(i)
    }
    ,
    o.prototype.autoPlay = function() {
        var t = this;
        t.autoPlayClear(),
        t.slideCount > t.options.slidesToShow && (t.autoPlayTimer = setInterval(t.autoPlayIterator, t.options.autoplaySpeed))
    }
    ,
    o.prototype.autoPlayClear = function() {
        this.autoPlayTimer && clearInterval(this.autoPlayTimer)
    }
    ,
    o.prototype.autoPlayIterator = function() {
        var t = this
          , e = t.currentSlide + t.options.slidesToScroll;
        t.paused || t.interrupted || t.focussed || (!1 === t.options.infinite && (1 === t.direction && t.currentSlide + 1 === t.slideCount - 1 ? t.direction = 0 : 0 === t.direction && (e = t.currentSlide - t.options.slidesToScroll,
        t.currentSlide - 1 == 0 && (t.direction = 1))),
        t.slideHandler(e))
    }
    ,
    o.prototype.buildArrows = function() {
        var t = this;
        !0 === t.options.arrows && (t.$prevArrow = c(t.options.prevArrow).addClass("slick-arrow"),
        t.$nextArrow = c(t.options.nextArrow).addClass("slick-arrow"),
        t.slideCount > t.options.slidesToShow ? (t.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
        t.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
        t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.prependTo(t.options.appendArrows),
        t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.appendTo(t.options.appendArrows),
        !0 !== t.options.infinite && t.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : t.$prevArrow.add(t.$nextArrow).addClass("slick-hidden").attr({
            "aria-disabled": "true",
            tabindex: "-1"
        }))
    }
    ,
    o.prototype.buildDots = function() {
        var t, e, i = this;
        if (!0 === i.options.dots && i.slideCount > i.options.slidesToShow) {
            for (i.$slider.addClass("slick-dotted"),
            e = c("<ul />").addClass(i.options.dotsClass),
            t = 0; t <= i.getDotCount(); t += 1)
                e.append(c("<li />").append(i.options.customPaging.call(this, i, t)));
            i.$dots = e.appendTo(i.options.appendDots),
            i.$dots.find("li").first().addClass("slick-active").attr("aria-hidden", "false")
        }
    }
    ,
    o.prototype.buildOut = function() {
        var t = this;
        t.$slides = t.$slider.children(t.options.slide + ":not(.slick-cloned)").addClass("slick-slide"),
        t.slideCount = t.$slides.length,
        t.$slides.each(function(t, e) {
            c(e).attr("data-slick-index", t).data("originalStyling", c(e).attr("style") || "")
        }),
        t.$slider.addClass("slick-slider"),
        t.$slideTrack = 0 === t.slideCount ? c('<div class="slick-track"/>').appendTo(t.$slider) : t.$slides.wrapAll('<div class="slick-track"/>').parent(),
        t.$list = t.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(),
        t.$slideTrack.css("opacity", 0),
        !0 !== t.options.centerMode && !0 !== t.options.swipeToSlide || (t.options.slidesToScroll = 1),
        c("img[data-lazy]", t.$slider).not("[src]").addClass("slick-loading"),
        t.setupInfinite(),
        t.buildArrows(),
        t.buildDots(),
        t.updateDots(),
        t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0),
        !0 === t.options.draggable && t.$list.addClass("draggable")
    }
    ,
    o.prototype.buildRows = function() {
        var t, e, i, n, a, o, s, r = this;
        if (n = document.createDocumentFragment(),
        o = r.$slider.children(),
        1 < r.options.rows) {
            for (s = r.options.slidesPerRow * r.options.rows,
            a = Math.ceil(o.length / s),
            t = 0; t < a; t++) {
                var l = document.createElement("div");
                for (e = 0; e < r.options.rows; e++) {
                    var c = document.createElement("div");
                    for (i = 0; i < r.options.slidesPerRow; i++) {
                        var u = t * s + (e * r.options.slidesPerRow + i);
                        o.get(u) && c.appendChild(o.get(u))
                    }
                    l.appendChild(c)
                }
                n.appendChild(l)
            }
            r.$slider.empty().append(n),
            r.$slider.children().children().children().css({
                width: 100 / r.options.slidesPerRow + "%",
                display: "inline-block"
            })
        }
    }
    ,
    o.prototype.checkResponsive = function(t, e) {
        var i, n, a, o = this, s = !1, r = o.$slider.width(), l = window.innerWidth || c(window).width();
        if ("window" === o.respondTo ? a = l : "slider" === o.respondTo ? a = r : "min" === o.respondTo && (a = Math.min(l, r)),
        o.options.responsive && o.options.responsive.length && null !== o.options.responsive) {
            for (i in n = null,
            o.breakpoints)
                o.breakpoints.hasOwnProperty(i) && (!1 === o.originalSettings.mobileFirst ? a < o.breakpoints[i] && (n = o.breakpoints[i]) : a > o.breakpoints[i] && (n = o.breakpoints[i]));
            null !== n ? null !== o.activeBreakpoint && n === o.activeBreakpoint && !e || (o.activeBreakpoint = n,
            "unslick" === o.breakpointSettings[n] ? o.unslick(n) : (o.options = c.extend({}, o.originalSettings, o.breakpointSettings[n]),
            !0 === t && (o.currentSlide = o.options.initialSlide),
            o.refresh(t)),
            s = n) : null !== o.activeBreakpoint && (o.activeBreakpoint = null,
            o.options = o.originalSettings,
            !0 === t && (o.currentSlide = o.options.initialSlide),
            o.refresh(t),
            s = n),
            t || !1 === s || o.$slider.trigger("breakpoint", [o, s])
        }
    }
    ,
    o.prototype.changeSlide = function(t, e) {
        var i, n, a = this, o = c(t.currentTarget);
        switch (o.is("a") && t.preventDefault(),
        o.is("li") || (o = o.closest("li")),
        i = a.slideCount % a.options.slidesToScroll != 0 ? 0 : (a.slideCount - a.currentSlide) % a.options.slidesToScroll,
        t.data.message) {
        case "previous":
            n = 0 == i ? a.options.slidesToScroll : a.options.slidesToShow - i,
            a.slideCount > a.options.slidesToShow && a.slideHandler(a.currentSlide - n, !1, e);
            break;
        case "next":
            n = 0 == i ? a.options.slidesToScroll : i,
            a.slideCount > a.options.slidesToShow && a.slideHandler(a.currentSlide + n, !1, e);
            break;
        case "index":
            var s = 0 === t.data.index ? 0 : t.data.index || o.index() * a.options.slidesToScroll;
            a.slideHandler(a.checkNavigable(s), !1, e),
            o.children().trigger("focus");
            break;
        default:
            return
        }
    }
    ,
    o.prototype.checkNavigable = function(t) {
        var e, i;
        if (i = 0,
        t > (e = this.getNavigableIndexes())[e.length - 1])
            t = e[e.length - 1];
        else
            for (var n in e) {
                if (t < e[n]) {
                    t = i;
                    break
                }
                i = e[n]
            }
        return t
    }
    ,
    o.prototype.cleanUpEvents = function() {
        var t = this;
        t.options.dots && null !== t.$dots && c("li", t.$dots).off("click.slick", t.changeSlide).off("mouseenter.slick", c.proxy(t.interrupt, t, !0)).off("mouseleave.slick", c.proxy(t.interrupt, t, !1)),
        t.$slider.off("focus.slick blur.slick"),
        !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && (t.$prevArrow && t.$prevArrow.off("click.slick", t.changeSlide),
        t.$nextArrow && t.$nextArrow.off("click.slick", t.changeSlide)),
        t.$list.off("touchstart.slick mousedown.slick", t.swipeHandler),
        t.$list.off("touchmove.slick mousemove.slick", t.swipeHandler),
        t.$list.off("touchend.slick mouseup.slick", t.swipeHandler),
        t.$list.off("touchcancel.slick mouseleave.slick", t.swipeHandler),
        t.$list.off("click.slick", t.clickHandler),
        c(document).off(t.visibilityChange, t.visibility),
        t.cleanUpSlideEvents(),
        !0 === t.options.accessibility && t.$list.off("keydown.slick", t.keyHandler),
        !0 === t.options.focusOnSelect && c(t.$slideTrack).children().off("click.slick", t.selectHandler),
        c(window).off("orientationchange.slick.slick-" + t.instanceUid, t.orientationChange),
        c(window).off("resize.slick.slick-" + t.instanceUid, t.resize),
        c("[draggable!=true]", t.$slideTrack).off("dragstart", t.preventDefault),
        c(window).off("load.slick.slick-" + t.instanceUid, t.setPosition),
        c(document).off("ready.slick.slick-" + t.instanceUid, t.setPosition)
    }
    ,
    o.prototype.cleanUpSlideEvents = function() {
        var t = this;
        t.$list.off("mouseenter.slick", c.proxy(t.interrupt, t, !0)),
        t.$list.off("mouseleave.slick", c.proxy(t.interrupt, t, !1))
    }
    ,
    o.prototype.cleanUpRows = function() {
        var t;
        1 < this.options.rows && ((t = this.$slides.children().children()).removeAttr("style"),
        this.$slider.empty().append(t))
    }
    ,
    o.prototype.clickHandler = function(t) {
        !1 === this.shouldClick && (t.stopImmediatePropagation(),
        t.stopPropagation(),
        t.preventDefault())
    }
    ,
    o.prototype.destroy = function(t) {
        var e = this;
        e.autoPlayClear(),
        e.touchObject = {},
        e.cleanUpEvents(),
        c(".slick-cloned", e.$slider).detach(),
        e.$dots && e.$dots.remove(),
        e.$prevArrow && e.$prevArrow.length && (e.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""),
        e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove()),
        e.$nextArrow && e.$nextArrow.length && (e.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""),
        e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove()),
        e.$slides && (e.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
            c(this).attr("style", c(this).data("originalStyling"))
        }),
        e.$slideTrack.children(this.options.slide).detach(),
        e.$slideTrack.detach(),
        e.$list.detach(),
        e.$slider.append(e.$slides)),
        e.cleanUpRows(),
        e.$slider.removeClass("slick-slider"),
        e.$slider.removeClass("slick-initialized"),
        e.$slider.removeClass("slick-dotted"),
        e.unslicked = !0,
        t || e.$slider.trigger("destroy", [e])
    }
    ,
    o.prototype.disableTransition = function(t) {
        var e = {};
        e[this.transitionType] = "",
        !1 === this.options.fade ? this.$slideTrack.css(e) : this.$slides.eq(t).css(e)
    }
    ,
    o.prototype.fadeSlide = function(t, e) {
        var i = this;
        !1 === i.cssTransitions ? (i.$slides.eq(t).css({
            zIndex: i.options.zIndex
        }),
        i.$slides.eq(t).animate({
            opacity: 1
        }, i.options.speed, i.options.easing, e)) : (i.applyTransition(t),
        i.$slides.eq(t).css({
            opacity: 1,
            zIndex: i.options.zIndex
        }),
        e && setTimeout(function() {
            i.disableTransition(t),
            e.call()
        }, i.options.speed))
    }
    ,
    o.prototype.fadeSlideOut = function(t) {
        !1 === this.cssTransitions ? this.$slides.eq(t).animate({
            opacity: 0,
            zIndex: this.options.zIndex - 2
        }, this.options.speed, this.options.easing) : (this.applyTransition(t),
        this.$slides.eq(t).css({
            opacity: 0,
            zIndex: this.options.zIndex - 2
        }))
    }
    ,
    o.prototype.filterSlides = o.prototype.slickFilter = function(t) {
        null !== t && (this.$slidesCache = this.$slides,
        this.unload(),
        this.$slideTrack.children(this.options.slide).detach(),
        this.$slidesCache.filter(t).appendTo(this.$slideTrack),
        this.reinit())
    }
    ,
    o.prototype.focusHandler = function() {
        var i = this;
        i.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*:not(.slick-arrow)", function(t) {
            t.stopImmediatePropagation();
            var e = c(this);
            setTimeout(function() {
                i.options.pauseOnFocus && (i.focussed = e.is(":focus"),
                i.autoPlay())
            }, 0)
        })
    }
    ,
    o.prototype.getCurrent = o.prototype.slickCurrentSlide = function() {
        return this.currentSlide
    }
    ,
    o.prototype.getDotCount = function() {
        var t = this
          , e = 0
          , i = 0
          , n = 0;
        if (!0 === t.options.infinite)
            for (; e < t.slideCount; )
                ++n,
                e = i + t.options.slidesToScroll,
                i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow;
        else if (!0 === t.options.centerMode)
            n = t.slideCount;
        else
            for (; e < t.slideCount; )
                ++n,
                e = i + t.options.slidesToScroll,
                i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow;
        return n - 1
    }
    ,
    o.prototype.getLeft = function(t) {
        var e, i, n, a = this, o = 0;
        return a.slideOffset = 0,
        i = a.$slides.first().outerHeight(!0),
        !0 === a.options.infinite ? (a.slideCount > a.options.slidesToShow && (a.slideOffset = a.slideWidth * a.options.slidesToShow * -1,
        o = i * a.options.slidesToShow * -1),
        a.slideCount % a.options.slidesToScroll != 0 && t + a.options.slidesToScroll > a.slideCount && a.slideCount > a.options.slidesToShow && (o = t > a.slideCount ? (a.slideOffset = (a.options.slidesToShow - (t - a.slideCount)) * a.slideWidth * -1,
        (a.options.slidesToShow - (t - a.slideCount)) * i * -1) : (a.slideOffset = a.slideCount % a.options.slidesToScroll * a.slideWidth * -1,
        a.slideCount % a.options.slidesToScroll * i * -1))) : t + a.options.slidesToShow > a.slideCount && (a.slideOffset = (t + a.options.slidesToShow - a.slideCount) * a.slideWidth,
        o = (t + a.options.slidesToShow - a.slideCount) * i),
        a.slideCount <= a.options.slidesToShow && (o = a.slideOffset = 0),
        !0 === a.options.centerMode && !0 === a.options.infinite ? a.slideOffset += a.slideWidth * Math.floor(a.options.slidesToShow / 2) - a.slideWidth : !0 === a.options.centerMode && (a.slideOffset = 0,
        a.slideOffset += a.slideWidth * Math.floor(a.options.slidesToShow / 2)),
        e = !1 === a.options.vertical ? t * a.slideWidth * -1 + a.slideOffset : t * i * -1 + o,
        !0 === a.options.variableWidth && (n = a.slideCount <= a.options.slidesToShow || !1 === a.options.infinite ? a.$slideTrack.children(".slick-slide").eq(t) : a.$slideTrack.children(".slick-slide").eq(t + a.options.slidesToShow),
        e = !0 === a.options.rtl ? n[0] ? -1 * (a.$slideTrack.width() - n[0].offsetLeft - n.width()) : 0 : n[0] ? -1 * n[0].offsetLeft : 0,
        !0 === a.options.centerMode && (n = a.slideCount <= a.options.slidesToShow || !1 === a.options.infinite ? a.$slideTrack.children(".slick-slide").eq(t) : a.$slideTrack.children(".slick-slide").eq(t + a.options.slidesToShow + 1),
        e = !0 === a.options.rtl ? n[0] ? -1 * (a.$slideTrack.width() - n[0].offsetLeft - n.width()) : 0 : n[0] ? -1 * n[0].offsetLeft : 0,
        e += (a.$list.width() - n.outerWidth()) / 2)),
        e
    }
    ,
    o.prototype.getOption = o.prototype.slickGetOption = function(t) {
        return this.options[t]
    }
    ,
    o.prototype.getNavigableIndexes = function() {
        var t, e = this, i = 0, n = 0, a = [];
        for (t = !1 === e.options.infinite ? e.slideCount : (i = -1 * e.options.slidesToScroll,
        n = -1 * e.options.slidesToScroll,
        2 * e.slideCount); i < t; )
            a.push(i),
            i = n + e.options.slidesToScroll,
            n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
        return a
    }
    ,
    o.prototype.getSlick = function() {
        return this
    }
    ,
    o.prototype.getSlideCount = function() {
        var i, n, a = this;
        return n = !0 === a.options.centerMode ? a.slideWidth * Math.floor(a.options.slidesToShow / 2) : 0,
        !0 === a.options.swipeToSlide ? (a.$slideTrack.find(".slick-slide").each(function(t, e) {
            if (e.offsetLeft - n + c(e).outerWidth() / 2 > -1 * a.swipeLeft)
                return i = e,
                !1
        }),
        Math.abs(c(i).attr("data-slick-index") - a.currentSlide) || 1) : a.options.slidesToScroll
    }
    ,
    o.prototype.goTo = o.prototype.slickGoTo = function(t, e) {
        this.changeSlide({
            data: {
                message: "index",
                index: parseInt(t)
            }
        }, e)
    }
    ,
    o.prototype.init = function(t) {
        var e = this;
        c(e.$slider).hasClass("slick-initialized") || (c(e.$slider).addClass("slick-initialized"),
        e.buildRows(),
        e.buildOut(),
        e.setProps(),
        e.startLoad(),
        e.loadSlider(),
        e.initializeEvents(),
        e.updateArrows(),
        e.updateDots(),
        e.checkResponsive(!0),
        e.focusHandler()),
        t && e.$slider.trigger("init", [e]),
        !0 === e.options.accessibility && e.initADA(),
        e.options.autoplay && (e.paused = !1,
        e.autoPlay())
    }
    ,
    o.prototype.initADA = function() {
        var e = this;
        e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({
            "aria-hidden": "true",
            tabindex: "-1"
        }).find("a, input, button, select").attr({
            tabindex: "-1"
        }),
        e.$slideTrack.attr("role", "listbox"),
        e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t) {
            c(this).attr({
                role: "option",
                "aria-describedby": "slick-slide" + e.instanceUid + t
            })
        }),
        null !== e.$dots && e.$dots.attr("role", "tablist").find("li").each(function(t) {
            c(this).attr({
                role: "presentation",
                "aria-selected": "false",
                "aria-controls": "navigation" + e.instanceUid + t,
                id: "slick-slide" + e.instanceUid + t
            })
        }).first().attr("aria-selected", "true").end().find("button").attr("role", "button").end().closest("div").attr("role", "toolbar"),
        e.activateADA()
    }
    ,
    o.prototype.initArrowEvents = function() {
        !0 === this.options.arrows && this.slideCount > this.options.slidesToShow && (this.$prevArrow.off("click.slick").on("click.slick", {
            message: "previous"
        }, this.changeSlide),
        this.$nextArrow.off("click.slick").on("click.slick", {
            message: "next"
        }, this.changeSlide))
    }
    ,
    o.prototype.initDotEvents = function() {
        var t = this;
        !0 === t.options.dots && t.slideCount > t.options.slidesToShow && c("li", t.$dots).on("click.slick", {
            message: "index"
        }, t.changeSlide),
        !0 === t.options.dots && !0 === t.options.pauseOnDotsHover && c("li", t.$dots).on("mouseenter.slick", c.proxy(t.interrupt, t, !0)).on("mouseleave.slick", c.proxy(t.interrupt, t, !1))
    }
    ,
    o.prototype.initSlideEvents = function() {
        this.options.pauseOnHover && (this.$list.on("mouseenter.slick", c.proxy(this.interrupt, this, !0)),
        this.$list.on("mouseleave.slick", c.proxy(this.interrupt, this, !1)))
    }
    ,
    o.prototype.initializeEvents = function() {
        var t = this;
        t.initArrowEvents(),
        t.initDotEvents(),
        t.initSlideEvents(),
        t.$list.on("touchstart.slick mousedown.slick", {
            action: "start"
        }, t.swipeHandler),
        t.$list.on("touchmove.slick mousemove.slick", {
            action: "move"
        }, t.swipeHandler),
        t.$list.on("touchend.slick mouseup.slick", {
            action: "end"
        }, t.swipeHandler),
        t.$list.on("touchcancel.slick mouseleave.slick", {
            action: "end"
        }, t.swipeHandler),
        t.$list.on("click.slick", t.clickHandler),
        c(document).on(t.visibilityChange, c.proxy(t.visibility, t)),
        !0 === t.options.accessibility && t.$list.on("keydown.slick", t.keyHandler),
        !0 === t.options.focusOnSelect && c(t.$slideTrack).children().on("click.slick", t.selectHandler),
        c(window).on("orientationchange.slick.slick-" + t.instanceUid, c.proxy(t.orientationChange, t)),
        c(window).on("resize.slick.slick-" + t.instanceUid, c.proxy(t.resize, t)),
        c("[draggable!=true]", t.$slideTrack).on("dragstart", t.preventDefault),
        c(window).on("load.slick.slick-" + t.instanceUid, t.setPosition),
        c(document).on("ready.slick.slick-" + t.instanceUid, t.setPosition)
    }
    ,
    o.prototype.initUI = function() {
        !0 === this.options.arrows && this.slideCount > this.options.slidesToShow && (this.$prevArrow.show(),
        this.$nextArrow.show()),
        !0 === this.options.dots && this.slideCount > this.options.slidesToShow && this.$dots.show()
    }
    ,
    o.prototype.keyHandler = function(t) {
        t.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === t.keyCode && !0 === this.options.accessibility ? this.changeSlide({
            data: {
                message: !0 === this.options.rtl ? "next" : "previous"
            }
        }) : 39 === t.keyCode && !0 === this.options.accessibility && this.changeSlide({
            data: {
                message: !0 === this.options.rtl ? "previous" : "next"
            }
        }))
    }
    ,
    o.prototype.lazyLoad = function() {
        var t, e, n = this;
        function i(t) {
            c("img[data-lazy]", t).each(function() {
                var t = c(this)
                  , e = c(this).attr("data-lazy")
                  , i = document.createElement("img");
                i.onload = function() {
                    t.animate({
                        opacity: 0
                    }, 100, function() {
                        t.attr("src", e).animate({
                            opacity: 1
                        }, 200, function() {
                            t.removeAttr("data-lazy").removeClass("slick-loading")
                        }),
                        n.$slider.trigger("lazyLoaded", [n, t, e])
                    })
                }
                ,
                i.onerror = function() {
                    t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),
                    n.$slider.trigger("lazyLoadError", [n, t, e])
                }
                ,
                i.src = e
            })
        }
        !0 === n.options.centerMode ? e = !0 === n.options.infinite ? (t = n.currentSlide + (n.options.slidesToShow / 2 + 1)) + n.options.slidesToShow + 2 : (t = Math.max(0, n.currentSlide - (n.options.slidesToShow / 2 + 1)),
        n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide) : (t = n.options.infinite ? n.options.slidesToShow + n.currentSlide : n.currentSlide,
        e = Math.ceil(t + n.options.slidesToShow),
        !0 === n.options.fade && (0 < t && t--,
        e <= n.slideCount && e++)),
        i(n.$slider.find(".slick-slide").slice(t, e)),
        n.slideCount <= n.options.slidesToShow ? i(n.$slider.find(".slick-slide")) : n.currentSlide >= n.slideCount - n.options.slidesToShow ? i(n.$slider.find(".slick-cloned").slice(0, n.options.slidesToShow)) : 0 === n.currentSlide && i(n.$slider.find(".slick-cloned").slice(-1 * n.options.slidesToShow))
    }
    ,
    o.prototype.loadSlider = function() {
        this.setPosition(),
        this.$slideTrack.css({
            opacity: 1
        }),
        this.$slider.removeClass("slick-loading"),
        this.initUI(),
        "progressive" === this.options.lazyLoad && this.progressiveLazyLoad()
    }
    ,
    o.prototype.next = o.prototype.slickNext = function() {
        this.changeSlide({
            data: {
                message: "next"
            }
        })
    }
    ,
    o.prototype.orientationChange = function() {
        this.checkResponsive(),
        this.setPosition()
    }
    ,
    o.prototype.pause = o.prototype.slickPause = function() {
        this.autoPlayClear(),
        this.paused = !0
    }
    ,
    o.prototype.play = o.prototype.slickPlay = function() {
        this.autoPlay(),
        this.options.autoplay = !0,
        this.paused = !1,
        this.focussed = !1,
        this.interrupted = !1
    }
    ,
    o.prototype.postSlide = function(t) {
        var e = this;
        e.unslicked || (e.$slider.trigger("afterChange", [e, t]),
        e.animating = !1,
        e.setPosition(),
        e.swipeLeft = null,
        e.options.autoplay && e.autoPlay(),
        !0 === e.options.accessibility && e.initADA())
    }
    ,
    o.prototype.prev = o.prototype.slickPrev = function() {
        this.changeSlide({
            data: {
                message: "previous"
            }
        })
    }
    ,
    o.prototype.preventDefault = function(t) {
        t.preventDefault()
    }
    ,
    o.prototype.progressiveLazyLoad = function(t) {
        t = t || 1;
        var e, i, n, a = this, o = c("img[data-lazy]", a.$slider);
        o.length ? (e = o.first(),
        i = e.attr("data-lazy"),
        (n = document.createElement("img")).onload = function() {
            e.attr("src", i).removeAttr("data-lazy").removeClass("slick-loading"),
            !0 === a.options.adaptiveHeight && a.setPosition(),
            a.$slider.trigger("lazyLoaded", [a, e, i]),
            a.progressiveLazyLoad()
        }
        ,
        n.onerror = function() {
            t < 3 ? setTimeout(function() {
                a.progressiveLazyLoad(t + 1)
            }, 500) : (e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),
            a.$slider.trigger("lazyLoadError", [a, e, i]),
            a.progressiveLazyLoad())
        }
        ,
        n.src = i) : a.$slider.trigger("allImagesLoaded", [a])
    }
    ,
    o.prototype.refresh = function(t) {
        var e, i, n = this;
        i = n.slideCount - n.options.slidesToShow,
        !n.options.infinite && n.currentSlide > i && (n.currentSlide = i),
        n.slideCount <= n.options.slidesToShow && (n.currentSlide = 0),
        e = n.currentSlide,
        n.destroy(!0),
        c.extend(n, n.initials, {
            currentSlide: e
        }),
        n.init(),
        t || n.changeSlide({
            data: {
                message: "index",
                index: e
            }
        }, !1)
    }
    ,
    o.prototype.registerBreakpoints = function() {
        var t, e, i, n = this, a = n.options.responsive || null;
        if ("array" === c.type(a) && a.length) {
            for (t in n.respondTo = n.options.respondTo || "window",
            a)
                if (i = n.breakpoints.length - 1,
                e = a[t].breakpoint,
                a.hasOwnProperty(t)) {
                    for (; 0 <= i; )
                        n.breakpoints[i] && n.breakpoints[i] === e && n.breakpoints.splice(i, 1),
                        i--;
                    n.breakpoints.push(e),
                    n.breakpointSettings[e] = a[t].settings
                }
            n.breakpoints.sort(function(t, e) {
                return n.options.mobileFirst ? t - e : e - t
            })
        }
    }
    ,
    o.prototype.reinit = function() {
        var t = this;
        t.$slides = t.$slideTrack.children(t.options.slide).addClass("slick-slide"),
        t.slideCount = t.$slides.length,
        t.currentSlide >= t.slideCount && 0 !== t.currentSlide && (t.currentSlide = t.currentSlide - t.options.slidesToScroll),
        t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0),
        t.registerBreakpoints(),
        t.setProps(),
        t.setupInfinite(),
        t.buildArrows(),
        t.updateArrows(),
        t.initArrowEvents(),
        t.buildDots(),
        t.updateDots(),
        t.initDotEvents(),
        t.cleanUpSlideEvents(),
        t.initSlideEvents(),
        t.checkResponsive(!1, !0),
        !0 === t.options.focusOnSelect && c(t.$slideTrack).children().on("click.slick", t.selectHandler),
        t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0),
        t.setPosition(),
        t.focusHandler(),
        t.paused = !t.options.autoplay,
        t.autoPlay(),
        t.$slider.trigger("reInit", [t])
    }
    ,
    o.prototype.resize = function() {
        var t = this;
        c(window).width() !== t.windowWidth && (clearTimeout(t.windowDelay),
        t.windowDelay = window.setTimeout(function() {
            t.windowWidth = c(window).width(),
            t.checkResponsive(),
            t.unslicked || t.setPosition()
        }, 50))
    }
    ,
    o.prototype.removeSlide = o.prototype.slickRemove = function(t, e, i) {
        var n = this;
        if (t = "boolean" == typeof t ? !0 === (e = t) ? 0 : n.slideCount - 1 : !0 === e ? --t : t,
        n.slideCount < 1 || t < 0 || t > n.slideCount - 1)
            return !1;
        n.unload(),
        !0 === i ? n.$slideTrack.children().remove() : n.$slideTrack.children(this.options.slide).eq(t).remove(),
        n.$slides = n.$slideTrack.children(this.options.slide),
        n.$slideTrack.children(this.options.slide).detach(),
        n.$slideTrack.append(n.$slides),
        n.$slidesCache = n.$slides,
        n.reinit()
    }
    ,
    o.prototype.setCSS = function(t) {
        var e, i, n = this, a = {};
        !0 === n.options.rtl && (t = -t),
        e = "left" == n.positionProp ? Math.ceil(t) + "px" : "0px",
        i = "top" == n.positionProp ? Math.ceil(t) + "px" : "0px",
        a[n.positionProp] = t,
        !1 === n.transformsEnabled || (!(a = {}) === n.cssTransitions ? a[n.animType] = "translate(" + e + ", " + i + ")" : a[n.animType] = "translate3d(" + e + ", " + i + ", 0px)"),
        n.$slideTrack.css(a)
    }
    ,
    o.prototype.setDimensions = function() {
        var t = this;
        !1 === t.options.vertical ? !0 === t.options.centerMode && t.$list.css({
            padding: "0px " + t.options.centerPadding
        }) : (t.$list.height(t.$slides.first().outerHeight(!0) * t.options.slidesToShow),
        !0 === t.options.centerMode && t.$list.css({
            padding: t.options.centerPadding + " 0px"
        })),
        t.listWidth = t.$list.width(),
        t.listHeight = t.$list.height(),
        !1 === t.options.vertical && !1 === t.options.variableWidth ? (t.slideWidth = Math.ceil(t.listWidth / t.options.slidesToShow),
        t.$slideTrack.width(Math.ceil(t.slideWidth * t.$slideTrack.children(".slick-slide").length))) : !0 === t.options.variableWidth ? t.$slideTrack.width(5e3 * t.slideCount) : (t.slideWidth = Math.ceil(t.listWidth),
        t.$slideTrack.height(Math.ceil(t.$slides.first().outerHeight(!0) * t.$slideTrack.children(".slick-slide").length)));
        var e = t.$slides.first().outerWidth(!0) - t.$slides.first().width();
        !1 === t.options.variableWidth && t.$slideTrack.children(".slick-slide").width(t.slideWidth - e)
    }
    ,
    o.prototype.setFade = function() {
        var i, n = this;
        n.$slides.each(function(t, e) {
            i = n.slideWidth * t * -1,
            !0 === n.options.rtl ? c(e).css({
                position: "relative",
                right: i,
                top: 0,
                zIndex: n.options.zIndex - 2,
                opacity: 0
            }) : c(e).css({
                position: "relative",
                left: i,
                top: 0,
                zIndex: n.options.zIndex - 2,
                opacity: 0
            })
        }),
        n.$slides.eq(n.currentSlide).css({
            zIndex: n.options.zIndex - 1,
            opacity: 1
        })
    }
    ,
    o.prototype.setHeight = function() {
        if (1 === this.options.slidesToShow && !0 === this.options.adaptiveHeight && !1 === this.options.vertical) {
            var t = this.$slides.eq(this.currentSlide).outerHeight(!0);
            this.$list.css("height", t)
        }
    }
    ,
    o.prototype.setOption = o.prototype.slickSetOption = function() {
        var t, e, i, n, a, o = this, s = !1;
        if ("object" === c.type(arguments[0]) ? (i = arguments[0],
        s = arguments[1],
        a = "multiple") : "string" === c.type(arguments[0]) && (n = arguments[1],
        s = arguments[2],
        "responsive" === (i = arguments[0]) && "array" === c.type(arguments[1]) ? a = "responsive" : void 0 !== arguments[1] && (a = "single")),
        "single" === a)
            o.options[i] = n;
        else if ("multiple" === a)
            c.each(i, function(t, e) {
                o.options[t] = e
            });
        else if ("responsive" === a)
            for (e in n)
                if ("array" !== c.type(o.options.responsive))
                    o.options.responsive = [n[e]];
                else {
                    for (t = o.options.responsive.length - 1; 0 <= t; )
                        o.options.responsive[t].breakpoint === n[e].breakpoint && o.options.responsive.splice(t, 1),
                        t--;
                    o.options.responsive.push(n[e])
                }
        s && (o.unload(),
        o.reinit())
    }
    ,
    o.prototype.setPosition = function() {
        this.setDimensions(),
        this.setHeight(),
        !1 === this.options.fade ? this.setCSS(this.getLeft(this.currentSlide)) : this.setFade(),
        this.$slider.trigger("setPosition", [this])
    }
    ,
    o.prototype.setProps = function() {
        var t = this
          , e = document.body.style;
        t.positionProp = !0 === t.options.vertical ? "top" : "left",
        "top" === t.positionProp ? t.$slider.addClass("slick-vertical") : t.$slider.removeClass("slick-vertical"),
        void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition || !0 === t.options.useCSS && (t.cssTransitions = !0),
        t.options.fade && ("number" == typeof t.options.zIndex ? t.options.zIndex < 3 && (t.options.zIndex = 3) : t.options.zIndex = t.defaults.zIndex),
        void 0 !== e.OTransform && (t.animType = "OTransform",
        t.transformType = "-o-transform",
        t.transitionType = "OTransition",
        void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (t.animType = !1)),
        void 0 !== e.MozTransform && (t.animType = "MozTransform",
        t.transformType = "-moz-transform",
        t.transitionType = "MozTransition",
        void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (t.animType = !1)),
        void 0 !== e.webkitTransform && (t.animType = "webkitTransform",
        t.transformType = "-webkit-transform",
        t.transitionType = "webkitTransition",
        void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (t.animType = !1)),
        void 0 !== e.msTransform && (t.animType = "msTransform",
        t.transformType = "-ms-transform",
        t.transitionType = "msTransition",
        void 0 === e.msTransform && (t.animType = !1)),
        void 0 !== e.transform && !1 !== t.animType && (t.animType = "transform",
        t.transformType = "transform",
        t.transitionType = "transition"),
        t.transformsEnabled = t.options.useTransform && null !== t.animType && !1 !== t.animType
    }
    ,
    o.prototype.setSlideClasses = function(t) {
        var e, i, n, a, o = this;
        i = o.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"),
        o.$slides.eq(t).addClass("slick-current"),
        !0 === o.options.centerMode ? (e = Math.floor(o.options.slidesToShow / 2),
        !0 === o.options.infinite && (e <= t && t <= o.slideCount - 1 - e ? o.$slides.slice(t - e, t + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (n = o.options.slidesToShow + t,
        i.slice(n - e + 1, n + e + 2).addClass("slick-active").attr("aria-hidden", "false")),
        0 === t ? i.eq(i.length - 1 - o.options.slidesToShow).addClass("slick-center") : t === o.slideCount - 1 && i.eq(o.options.slidesToShow).addClass("slick-center")),
        o.$slides.eq(t).addClass("slick-center")) : 0 <= t && t <= o.slideCount - o.options.slidesToShow ? o.$slides.slice(t, t + o.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : i.length <= o.options.slidesToShow ? i.addClass("slick-active").attr("aria-hidden", "false") : (a = o.slideCount % o.options.slidesToShow,
        n = !0 === o.options.infinite ? o.options.slidesToShow + t : t,
        o.options.slidesToShow == o.options.slidesToScroll && o.slideCount - t < o.options.slidesToShow ? i.slice(n - (o.options.slidesToShow - a), n + a).addClass("slick-active").attr("aria-hidden", "false") : i.slice(n, n + o.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false")),
        "ondemand" === o.options.lazyLoad && o.lazyLoad()
    }
    ,
    o.prototype.setupInfinite = function() {
        var t, e, i, n = this;
        if (!0 === n.options.fade && (n.options.centerMode = !1),
        !0 === n.options.infinite && !1 === n.options.fade && (e = null,
        n.slideCount > n.options.slidesToShow)) {
            for (i = !0 === n.options.centerMode ? n.options.slidesToShow + 1 : n.options.slidesToShow,
            t = n.slideCount; t > n.slideCount - i; t -= 1)
                e = t - 1,
                c(n.$slides[e]).clone(!0).attr("id", "").attr("data-slick-index", e - n.slideCount).prependTo(n.$slideTrack).addClass("slick-cloned");
            for (t = 0; t < i; t += 1)
                e = t,
                c(n.$slides[e]).clone(!0).attr("id", "").attr("data-slick-index", e + n.slideCount).appendTo(n.$slideTrack).addClass("slick-cloned");
            n.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                c(this).attr("id", "")
            })
        }
    }
    ,
    o.prototype.interrupt = function(t) {
        t || this.autoPlay(),
        this.interrupted = t
    }
    ,
    o.prototype.selectHandler = function(t) {
        var e = c(t.target).is(".slick-slide") ? c(t.target) : c(t.target).parents(".slick-slide")
          , i = parseInt(e.attr("data-slick-index"));
        if (i || (i = 0),
        this.slideCount <= this.options.slidesToShow)
            return this.setSlideClasses(i),
            void this.asNavFor(i);
        this.slideHandler(i)
    }
    ,
    o.prototype.slideHandler = function(t, e, i) {
        var n, a, o, s, r, l, c = this;
        if (e = e || !1,
        (!0 !== c.animating || !0 !== c.options.waitForAnimate) && !(!0 === c.options.fade && c.currentSlide === t || c.slideCount <= c.options.slidesToShow))
            if (!1 === e && c.asNavFor(t),
            n = t,
            r = c.getLeft(n),
            s = c.getLeft(c.currentSlide),
            c.currentLeft = null === c.swipeLeft ? s : c.swipeLeft,
            !1 === c.options.infinite && !1 === c.options.centerMode && (t < 0 || t > c.getDotCount() * c.options.slidesToScroll))
                !1 === c.options.fade && (n = c.currentSlide,
                !0 !== i ? c.animateSlide(s, function() {
                    c.postSlide(n)
                }) : c.postSlide(n));
            else if (!1 === c.options.infinite && !0 === c.options.centerMode && (t < 0 || t > c.slideCount - c.options.slidesToScroll))
                !1 === c.options.fade && (n = c.currentSlide,
                !0 !== i ? c.animateSlide(s, function() {
                    c.postSlide(n)
                }) : c.postSlide(n));
            else {
                if (c.options.autoplay && clearInterval(c.autoPlayTimer),
                a = n < 0 ? c.slideCount % c.options.slidesToScroll != 0 ? c.slideCount - c.slideCount % c.options.slidesToScroll : c.slideCount + n : n >= c.slideCount ? c.slideCount % c.options.slidesToScroll != 0 ? 0 : n - c.slideCount : n,
                c.animating = !0,
                c.$slider.trigger("beforeChange", [c, c.currentSlide, a]),
                o = c.currentSlide,
                c.currentSlide = a,
                c.setSlideClasses(c.currentSlide),
                c.options.asNavFor && (l = (l = c.getNavTarget()).slick("getSlick")).slideCount <= l.options.slidesToShow && l.setSlideClasses(c.currentSlide),
                c.updateDots(),
                c.updateArrows(),
                !0 === c.options.fade)
                    return !0 !== i ? (c.fadeSlideOut(o),
                    c.fadeSlide(a, function() {
                        c.postSlide(a)
                    })) : c.postSlide(a),
                    void c.animateHeight();
                !0 !== i ? c.animateSlide(r, function() {
                    c.postSlide(a)
                }) : c.postSlide(a)
            }
    }
    ,
    o.prototype.startLoad = function() {
        var t = this;
        !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && (t.$prevArrow.hide(),
        t.$nextArrow.hide()),
        !0 === t.options.dots && t.slideCount > t.options.slidesToShow && t.$dots.hide(),
        t.$slider.addClass("slick-loading")
    }
    ,
    o.prototype.swipeDirection = function() {
        var t, e, i, n;
        return t = this.touchObject.startX - this.touchObject.curX,
        e = this.touchObject.startY - this.touchObject.curY,
        i = Math.atan2(e, t),
        (n = Math.round(180 * i / Math.PI)) < 0 && (n = 360 - Math.abs(n)),
        n <= 45 && 0 <= n ? !1 === this.options.rtl ? "left" : "right" : n <= 360 && 315 <= n ? !1 === this.options.rtl ? "left" : "right" : 135 <= n && n <= 225 ? !1 === this.options.rtl ? "right" : "left" : !0 === this.options.verticalSwiping ? 35 <= n && n <= 135 ? "down" : "up" : "vertical"
    }
    ,
    o.prototype.swipeEnd = function(t) {
        var e, i, n = this;
        if (n.dragging = !1,
        n.interrupted = !1,
        n.shouldClick = !(10 < n.touchObject.swipeLength),
        void 0 === n.touchObject.curX)
            return !1;
        if (!0 === n.touchObject.edgeHit && n.$slider.trigger("edge", [n, n.swipeDirection()]),
        n.touchObject.swipeLength >= n.touchObject.minSwipe) {
            switch (i = n.swipeDirection()) {
            case "left":
            case "down":
                e = n.options.swipeToSlide ? n.checkNavigable(n.currentSlide + n.getSlideCount()) : n.currentSlide + n.getSlideCount(),
                n.currentDirection = 0;
                break;
            case "right":
            case "up":
                e = n.options.swipeToSlide ? n.checkNavigable(n.currentSlide - n.getSlideCount()) : n.currentSlide - n.getSlideCount(),
                n.currentDirection = 1
            }
            "vertical" != i && (n.slideHandler(e),
            n.touchObject = {},
            n.$slider.trigger("swipe", [n, i]))
        } else
            n.touchObject.startX !== n.touchObject.curX && (n.slideHandler(n.currentSlide),
            n.touchObject = {})
    }
    ,
    o.prototype.swipeHandler = function(t) {
        var e = this;
        if (!(!1 === e.options.swipe || "ontouchend"in document && !1 === e.options.swipe || !1 === e.options.draggable && -1 !== t.type.indexOf("mouse")))
            switch (e.touchObject.fingerCount = t.originalEvent && void 0 !== t.originalEvent.touches ? t.originalEvent.touches.length : 1,
            e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold,
            !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold),
            t.data.action) {
            case "start":
                e.swipeStart(t);
                break;
            case "move":
                e.swipeMove(t);
                break;
            case "end":
                e.swipeEnd(t)
            }
    }
    ,
    o.prototype.swipeMove = function(t) {
        var e, i, n, a, o, s = this;
        return o = void 0 !== t.originalEvent ? t.originalEvent.touches : null,
        !(!s.dragging || o && 1 !== o.length) && (e = s.getLeft(s.currentSlide),
        s.touchObject.curX = void 0 !== o ? o[0].pageX : t.clientX,
        s.touchObject.curY = void 0 !== o ? o[0].pageY : t.clientY,
        s.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(s.touchObject.curX - s.touchObject.startX, 2))),
        !0 === s.options.verticalSwiping && (s.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(s.touchObject.curY - s.touchObject.startY, 2)))),
        "vertical" !== (i = s.swipeDirection()) ? (void 0 !== t.originalEvent && 4 < s.touchObject.swipeLength && t.preventDefault(),
        a = (!1 === s.options.rtl ? 1 : -1) * (s.touchObject.curX > s.touchObject.startX ? 1 : -1),
        !0 === s.options.verticalSwiping && (a = s.touchObject.curY > s.touchObject.startY ? 1 : -1),
        n = s.touchObject.swipeLength,
        (s.touchObject.edgeHit = !1) === s.options.infinite && (0 === s.currentSlide && "right" === i || s.currentSlide >= s.getDotCount() && "left" === i) && (n = s.touchObject.swipeLength * s.options.edgeFriction,
        s.touchObject.edgeHit = !0),
        !1 === s.options.vertical ? s.swipeLeft = e + n * a : s.swipeLeft = e + n * (s.$list.height() / s.listWidth) * a,
        !0 === s.options.verticalSwiping && (s.swipeLeft = e + n * a),
        !0 !== s.options.fade && !1 !== s.options.touchMove && (!0 === s.animating ? (s.swipeLeft = null,
        !1) : void s.setCSS(s.swipeLeft))) : void 0)
    }
    ,
    o.prototype.swipeStart = function(t) {
        var e, i = this;
        if (i.interrupted = !0,
        1 !== i.touchObject.fingerCount || i.slideCount <= i.options.slidesToShow)
            return !(i.touchObject = {});
        void 0 !== t.originalEvent && void 0 !== t.originalEvent.touches && (e = t.originalEvent.touches[0]),
        i.touchObject.startX = i.touchObject.curX = void 0 !== e ? e.pageX : t.clientX,
        i.touchObject.startY = i.touchObject.curY = void 0 !== e ? e.pageY : t.clientY,
        i.dragging = !0
    }
    ,
    o.prototype.unfilterSlides = o.prototype.slickUnfilter = function() {
        null !== this.$slidesCache && (this.unload(),
        this.$slideTrack.children(this.options.slide).detach(),
        this.$slidesCache.appendTo(this.$slideTrack),
        this.reinit())
    }
    ,
    o.prototype.unload = function() {
        var t = this;
        c(".slick-cloned", t.$slider).remove(),
        t.$dots && t.$dots.remove(),
        t.$prevArrow && t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove(),
        t.$nextArrow && t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove(),
        t.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
    }
    ,
    o.prototype.unslick = function(t) {
        this.$slider.trigger("unslick", [this, t]),
        this.destroy()
    }
    ,
    o.prototype.updateArrows = function() {
        var t = this;
        Math.floor(t.options.slidesToShow / 2),
        !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && !t.options.infinite && (t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
        t.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
        0 === t.currentSlide ? (t.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
        t.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : t.currentSlide >= t.slideCount - t.options.slidesToShow && !1 === t.options.centerMode ? (t.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
        t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : t.currentSlide >= t.slideCount - 1 && !0 === t.options.centerMode && (t.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
        t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
    }
    ,
    o.prototype.updateDots = function() {
        null !== this.$dots && (this.$dots.find("li").removeClass("slick-active").attr("aria-hidden", "true"),
        this.$dots.find("li").eq(Math.floor(this.currentSlide / this.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden", "false"))
    }
    ,
    o.prototype.visibility = function() {
        this.options.autoplay && (document[this.hidden] ? this.interrupted = !0 : this.interrupted = !1)
    }
    ,
    c.fn.slick = function() {
        var t, e, i = arguments[0], n = Array.prototype.slice.call(arguments, 1), a = this.length;
        for (t = 0; t < a; t++)
            if ("object" == typeof i || void 0 === i ? this[t].slick = new o(this[t],i) : e = this[t].slick[i].apply(this[t].slick, n),
            void 0 !== e)
                return e;
        return this
    }
}),
function(t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define(["moment"], e) : "object" == typeof module && module.exports ? module.exports = e(require("moment")) : e(t.moment)
}(this, function(o) {
    "use strict";
    if (void 0 !== o.tz)
        return x("Moment Timezone " + o.tz.version + " was already loaded " + (o.tz.dataVersion ? "with data from " : "without any data") + o.tz.dataVersion),
        o;
    var e, s = {}, r = {}, c = {}, u = {}, t = o.version.split("."), i = +t[0], n = +t[1];
    function l(t) {
        return 96 < t ? t - 87 : 64 < t ? t - 29 : t - 48
    }
    function a(t) {
        var e = 0
          , i = t.split(".")
          , n = i[0]
          , a = i[1] || ""
          , o = 1
          , s = 0
          , r = 1;
        for (45 === t.charCodeAt(0) && (r = -(e = 1)); e < n.length; e++)
            s = 60 * s + l(n.charCodeAt(e));
        for (e = 0; e < a.length; e++)
            o /= 60,
            s += l(a.charCodeAt(e)) * o;
        return s * r
    }
    function d(t) {
        for (var e = 0; e < t.length; e++)
            t[e] = a(t[e])
    }
    function h(t, e) {
        var i, n = [];
        for (i = 0; i < e.length; i++)
            n[i] = t[e[i]];
        return n
    }
    function f(t) {
        var e = t.split("|")
          , i = e[2].split(" ")
          , n = e[3].split("")
          , a = e[4].split(" ");
        return d(i),
        d(n),
        d(a),
        function(t, e) {
            for (var i = 0; i < e; i++)
                t[i] = Math.round((t[i - 1] || 0) + 6e4 * t[i]);
            t[e - 1] = 1 / 0
        }(a, n.length),
        {
            name: e[0],
            abbrs: h(e[1].split(" "), n),
            offsets: h(i, n),
            untils: a,
            population: 0 | e[5]
        }
    }
    function p(t) {
        t && this._set(f(t))
    }
    function m(t) {
        var e = t.toTimeString()
          , i = e.match(/\([a-z ]+\)/i);
        "GMT" === (i = i && i[0] ? (i = i[0].match(/[A-Z]/g)) ? i.join("") : void 0 : (i = e.match(/[A-Z]{3,5}/g)) ? i[0] : void 0) && (i = void 0),
        this.at = +t,
        this.abbr = i,
        this.offset = t.getTimezoneOffset()
    }
    function g(t) {
        this.zone = t,
        this.offsetScore = 0,
        this.abbrScore = 0
    }
    function y(t, e) {
        for (var i, n; n = 6e4 * ((e.at - t.at) / 12e4 | 0); )
            (i = new m(new Date(t.at + n))).offset === t.offset ? t = i : e = i;
        return t
    }
    function v(t, e) {
        return t.offsetScore !== e.offsetScore ? t.offsetScore - e.offsetScore : t.abbrScore !== e.abbrScore ? t.abbrScore - e.abbrScore : e.zone.population - t.zone.population
    }
    function b(t, e) {
        var i, n;
        for (d(e),
        i = 0; i < e.length; i++)
            n = e[i],
            u[n] = u[n] || {},
            u[n][t] = !0
    }
    function A() {
        try {
            var t = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (t) {
                var e = c[w(t)];
                if (e)
                    return e;
                x("Moment Timezone found " + t + " from the Intl api, but did not have that data loaded.")
            }
        } catch (t) {}
        var i, n, a, o = function() {
            var t, e, i, n = (new Date).getFullYear() - 2, a = new m(new Date(n,0,1)), o = [a];
            for (i = 1; i < 48; i++)
                (e = new m(new Date(n,i,1))).offset !== a.offset && (t = y(a, e),
                o.push(t),
                o.push(new m(new Date(t.at + 6e4)))),
                a = e;
            for (i = 0; i < 4; i++)
                o.push(new m(new Date(n + i,0,1))),
                o.push(new m(new Date(n + i,6,1)));
            return o
        }(), s = o.length, r = function(t) {
            var e, i, n, a = t.length, o = {}, s = [];
            for (e = 0; e < a; e++)
                for (i in n = u[t[e].offset] || {})
                    n.hasOwnProperty(i) && (o[i] = !0);
            for (e in o)
                o.hasOwnProperty(e) && s.push(c[e]);
            return s
        }(o), l = [];
        for (n = 0; n < r.length; n++) {
            for (i = new g(C(r[n]),s),
            a = 0; a < s; a++)
                i.scoreOffsetAt(o[a]);
            l.push(i)
        }
        return l.sort(v),
        0 < l.length ? l[0].zone.name : void 0
    }
    function w(t) {
        return (t || "").toLowerCase().replace(/\//g, "_")
    }
    function S(t) {
        var e, i, n, a;
        for ("string" == typeof t && (t = [t]),
        e = 0; e < t.length; e++)
            a = w(i = (n = t[e].split("|"))[0]),
            s[a] = t[e],
            c[a] = i,
            n[5] && b(a, n[2].split(" "))
    }
    function C(t, e) {
        t = w(t);
        var i, n = s[t];
        return n instanceof p ? n : "string" == typeof n ? (n = new p(n),
        s[t] = n) : r[t] && e !== C && (i = C(r[t], C)) ? ((n = s[t] = new p)._set(i),
        n.name = c[t],
        n) : null
    }
    function T(t) {
        var e, i, n, a;
        for ("string" == typeof t && (t = [t]),
        e = 0; e < t.length; e++)
            n = w((i = t[e].split("|"))[0]),
            a = w(i[1]),
            r[n] = a,
            c[n] = i[0],
            r[a] = n,
            c[a] = i[1]
    }
    function k(t) {
        S(t.zones),
        T(t.links),
        _.dataVersion = t.version
    }
    function M(t) {
        return !(!t._a || void 0 !== t._tzm)
    }
    function x(t) {
        "undefined" != typeof console && "function" == typeof console.error && console.error(t)
    }
    function _(t) {
        var e = Array.prototype.slice.call(arguments, 0, -1)
          , i = arguments[arguments.length - 1]
          , n = C(i)
          , a = o.utc.apply(null, e);
        return n && !o.isMoment(t) && M(a) && a.add(n.parse(a), "minutes"),
        a.tz(i),
        a
    }
    (i < 2 || 2 == i && n < 6) && x("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js " + o.version + ". See momentjs.com"),
    p.prototype = {
        _set: function(t) {
            this.name = t.name,
            this.abbrs = t.abbrs,
            this.untils = t.untils,
            this.offsets = t.offsets,
            this.population = t.population
        },
        _index: function(t) {
            var e, i = +t, n = this.untils;
            for (e = 0; e < n.length; e++)
                if (i < n[e])
                    return e
        },
        parse: function(t) {
            var e, i, n, a, o = +t, s = this.offsets, r = this.untils, l = r.length - 1;
            for (a = 0; a < l; a++)
                if (e = s[a],
                i = s[a + 1],
                n = s[a ? a - 1 : a],
                e < i && _.moveAmbiguousForward ? e = i : n < e && _.moveInvalidForward && (e = n),
                o < r[a] - 6e4 * e)
                    return s[a];
            return s[l]
        },
        abbr: function(t) {
            return this.abbrs[this._index(t)]
        },
        offset: function(t) {
            return this.offsets[this._index(t)]
        }
    },
    g.prototype.scoreOffsetAt = function(t) {
        this.offsetScore += Math.abs(this.zone.offset(t.at) - t.offset),
        this.zone.abbr(t.at).replace(/[^A-Z]/g, "") !== t.abbr && this.abbrScore++
    }
    ,
    _.version = "0.5.9",
    _.dataVersion = "",
    _._zones = s,
    _._links = r,
    _._names = c,
    _.add = S,
    _.link = T,
    _.load = k,
    _.zone = C,
    _.zoneExists = function t(e) {
        return t.didShowError || (t.didShowError = !0,
        x("moment.tz.zoneExists('" + e + "') has been deprecated in favor of !moment.tz.zone('" + e + "')")),
        !!C(e)
    }
    ,
    _.guess = function(t) {
        return e && !t || (e = A()),
        e
    }
    ,
    _.names = function() {
        var t, e = [];
        for (t in c)
            c.hasOwnProperty(t) && (s[t] || s[r[t]]) && c[t] && e.push(c[t]);
        return e.sort()
    }
    ,
    _.Zone = p,
    _.unpack = f,
    _.unpackBase60 = a,
    _.needsOffset = M,
    _.moveInvalidForward = !0,
    _.moveAmbiguousForward = !1;
    var P, E = o.fn;
    function O(t) {
        return function() {
            return this._z ? this._z.abbr(this) : t.call(this)
        }
    }
    o.tz = _,
    o.defaultZone = null,
    o.updateOffset = function(t, e) {
        var i, n = o.defaultZone;
        void 0 === t._z && (n && M(t) && !t._isUTC && (t._d = o.utc(t._a)._d,
        t.utc().add(n.parse(t), "minutes")),
        t._z = n),
        t._z && (i = t._z.offset(t),
        Math.abs(i) < 16 && (i /= 60),
        void 0 !== t.utcOffset ? t.utcOffset(-i, e) : t.zone(i, e))
    }
    ,
    E.tz = function(t) {
        return t ? (this._z = C(t),
        this._z ? o.updateOffset(this) : x("Moment Timezone has no data for " + t + ". See http://momentjs.com/timezone/docs/#/data-loading/."),
        this) : this._z ? this._z.name : void 0
    }
    ,
    E.zoneName = O(E.zoneName),
    E.zoneAbbr = O(E.zoneAbbr),
    E.utc = (P = E.utc,
    function() {
        return this._z = null,
        P.apply(this, arguments)
    }
    ),
    o.tz.setDefault = function(t) {
        return (i < 2 || 2 == i && n < 9) && x("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js " + o.version + "."),
        o.defaultZone = t ? C(t) : null,
        o
    }
    ;
    var D = o.momentProperties;
    return "[object Array]" === Object.prototype.toString.call(D) ? (D.push("_z"),
    D.push("_a")) : D && (D._z = null),
    k({
        version: "2016i",
        zones: ["Africa/Abidjan|GMT|0|0||48e5", "Africa/Khartoum|EAT|-30|0||51e5", "Africa/Algiers|CET|-10|0||26e5", "Africa/Lagos|WAT|-10|0||17e6", "Africa/Maputo|CAT|-20|0||26e5", "Africa/Cairo|EET EEST|-20 -30|010101010|1Cby0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6", "Africa/Casablanca|WET WEST|0 -10|01010101010101010101010101010101010101010|1Cco0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0|32e5", "Europe/Paris|CET CEST|-10 -20|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6", "Africa/Johannesburg|SAST|-20|0||84e5", "Africa/Tripoli|EET CET CEST|-20 -10 -20|0120|1IlA0 TA0 1o00|11e5", "Africa/Windhoek|WAST WAT|-20 -10|01010101010101010101010|1C1c0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0|32e4", "America/Adak|HST HDT|a0 90|01010101010101010101010|1BR00 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326", "America/Anchorage|AKST AKDT|90 80|01010101010101010101010|1BQX0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4", "America/Santo_Domingo|AST|40|0||29e5", "America/Araguaina|BRT BRST|30 20|010|1IdD0 Lz0|14e4", "America/Argentina/Buenos_Aires|ART|30|0|", "America/Asuncion|PYST PYT|30 40|01010101010101010101010|1C430 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5", "America/Panama|EST|50|0||15e5", "America/Bahia|BRT BRST|30 20|010|1FJf0 Rb0|27e5", "America/Bahia_Banderas|MST CDT CST|70 50 60|01212121212121212121212|1C1l0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3", "America/Fortaleza|BRT|30|0||34e5", "America/Managua|CST|60|0||22e5", "America/Manaus|AMT|40|0||19e5", "America/Bogota|COT|50|0||90e5", "America/Denver|MST MDT|70 60|01010101010101010101010|1BQV0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5", "America/Campo_Grande|AMST AMT|30 40|01010101010101010101010|1BIr0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10|77e4", "America/Cancun|CST CDT EST|60 50 50|010101010102|1C1k0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4", "America/Caracas|VET VET|4u 40|01|1QMT0|29e5", "America/Cayenne|GFT|30|0||58e3", "America/Chicago|CST CDT|60 50|01010101010101010101010|1BQU0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5", "America/Chihuahua|MST MDT|70 60|01010101010101010101010|1C1l0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4", "America/Phoenix|MST|70|0||42e5", "America/Los_Angeles|PST PDT|80 70|01010101010101010101010|1BQW0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6", "America/New_York|EST EDT|50 40|01010101010101010101010|1BQT0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6", "America/Rio_Branco|AMT ACT|40 50|01|1KLE0|31e4", "America/Fort_Nelson|PST PDT MST|80 70 70|010101010102|1BQW0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2", "America/Halifax|AST ADT|40 30|01010101010101010101010|1BQS0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4", "America/Godthab|WGT WGST|30 20|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3", "America/Goose_Bay|AST ADT|40 30|01010101010101010101010|1BQQ1 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2", "America/Grand_Turk|EST EDT AST|50 40 40|0101010101012|1BQT0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2", "America/Guayaquil|ECT|50|0||27e5", "America/Guyana|GYT|40|0||80e4", "America/Havana|CST CDT|50 40|01010101010101010101010|1BQR0 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5", "America/La_Paz|BOT|40|0||19e5", "America/Lima|PET|50|0||11e6", "America/Mexico_City|CST CDT|60 50|01010101010101010101010|1C1k0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6", "America/Metlakatla|PST AKST AKDT|80 90 80|012121212121|1PAa0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2", "America/Miquelon|PMST PMDT|30 20|01010101010101010101010|1BQR0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2", "America/Montevideo|UYST UYT|20 30|010101010101|1BQQ0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5", "America/Noronha|FNT|20|0||30e2", "America/North_Dakota/Beulah|MST MDT CST CDT|70 60 60 50|01232323232323232323232|1BQV0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0", "America/Paramaribo|SRT|30|0||24e4", "America/Port-au-Prince|EST EDT|50 40|010101010|1GI70 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5", "America/Santiago|CLST CLT|30 40|010101010101010101010|1C1f0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5", "America/Sao_Paulo|BRST BRT|20 30|01010101010101010101010|1BIq0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10|20e6", "America/Scoresbysund|EGT EGST|10 0|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452", "America/St_Johns|NST NDT|3u 2u|01010101010101010101010|1BQPv 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4", "Antarctica/Casey|+11 +08|-b0 -80|01010|1BN30 40P0 KL0 blz0|10", "Antarctica/Davis|+05 +07|-50 -70|0101|1BPw0 3Wn0 KN0|70", "Antarctica/DumontDUrville|+10|-a0|0||80", "Antarctica/Macquarie|AEDT MIST|-b0 -b0|01|1C140|1", "Asia/Tashkent|+05|-50|0||23e5", "Pacific/Auckland|NZDT NZST|-d0 -c0|01010101010101010101010|1C120 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5", "Antarctica/Rothera|-03|30|0||130", "Antarctica/Syowa|+03|-30|0||20", "Antarctica/Troll|+00 +02|0 -20|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40", "Asia/Almaty|+06|-60|0||15e5", "Asia/Baghdad|AST|-30|0||66e5", "Asia/Amman|EET EEST|-20 -30|010101010101010101010|1BVy0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0|25e5", "Asia/Kamchatka|+12 +11|-c0 -b0|010|1Dp30 WM0|18e4", "Asia/Baku|+04 +05|-40 -50|0101010101010|1BWo0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5", "Asia/Bangkok|ICT|-70|0||15e6", "Asia/Barnaul|+06 +07|-60 -70|010101|1BWk0 1qM0 WM0 8Hz0 3rd0", "Asia/Beirut|EET EEST|-20 -30|01010101010101010101010|1BWm0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5", "Asia/Brunei|BNT|-80|0||42e4", "Asia/Kolkata|IST|-5u|0||15e6", "Asia/Chita|+09 +10 +08|-90 -a0 -80|010120|1BWh0 1qM0 WM0 8Hz0 3re0|33e4", "Asia/Choibalsan|CHOT CHOST|-80 -90|0101010101010|1O8G0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0|38e3", "Asia/Shanghai|CST|-80|0||23e6", "Asia/Colombo|+0530|-5u|0||22e5", "Asia/Dhaka|BDT|-60|0||16e6", "Asia/Damascus|EET EEST|-20 -30|01010101010101010101010|1C0m0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0|26e5", "Asia/Dili|TLT|-90|0||19e4", "Asia/Dubai|GST|-40|0||39e5", "Asia/Famagusta|EET EEST +03|-20 -30 -30|010101010101012|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0", "Asia/Gaza|EET EEST|-20 -30|01010101010101010101010|1BVW1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|18e5", "Asia/Hebron|EET EEST|-20 -30|0101010101010101010101010|1BVy0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|25e4", "Asia/Hong_Kong|HKT|-80|0||73e5", "Asia/Hovd|HOVT HOVST|-70 -80|0101010101010|1O8H0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0|81e3", "Asia/Irkutsk|+08 +09|-80 -90|01010|1BWi0 1qM0 WM0 8Hz0|60e4", "Europe/Istanbul|EET EEST +03|-20 -30 -30|010101010101012|1BWp0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6", "Asia/Jakarta|WIB|-70|0||31e6", "Asia/Jayapura|WIT|-90|0||26e4", "Asia/Jerusalem|IST IDT|-20 -30|01010101010101010101010|1BVA0 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4", "Asia/Kabul|AFT|-4u|0||46e5", "Asia/Karachi|PKT|-50|0||24e6", "Asia/Urumqi|XJT|-60|0||32e5", "Asia/Kathmandu|NPT|-5J|0||12e5", "Asia/Khandyga|+10 +11 +09|-a0 -b0 -90|010102|1BWg0 1qM0 WM0 17V0 7zD0|66e2", "Asia/Krasnoyarsk|+07 +08|-70 -80|01010|1BWj0 1qM0 WM0 8Hz0|10e5", "Asia/Kuala_Lumpur|MYT|-80|0||71e5", "Asia/Magadan|+11 +12 +10|-b0 -c0 -a0|010120|1BWf0 1qM0 WM0 8Hz0 3Cq0|95e3", "Asia/Makassar|WITA|-80|0||15e5", "Asia/Manila|PHT|-80|0||24e6", "Europe/Athens|EET EEST|-20 -30|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5", "Asia/Novokuznetsk|+07 +06|-70 -60|010|1Dp80 WM0|55e4", "Asia/Novosibirsk|+06 +07|-60 -70|010101|1BWk0 1qM0 WM0 8Hz0 4eN0|15e5", "Asia/Omsk|+06 +07|-60 -70|01010|1BWk0 1qM0 WM0 8Hz0|12e5", "Asia/Pyongyang|KST KST|-90 -8u|01|1P4D0|29e5", "Asia/Rangoon|MMT|-6u|0||48e5", "Asia/Sakhalin|+10 +11|-a0 -b0|010101|1BWg0 1qM0 WM0 8Hz0 3rd0|58e4", "Asia/Seoul|KST|-90|0||23e6", "Asia/Singapore|SGT|-80|0||56e5", "Asia/Srednekolymsk|+11 +12|-b0 -c0|01010|1BWf0 1qM0 WM0 8Hz0|35e2", "Asia/Tbilisi|+04|-40|0||11e5", "Asia/Tehran|IRST IRDT|-3u -4u|01010101010101010101010|1BTUu 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6", "Asia/Thimphu|BTT|-60|0||79e3", "Asia/Tokyo|JST|-90|0||38e6", "Asia/Tomsk|+06 +07|-60 -70|010101|1BWk0 1qM0 WM0 8Hz0 3Qp0|10e5", "Asia/Ulaanbaatar|ULAT ULAST|-80 -90|0101010101010|1O8G0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0|12e5", "Asia/Ust-Nera|+11 +12 +10|-b0 -c0 -a0|010102|1BWf0 1qM0 WM0 17V0 7zD0|65e2", "Asia/Vladivostok|+10 +11|-a0 -b0|01010|1BWg0 1qM0 WM0 8Hz0|60e4", "Asia/Yakutsk|+09 +10|-90 -a0|01010|1BWh0 1qM0 WM0 8Hz0|28e4", "Asia/Yekaterinburg|+05 +06|-50 -60|01010|1BWl0 1qM0 WM0 8Hz0|14e5", "Asia/Yerevan|+04 +05|-40 -50|01010|1BWm0 1qM0 WM0 1qM0|13e5", "Atlantic/Azores|AZOT AZOST|10 0|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4", "Europe/Lisbon|WET WEST|0 -10|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5", "Atlantic/Cape_Verde|CVT|10|0||50e4", "Atlantic/South_Georgia|GST|20|0||30", "Atlantic/Stanley|FKST FKT|30 40|010|1C6R0 U10|21e2", "Australia/Sydney|AEDT AEST|-b0 -a0|01010101010101010101010|1C140 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5", "Australia/Adelaide|ACDT ACST|-au -9u|01010101010101010101010|1C14u 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5", "Australia/Brisbane|AEST|-a0|0||20e5", "Australia/Darwin|ACST|-9u|0||12e4", "Australia/Eucla|ACWST|-8J|0||368", "Australia/Lord_Howe|LHDT LHST|-b0 -au|01010101010101010101010|1C130 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347", "Australia/Perth|AWST|-80|0||18e5", "Pacific/Easter|EASST EAST|50 60|010101010101010101010|1C1f0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2", "Europe/Dublin|GMT IST|0 -10|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5", "Etc/GMT+1|-01|10|0|", "Etc/GMT+10|-10|a0|0|", "Etc/GMT+11|-11|b0|0|", "Etc/GMT+12|-12|c0|0|", "Etc/GMT+2|-02|20|0|", "Etc/GMT+4|-04|40|0|", "Etc/GMT+5|-05|50|0|", "Etc/GMT+6|-06|60|0|", "Etc/GMT+7|-07|70|0|", "Etc/GMT+8|-08|80|0|", "Etc/GMT+9|-09|90|0|", "Etc/GMT-1|+01|-10|0|", "Etc/GMT-11|+11|-b0|0|", "Etc/GMT-12|+12|-c0|0|", "Etc/GMT-13|+13|-d0|0|", "Etc/GMT-14|+14|-e0|0|", "Etc/GMT-2|+02|-20|0|", "Etc/GMT-7|+07|-70|0|", "Etc/GMT-8|+08|-80|0|", "Etc/GMT-9|+09|-90|0|", "Etc/UCT|UCT|0|0|", "Etc/UTC|UTC|0|0|", "Europe/Astrakhan|+03 +04|-30 -40|010101|1BWn0 1qM0 WM0 8Hz0 3rd0", "Europe/London|GMT BST|0 -10|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6", "Europe/Chisinau|EET EEST|-20 -30|01010101010101010101010|1BWo0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4", "Europe/Kaliningrad|EET EEST +03|-20 -30 -30|01020|1BWo0 1qM0 WM0 8Hz0|44e4", "Europe/Volgograd|+03 +04|-30 -40|01010|1BWn0 1qM0 WM0 8Hz0|10e5", "Europe/Minsk|EET EEST +03|-20 -30 -30|0102|1BWo0 1qM0 WM0|19e5", "Europe/Moscow|MSK MSD MSK|-30 -40 -40|01020|1BWn0 1qM0 WM0 8Hz0|16e6", "Europe/Samara|+04 +03|-40 -30|010|1Dpb0 WM0|12e5", "Europe/Simferopol|EET EEST MSK MSK|-20 -30 -40 -30|01010101023|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4", "Pacific/Honolulu|HST|a0|0||37e4", "Indian/Chagos|IOT|-60|0||30e2", "Indian/Christmas|CXT|-70|0||21e2", "Indian/Cocos|CCT|-6u|0||596", "Indian/Mahe|SCT|-40|0||79e3", "Indian/Maldives|MVT|-50|0||35e4", "Indian/Mauritius|MUT|-40|0||15e4", "Indian/Reunion|RET|-40|0||84e4", "Pacific/Majuro|MHT|-c0|0||28e3", "MET|MET MEST|-10 -20|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00", "Pacific/Chatham|CHADT CHAST|-dJ -cJ|01010101010101010101010|1C120 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600", "Pacific/Apia|SST SDT WSDT WSST|b0 a0 -e0 -d0|01012323232323232323232|1Dbn0 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3", "Pacific/Bougainville|PGT BST|-a0 -b0|01|1NwE0|18e4", "Pacific/Chuuk|CHUT|-a0|0||49e3", "Pacific/Efate|VUT|-b0|0||66e3", "Pacific/Enderbury|PHOT|-d0|0||1", "Pacific/Fakaofo|TKT TKT|b0 -d0|01|1Gfn0|483", "Pacific/Fiji|FJST FJT|-d0 -c0|01010101010101010101010|1BWe0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0|88e4", "Pacific/Funafuti|TVT|-c0|0||45e2", "Pacific/Galapagos|GALT|60|0||25e3", "Pacific/Gambier|GAMT|90|0||125", "Pacific/Guadalcanal|SBT|-b0|0||11e4", "Pacific/Guam|ChST|-a0|0||17e4", "Pacific/Kiritimati|LINT|-e0|0||51e2", "Pacific/Kosrae|KOST|-b0|0||66e2", "Pacific/Marquesas|MART|9u|0||86e2", "Pacific/Pago_Pago|SST|b0|0||37e2", "Pacific/Nauru|NRT|-c0|0||10e3", "Pacific/Niue|NUT|b0|0||12e2", "Pacific/Norfolk|NFT NFT|-bu -b0|01|1PoCu|25e4", "Pacific/Noumea|NCT|-b0|0||98e3", "Pacific/Palau|PWT|-90|0||21e3", "Pacific/Pitcairn|PST|80|0||56", "Pacific/Pohnpei|PONT|-b0|0||34e3", "Pacific/Port_Moresby|PGT|-a0|0||25e4", "Pacific/Rarotonga|CKT|a0|0||13e3", "Pacific/Tahiti|TAHT|a0|0||18e4", "Pacific/Tarawa|GILT|-c0|0||29e3", "Pacific/Tongatapu|+13 +14|-d0 -e0|0101010101|1S4d0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0|75e3", "Pacific/Wake|WAKT|-c0|0||16e3", "Pacific/Wallis|WFT|-c0|0||94"],
        links: ["Africa/Abidjan|Africa/Accra", "Africa/Abidjan|Africa/Bamako", "Africa/Abidjan|Africa/Banjul", "Africa/Abidjan|Africa/Bissau", "Africa/Abidjan|Africa/Conakry", "Africa/Abidjan|Africa/Dakar", "Africa/Abidjan|Africa/Freetown", "Africa/Abidjan|Africa/Lome", "Africa/Abidjan|Africa/Monrovia", "Africa/Abidjan|Africa/Nouakchott", "Africa/Abidjan|Africa/Ouagadougou", "Africa/Abidjan|Africa/Sao_Tome", "Africa/Abidjan|Africa/Timbuktu", "Africa/Abidjan|America/Danmarkshavn", "Africa/Abidjan|Atlantic/Reykjavik", "Africa/Abidjan|Atlantic/St_Helena", "Africa/Abidjan|Etc/GMT", "Africa/Abidjan|Etc/GMT+0", "Africa/Abidjan|Etc/GMT-0", "Africa/Abidjan|Etc/GMT0", "Africa/Abidjan|Etc/Greenwich", "Africa/Abidjan|GMT", "Africa/Abidjan|GMT+0", "Africa/Abidjan|GMT-0", "Africa/Abidjan|GMT0", "Africa/Abidjan|Greenwich", "Africa/Abidjan|Iceland", "Africa/Algiers|Africa/Tunis", "Africa/Cairo|Egypt", "Africa/Casablanca|Africa/El_Aaiun", "Africa/Johannesburg|Africa/Maseru", "Africa/Johannesburg|Africa/Mbabane", "Africa/Khartoum|Africa/Addis_Ababa", "Africa/Khartoum|Africa/Asmara", "Africa/Khartoum|Africa/Asmera", "Africa/Khartoum|Africa/Dar_es_Salaam", "Africa/Khartoum|Africa/Djibouti", "Africa/Khartoum|Africa/Juba", "Africa/Khartoum|Africa/Kampala", "Africa/Khartoum|Africa/Mogadishu", "Africa/Khartoum|Africa/Nairobi", "Africa/Khartoum|Indian/Antananarivo", "Africa/Khartoum|Indian/Comoro", "Africa/Khartoum|Indian/Mayotte", "Africa/Lagos|Africa/Bangui", "Africa/Lagos|Africa/Brazzaville", "Africa/Lagos|Africa/Douala", "Africa/Lagos|Africa/Kinshasa", "Africa/Lagos|Africa/Libreville", "Africa/Lagos|Africa/Luanda", "Africa/Lagos|Africa/Malabo", "Africa/Lagos|Africa/Ndjamena", "Africa/Lagos|Africa/Niamey", "Africa/Lagos|Africa/Porto-Novo", "Africa/Maputo|Africa/Blantyre", "Africa/Maputo|Africa/Bujumbura", "Africa/Maputo|Africa/Gaborone", "Africa/Maputo|Africa/Harare", "Africa/Maputo|Africa/Kigali", "Africa/Maputo|Africa/Lubumbashi", "Africa/Maputo|Africa/Lusaka", "Africa/Tripoli|Libya", "America/Adak|America/Atka", "America/Adak|US/Aleutian", "America/Anchorage|America/Juneau", "America/Anchorage|America/Nome", "America/Anchorage|America/Sitka", "America/Anchorage|America/Yakutat", "America/Anchorage|US/Alaska", "America/Argentina/Buenos_Aires|America/Argentina/Catamarca", "America/Argentina/Buenos_Aires|America/Argentina/ComodRivadavia", "America/Argentina/Buenos_Aires|America/Argentina/Cordoba", "America/Argentina/Buenos_Aires|America/Argentina/Jujuy", "America/Argentina/Buenos_Aires|America/Argentina/La_Rioja", "America/Argentina/Buenos_Aires|America/Argentina/Mendoza", "America/Argentina/Buenos_Aires|America/Argentina/Rio_Gallegos", "America/Argentina/Buenos_Aires|America/Argentina/Salta", "America/Argentina/Buenos_Aires|America/Argentina/San_Juan", "America/Argentina/Buenos_Aires|America/Argentina/San_Luis", "America/Argentina/Buenos_Aires|America/Argentina/Tucuman", "America/Argentina/Buenos_Aires|America/Argentina/Ushuaia", "America/Argentina/Buenos_Aires|America/Buenos_Aires", "America/Argentina/Buenos_Aires|America/Catamarca", "America/Argentina/Buenos_Aires|America/Cordoba", "America/Argentina/Buenos_Aires|America/Jujuy", "America/Argentina/Buenos_Aires|America/Mendoza", "America/Argentina/Buenos_Aires|America/Rosario", "America/Campo_Grande|America/Cuiaba", "America/Chicago|America/Indiana/Knox", "America/Chicago|America/Indiana/Tell_City", "America/Chicago|America/Knox_IN", "America/Chicago|America/Matamoros", "America/Chicago|America/Menominee", "America/Chicago|America/North_Dakota/Center", "America/Chicago|America/North_Dakota/New_Salem", "America/Chicago|America/Rainy_River", "America/Chicago|America/Rankin_Inlet", "America/Chicago|America/Resolute", "America/Chicago|America/Winnipeg", "America/Chicago|CST6CDT", "America/Chicago|Canada/Central", "America/Chicago|US/Central", "America/Chicago|US/Indiana-Starke", "America/Chihuahua|America/Mazatlan", "America/Chihuahua|Mexico/BajaSur", "America/Denver|America/Boise", "America/Denver|America/Cambridge_Bay", "America/Denver|America/Edmonton", "America/Denver|America/Inuvik", "America/Denver|America/Ojinaga", "America/Denver|America/Shiprock", "America/Denver|America/Yellowknife", "America/Denver|Canada/Mountain", "America/Denver|MST7MDT", "America/Denver|Navajo", "America/Denver|US/Mountain", "America/Fortaleza|America/Belem", "America/Fortaleza|America/Maceio", "America/Fortaleza|America/Recife", "America/Fortaleza|America/Santarem", "America/Halifax|America/Glace_Bay", "America/Halifax|America/Moncton", "America/Halifax|America/Thule", "America/Halifax|Atlantic/Bermuda", "America/Halifax|Canada/Atlantic", "America/Havana|Cuba", "America/Los_Angeles|America/Dawson", "America/Los_Angeles|America/Ensenada", "America/Los_Angeles|America/Santa_Isabel", "America/Los_Angeles|America/Tijuana", "America/Los_Angeles|America/Vancouver", "America/Los_Angeles|America/Whitehorse", "America/Los_Angeles|Canada/Pacific", "America/Los_Angeles|Canada/Yukon", "America/Los_Angeles|Mexico/BajaNorte", "America/Los_Angeles|PST8PDT", "America/Los_Angeles|US/Pacific", "America/Los_Angeles|US/Pacific-New", "America/Managua|America/Belize", "America/Managua|America/Costa_Rica", "America/Managua|America/El_Salvador", "America/Managua|America/Guatemala", "America/Managua|America/Regina", "America/Managua|America/Swift_Current", "America/Managua|America/Tegucigalpa", "America/Managua|Canada/East-Saskatchewan", "America/Managua|Canada/Saskatchewan", "America/Manaus|America/Boa_Vista", "America/Manaus|America/Porto_Velho", "America/Manaus|Brazil/West", "America/Mexico_City|America/Merida", "America/Mexico_City|America/Monterrey", "America/Mexico_City|Mexico/General", "America/New_York|America/Detroit", "America/New_York|America/Fort_Wayne", "America/New_York|America/Indiana/Indianapolis", "America/New_York|America/Indiana/Marengo", "America/New_York|America/Indiana/Petersburg", "America/New_York|America/Indiana/Vevay", "America/New_York|America/Indiana/Vincennes", "America/New_York|America/Indiana/Winamac", "America/New_York|America/Indianapolis", "America/New_York|America/Iqaluit", "America/New_York|America/Kentucky/Louisville", "America/New_York|America/Kentucky/Monticello", "America/New_York|America/Louisville", "America/New_York|America/Montreal", "America/New_York|America/Nassau", "America/New_York|America/Nipigon", "America/New_York|America/Pangnirtung", "America/New_York|America/Thunder_Bay", "America/New_York|America/Toronto", "America/New_York|Canada/Eastern", "America/New_York|EST5EDT", "America/New_York|US/East-Indiana", "America/New_York|US/Eastern", "America/New_York|US/Michigan", "America/Noronha|Brazil/DeNoronha", "America/Panama|America/Atikokan", "America/Panama|America/Cayman", "America/Panama|America/Coral_Harbour", "America/Panama|America/Jamaica", "America/Panama|EST", "America/Panama|Jamaica", "America/Phoenix|America/Creston", "America/Phoenix|America/Dawson_Creek", "America/Phoenix|America/Hermosillo", "America/Phoenix|MST", "America/Phoenix|US/Arizona", "America/Rio_Branco|America/Eirunepe", "America/Rio_Branco|America/Porto_Acre", "America/Rio_Branco|Brazil/Acre", "America/Santiago|Antarctica/Palmer", "America/Santiago|Chile/Continental", "America/Santo_Domingo|America/Anguilla", "America/Santo_Domingo|America/Antigua", "America/Santo_Domingo|America/Aruba", "America/Santo_Domingo|America/Barbados", "America/Santo_Domingo|America/Blanc-Sablon", "America/Santo_Domingo|America/Curacao", "America/Santo_Domingo|America/Dominica", "America/Santo_Domingo|America/Grenada", "America/Santo_Domingo|America/Guadeloupe", "America/Santo_Domingo|America/Kralendijk", "America/Santo_Domingo|America/Lower_Princes", "America/Santo_Domingo|America/Marigot", "America/Santo_Domingo|America/Martinique", "America/Santo_Domingo|America/Montserrat", "America/Santo_Domingo|America/Port_of_Spain", "America/Santo_Domingo|America/Puerto_Rico", "America/Santo_Domingo|America/St_Barthelemy", "America/Santo_Domingo|America/St_Kitts", "America/Santo_Domingo|America/St_Lucia", "America/Santo_Domingo|America/St_Thomas", "America/Santo_Domingo|America/St_Vincent", "America/Santo_Domingo|America/Tortola", "America/Santo_Domingo|America/Virgin", "America/Sao_Paulo|Brazil/East", "America/St_Johns|Canada/Newfoundland", "Antarctica/DumontDUrville|Etc/GMT-10", "Antarctica/Rothera|Etc/GMT+3", "Antarctica/Syowa|Etc/GMT-3", "Asia/Almaty|Antarctica/Vostok", "Asia/Almaty|Asia/Bishkek", "Asia/Almaty|Asia/Qyzylorda", "Asia/Almaty|Etc/GMT-6", "Asia/Baghdad|Asia/Aden", "Asia/Baghdad|Asia/Bahrain", "Asia/Baghdad|Asia/Kuwait", "Asia/Baghdad|Asia/Qatar", "Asia/Baghdad|Asia/Riyadh", "Asia/Bangkok|Asia/Ho_Chi_Minh", "Asia/Bangkok|Asia/Phnom_Penh", "Asia/Bangkok|Asia/Saigon", "Asia/Bangkok|Asia/Vientiane", "Asia/Dhaka|Asia/Dacca", "Asia/Dubai|Asia/Muscat", "Asia/Hong_Kong|Hongkong", "Asia/Jakarta|Asia/Pontianak", "Asia/Jerusalem|Asia/Tel_Aviv", "Asia/Jerusalem|Israel", "Asia/Kamchatka|Asia/Anadyr", "Asia/Kathmandu|Asia/Katmandu", "Asia/Kolkata|Asia/Calcutta", "Asia/Kuala_Lumpur|Asia/Kuching", "Asia/Makassar|Asia/Ujung_Pandang", "Asia/Rangoon|Asia/Yangon", "Asia/Seoul|ROK", "Asia/Shanghai|Asia/Chongqing", "Asia/Shanghai|Asia/Chungking", "Asia/Shanghai|Asia/Harbin", "Asia/Shanghai|Asia/Macao", "Asia/Shanghai|Asia/Macau", "Asia/Shanghai|Asia/Taipei", "Asia/Shanghai|PRC", "Asia/Shanghai|ROC", "Asia/Singapore|Singapore", "Asia/Tashkent|Antarctica/Mawson", "Asia/Tashkent|Asia/Aqtau", "Asia/Tashkent|Asia/Aqtobe", "Asia/Tashkent|Asia/Ashgabat", "Asia/Tashkent|Asia/Ashkhabad", "Asia/Tashkent|Asia/Dushanbe", "Asia/Tashkent|Asia/Oral", "Asia/Tashkent|Asia/Samarkand", "Asia/Tashkent|Etc/GMT-5", "Asia/Tashkent|Indian/Kerguelen", "Asia/Tbilisi|Etc/GMT-4", "Asia/Tehran|Iran", "Asia/Thimphu|Asia/Thimbu", "Asia/Tokyo|Japan", "Asia/Ulaanbaatar|Asia/Ulan_Bator", "Asia/Urumqi|Asia/Kashgar", "Australia/Adelaide|Australia/Broken_Hill", "Australia/Adelaide|Australia/South", "Australia/Adelaide|Australia/Yancowinna", "Australia/Brisbane|Australia/Lindeman", "Australia/Brisbane|Australia/Queensland", "Australia/Darwin|Australia/North", "Australia/Lord_Howe|Australia/LHI", "Australia/Perth|Australia/West", "Australia/Sydney|Australia/ACT", "Australia/Sydney|Australia/Canberra", "Australia/Sydney|Australia/Currie", "Australia/Sydney|Australia/Hobart", "Australia/Sydney|Australia/Melbourne", "Australia/Sydney|Australia/NSW", "Australia/Sydney|Australia/Tasmania", "Australia/Sydney|Australia/Victoria", "Etc/UCT|UCT", "Etc/UTC|Etc/Universal", "Etc/UTC|Etc/Zulu", "Etc/UTC|UTC", "Etc/UTC|Universal", "Etc/UTC|Zulu", "Europe/Astrakhan|Europe/Ulyanovsk", "Europe/Athens|Asia/Nicosia", "Europe/Athens|EET", "Europe/Athens|Europe/Bucharest", "Europe/Athens|Europe/Helsinki", "Europe/Athens|Europe/Kiev", "Europe/Athens|Europe/Mariehamn", "Europe/Athens|Europe/Nicosia", "Europe/Athens|Europe/Riga", "Europe/Athens|Europe/Sofia", "Europe/Athens|Europe/Tallinn", "Europe/Athens|Europe/Uzhgorod", "Europe/Athens|Europe/Vilnius", "Europe/Athens|Europe/Zaporozhye", "Europe/Chisinau|Europe/Tiraspol", "Europe/Dublin|Eire", "Europe/Istanbul|Asia/Istanbul", "Europe/Istanbul|Turkey", "Europe/Lisbon|Atlantic/Canary", "Europe/Lisbon|Atlantic/Faeroe", "Europe/Lisbon|Atlantic/Faroe", "Europe/Lisbon|Atlantic/Madeira", "Europe/Lisbon|Portugal", "Europe/Lisbon|WET", "Europe/London|Europe/Belfast", "Europe/London|Europe/Guernsey", "Europe/London|Europe/Isle_of_Man", "Europe/London|Europe/Jersey", "Europe/London|GB", "Europe/London|GB-Eire", "Europe/Moscow|W-SU", "Europe/Paris|Africa/Ceuta", "Europe/Paris|Arctic/Longyearbyen", "Europe/Paris|Atlantic/Jan_Mayen", "Europe/Paris|CET", "Europe/Paris|Europe/Amsterdam", "Europe/Paris|Europe/Andorra", "Europe/Paris|Europe/Belgrade", "Europe/Paris|Europe/Berlin", "Europe/Paris|Europe/Bratislava", "Europe/Paris|Europe/Brussels", "Europe/Paris|Europe/Budapest", "Europe/Paris|Europe/Busingen", "Europe/Paris|Europe/Copenhagen", "Europe/Paris|Europe/Gibraltar", "Europe/Paris|Europe/Ljubljana", "Europe/Paris|Europe/Luxembourg", "Europe/Paris|Europe/Madrid", "Europe/Paris|Europe/Malta", "Europe/Paris|Europe/Monaco", "Europe/Paris|Europe/Oslo", "Europe/Paris|Europe/Podgorica", "Europe/Paris|Europe/Prague", "Europe/Paris|Europe/Rome", "Europe/Paris|Europe/San_Marino", "Europe/Paris|Europe/Sarajevo", "Europe/Paris|Europe/Skopje", "Europe/Paris|Europe/Stockholm", "Europe/Paris|Europe/Tirane", "Europe/Paris|Europe/Vaduz", "Europe/Paris|Europe/Vatican", "Europe/Paris|Europe/Vienna", "Europe/Paris|Europe/Warsaw", "Europe/Paris|Europe/Zagreb", "Europe/Paris|Europe/Zurich", "Europe/Paris|Poland", "Europe/Volgograd|Europe/Kirov", "Pacific/Auckland|Antarctica/McMurdo", "Pacific/Auckland|Antarctica/South_Pole", "Pacific/Auckland|NZ", "Pacific/Chatham|NZ-CHAT", "Pacific/Chuuk|Pacific/Truk", "Pacific/Chuuk|Pacific/Yap", "Pacific/Easter|Chile/EasterIsland", "Pacific/Guam|Pacific/Saipan", "Pacific/Honolulu|HST", "Pacific/Honolulu|Pacific/Johnston", "Pacific/Honolulu|US/Hawaii", "Pacific/Majuro|Kwajalein", "Pacific/Majuro|Pacific/Kwajalein", "Pacific/Pago_Pago|Pacific/Midway", "Pacific/Pago_Pago|Pacific/Samoa", "Pacific/Pago_Pago|US/Samoa", "Pacific/Pohnpei|Pacific/Ponape"]
    }),
    o
});
